// context/translations.js
// Kamus terjemahan ID/EN. Tambahkan key baru di kedua bahasa saat memperluas i18n.
// Konvensi key: "area.nama" — misal "header.logout", "sidebar.overview".
//
// TAHAP 1: common, language switcher, header, page titles.
// TAHAP 2: sidebar, overview.

export const translations = {
  id: {
    // ── Language switcher ──
    'lang.label':       'Bahasa',
    'lang.indonesian':  'Indonesia',
    'lang.english':     'English',

    // ── Common ──
    'common.save':       'Simpan',
    'common.cancel':     'Batal',
    'common.delete':     'Hapus',
    'common.edit':       'Edit',
    'common.search':     'Cari...',
    'common.loading':    'Memuat...',
    'common.refresh':    'Refresh',
    'common.yes':        'Ya',
    'common.no':         'Tidak',
    'common.close':      'Tutup',
    'common.confirm':    'Konfirmasi',
    'common.actions':    'Aksi',
    'common.all':        'Semua',
    'common.noData':     'Tidak ada data',

    // ── Header: judul halaman ──
    'page.overview.title':     'Overview',
    'page.overview.subtitle':  'Ringkasan semua sistem',
    'page.awsBilling.title':   'AWS Billing',
    'page.awsBilling.subtitle':'Dashboard biaya & penggunaan AWS',
    'page.awsCost.title':      'AWS Cost Explorer',
    'page.awsCost.subtitle':   'Analisis biaya mendalam AWS',
    'page.awsInventory.title':    'AWS Inventory',
    'page.awsInventory.subtitle': 'Dokumentasi resource AWS multi-region',
    'page.awsCloudTrail.title':    'AWS CloudTrail',
    'page.awsCloudTrail.subtitle': 'Log aktivitas & audit event AWS multi-region',
    'page.solman.title':       'SAP Solution Manager',
    'page.solman.subtitle':    'Monitoring tiket & insiden SAP',
    'page.sapUsage.title':     'SAP User Utilization',
    'page.sapUsage.subtitle':  'Analisis penggunaan user SAP',
    'page.sapUserMgmt.title':     'SAP User Maintenance',
    'page.sapUserMgmt.subtitle':  'Kelola user SAP — lock, unlock, reset password',
    'sidebar.sapUserMgmt':        'SAP User Maintenance',
    'sidebar.sapUserMgmt.sub':    'Lock / unlock / reset PW',
    'sidebar.sapRoles':           'SAP Role Maintenance',
    'sidebar.sapRoles.sub':       'Audit role & penugasan',
    // Menu tanpa terjemahan sebelumnya (label + subjudul)
    'sidebar.solman_docs': 'Solman Documents',
    'sidebar.solman_docs.sub': 'Dokumen project SolMan (PDF + OCR)',
    'sidebar.sapBasisMon': 'SAP Basis Monitor',
    'sidebar.sapBasisMon.sub': 'Kesehatan: job, lock, WP, sistem',
    'sidebar.sapLogonAudit': 'External Access Audit',
    'sidebar.sapLogonAudit.sub': 'Akses SAP dari luar jaringan',
    'sidebar.linuxLoginAudit': 'Linux Login Audit',
    'sidebar.linuxLoginAudit.sub': 'Login SSH di semua EC2 Linux',
    'sidebar.claudeActivity': 'Claude Activity',
    'sidebar.claudeActivity.sub': 'Aktivitas member di Claude (OTel)',
    'sidebar.sapRouterLog': 'SAProuter Log',
    'sidebar.sapRouterLog.sub': 'Koneksi masuk & IP publik asal',
    'sidebar.transport': 'SAP Transport Request',
    'sidebar.transport.sub': 'Antrian STMS & import Q01/P01',
    'sidebar.sapNotes': 'SAP Note',
    'sidebar.sapNotes.sub': 'Katalog, arsip & tracking note',
    'sidebar.netmap': 'Network Topology',
    'sidebar.netmap.sub': 'Diagram jaringan per site',
    'sidebar.aiActions': 'AI Actions',
    'sidebar.aiActions.sub': 'Aksi bahasa natural + approval',
    'sidebar.shareLinks': 'Share Links',
    'sidebar.shareLinks.sub': 'Link publik read-only',
    'sidebar.fileDeploy': 'File Deploy',
    'sidebar.fileDeploy.sub': 'Upload & deploy file .js/.jsx',
    'sidebar.notes': 'Notes',
    'sidebar.notes.sub': 'Catatan & memo tim',
    'sidebar.notesPlain': 'Notes Plain',
    'sidebar.notesPlain.sub': 'Catatan tanpa indeks RAG',
    // ── SAP Customizing & Enhancement ──
    'sidebar.sapCustomizing':     'SAP Customizing',
    'sidebar.sapCustomizing.sub': 'User exit, BAdI & enhancement',
    'sidebar.sapConfig':          'SAP Configuration',
    'sidebar.sapConfig.sub':      'SPRO / IMG customizing',
    'page.sapCustomizing.title':    'SAP Customizing & Enhancement',
    'page.sapCustomizing.subtitle': 'Metadata user exit, screen exit & table append (CMOD/SMOD) di sistem SAP — BAdI belum termasuk',

    // ── ABAP Source Viewer ──
    'sidebar.sapSource':          'ABAP Workbench',
    'sidebar.sapSource.sub':      'Source, kamus, class & enhancement custom',
    'page.sapSource.title':       'ABAP Workbench',
    'page.sapSource.subtitle':    'Objek repository custom: source program/FM/class, ABAP Dictionary, katalog workbench, dan enhancement (exit/BAdI)',
    'sapSrc.scopeNote':           'Hanya program di namespace custom (Z*/Y*). Program SAP standard ditolak oleh SAP itu sendiri — pagarnya ada di function module, bukan di halaman ini. Setiap pembacaan dicatat di Activity Log.',
    'sapSrc.noPath':              'Profil koneksi ini belum punya service path ZRFC_READ_SOURCE. Isi dulu di SAP Config; tanpa itu pembacaan pasti gagal.',
    'sapSrc.progPlaceholder':     'Nama program / include, mis. ZXVVFU02',
    'sapSrc.progInvalid':         'Nama tidak sah. Hanya huruf, angka, dan _ / = < > + - (maks 40 karakter).',
    'sapSrc.withIncludes':        'Sertakan include',
    'sapSrc.read':                'Tampilkan',
    'sapSrc.reading':             'Membaca...',
    'sapSrc.linesUnit':           'baris',
    'sapSrc.codeLines':           'baris kode',
    'sapSrc.progUnit':            'program',
    'sapSrc.state.code':          'Berisi kode',
    'sapSrc.state.empty':         'Ada, tapi hanya komentar / baris kosong',
    'sapSrc.state.missing':       'Tidak ada source',
    'sapSrc.state.denied':        'Ditolak SAP',
    'sapSrc.state.auth':          'Autentikasi ditolak',
    'sapSrc.state.error':         'Gagal dibaca',
    'sapSrc.truncWarn':           '{n} baris dipotong oleh SAP di karakter ke-255. Yang tampil bukan baris utuh.',
    'sapSrc.findPlaceholder':     'Cari di dalam kode...',
    'sapSrc.findNote':            'Pencarian menyorot, tidak menyaring baris.',
    'sapSrc.hits':                '{n} kecocokan',
    'sapSrc.copy':                'Salin',
    'sapSrc.copied':              'Tersalin',
    'sapSrc.download':            'Unduh',
    'sapSrc.noLines':             'SAP tidak mengembalikan satu baris pun untuk program ini.',
    'sapSrc.emptyState':          'Ketik nama program atau include ABAP di atas, lalu tekan Tampilkan. Saran nama diambil dari katalog Custom Workbench (hasil sync TADIR), bukan dari pembacaan langsung ke SAP — nama yang tidak muncul belum tentu tidak ada.',
    'sapSrc.requested':           'diminta',
    'sapSrc.expand':              'klik untuk buka',
    'sapSrc.collapse':            'klik untuk tutup',
    'sapSrc.sugNote':             'Saran dari program yang pernah terbaca, bukan daftar lengkap.',
    'sapSrc.sugMore':             'Masih ada yang lain — persempit ketikan Anda.',
    // ── ABAP Source Viewer · mode Function Module ──
    'sapSrc.mode.prog':           'Program / Report',
    'sapSrc.mode.fm':             'Function Module',
    'sapSrc.fmPlaceholder':       'Nama function module, mis. ZMMFM_PRREL_SEND_MAIL',
    'sapSrc.fmInvalid':           'Nama tidak sah. Hanya huruf, angka, _ dan / (maks 30 karakter).',
    'sapSrc.fmLookup':            'Tampilkan',
    'sapSrc.fmLooking':           'Mencari...',
    'sapSrc.fmEmptyState':        'Ketik nama function module di atas, lalu tekan Tampilkan. Saran nama dibaca langsung dari TFDIR di SAP, dibatasi namespace custom (Z*/Y*). Bukan SE37 penuh: tidak ada Test/Execute dan tidak ada edit.',
    'sapSrc.fmSugLive':           'Saran dibaca langsung dari TFDIR di SAP.',
    'sapSrc.tab.import':          'Import',
    'sapSrc.tab.export':          'Export',
    'sapSrc.tab.changing':        'Changing',
    'sapSrc.tab.tables':          'Tables',
    'sapSrc.tab.exceptions':      'Exceptions',
    'sapSrc.tab.other':           'Lain (PARAMTYPE {code})',
    'sapSrc.tab.source':          'Source code',
    'sapSrc.attr.group':          'Function group',
    'sapSrc.attr.mainProg':       'Program utama',
    'sapSrc.attr.include':        'Include',
    'sapSrc.attr.remote':         'REMOTE-ENABLED (RFC)',
    'sapSrc.attr.updateModule':   'UPDATE MODULE',
    'sapSrc.attr.normal':         'Normal',
    'sapSrc.col.param':           'Parameter',
    'sapSrc.col.typeRef':         'Tipe terkait',
    'sapSrc.col.default':         'Default',
    'sapSrc.col.optional':        'Opsional',
    'sapSrc.col.text':            'Keterangan',
    'sapSrc.rawCols':             'Tampilkan kolom mentah SAP (PPOSITION, REFERENCE, TYPE, REF_CLASS)',
    'sapSrc.tabEmpty':            'Tidak ada parameter pada kelompok ini.',
    'sapSrc.optYes':              'opsional',
    'sapSrc.optNo':               'wajib',
    'sapSrc.warnTitle':           'Perlu diperhatikan:',
    'sapSrc.orphanTitle':         'Ada teks parameter di FUNCT yang tidak punya padanan di FUPARAREF:',
    'sapSrc.fmSourceNote':        'Source FM dibaca lewat program utama function group ({prog}) dengan seluruh include-nya — include tunggal tidak bisa dibaca sendirian di sistem ini. Blok milik FM ini ({inc}) ditampilkan lebih dulu dan terbuka; include milik FM lain di group yang sama tertutup.',
    'sapSrc.reload':              'Baca ulang',
    // ── ABAP Source Viewer · mode ABAP Dictionary ──
    'sapSrc.mode.dd':             'ABAP Dictionary',
    'sapSrc.ddPlaceholder':       'Nama tabel / struktur, mis. EKKO atau ZTAMM_PRREL',
    'sapSrc.ddInvalid':           'Nama tidak sah. Hanya huruf, angka, _ dan / (maks 30 karakter).',
    'sapSrc.ddLookup':            'Tampilkan',
    'sapSrc.ddLooking':           'Mencari...',
    'sapSrc.ddEmptyState':        'Ketik nama tabel atau struktur di atas, lalu tekan Tampilkan. Berlaku untuk semua tabel termasuk SAP standard.',
    'sapSrc.ddSugLive':           'Saran dibaca langsung dari DD02L (versi aktif) di SAP.',
    'sapSrc.dd.scopeNote':        'Yang ditampilkan STRUKTUR tabel — nama field, tipe, panjang, data element. ISI DATA tidak dibaca di sini; itu wilayah halaman Table Maintenance dengan izinnya sendiri. Hanya versi aktif (AS4LOCAL=A) yang dipakai.',
    'sapSrc.dd.maintain':         'Boleh di-maintain (SM30)',
    'sapSrc.dd.noMaintain':       'Tanpa maintenance view',
    'sapSrc.dd.delivery':         'Delivery class',
    'sapSrc.dd.changed':          'Diubah oleh',
    'sapSrc.dd.fields':           'field',
    'sapSrc.dd.keys':             'key',
    'sapSrc.dd.includes':         'include',
    'sapSrc.dd.textSrc':          'Teks diambil dari {src}, bahasa {lang}.',
    'sapSrc.dd.include':          'INCLUDE',
    'sapSrc.dd.append':           'APPEND',
    'sapSrc.dd.filterPlaceholder': 'Saring field, data element, atau keterangan...',
    'sapSrc.dd.noFields':         'Tidak ada daftar field untuk objek ini.',
    'sapSrc.dd.navHint':          'Buka {name}',
    'sapSrc.dd.col.key':          'Key',
    'sapSrc.dd.col.pos':          'Pos',
    'sapSrc.dd.col.field':        'Field',
    'sapSrc.dd.col.de':           'Data element',
    'sapSrc.dd.col.type':         'Tipe',
    'sapSrc.dd.col.chk':          'Check table',
    'sapSrc.dd.col.text':         'Keterangan',
    // ── ABAP Source Viewer · sampel isi tabel ──
    'sapSrc.peek.open':           'Lihat sampel isi tabel',
    'sapSrc.peek.hint':           'Membaca data bisnis, bukan struktur. Butuh izin sap_table_peek.',
    'sapSrc.peek.title':          'Sampel isi tabel',
    'sapSrc.peek.note':           'Ini DATA BISNIS, bukan metadata. Dibaca lewat RFC_READ_TABLE standard, jadi otorisasi tabel (S_TABU_DIS) user RFC di profil koneksi tetap berlaku. Setiap pembacaan dicatat di Activity Log.',
    'sapSrc.peek.wide':           'Tabel ini lebar: total {total} byte, melebihi batas {limit} byte untuk {fm}. Pilih field yang ingin dilihat, atau biarkan kosong untuk diisi otomatis sampai batas.',
    'sapSrc.peek.fieldFilter':    'Saring nama field...',
    'sapSrc.peek.budget':         '{n} field dipilih · {w}/{limit} byte',
    'sapSrc.peek.autoFit':        'Tanpa pilihan — field diisi otomatis sampai batas',
    'sapSrc.peek.clear':          'Kosongkan pilihan',
    'sapSrc.peek.rows':           'Jumlah baris',
    'sapSrc.peek.fetch':          'Ambil sampel',
    'sapSrc.peek.fetching':       'Mengambil...',
    'sapSrc.peek.overBudget':     'Melebihi batas: {w}/{limit} byte. Kurangi field.',
    'sapSrc.peek.got':            '{n} baris diambil dari {req} yang diminta',
    'sapSrc.peek.exhausted':      'Tabelnya memang lebih pendek — bukan terpotong.',
    'sapSrc.peek.empty':          'Tabel ini tidak mengembalikan satu baris pun.',
    // ── ABAP Source Viewer · mode Class ──
    'sapSrc.mode.cls':            'Class',
    'sapSrc.clsPlaceholder':      'Nama kelas, mis. CL_GUI_ALV_GRID atau ZCL_...',
    'sapSrc.clsInvalid':          'Nama tidak sah. Hanya huruf, angka, _ dan / (maks 30 karakter).',
    'sapSrc.clsLookup':           'Tampilkan',
    'sapSrc.clsLooking':          'Mencari...',
    'sapSrc.clsEmptyState':       'Ketik nama kelas di atas, lalu tekan Tampilkan. Berlaku untuk semua kelas termasuk SAP standard; source code hanya untuk namespace custom. Bukan SE24 penuh: tidak ada edit dan tidak ada eksekusi.',
    'sapSrc.clsSugLive':          'Saran dibaca langsung dari SEOCLASSDF (versi aktif) di SAP.',
    'sapSrc.cls.super':           'Superclass',
    'sapSrc.cls.implements':      'Mengimplement',
    'sapSrc.cls.relOther':        'Relasi dengan RELTYPE yang belum dikenal',
    'sapSrc.cls.changed':         'Diubah oleh',
    'sapSrc.cls.tab.methods':     'Methods',
    'sapSrc.cls.tab.attributes':  'Attributes',
    'sapSrc.cls.tab.events':      'Events',
    'sapSrc.cls.tab.other':       'Lain (CMPTYPE {code})',
    'sapSrc.cls.otherNote':       'CMPTYPE {code} ada di sistem ini tetapi artinya belum terbukti, dan belum ada view yang diverifikasi untuknya. Yang bisa ditampilkan hanya NAMA komponennya — bukan tipe, exposure, atau keterangannya.',
    'sapSrc.cls.filter':          'Saring nama atau keterangan...',
    'sapSrc.cls.importing':       'IMPORTING',
    'sapSrc.cls.exporting':       'EXPORTING',
    'sapSrc.cls.changing':        'CHANGING',
    'sapSrc.cls.returning':       'RETURNING',
    'sapSrc.cls.paramOther':      'Lain (PARDECLTYP {code})',
    'sapSrc.cls.noParams':        'Method ini tidak punya parameter maupun exception.',
    'sapSrc.cls.findInSource':    'Cari "METHOD ..." di source',
    'sapSrc.cls.sourceNote':      'Source dibaca dari class pool {pool} beserta seluruh include-nya. Tidak ada tombol lompat-ke-method: nomor include per method tidak bisa diturunkan dari nama method di sistem ini, dan menebaknya akan menampilkan method yang salah. Tombol pada tiap method mengisi kotak pencarian dengan "METHOD <nama>" — itu pencarian teks, bukan pemetaan.',
    'sapCust.sync':          'Tarik dari SAP',
    'sapCust.syncing':       'Menarik...',
    'sapCust.syncDone':      'Sync selesai: {enh} komponen, {raw} baris mentah, {kb} dokumen ter-index ke AI.',
    'sapCust.limitTitle':    'Batas informasi:',
    'sapCust.limitBody':     'Halaman ini menampilkan metadata enhancement KLASIK (CMOD/SMOD): user exit, screen exit, dan table append. BAdI dan enhancement spot BELUM diperiksa — ketiadaannya di sini bukan berarti tidak ada. Isi kode ABAP belum dibaca; tekan "Baca source ABAP" atau buka include-nya di SE38/SE80.',
    'sapCust.limitBodySrc':  'Cakupan halaman ini: enhancement KLASIK (CMOD/SMOD) saja — user exit, screen exit, table append. BAdI dan enhancement spot BELUM diperiksa; ketiadaannya di sini bukan berarti tidak ada. Isi kode ABAP tersedia untuk include yang sudah dibaca dan merupakan salinan, bukan versi langsung dari SAP.',
    'sapCust.limitDetail':   'Isi kode ABAP dari komponen ini tidak tersimpan di sini. Buka include di atas lewat SE38/SE80 untuk melihat logikanya. Jangan menyimpulkan isi logika hanya dari nama exit.',
    'sapCust.stat.total':    'Total komponen',
    'sapCust.stat.active':   'Aktif',
    'sapCust.stat.project':  'Project CMOD',
    'sapCust.stat.module':   'Modul SAP',
    'sapCust.stat.moduleSub':'{n} tanpa modul',
    'sapCust.lastSync':      'Snapshot terakhir',
    'sapCust.cronRunConfirm': 'Jalankan refresh SAP Customizing sekarang? Proses ini melakukan puluhan panggilan SOAP ke SAP (termasuk PRODUKSI) dan bisa berjalan beberapa menit. Lanjutkan?',
    'sapCust.kbPrune.title':     'Pembersihan knowledge base',
    'sapCust.kbPrune.check':     'Periksa',
    'sapCust.kbPrune.hint':      'Sync hanya menulis dan memperbarui dokumen — tidak pernah menghapus. Dokumen yang tidak lagi dihasilkan indexer akan tetap dijawab AI sampai dibersihkan. Cron mingguan sudah menjalankan ini di langkah terakhir.',
    'sapCust.kbPrune.keepTitle': 'Koneksi yang dokumennya DIPERTAHANKAN:',
    'sapCust.kbPrune.emptyWarn': 'Koneksi berikut punya nol baris enhancement, jadi dokumennya akan dianggap usang dan dihapus',
    'sapCust.kbPrune.execute':   'Bersihkan sekarang',
    'sapCust.kbPrune.running':   'Membersihkan…',
    'sapCust.kbPrune.confirm':   'Hapus dokumen usang dari knowledge base? Dokumen milik koneksi di daftar "dipertahankan" tetap aman; selain itu akan dihapus dan tidak bisa dikembalikan tanpa sync ulang. Lanjutkan?',
    'sapCust.kbPrune.done':      'Dokumen usang dihapus',
    'sapCust.kbPrune.clean':     'Knowledge base sudah bersih — tidak ada dokumen usang.',
    'sapCust.srcCopy':       'Salin',
    'sapCust.srcCopied':     'Tersalin',
    'sapCust.statusLabel':   'Status',
    'sapCust.docs':          'dokumen',
    'sapCust.badiSync':      'Tarik BAdI',
    'sapCust.badiSyncing':   'Menarik BAdI…',
    'sapCust.badiDone':      'BAdI & enhancement: {total} objek ({classic} BAdI klasik, {new} BAdI spot, {src} source code).',
    'sapCust.viewEnh':       'Enhancement klasik',
    'sapCust.viewBadi':      'BAdI & enhancement',
    'sapCust.viewConfig':    'Lapis config (SPRO)',
    'sapCust.cfg.limitBody':  'Halaman ini membaca TR customizing dari E070C/E070/E071/E071K di sistem DEV saja. Tiga hal yang mudah salah dibaca: (1) pada panel "Tabel tersering", cacah baris kunci hanya tersedia untuk objek bertipe TABU — 68% baris objek ditulis "tidak tercatat", bukan nol, karena nama view tidak pernah cocok dengan E071K; (2) meski begitu cacah LENGKAPNYA tetap ada — lihat panel "Tabel fisik yang barisnya berubah", yang membaca E071K langsung dan mencakup seluruh baris kunci; (3) TR yang dikecualikan TETAP tercatat di sini, hanya isinya yang tidak dianalisis. Angka bertanda ~ adalah batas bawah untuk dimensi objek, bukan total keseluruhan.',
    'sapCust.cfg.sync':       'Tarik config dari SAP',
    'sapCust.cfg.syncing':    'Menarik config…',
    'sapCust.cfg.syncConfirm':'Tarik ulang lapis config dari SAP? Proses ini membaca E070C/E070/E07T/E071/E071K lewat RFC dan berjalan sekitar 40 detik. Data lama untuk koneksi ini DIGANTI seluruhnya (mode replace) — snapshot sebelumnya tidak disimpan. Lanjutkan?',
    'sapCust.cfg.syncDone':   'Sync config selesai: {tr} TR, {obj} baris objek.',
    'sapCust.cfg.unknown':    'tidak tercatat',
    'sapCust.cfg.unknownHint':'Cacah baris kunci tidak diketahui untuk objek ini — bukan berarti nol. Hanya objek bertipe TABU yang bisa dicocokkan ke E071K; nama view dan view cluster tidak pernah cocok dengan nama tabel fisik.',
    'sapCust.cfg.stat.tr':          'TR tercatat',
    'sapCust.cfg.stat.analyzed':    'Dianalisis penuh',
    'sapCust.cfg.stat.analyzedSub': '{n} dikecualikan (tetap tercatat)',
    'sapCust.cfg.stat.unreleased':  'Belum dirilis',
    'sapCust.cfg.stat.tables':      'Tabel config unik',
    'sapCust.cfg.stat.objectRows':  'Baris objek',
    'sapCust.cfg.stat.keys':        'Kunci baris',
    'sapCust.cfg.stat.keysSub':     '{n} baris ({pct}%) cacahnya tidak tercatat — angka di atas batas bawah',
    'sapCust.cfg.stat.heavy':       'Ditandai berat',
    'sapCust.cfg.stat.heavySub':    'penanda saja, bukan pengecualian',
    'sapCust.cfg.stat.notArrived':    'Belum sampai {sid}',
    'sapCust.cfg.stat.notArrivedSub': 'dari {cand} TR rilis · {failed} gagal (rc≥8) · catatan impor {rows} baris',
    'sapCust.cfg.imp.done':           'sudah diimpor',
    'sapCust.cfg.imp.failed':         'impor GAGAL (rc≥8)',
    'sapCust.cfg.imp.pending':        'belum ada catatan impor',
    'sapCust.cfg.imp.naHint':         'Tidak dinilai: TR belum dirilis atau dikecualikan. Berbeda dari "belum sampai".',
    'sapCust.cfg.imp.colHint':        'Status impor ke {sid} ({env}). Sumber TPALOG di sistem itu sendiri; diambil dari langkah TERAKHIR, bukan saat masuk antrean. Kolom ini tidak bisa diurutkan.',
    'sapCust.cfg.byModule':      'Sebaran modul',
    'sapCust.cfg.byModuleApp':     'Komponen aplikasi (paket)',
    'sapCust.cfg.byModuleAppHint': 'Diturunkan dari paket objeknya lewat TADIR → TDEVC → PS_POSID, bukan dari deskripsi TR. Ini DOMAIN BISNIS yang dilayani tabelnya; kolom Modul di sebelah adalah JENIS PEKERJAAN menurut deskripsi. Keduanya bisa berbeda dan keduanya benar.',
    'sapCust.cfg.col.moduleApp':    'Komp. aplikasi',
    'sapCust.cfg.col.mixed':        'Campuran',
    'sapCust.cfg.mixedHint':        'TR ini menyentuh {n} komponen aplikasi; yang ditampilkan hanya yang terbanyak. Seluruhnya: {list}',
    'sapCust.cfg.modAppUnknown':    '{n} TR belum punya komponen aplikasi — objeknya tidak terjangkau rantai TADIR (mis. seluruhnya di paket developer ZD01). Bukan berarti tanpa modul.',
    'sapCust.cfg.modAppNoObj':  '{n} TR tidak memuat objek customizing sama sekali — umumnya transport workbench (program ABAP, paket, backup). TR seperti ini memang tidak punya komponen aplikasi untuk diturunkan; ini bukan kegagalan pembacaan.',
    'sapCust.cfg.modAppUnreach': '{n} TR punya objek, tetapi objeknya tidak terjangkau rantai TADIR — mis. seluruhnya di paket developer ZD01. Bukan berarti tanpa modul.',
    'sapCust.cfg.byTrfunction':  'Jenis transport',
    'sapCust.cfg.excluded':      'Pengecualian',
    'sapCust.cfg.excludedHint':  'TR di bawah ini TETAP tersimpan dan bisa dibuka lewat filter — yang dilewati hanya analisis isinya.',
    'sapCust.cfg.topTables':     'Tabel tersering',
    'sapCust.cfg.topTablesHint':  'Apa yang DIDAFTARKAN TR (E071). Untuk objtype non-TABU isinya nama view / view cluster, dan cacah kuncinya tidak diketahui karena nama view tidak pernah cocok dengan E071K.',
    'sapCust.cfg.keyTables':      'Tabel fisik yang barisnya berubah',
    'sapCust.cfg.keyTablesHint':  'Tabel FISIK di belakang view tersebut, dibaca langsung dari E071K. Cacahnya selalu terukur — tidak ada keadaan "tidak diketahui" di sini. Daftar ini melengkapi kolom di sebelah, bukan menggantikannya.',
    'sapCust.cfg.keyTablesTotal': 'Seluruhnya {tables} tabel · {keys} baris kunci (daftar di bawah hanya 25 teratas)',
    'sapCust.cfg.col.tabname':    'Tabel',
    'sapCust.cfg.splitSrc':      'pecah per sumber',
    'sapCust.cfg.splitSrcHint':  'Backend mengelompokkan per (module, module_src), sehingga satu modul bisa muncul beberapa baris. Default halaman ini menggabungkannya per modul; centang untuk melihat jalur classifier mana yang menghasilkannya.',
    'sapCust.cfg.noModule':      '(tidak dikenal)',
    'sapCust.cfg.total':         'Jumlah',
    'sapCust.cfg.levelTr':       'Per TR',
    'sapCust.cfg.levelObject':   'Per objek',
    'sapCust.cfg.rowCount':      '{n} baris',
    'sapCust.cfg.filterNoteNone': 'TR yang dikecualikan disembunyikan — ubah dropdown untuk melihat semua',
    'sapCust.cfg.filterNoteOnly': 'hanya menampilkan TR yang dikecualikan',
    'sapCust.cfg.sortHint':       'Klik judul kolom untuk mengurutkan seluruh data, bukan hanya halaman ini.',
    'sapCust.cfg.loading':       'Memuat…',
    'sapCust.cfg.empty':         'Tidak ada baris yang cocok dengan filter.',
    'sapCust.cfg.reset':         'Reset filter',
    'sapCust.cfg.searchTr':      'Cari TRKORR / deskripsi…',
    'sapCust.cfg.excAll':        'Semua TR',
    'sapCust.cfg.excNone':       'Tanpa yang dikecualikan',
    'sapCust.cfg.excOnly':       'Hanya yang dikecualikan',
    'sapCust.cfg.heavyHint':     'Ditandai berat: cacah kunci melampaui ambang. Penanda saja — TR ini tetap dianalisis.',
    'sapCust.cfg.col.module':     'Modul',
    'sapCust.cfg.col.moduleSrc':  'Sumber',
    'sapCust.cfg.col.trfunction': 'Jenis',
    'sapCust.cfg.col.trstatus':   'Status',
    'sapCust.cfg.col.descr':      'Deskripsi',
    'sapCust.cfg.col.objCount':   'Objek',
    'sapCust.cfg.col.keys':       'Kunci',
    'sapCust.cfg.col.known':      'Tercatat',
    'sapCust.cfg.col.objname':    'Objek',
    'sapCust.cfg.col.objtype':    'Tipe',
    'sapCust.cfg.col.ddText':     'Deskripsi kamus',
    'sapCust.cfg.col.releasedOn': 'Rilis',
    'sapCust.cfg.rowClickHint':   'Klik untuk melihat objek dalam TR ini',
    'sapCust.cfg.secStats':       'Ringkasan angka',
    'sapCust.cfg.secStatsHint':   '{tr} TR · {obj} baris objek',
    'sapCust.cfg.secAggr':        'Agregat',
    'sapCust.cfg.secAggrHint':    'modul · app component · tipe transport · pengecualian',
    'sapCust.cfg.secTables':      'Tabel tersering',
    'sapCust.cfg.secTablesHint':  'objek terdaftar · tabel fisik yang berubah',
    'sapCust.cfg.notReleased':    'belum dirilis',
    'sapCust.cfg.ddNone':         'tidak ada di kamus data',
    'sapCust.cfg.ddNotSynced':    'deskripsi belum disinkronkan',
    'sapCust.cfg.col.analyzed':   'Dianalisis',
    'sapCust.cfg.col.excluded':   'Pengecualian',
    'sapCust.cfg.exc.sap_delivered':        'Bawaan SAP',
    'sapCust.cfg.exc.do_not_transport':     'Tidak ditransport',
    'sapCust.cfg.exc.client_export':        'Client export',
    'sapCust.cfg.exc.duplicate_piece_list': 'Duplikat piece list',
    'sapCust.cfg.exc.foreign_landscape':    'Landscape lain',
    'sapCust.badi.installed':'terpasang',
    'sapCust.badi.stat.total':      'Total objek',
    'sapCust.badi.stat.inactive':   'BAdI tidak aktif',
    'sapCust.badi.stat.inactiveSub':'terdaftar, logika tidak jalan',
    'sapCust.badi.stat.local':      'Objek lokal ($TMP)',
    'sapCust.badi.stat.localSub':   'tidak bisa ditransport',
    'sapCust.badi.limit':    'Daftar ini hanya objek milik pelanggan (Z*/Y*). Isi kode BAdI ada di kelas implementasi dan BELUM pernah dibaca — berbeda dari user exit klasik. Status aktif hanya tersedia untuk BAdI klasik; untuk BAdI spot dan source code, sumber datanya tidak menyimpan flag aktivasi.',
    'sapCust.badi.col.name':       'Implementasi',
    'sapCust.badi.col.kind':       'Jenis',
    'sapCust.badi.col.definition': 'Definisi / program',
    'sapCust.badi.col.descr':      'Deskripsi',
    'sapCust.badi.col.status':     'Status',
    'sapCust.badi.col.class':      'Kelas implementasi',
    'sapCust.badi.col.package':    'Package',
    'sapCust.badi.col.src':        'Source',
    'sapCust.badi.srcNever':       'belum dibaca',
    'sapCust.badi.src.code':       'ada kode',
    'sapCust.badi.src.empty':      'tanpa kode',
    'sapCust.badi.src.missing':    'tak ditemukan',
    'sapCust.badi.src.denied':     'ditolak',
    'sapCust.badi.src.error':      'gagal',
    'sapCust.badi.src.auth':       'autentikasi ditolak',
    'sapCust.badiSrcSync':         'Baca source BAdI',
    'sapCust.badiSrcSyncing':      'Membaca source BAdI…',
    'sapCust.badiSrcDone':         'Source BAdI dibaca: {read} kelas — {code} berisi kode, {prog} program, {lines} baris.',
    'sapCust.badiSrc.pool':        'Class pool',
    'sapCust.badiSrc.poolTag':     'kerangka kelas',
    'sapCust.badiSrc.progs':       '{n} program · {lines} baris · {code} baris kode',
    'sapCust.badiSrc.needSync':    'Source kelas implementasi belum pernah dibaca. Jalankan "Baca source BAdI".',
    'sapCust.searchPh':      'Cari komponen, enhancement, include, project...',
    'sapCust.allTypes':      'Semua tipe',
    'sapCust.allProjects':   'Semua project',
    'sapCust.allModules':    'Semua modul',
    'sapCust.noModule':      'Tanpa modul',
    'sapCust.activeOnly':    'Hanya yang aktif',
    'sapCust.active':        'Aktif',
    'sapCust.inactive':      'Tidak aktif',
    'sapCust.empty':         'Belum ada data. Tekan "Tarik dari SAP" untuk mulai.',
    'sapCust.col.component':   'Komponen',
    'sapCust.col.type':        'Tipe',
    'sapCust.col.enhancement': 'Enhancement',
    'sapCust.col.project':     'Project',
    'sapCust.col.module':      'Modul',
    'sapCust.col.include':     'Include',
    'sapCust.col.changed':     'Diubah oleh',
    'sapCust.d.enhancement':   'SAP enhancement',
    'sapCust.d.module':        'Modul SAP',
    'sapCust.d.appComponent':  'Application component',
    'sapCust.d.project':       'Project CMOD',
    'sapCust.d.funcGroup':     'Function group',
    'sapCust.d.include':       'Include implementasi',
    'sapCust.d.fgIncludes':    'Include lain di group',
    'sapCust.d.badi':          'Implementasi BAdI',
    'sapCust.d.package':       'Package include',
    'sapCust.d.projPackage':   'Package project',
    'sapCust.d.createdBy':     'Dibuat oleh',
    'sapCust.d.activatedBy':   'Diaktifkan oleh',
    'sapCust.d.changedBy':     'Terakhir diubah',
    // ── SAP Customizing: status isi kode & source ABAP ──
    'sapCust.col.srcState':   'Isi kode',
    'sapCust.srcSync':        'Baca source ABAP',
    'sapCust.srcSyncing':     'Membaca source...',
    'sapCust.srcDone':        'Source dibaca: {read} include — {code} berisi kode, {empty} kosong.',
    'sapCust.srcAborted':     'Pembacaan source dihentikan sebelum selesai. Hasilnya tidak lengkap.',
    'sapCust.srcNotConfigured': 'Service path ZRFC_READ_SOURCE belum diisi di SAP Config',
    'sapCust.srcNotRead':     'belum dibaca',
    'sapCust.srcTitle':       'Source ABAP',
    'sapCust.srcReadAt':      'dibaca',
    'sapCust.srcNone':        'Tidak ada baris source tersimpan.',
    'sapCust.srcMissing':     'Include tidak ditemukan di sistem ini.',
    'sapCust.srcDenied':      'Source tidak dapat dibaca (akses ditolak oleh SAP).',
    'sapCust.srcNeedSync':    'Belum pernah dibaca. Tekan "Baca source ABAP" di atas.',
    'sapCust.srcTrunc':       '{n} baris lebih panjang dari 255 karakter dan terpotong.',
    'sapCust.linesShort':     'baris kode',
    'sapCust.commentOnly':    'baris, semuanya komentar',
    'sapCust.allStates':      'Semua status isi kode',
    'sapCust.stat.activeEmpty':    'Aktif tapi kosong',
    'sapCust.stat.activeEmptySub': 'terdaftar aktif, tanpa kode',
    'sapCust.emptyWarnTitle': 'Aktif tetapi tidak ada kode.',
    'sapCust.emptyWarnBody':  'Project CMOD-nya aktif, tetapi include implementasinya tidak memuat satu pun baris kode — hanya komentar atau baris kosong. Tidak ada logika kustom yang dijalankan di titik ini. Isi di bawah ditampilkan supaya terlihat apa yang tersisa; komentar yang panjang biasanya berarti kode pernah ada lalu dimatikan.',
    'sapCust.limitSrcLive':   'Source di atas adalah salinan dari pembacaan terakhir dan bisa tertinggal dari versi terbaru di SAP. Untuk kepastian, buka include-nya di SE38/SE80.',
    // ── SAP Customizing: riwayat transport ──
    'sapCust.col.transport':  'Transport',
    'sapCust.trSync':         'Baca riwayat transport',
    'sapCust.trSyncing':      'Membaca transport...',
    'sapCust.trDone':         'Transport dibaca: {ver} baris versi, {tr} TR, {imp} TR ber-riwayat impor.',
    'sapCust.trTitle':        'Riwayat transport',
    'sapCust.trNone':         'belum dibaca',
    'sapCust.trNeedSync':     'Belum ada data. Tekan "Baca riwayat transport" di atas.',
    'sapCust.trChanged':      'diubah',
    'sapCust.trRelease':      'rilis',
    'sapCust.trImport':       'impor',
    'sapCust.trNoImport':     'Belum ada jejak impor di sistem mana pun.',
    'sapCust.trAll':          'Sudah di semua sistem',
    'sapCust.trMissing':      'Belum di {sids}',
    'sapCust.trGapTitle':     'Perubahan terakhir belum sampai.',
    'sapCust.trGapBody':      'TR {tr} belum tercatat diimpor ke {sids}. Bila objek ini sudah ada di sana, kemungkinan yang berjalan adalah VERSI LAMA — dan itu tidak menimbulkan error yang terlihat. Periksa antrean impor di STMS.',
    'page.default.title':      'Dashboard',

    // ── Header: lainnya ──
    'header.home':            'Beranda',
    'header.ai':              'AI',
    'header.aiAssistant':     'AI Assistant',
    'header.dashboardAccess': 'Akses Dashboard',
    'header.logout':          'Keluar dari Sistem',
    'pwd.menu':       'Ganti Password',
    'pwd.title':      'Ganti Password',
    'pwd.current':    'Password Lama',
    'pwd.new':        'Password Baru',
    'pwd.confirm':    'Konfirmasi Password Baru',
    'pwd.submit':     'Simpan',
    'pwd.cancel':     'Batal',
    'pwd.success':    'Password berhasil diganti.',
    'pwd.errRequired':  'Password lama dan baru wajib diisi.',
    'pwd.errMinLength': 'Password baru minimal 6 karakter.',
    'pwd.errMismatch':  'Konfirmasi password tidak cocok.',
    'pwd.errSameAsOld': 'Password baru harus berbeda dari password lama.',
    'pwd.errGeneric':   'Gagal mengganti password.',
    'role.admin':             'Administrator',
    'role.sapOperator':       'SAP Operator',
    'role.awsOperator':       'AWS Operator',

    // ── Sidebar: brand & grup ──
    'sidebar.brand':          'Primary Dashboard',
    'sidebar.brandSub':       'Monitoring Terpadu',
    'sidebar.group.aws':      'AWS',
    'sidebar.group.sap':      'SAP',
    'sidebar.group.infra':    'INFRA',
    'sidebar.group.docs':     'DOCUMENTATION',
    'sidebar.group.admin':    'ADMIN',
    'sidebar.group.hr':       'HR',
    'sidebar.group.tools':    'TOOLS',
    'sidebar.group.ai':          'AI',
    'sidebar.group.access':      'AKSES & PENGGUNA',
    'sidebar.group.system':      'SISTEM',
    'sidebar.group.integration': 'INTEGRASI',
    'sidebar.m365':           'Lisensi Microsoft 365',
    'sidebar.m365.sub':       'Ringkasan lisensi Microsoft 365',
    'sidebar.sdp':            'SDP Cloud',
    'sidebar.sdp.sub':        'ManageEngine ticketing & asset',

    // ── Sidebar: menu label + sublabel ──
    'sidebar.overview':                 'Overview',
    'sidebar.awsBilling':               'AWS Billing',
    'sidebar.awsBilling.sub':           'Cost & Usage',
    'sidebar.awsCost':                  'AWS Cost Explorer',
    'sidebar.awsCost.sub':              'Cost Analysis',
    'sidebar.awsCostBrief':             'AWS Cost Brief',
    'sidebar.awsCostBrief.sub':         'Ringkasan biaya bulanan',
    'sidebar.awsInventory':             'AWS Inventory',
    'sidebar.awsInventory.sub':         'Resource Documentation',
    'sidebar.awsCloudTrail':            'AWS CloudTrail',
    'sidebar.awsCloudTrail.sub':        'Activity & Audit Log',
    'sidebar.solman':                   'SAP Solman',
    'sidebar.solman.sub':               'Ticket & Incident',
    'sidebar.sapUsage':                 'SAP User Usage',
    'sidebar.sapUsage.sub':             'Utilization',
    'sidebar.employeeOvertime':         'Employee Overtime',
    'sidebar.employeeOvertime.sub':     'Overtime Data',
    'sidebar.logs':                     'Activity Log',
    'sidebar.logs.sub':                 'Audit Trail',
    'sidebar.aiHistory':                'AI Chat History',
    'sidebar.aiHistory.sub':            'AI Conversations',
    'sidebar.aiDataSources':            'AI Data Sources',
    'sidebar.aiDataSources.sub':        'Kelola Data AI',
    'sidebar.aiConfig':                 'AI Configuration',
    'sidebar.aiConfig.sub':             'Provider, model & API key',
    'sidebar.aiWorkspace':              'AI Workspace',
    'sidebar.aiWorkspace.sub':          'Chat AI halaman penuh',
    'sidebar.aiCoding':                 'AI Coding',
    'sidebar.aiCoding.sub':             'Asisten coding + tool use',
    // ── AI Coding · pemilih root proyek ──────────────────────────────────
    'aiCoding.sbx.open':            'Sandbox kode (.zip)',
    'aiCoding.sbx.title':           'Sandbox kode',
    'aiCoding.sbx.upload':          'Unggah .zip',
    'aiCoding.sbx.close':           'Tutup',
    'aiCoding.sbx.delete':          'Hapus sandbox ini',
    'aiCoding.sbx.empty':           'Belum ada sandbox. Unggah .zip berisi kode yang ingin diperiksa.',
    'aiCoding.sbx.done':            'Sandbox "{label}" siap — {files} berkas. Pilih di Project root untuk mulai memeriksanya.',
    'aiCoding.sbx.truncated':       'sebagian dipotong karena melewati batas',
    'aiCoding.sbx.skipped':         'dilewati:',
    'aiCoding.sbx.limits':          'Hanya berkas sumber yang diekstrak; node_modules, .git, binary, dan berkas berpotensi kredensial dilewati. Batas {mb} MB / {files} berkas. Sandbox dihapus otomatis setelah {days} hari.',
    'aiCoding.sbx.noPython':        'Ekstraksi belum aktif: AI_SANDBOX_PYTHON / PDF2MD_PYTHON belum diatur di ecosystem.config.js.',
    'aiCoding.sbx.docDone':         'Dokumen "{name}" tersimpan. Sebut namanya di prompt, mis. "baca {name} lalu kerjakan ...".',
    'aiCoding.sbx.docDelete':       'Hapus dokumen ini',
    'aiCoding.sbx.docHint':         'Dokumen instruksi (.md / .txt, maks {kb} KB) disimpan langsung di {root} dan dipanggil dengan namanya saja. Tidak ikut terhapus otomatis.',
    'aiCoding.dft.open':            'Draft hasil AI',
    'aiCoding.dft.title':           'Draft hasil AI',
    'aiCoding.dft.refresh':         'Muat ulang',
    'aiCoding.dft.download':        'Unduh berkas ini',
    'aiCoding.dft.delete':          'Hapus draft ini',
    'aiCoding.dft.empty':           'Belum ada draft. Minta AI membuat berkas, mis. "buat file x.py ... lalu simpan".',
    'aiCoding.dft.missing':         'Direktori draft belum ada. Wajar bila write_file belum pernah dipakai — tapi bisa juga berarti root di dashboard berbeda dari yang dipakai ai-service.',
    'aiCoding.dft.blocked':         'Berkas ini tidak boleh diunduh (berpotensi memuat kredensial). Masih bisa dihapus.',
    'aiCoding.projectRoot':             'Root proyek',
    'aiCoding.rootHint':                'read_file & grep_code dibatasi pada root ini',
    'aiCoding.rootUnavailable':         'Daftar root proyek tidak bisa dimuat',
    // AI Settings (Konfigurasi AI)
    'ai.set.title':            'Konfigurasi AI',
    'ai.set.subtitle':         'Provider & API key per user · prompt per dashboard',
    'ai.set.provider':         'AI Provider',
    'ai.set.apiKey':           'API Key',
    'ai.set.noKey':            'No Key',
    'ai.set.baseUrl':          'Base URL / Endpoint',
    'ai.set.baseUrlHintPre':   'Tanpa',
    'ai.set.baseUrlHintPost':  '— ditambahkan otomatis.',
    'ai.set.fetching':         'Fetching...',
    'ai.set.fetchModels':      'Fetch Models',
    'ai.set.modelsFound':      '{n} model ditemukan',
    'ai.set.noModelsFound':    'Tidak ada model yang ditemukan.',
    'ai.set.fetchModelFailed': 'Gagal fetch model.',
    'ai.set.bedrockRegionHint':'Region tempat model Bedrock diaktifkan (mis. us-east-1, ap-southeast-1).',
    'ai.set.bedrockCredHint':  'Kredensial opsional — kosongkan untuk memakai IAM role / environment server (cara teraman, sama seperti integrasi Cost Explorer). Isi hanya jika ingin kredensial khusus.',
    'ai.set.optional':         'AKIA... (opsional)',
    'ai.set.hide':             'Sembunyikan',
    'ai.set.show':             'Tampilkan',
    'ai.set.params':           'Parameter Generasi',
    'ai.set.resetDefault':     'Reset default',
    'ai.set.preset':           'Preset',
    'ai.set.presetPrecise':    'Presisi',
    'ai.set.presetPreciseDesc':'Akurat & konsisten',
    'ai.set.presetBalanced':   'Seimbang',
    'ai.set.presetBalancedDesc':'Default umum',
    'ai.set.presetCreative':   'Kreatif',
    'ai.set.presetCreativeDesc':'Variatif',
    'ai.set.tempLow':          '0 · Presisi/konsisten',
    'ai.set.tempHigh':         '2 · Kreatif/variatif',
    'ai.set.tempHint':         'Untuk Q&A data yang akurat, gunakan 0,1–0,2. Nilai tinggi membuat jawaban lebih bervariasi dan rawan mengarang.',
    'ai.set.topPHint':         'Biarkan 1,0 saat temperature sudah rendah. Sebaiknya atur salah satu saja (temperature ATAU Top P), bukan keduanya sekaligus.',
    'ai.set.maxTokens':        'Max Tokens (panjang jawaban)',
    'ai.set.maxTokensHint':    'Rentang 100–8000. Default 2000.',
    'ai.set.chart':            'Grafik / Chart',
    'ai.set.chartAuto':        'Otomatis — AI membuat grafik bila relevan',
    'ai.set.chartManual':      'Hanya saat diminta — grafik dibuat jika diminta user',
    'ai.set.chartHint':        '"Hanya saat diminta": AI tidak membuat chart kecuali kamu memintanya (mis. "buat grafik").',
    'ai.set.hideAccuracy':     'Sembunyikan skor akurasi',
    'ai.set.hideAccuracyHint': 'Sembunyikan badge "Accuracy %" pada jawaban & ringkasan sesi. Skor ini hanya perkiraan heuristik, bukan ukuran kebenaran.',
    'ai.set.followUp':         'Follow-up (chart/insight dari hasil sebelumnya)',
    'ai.set.followUpOn':       'Aktif',
    'ai.set.followUpOff':      'Nonaktif',
    'ai.set.followUpHint':     'Bila aktif, permintaan seperti "buatkan chart dari itu" atau "insight" memakai hasil query terakhir tanpa query ulang.',
    'ai.edit.resend':          'Kirim ulang',
    'ai.set.advanced':         'Lanjutan (penalti & seed)',
    'ai.set.penaltyHint':      'Untuk Q&A data, biarkan keduanya di 0 — penalti dapat menghalangi pengulangan angka/label yang justru diperlukan.',
    'ai.set.seed':             'Seed (reproducibility)',
    'ai.set.seedPlaceholder':  'Kosong = acak setiap kali',
    'ai.set.seedHint':         'Isi angka tetap (mis. 42) + temperature rendah → jawaban lebih reproducible. Tidak didukung semua provider.',
    'ai.set.configured':       'dikonfigurasi',
    'ai.set.autoRotateLong':   'rotasi otomatis',
    'ai.set.notConfigured':    'Belum dikonfigurasi',
    'ai.set.copyFirstKey':     'Copy key pertama',
    'ai.set.keysPlaceholder':  '(pisahkan dengan koma atau baris baru untuk rotasi otomatis)',
    'ai.set.keyInfoSingle':    'Tersimpan di database per user. Masukkan beberapa key dipisah koma/Enter untuk rotasi otomatis saat rate limit.',
    'ai.set.keyInfoMulti':     '{n} key aktif — otomatis rotasi ke key berikutnya saat key manapun kena rate limit atau expired.',
    'ai.set.promptGeneral':    '(umum — buka di dalam dashboard untuk prompt spesifik)',
    'ai.set.default':          'Default',
    'ai.set.reset':            'Reset',
    'ai.set.promptPlaceholder':'Masukkan instruksi khusus untuk AI assistant di dashboard ini...',
    'ai.set.promptScope':      'Prompt ini khusus untuk dashboard {dash} dan akun {user}.',
    'ai.set.add':              'Tambah',
    'ai.set.resetDefaultShort':'Reset (pakai default)',
    'ai.set.quickPromptHint':  'Kosong = pakai prompt bawaan. Tersimpan per dashboard + user.',
    'ai.set.clearAll':         'Kosongkan',
    'ai.set.quickPromptCleared':'Dikosongkan — tidak ada quick prompt yang tampil di chat.',
    'ai.set.cancel':           'Batal',
    'ai.set.saving':           'Menyimpan...',
    'ai.set.saved':            'Tersimpan!',
    'ai.set.save':             'Simpan Konfigurasi',
    'ai.set.savedLocal':       'Tersimpan lokal. Server:',
    'sidebar.users':                    'User Management',
    'sidebar.users.sub':                'Manage Users',
    'sidebar.roles':                    'Role Management',
    'sidebar.roles.sub':                'Manage Roles',
    'sidebar.monthlyReport':            'Periodic Report',
    'sidebar.monthlyReport.sub':        'Laporan bulanan & trimester',
    'mreport.title':                    'Periodic Report',
    'mreport.subtitle':                 'Jadwal, konfigurasi, dan pengiriman laporan berkala (bulanan & trimester)',
    'mreport.loading':              'Memuat konfigurasi…',
    'mreport.switches.title':       'Dua saklar terpisah.',
    'mreport.switches.body':        'Kotak "Enable" di atas mengatur apakah jadwalnya jalan. Kotak "Aktifkan pengiriman otomatis" di bawah mengatur apakah laporan benar-benar dikirim saat cron memanggil. Keduanya harus aktif untuk pengiriman otomatis. Tombol "Run Now" dan "Kirim sekarang" memakai trigger manual, jadi tetap jalan walau saklar kedua mati.',
    'mreport.config':               'Konfigurasi',
    'mreport.enableAuto':           'Aktifkan pengiriman otomatis (saat cron memanggil)',
    'mreport.resendEvery':          'Kirim ulang setiap cron jalan (lewati cek sekali-per-periode)',
    'mreport.resendEveryHint':      'Jika aktif, setiap jadwal cron mengirim report periode terakhir yang sudah tutup meskipun sudah pernah terkirim. Jika mati, satu periode hanya dikirim sekali.',
    'mreport.to':                   'Penerima (To)',
    'mreport.to.ph':                'nama@perusahaan.com, lain@perusahaan.com',
    'mreport.to.hint':              'Boleh lebih dari satu alamat, dipisah koma. Kosong = pakai env MONTHLY_REPORT_TO. SMTP (host/auth/from) diambil dari tab ASE Alert.',
    'mreport.cc':                   'CC (opsional)',
    'mreport.cc.ph':                'cc1@perusahaan.com, cc2@perusahaan.com',
    'mreport.bcc':                  'BCC (opsional)',
    'mreport.bcc.ph':               'bcc@perusahaan.com',
    'mreport.ccbcc.hint':           'CC/BCC berlaku per profil laporan ini saja. Kosong = pakai env MONTHLY_REPORT_CC / MONTHLY_REPORT_BCC bila diset. Alamat BCC tidak terlihat oleh penerima lain.',
    'mreport.senderName':           'Nama pengirim (display name)',
    'mreport.senderName.hint':      'Nama yang tampil di kolom From penerima, mis. "PIL Group IT — SAP". Kosong = Primary Dashboard. Alamat email pengirim sendiri diambil dari smtp_from di tab ASE Alert dan tidak diatur per profil.',
    'mreport.modules':              'Modul yang disertakan',
    'mreport.body':                 'Sertakan isi laporan di badan email',
    'mreport.body.hint':            'Matikan untuk mode surat pengantar: email hanya berisi kalimat pengantar, judul, dan lampiran .xlsx — tanpa tabel, chart, maupun ringkasan AI. Data tetap dikumpulkan lengkap dan lampirannya tidak berubah sedikit pun; yang dilewati hanya penyajiannya di badan email.',
    'mreport.body.warn':            'Badan email mati. Penerima hanya akan melihat pengantar, judul, dan lampiran. Chart tidak dirender, dan panggilan AI dilewati sepenuhnya (tidak ada biaya token untuk profil ini).',
    'mreport.body.warnNoIntro':     'Pengantar juga masih kosong — email akan nyaris tanpa teks. Isi kalimat pengantar di bawah.',
    'mreport.layout.bodyOff':       'Dengan badan email dimatikan, kedua setelan ini hanya mempengaruhi pengantar dan judul.',
    'mreport.layout':               'Tampilan email',
    'mreport.layout.scale':         'Ukuran teks',
    'mreport.layout.scale.compact': 'Padat — ukuran lama (tabel 12px)',
    'mreport.layout.scale.normal':  'Normal — disarankan (tabel 13px)',
    'mreport.layout.scale.large':   'Besar — untuk manajemen (tabel 14px)',
    'mreport.layout.width':         'Lebar isi',
    'mreport.layout.hint':          'Klien email tidak punya zoom yang bisa diandalkan (Outlook desktop merender lewat mesin Word), jadi ukuran harus dipilih di sisi pengirim dan berlaku sama untuk semua penerima profil ini. Lebar 900px adalah default: tabel yang hanya 2-3 kolom direntang 1100px membuat angkanya berjarak jauh dari labelnya. Tabel sempit kini juga dibatasi lebarnya mengikuti jumlah kolom, jadi tepi kanannya tidak rata dengan tabel lebar — itu disengaja.',
    'mreport.intro':                'Kalimat pengantar (di atas judul)',
    'mreport.intro.ph':             'Yth. Bapak/Ibu,\n\nBerikut laporan {{profile}} untuk periode {{period}}. Rincian lengkapnya ada pada lampiran.',
    'mreport.intro.hint':           'Muncul di badan email SEBELUM judul, seperti surat pengantar — berbeda dari sub-judul yang tampil di bawah judul. Kosong = tidak ada blok pengantar sama sekali. Satu enter = baris baru yang rapat; baris kosong = paragraf baru. Format: **tebal**, *miring*, __garis bawah__, `kode` — pakai tombol di atas, tidak perlu mengetik penandanya. Token yang tersedia: {{period}}, {{title}}, {{profile}}, {{generated}} — pakai token ini, jangan ketik nama bulan langsung, karena laporan dikirim otomatis tiap bulan. HTML tidak didukung dan akan tampil sebagai teks biasa. Maksimal 4000 karakter.',
    'mreport.intro.spacing':          'Jarak baris',
    'mreport.intro.spacing.tight':    'Rapat',
    'mreport.intro.spacing.normal':   'Normal',
    'mreport.intro.spacing.relaxed':  'Longgar',
    'mreport.intro.fmt.bold':         'Tebal — **teks**',
    'mreport.intro.fmt.italic':       'Miring — *teks*',
    'mreport.intro.fmt.underline':    'Garis bawah — __teks__',
    'mreport.intro.fmt.code':          'Kode inline — `teks`, dipakai untuk nama kolom/tabel/file agar tidak diproses sebagai bold/italic',
    'mreport.intro.fmt.numbered':     'Daftar bernomor — beri nomor pada baris yang diblok',
    'mreport.intro.fmt.bullet':       'Daftar butir — beri tanda • pada baris yang diblok',
    'mreport.intro.fmt.clear':        'Hapus format pada seleksi (atau seluruh teks bila tidak ada yang diblok)',
    'mreport.intro.preview':          'Pratinjau',
    'mreport.intro.previewEmpty':     'Pengantar masih kosong.',
    'mreport.intro.previewNote':      'Perkiraan tampilan di email. Huruf sebenarnya mengikuti Ukuran teks profil ini; untuk hasil persis, pakai tombol Preview di bawah.',
    'mreport.header':               'Judul & header laporan',
    'mreport.header.titlePh':       'IT Operations Monthly Report',
    'mreport.header.subtitlePh':    'Sub-judul (opsional)',
    'mreport.header.preparedPh':    'Disiapkan oleh (mis. Taufan / IT)',
    'mreport.header.hint':          'Judul juga dipakai sebagai subjek email dan judul sheet Cover.',
    'mreport.ai.enable':            'Sertakan ringkasan eksekutif dari AI',
    'mreport.ai.providerPh':        'provider (kosong = global)',
    'mreport.ai.modelPh':           'model (kosong = default provider)',
    'mreport.ai.warn':              'Angka tidak pernah dihitung oleh AI — semuanya dari database, dan model hanya merangkai kalimat. Yang masih bisa dikarang adalah SEBAB-nya, jadi seksinya selalu diberi label "generated by AI" dan perlu Anda periksa sebelum diteruskan. Bila panggilan AI gagal, seksinya dihilangkan dan laporan tetap terkirim.',
    'mreport.save':                 'Simpan konfigurasi',
    'mreport.saving':               'Menyimpan…',
    'mreport.saved':                'Konfigurasi disimpan.',
    'mreport.lastSent':             'Terakhir dikirim',
    'mreport.status':               'status',
    'mreport.test':                 'Uji manual',
    'mreport.year':                 'Tahun (opsional)',
    'mreport.month':                'Bulan (opsional)',
    'mreport.preview':              'Preview (tanpa kirim)',
    'mreport.preview.busy':         'Menyusun…',
    'mreport.xlsx':                 'Unduh lampiran .xlsx',
    'mreport.xlsx.busy':            'Menyiapkan…',
    'mreport.xlsx.done':            'Lampiran diunduh: {name}',
    'mreport.send':                 'Kirim sekarang',
    'mreport.send.busy':            'Mengirim…',
    'mreport.test.hint':            'Kosongkan tahun/bulan untuk memakai bulan terakhir yang sudah tutup. Jangan memilih bulan yang masih berjalan — perbandingan MoM-nya selalu menyesatkan.',
    'mreport.sendConfirm':          'Kirim laporan bulanan sekarang ke {to}? Email sungguhan akan terkirim.',
    'mreport.runConfirm':           'Jalankan laporan bulanan {type} sekarang? Email sungguhan akan terkirim.',
    'mreport.empty':                '(kosong)',
    'mreport.sentOk':               'Terkirim: {period} ke {to} (lampiran {size}).',
    'mreport.notSent':              'Tidak terkirim: {reason}',
    'mreport.skipped':              'Dilewati: {reason}',
    'mreport.previewCard':          'Preview',
    'mreport.period':               'Periode',
    'mreport.subject':              'Subjek',
    'mreport.attachment':           'Lampiran',
    'mreport.profile':              'Profil',
    'mreport.cronJob':              'job cron',
    'mreport.lastSentShort':        'terakhir dikirim',
    'mreport.schedOn':              'Jadwal aktif',
    'mreport.schedOff':             'Jadwal mati',
        'mreport.mod.sapUsage':         'SAP User Utilisation',
    'mreport.tab.sap.hint':         'Solman + SAP User Utilisation + Licenses',
    'mreport.tab.sapusage.hint': 'Laporan SAP User Usage per trimester/bulan/tahun — unduh .xlsx',
    'mreport.mod.sapLicenses':      'SAP Licences (snapshot)',
    'mreport.sapLic.conn':          'Koneksi SAP untuk seksi lisensi (landscape / SID / client)',
    'mreport.sapLic.hint':          'Diambil dari snapshot halaman SAP User Maintenance untuk koneksi ini — bukan data bulanan. Tabel itu hanya terisi ulang saat "Load Users" ditekan (tidak ada cron), jadi email menampilkan tanggal snapshot dan memberi peringatan bila usianya lebih dari 30 hari. Hanya user aktif; lisensi 91 (test/technical) dan akun kedaluwarsa dikecualikan. Email hanya memuat totalnya; rinciannya di sheet SAP_Licenses pada lampiran.',
    'mreport.charts':               'Sertakan grafik di email',
    'mreport.charts.hint':          'Jenis grafik dipilih otomatis dari bentuk datanya: pie/donat untuk komposisi, bar untuk peringkat dan perbandingan, kolom untuk deret waktu. Grafik selalu mendampingi tabel, tidak menggantikannya. Hanya pie/donat yang berupa gambar; sisanya HTML biasa. Lampiran .xlsx tidak terpengaruh.',
    'mreport.tab.infra.hint':       'M365 + SDP Cloud',
    'mreport.tab.aws.hint':         'Biaya AWS saja',
    'mreport.tab.s3.hint':          'Storage S3 & media backup SAP',
    'mreport.tab.exec.hint':        'Gabungan semua modul — untuk manajemen',
    'sidebar.tableMaintenance':         'Table Maintenance',
    'sidebar.tableMaintenance.sub':     'DB Admin',
    'sidebar.telegram':                 'Telegram Bot',
    'sidebar.telegram.sub':             'Notifikasi & AI Chat',
    'sidebar.telegramLog':              'Telegram Chat Log',
    'sidebar.telegramLog.sub':          'Riwayat percakapan bot',
    'sidebar.sessions':                 'Session Log',
    'sidebar.sessions.sub':             'Sesi aktif & force-logout',

    // ── Sidebar: kontrol bawah ──
    'sidebar.collapse':         'Ciutkan',
    'sidebar.expand':           'Lebarkan sidebar',
    'sidebar.autoHide':         'Auto-hide',
    'sidebar.autoHide.on':      'Aktif',
    'sidebar.autoHide.off':     'Nonaktif',

    // ── Overview ──
    'overview.systemOnline':   'Sistem Online',
    'overview.systemOffline':  'Sistem Offline',
    'overview.someUnavailable':'Sebagian sistem tidak tersedia',
    'overview.welcome':        'Selamat Datang, {name}!',
    'overview.accessInfo':     'Anda memiliki akses ke {count} dashboard. Pilih dashboard di bawah untuk memulai.',
    'overview.accessInfoBold': '{count} dashboard',
    'overview.allNormal':      'Semua sistem normal',
    'theme.label':             'Tema Warna',
    'theme.blue':              'Biru',
    'theme.indigo':            'Indigo',
    'theme.teal':              'Tosca',
    'theme.emerald':           'Hijau',
    'theme.violet':            'Ungu',
    'theme.amber':             'Kuning Amber',
    'theme.rose':              'Merah Mawar',
    'theme.black':             'Hitam',
    'fontScale.label':         'Ukuran Font',
    'fontScale.sm':            'Kecil',
    'fontScale.md':            'Normal',
    'fontScale.lg':            'Besar',
    'overview.statDashboards': 'dashboard',
    'overview.statCategories': 'kategori',
    'overview.realtime':       'Data real-time',
    'overview.available':      'Dashboard Tersedia',
    'overview.clickHint':      'Klik kartu di bawah untuk membuka dashboard yang sesuai.',
    'overview.openDashboard':  'Buka Dashboard',
    'overview.footer':         'Primary Dashboard v1.0 · Data diperbarui secara otomatis',

    // ── Overview: kartu dashboard (desc + stat label) ──
    'overview.card.awsBilling.desc':   'Monitoring biaya dan penggunaan layanan AWS secara real-time.',
    'overview.card.awsBilling.stat':   'Periode',
    'overview.card.awsCost.desc':      'Analisis mendalam pengeluaran dan tren biaya AWS.',
    'overview.card.awsCost.stat':      'Tahun',
    'overview.card.solman.desc':       'Tracking tiket insiden dan service request SAP.',
    'overview.card.solman.stat':       'Tiket Open',
    'overview.card.sdp.desc':          'Ticketing & asset dari ManageEngine ServiceDesk Plus Cloud.',
    'overview.card.sdp.stat':          'Tiket Terbuka',
    'overview.card.sapUsage.desc':     'Analisis penggunaan dan aktivitas user di sistem SAP.',
    'overview.card.sapUsage.stat':     'Baris Data',
    'overview.card.sapUserMgmt.desc':  'Kelola user SAP dialog — lock, unlock, dan reset password.',
    'overview.card.sapUserMgmt.stat':  'Sistem Siap',
    'overview.card.awsInventory.desc': 'Inventaris sumber daya AWS lintas region.',
    'overview.card.awsInventory.stat': 'Resource',
    'overview.card.awsCloudTrail.desc':'Jejak aktivitas & audit API AWS.',
    'overview.card.awsCloudTrail.stat':'Event',
    'overview.card.employeeOvertime.desc':'Data lembur karyawan per perusahaan, bagian & grade.',
    'overview.card.employeeOvertime.stat':'Lembur',
    'overview.card.aiWorkspace.desc':'Chat AI halaman penuh — pilih dashboard untuk dianalisis.',
    'overview.card.aiWorkspace.stat':'AI',
    'overview.card.tableMaintenance.desc': 'Kelola data tabel dashboard — upload, hapus, dan maintenance data.',
    'overview.card.tableMaintenance.stat': 'Admin',
    'overview.card.logViewer.desc':        'Monitor log aktivitas pengguna dan sistem secara real-time.',
    'overview.card.logViewer.stat':        'Admin',
    'overview.card.sessionLog.desc':       'Pantau sesi login aktif dan riwayat akses pengguna.',
    'overview.card.sessionLog.stat':       'Admin',
    'overview.card.shareLinks.desc':       'Buat dan kelola link publik hanya-baca untuk berbagi dashboard.',
    'overview.card.shareLinks.stat':       'Admin',
    'overview.card.telegram.desc':         'Kelola bot Telegram untuk notifikasi dan query data dashboard.',
    'overview.card.telegram.stat':         'Admin',
    'overview.card.telegramLog.desc':      'Riwayat percakapan dan interaksi pengguna dengan bot Telegram.',
    'overview.card.telegramLog.stat':      'Admin',
    'overview.card.userMgmt.desc':         'Kelola akun pengguna, password, dan hak akses dashboard.',
    'overview.card.userMgmt.stat':         'Admin',
    'overview.card.roleMgmt.desc':         'Konfigurasi role dan kumpulan permission untuk kontrol akses.',
    'overview.card.roleMgmt.stat':         'Admin',
    'overview.card.sapBasisMon.desc':      'Pantau kesehatan SAP Basis — job, lock, work process & sistem.',
    'overview.card.sapBasisMon.stat':      'Koneksi',
    // Pencarian & kunjungan terakhir
    'overview.search.placeholder':   'Cari dashboard…',
    'overview.search.noResults':     'Dashboard tidak ditemukan',
    'overview.search.noResultsHint': 'Tidak ada yang cocok dengan kata kunci Anda.',
    'overview.search.resultCount':   'hasil',
    'overview.recent.title':         'Baru Dikunjungi',

    // ── AI Chat ──
    'ai.assistant':        'AI Assistant',
    'ai.exportPdf':        'Export ke PDF',
    'ai.export':           'Export chat',
    'ai.newSession':       'Mulai sesi baru',
    'ai.settings':         'Pengaturan',
    'ai.noData':           'Belum ada data',
    'ai.records':          'records',
    'ai.notConfigured':    'Konfigurasi AI belum lengkap',
    'ai.openSettings':     'Buka Pengaturan',
    'ai.notConfiguredAdmin': 'Hubungi pengelola AI untuk mengatur konfigurasi.',
    'ai.quickData':        'Analisis data aktual',
    'ai.quick':            'Pertanyaan cepat',
    'ai.analyzing':        'Menganalisis data...',
    'ai.placeholder':      'Ketik pertanyaan... (Enter kirim)',
    'ai.placeholderConfig':'Konfigurasi AI dulu...',
    'ai.inputHint':        'Shift+Enter baris baru · export PDF · history tersimpan otomatis',
    'ai.copy':             'Salin',
    'ai.copied':           'Disalin!',
    'ai.dataAvailable':    'Data aktual tersedia — jawaban berdasarkan data nyata',
    'ai.dataSourceTitle':  'Sumber data AI',
    'ai.session':          'Session',
    'ai.avg':              'Avg',
    'ai.accuracy':         'Akurasi',
    'ai.accuracyHigh':     'Tinggi',
    'ai.accuracyMed':      'Sedang',
    'ai.accuracyLow':      'Rendah',
    'ai.filter':           'Filter',
    'ai.tokens':           'tokens',
    'ai.sources':          'Sumber',
    'ai.openNote':         'Buka note · Relevansi',
    'ai.viewSource':       'Lihat isi sumber',
    'ai.kbRelevance':      'Relevansi',
    'ai.kbChunkHint':      'Ini potongan teks yang dibaca AI saat menyusun jawaban — bukan seluruh dokumen.',
    'ai.kbTruncated':      'Hanya cuplikan yang tersimpan untuk chat lama; buka ulang pertanyaan untuk melihat teks utuh.',
    'ai.kbOpenNote':       'Buka note asli',
    'ai.kbOpenDashboard':  'Buka di dashboard',
    'ai.untitled':         '(tanpa judul)',
    'ai.srcRag':           '📚 Basis Pengetahuan (RAG)',
    'ai.srcSql':           '🗄️ Text-to-SQL',
    'ai.srcChat':          '💬 AI Service',
    'ai.srcSqliteSql':     '🗄️ SQLite (text-to-SQL)',
    'ai.srcSqliteLive':    '🗄️ SQLite DB (real-time)',
    'ai.srcNone':          '⚠️ Tidak ada data source',
    'ai.autoDetected':     'Terdeteksi otomatis',
    'ai.grpFlat':          '☰ Tampilkan datar',
    'ai.grpBy':            '⊞ Kelompokkan per',
    'ai.grpEmpty':         '(kosong)',
    'ai.skipTyping':       'Klik untuk tampilkan penuh',
    'ai.cmdHelp':          '**Perintah yang tersedia:**\n- `/clear` (alias `/new`, `/reset`) — mulai sesi baru & reset konteks percakapan\n- `/sql` — tampilkan SQL query dari jawaban data terakhir\n- `/examples` — tampilkan contoh pertanyaan untuk dashboard ini\n- `/help` — tampilkan daftar perintah ini',
    'ai.cmdSqlLabel':      'SQL dari jawaban data terakhir:',
    'ai.cmdNoSql':         'Belum ada query data di sesi ini. Ajukan pertanyaan data dulu, lalu ketik `/sql`.',
    'ai.cmdExamples':      '**Contoh pertanyaan:**',
    'ai.cmdNoExamples':    'Tidak ada contoh khusus untuk dashboard ini. Ketik pertanyaan data Anda langsung.',
    'ai.cmdUnknownPre':    'Perintah',
    'ai.cmdUnknownPost':   'tidak dikenal. Ketik `/help` untuk daftar perintah.',

    // ── AWS Billing Dashboard ──
    'awsb.dashTitle':       'AWS Billing Dashboard',
    'awsb.account':         'Akun',
    'awsb.loading':         'Memuat data billing dari SQLite…',
    'awsb.retry':           'Coba Lagi',
    'awsb.backendHint':     'Pastikan backend berjalan:',
    'awsb.uploadTitle':     'Upload CSV / JSON',
    'awsb.overrideHint1':   'Mengupload file akan',
    'awsb.override':        'menimpa',
    'awsb.overrideHint2':   'tampilan dashboard dengan data CSV. Database SQLite tidak terpengaruh kecuali Anda klik',
    'awsb.backToSqlite':    'Kembali ke SQLite',
    'awsb.saveToDbBtn':     'Simpan ke DB',
    'awsb.savedToDb':       'Tersimpan ke DB',
    'awsb.adminOnly':       'Hanya admin yang bisa upload file CSV/JSON',
    'awsb.uploadHintTitle': 'Upload data billing CSV atau JSON',
    'awsb.uploadBtn':       'Upload CSV / JSON',
    'awsb.rows':            'baris',
    'awsb.periodsParen':    'periode',
    'awsb.reload':          'Muat Ulang',
    'awsb.year':            'Tahun',
    'awsb.selected':        'dipilih —',
    'awsb.clear':           'Bersihkan',
    'awsb.holdCtrl1':       'Tahan',
    'awsb.holdCtrl2':       'untuk pilih beberapa',
    'awsb.all':             'Semua',
    'awsb.periodsWord':     'periode',
    'awsb.billingPeriods':  'Periode Billing',
    'awsb.allPeriods':      'Semua',
    'awsb.comparing':       '✓ Membandingkan vs sebelumnya',
    'awsb.compareVsPrev':   '⇄ Bandingkan vs periode sebelumnya',
    'awsb.compareBanner':   '📊 Membandingkan dengan periode sebelumnya:',
    'awsb.trendTitle':      'Tren total biaya antar periode',
    'awsb.filter':          'Filter:',
    'awsb.allTaxTypes':     'Semua jenis pajak',
    'awsb.searchService':   'Cari service…',
    'awsb.sortTotal':       'Urut: total biaya',
    'awsb.sortPretax':      'Urut: biaya sebelum pajak',
    'awsb.sortTax':         'Urut: pajak',
    'awsb.sortName':        'Urut: nama',
    'awsb.costBeforeTax':   'Biaya sebelum pajak',
    'awsb.taxAmount':       'Jumlah pajak',
    'awsb.totalInvoice':    'Total tagihan',
    'awsb.inclTaxes':       'Termasuk semua pajak',
    'awsb.creditsApplied':  'Kredit diterapkan',
    'awsb.services':        'service',
    'awsb.periodWord':      'Periode',
    'awsb.allPeriodsWord':  'Semua periode',
    'awsb.none':            'Tidak ada',
    'awsb.costByService':   'Biaya per service',
    'awsb.topUsageTypes':   'Usage type teratas',
    'awsb.noUsageData':     'Tidak ada data usage type.',
    'awsb.breakdown':       'Rincian biaya per service',
    'awsb.showing':         'menampilkan',
    'awsb.of':              'dari',
    'awsb.service':         'Service',
    'awsb.code':            'Kode',
    'awsb.pretax':          'Sebelum pajak',
    'awsb.tax':             'Pajak',
    'awsb.total':           'Total',
    'awsb.vsPrev':          'vs periode sebelumnya',
    'awsb.share':           'Porsi',
    'awsb.ud.tabOverview':  'Ringkasan',
    'awsb.ud.tabUsage':     'Detail Usage',
    'awsb.ud.tabReport':     'Laporan',
    'header.search':         'Cari halaman',
    'header.search.recent':      'Terakhir dibuka',
    'header.search.clearRecent': 'Hapus',
    'awsb.ud.totalServices':'Total service aktif',
    'awsb.ud.totalCharges': 'Total biaya sebelum pajak',
    'awsb.ud.filterPlaceholder':'Filter berdasarkan nama service, region, atau deskripsi…',
    'awsb.ud.expandAll':    'Buka semua',
    'awsb.ud.collapseAll':  'Tutup semua',
    'awsb.ud.groupByPeriod':'Kelompokkan per periode',
    'awsb.ud.periodFilter': 'Pilih periode',
    'awsb.ud.allPeriods':   'Semua periode',
    'awsb.ud.description':  'Deskripsi',
    'awsb.ud.usageQty':     'Jumlah Usage',
    'awsb.ud.amount':       'Jumlah',
    'awsb.ud.noQtyNote':    'Data Anda tidak menyimpan kolom Usage Quantity, jadi kolom jumlah usage disembunyikan. Region diturunkan dari prefix UsageType.',
    'awsb.noMatch':         'Tidak ada service yang cocok dengan filter.',
    'awsb.new':             'baru',
    'awsb.totalWord':       'Total',
    'awsb.seller':          'Penjual',
    'awsb.periodLabel':     'Periode',
    'awsb.currency':        'Mata uang',
    'awsb.uploadedFile':    'File terupload',
    'awsb.dragDrop':        'Tarik & lepas file CSV atau JSON di sini',
    'awsb.browse':          'Pilih file',
    'awsb.saveModalTitle':  '💾 Simpan ke SQLite DB',
    'awsb.across':          'pada',
    'awsb.saveMode':        'Mode simpan',
    'awsb.append':          'Tambah',
    'awsb.appendDesc':      'Tambah baris — data lama tetap',
    'awsb.replace':         'Ganti',
    'awsb.replaceDesc':     'Timpa periode yang sama di DB',
    'awsb.saving':          'Menyimpan…',
    'awsb.saved':           'Tersimpan ✓',
    'awsb.productCode':     'Kode produk',
    'awsb.periodsDrawer':   'Periode',
    'awsb.effectiveTaxRate':'Tarif pajak efektif',
    'awsb.totalCost':       'Total biaya',
    'awsb.taxType':         'Jenis pajak',
    'awsb.credits':         'Kredit',
    'awsb.topLineItems':    'Item teratas',

    // ── AWS Cost Explorer ──
    'awsc.dashTitle':       'AWS Cost Dashboard',
    'awsc.reset':           'Reset',
    'awsc.ctrlMulti':       'Ctrl+klik multi',
    'awsc.upload':          'Upload CSV',
    'awsc.uploading':       'Mengupload...',
    'awsc.failed':          'Gagal',
    'awsc.rowsSaved':       'baris tersimpan',
    'awsc.adminOnly':       'Hanya admin yang bisa upload file CSV',
    'awsc.uploadTitle':     'Upload data billing CSV',
    'awsc.ofTotal':         'dari total',
    'awsc.allBuCombined':   'Semua business unit digabung',
    'awsc.noData':          'Tidak ada data',
    'awsc.monthlyCostByBu': 'Biaya Bulanan per BU',
    'awsc.costShareByBu':   'Porsi Biaya per BU',
    'awsc.yearlyTrend':     'Tren Biaya AWS Tahunan',
    'awsc.allocated':       'TERALOKASI',
    'awsc.shareNoTags':     'Share & No-Tags dibagi rata ke 3 BU',
    'awsc.barChart':        'Bar Chart',
    'awsc.lineChart':       'Line Chart',
    'awsc.allMonths':       'Semua Bulan',
    'awsc.inclAlloc':       'inkl. alokasi',
    'awsc.costPerBu':       'Biaya per BU (inkl. alokasi)',
    'awsc.proportion':      'Proporsi',
    'awsc.detailPerMonth':  'Detail per Bulan (Consolidated)',
    'awsc.month':           'Bulan',
    'awsc.total':           'Total',
    'awsc.grandTotal':      'Grand Total',
    'awsc.monthlyDetailByBu':'Detail Bulanan per Business Unit',
    'awsc.buLabel':         'BU:',
    'awsc.allBu':           'Semua BU',
    'awsc.monthCol':        'Bulan',
    'awsc.topProducts':     'Service Teratas',
    'awsc.monthFilter':     'Bulan:',
    'awsc.all':             'Semua',
    'awsc.productFilter':   'Service:',
    'awsc.product':         'Service',
    'awsc.usageDetail':     'Detail Usage Type',
    'awsc.usageType':       'Usage Type',
    'awsc.grandTop50':      'Grand Total (top 50)',
    'awsc.tab.overview':    'Overview',
    'awsc.tab.consolidated':'Consolidated',
    'awsc.tab.monthly':     'Monthly',
    'awsc.tab.products':    'Services',
    'awsc.tab.usage':       'Usage Detail',
    'awsc.loading':         'Memuat data dari database…',
    'awsc.empty':           'Belum ada data AWS Cost',
    'awsc.emptyHint1':      'Upload file CSV melalui tombol',
    'awsc.emptyHint2':      'di atas.',
    'awsc.requiredCols':    'Kolom wajib CSV:',

    // ── AWS Cost: tambahan (year selector, multi-year, search) ──
    'awsc.service':         'Service',
    'awsc.allYears':        'Semua',
    'awsc.searchService':   '🔍 Service / Usage Type…',
    'awsc.perYearSuffix':   '/th',
    'awsc.multiYearNote':   '{count} tahun digabung ({range}) · angka per bulan = total semua tahun, baris kedua = rata-rata/tahun',
    'awsc.tab.daily':       'Daily Usage',
    'awsc.dailyUsage':      'Rincian Harian (Hari › Service › Usage Type)',
    'awsc.dayCol':          'Hari',
    'awsc.expandAll':       'Buka semua',
    'awsc.collapseAll':     'Tutup semua',
    'awsc.dailyTreeNote':   'Klik baris untuk expand/collapse. Data lama (sebelum fitur harian) muncul di tanggal 1; upload/fetch baru terisi per hari. Tax ditempatkan di tanggal 1.',

    // ── SAP Solution Manager ──
    'solm.title':           'SAP Solution Manager',
    'solm.subtitle':        'Monitoring Tiket & Insiden SAP',
    'solm.records':         'records',
    'solm.uploadCsv':       'Upload CSV',
    'solm.uploadTitle':     'Upload file CSV',
    'solm.uploadAdminOnly': 'Hanya admin yang bisa upload CSV',
    'solm.saving':          'Menyimpan...',
    'solm.saved':           'Tersimpan',
    'solm.saveToDb':        'Simpan ke DB',
    'solm.saveToDbTitle':   'Simpan ke Database',
    'solm.saveAdminOnly':   'Hanya admin yang bisa simpan ke database',
    'solm.total':           'Total',
    'solm.open':            'Open',
    'solm.closed':          'Closed',
    'solm.incidentTickets': 'SAP Solution Manager — Tiket Insiden',
    'solm.nav.overview':    'Overview',
    'solm.nav.trends':      'Tren',
    'solm.nav.teams':       'Tim',
    'solm.nav.detail':      'Detail Tiket',
    'solm.det.sub':         'Detail tiket — mengikuti filter di atas',
    'solm.det.searchPh':    'Cari di semua kolom…',
    'solm.det.columns':     'Kolom {n}/{total}',
    'solm.det.colsAll':     'Tampilkan semua',
    'solm.det.colsDefault': 'Kembali ke default',
    'solm.det.clearFilters': 'Bersihkan {n} filter',
    'solm.det.filterPh':    'filter…',
    'solm.det.allValues':   '(semua)',
    'solm.det.perPage':     'Baris/halaman',
    'solm.det.export':      'Export Excel',
    'solm.det.showing':     'Menampilkan {from}–{to} dari {total} baris',
    'solm.det.ofFiltered':  '(dari {n} hasil filter atas)',
    'solm.det.pageOf':      'Hal. {page} / {total}',
    'solm.det.noRows':      'Tidak ada baris yang cocok. Coba longgarkan pencarian atau filter kolom.',
    'solm.det.sortHint':    'Klik untuk sort: naik / turun',
    'solm.nav.pivot':       'Tabel Pivot',
    'solm.nav.export':      'Export Excel',
    'solm.nav.aging':       'Umur Status',
    'solm.nav.report':      'Laporan Bulanan',
    'solm.export.title':      'Export ke Excel',
    'solm.export.subtitle':   'Unduh tiket per company & bulan, format sama persis dengan file laporan bulanan.',
    'solm.export.company':    'Company',
    'solm.export.month':      'Bulan',
    'solm.export.year':       'Tahun',
    'solm.export.matchCount': 'Ditemukan',
    'solm.export.button':     'Export Excel',
    'solm.export.exporting':  'Mengekspor…',
    'solm.export.done':       'Berhasil diunduh:',
    'solm.export.note':       'Nama file & urutan kolom mengikuti format laporan Solman bulanan (MM. Solman tickets Month yyyy - COMPANY). Kolom "Created On2" ditulis sbg tanggal asli, ID/Client/SAP Installation/Software Release sbg angka — sama seperti file sumber.',
    'solm.export.spButton':   'Simpan ke SharePoint',
    'solm.export.spUploading':'Menyimpan ke SharePoint…',
    'solm.export.spDone':     'Hasil upload SharePoint:',
    'solm.allCompanies':    'Semua Company',
    'solm.allTeams':        'Semua Tim (Impact)',
    'solm.year':            'TAHUN:',
    'solm.all':             'Semua',
    'solm.status':          'STATUS:',
    'solm.clear':           'Bersihkan',
    'solm.showing':         'Menampilkan',
    'solm.tickets':         'tiket',
    'solm.loading':         'Memuat data dari database...',
    'solm.loadingSub':      'Mengambil tiket dari SQLite via API',
    'solm.cantLoad':        'Tidak bisa load dari DB',
    'solm.cantLoadDesc':    'Tidak bisa konek ke server atau token tidak valid. Upload CSV manual, atau pastikan server berjalan.',
    'solm.retry':           'Coba lagi',
    'solm.dbEmpty':         'Database kosong',
    'solm.dbEmptyDesc':     'Belum ada tiket di database. Upload CSV lalu klik "Save to DB".',
    'solm.noData':          'Belum ada data',
    'solm.noDataDesc':      'Drop file CSV Solman ke sidebar di kiri, atau klik drop zone untuk browse.',
    'solm.chip1':           'KPI Overview',
    'solm.chip2':           'Tren bulanan',
    'solm.chip3':           'Beban kerja tim',
    'solm.chip4':           'Pivot status',
    'solm.chip5':           'Detail tiket',
    'solm.totalTickets':    'Total Tiket',
    'solm.withdrawn':       'Withdrawn',
    'solm.closeRate':       'Close Rate',
    'solm.ofTotal':         '% dari total',
    'solm.statusBreakdown': 'Rincian status',
    'solm.statusBreakdownSub':'Semua tiket berdasarkan status saat ini',
    'solm.ticketsByCompany':'Tiket per company',
    'solm.monthlyStacked':  'Tiket bulanan — bertumpuk per status',
    'solm.monthlyStackedSub':'Tiap bar dibagi berdasarkan field Status',
    'solm.monthStatusTable':'Tabel detail Bulan × Status',
    'solm.monthStatusSub':  'Jumlah per status per bulan — dari Created On (bulan = MM dari DD.MM.YYYY)',
    'solm.priorityDist':    'Distribusi prioritas',
    'solm.priorityDistSub': 'Tiket dikelompokkan per tingkat urgensi',
    'solm.monthlyVolume':   'Volume tiket bulanan',
    'solm.monthlyVolumeSub':'Total, Closed, dan Open dari waktu ke waktu',
    'solm.monthlyStacked2': 'Bulanan bertumpuk per status',
    'solm.monthlyStacked2Sub':'Semua 7 status per bulan',
    'solm.ticketVolPerTeam':'Volume tiket per tim',
    'solm.teamStatusMatrix':'Matriks Tim × Status',
    'solm.teamStatusMatrixSub':'Field Impact × Status — jumlah per status per tim',
    'solm.monthStatusFilter':'Bulan × Status (filter aktif)',
    'solm.monthStatusFilterSub':'Rincian bulanan semua status untuk filter aktif',
    'solm.monthStatusDetail':'Detail Bulan × Status',
    'solm.monthStatusDetailSub':'Rincian penuh per bulan dan status',
    'solm.month':           'Bulan',
    'solm.monthlySummary':  'Ringkasan bulanan',
    'solm.monthlySummarySub':'Total per bulan dengan close rate',
    'solm.uploadHeader':    'SAP Solman Dashboard',
    'solm.uploadIntro':     'Upload export CSV tiket Solman Anda untuk menelusuri tren insiden, beban kerja tim, dan rincian status per bulan.',
    'solm.dropCsv':         'Drop file CSV di sini',
    'solm.orClick':         'atau klik untuk browse — mendukung export Solman (.csv)',
    'solm.noTickets':       'Tidak ada tiket ditemukan',
    'solm.totalTicket':     'total tiket',
    'solm.close':           'Tutup',
    'solm.pivotTitle':      'Pivot: Impact × Status × Bulan',
    'solm.number':          'angka',
    'solm.totalCaps':       'TOTAL',
    'solm.allStatuses':     'Semua status',
    'solm.teamImpact':      'Tim (Impact)',
    'solm.clickAny':        'Klik angka',
    'solm.toViewDetails':   'untuk lihat detail tiket ·',
    'solm.scrollHorizontal':'scroll horizontal untuk lihat semua bulan',
    'solm.monthsWord':      'bulan',
    'solm.teamsWord':       'tim',

    // ── SAP User Utilization ──
    'sapu.loadCsvTitle':    '📂 Load CSV Data Source',
    'sapu.csvOnly':         'Hanya .csv yang didukung.',
    'sapu.noValidData':     'Tidak ada data valid.',
    'sapu.csvSuccess':      'Berhasil: {n} records dari {file}',
    'sapu.dragDrop':        'Drag & drop file CSV atau klik',
    'sapu.csvFormat':       'Format: Client, Dept., Period, User, Total, Lic., License Type, Landscape (opsional)',
    'sapu.activeLabel':     'Aktif:',
    'sapu.resetDefault':    'Reset default',
    'sapu.close':           'Tutup',
    'sapu.loading':         'Memuat data dari database...',
    'sapu.erpSystem':       'SAP ERP System',
    'sapu.title':           'User Usage Dashboard',
    'sapu.records':         'records',
    'sapu.loadCsv':         'Load CSV',
    'sapu.saving':          '⏳ Menyimpan...',
    'sapu.saveToDb':        '💾 Save to DB',
    'sapu.alreadyFromDb':   'Data dari DB (tidak perlu disave ulang)',
    'sapu.saveTitle':       'Click untuk save data ke database',
    'sapu.loadFromDb':      '🗄️ Load from DB',
    'sapu.totalHours':      'Total Hours',
    'sapu.totalUsers':      'Total Users',
    'sapu.activeUsers':     'Active Users',
    'sapu.rows':            'baris',
    'sapu.year':            'TAHUN',
    'sapu.all':             'Semua',
    'sapu.yearsSelected':   'tahun dipilih',
    'sapu.period':          'PERIODE',
    'sapu.selected':        'dipilih',
    'sapu.ctrlDeselect':    'Ctrl+klik untuk deselect / klik untuk pilih satu',
    'sapu.ctrlMulti':       'Klik untuk pilih · Ctrl+klik untuk multiselect',
    'sapu.tab.overview':    '📊 Overview',
    'sapu.tab.company':     '🏢 Per Company',
    'sapu.tab.module':      '⚙️ Per Module',
    'sapu.tab.users':       '👤 Top Users',
    'sapu.tab.table':       '📋 Tabel Data',
    'sapu.tab.pivot':       '📊 Monthly Usage',
    'sapu.hoursByCompany':  'Jam per Company',
    'sapu.hoursByModule':   'Jam per Modul',
    'sapu.usageTrend':      'Tren Usage per Company × Periode',
    'sapu.licenseTypeSplit':'Distribusi License Type',
    'sapu.moduleRanking':   'Ranking Modul (jam)',
    'sapu.module':          'MODUL',
    'sapu.allModules':      'Semua Modul',
    'sapu.hoursPerModule':  'Jam per Modul — klik bar untuk drill-down',
    'sapu.clickToSeeUsers': '👆 Klik untuk lihat users',
    'sapu.back':            '← Kembali',
    'sapu.totalUsage':      'Total Usage',
    'sapu.activeWord':      'Aktif',
    'sapu.companies':       'Company',
    'sapu.usersIn':         'Users dalam',
    'sapu.userDetail':      'Detail User —',
    'sapu.usersWord':       'pengguna',
    'sapu.ofUsers':         'dari {n} pengguna',
    'sapu.showTop':         'Tampilkan top',
    'sapu.highest':         'Highest Usage',
    'sapu.lowest':          'Lowest Usage',
    'sapu.ofMax':           '% dari max',
    'sapu.searchUserDept':  'Cari user / dept...',
    'sapu.showingLimit':    'Showing 100 dari {n} baris — gunakan filter untuk mempersempit.',
    'sapu.licenses':        'Lisensi:',
    'sapu.moduleLabel':     'MODUL:',
    'sapu.searchUser':      '🔍 Cari user...',
    // ── Employee Overtime ──
    'overtime.subtitle':        'Data lembur karyawan — {recs} total records dari {files} file sumber.',
    'overtime.tabOverview':     'Overview',
    'overtime.tabDetail':       'Overtime Detail',
    'overtime.tabPivot':        'Pivot Table',
    'overtime.pivotTitle':      '📐 Pivot: Business Unit × Bulan',
    'overtime.measure':         'Nilai:',
    'overtime.measureHours':    'Total Jam OT',
    'overtime.measureAmount':   'Total Amount',
    'overtime.measureCount':    'Jumlah Sesi',
    'overtime.rowTotal':        'Total Baris',
    'overtime.colTotal':        'Total',
    'overtime.grandTotal':      'Grand Total',
    'overtime.expandAll':       'Buka Semua',
    'overtime.collapseAll':     'Tutup Semua',
    'overtime.clickSort':       'Klik untuk urutkan',
    'overtime.clickReason':     'Klik untuk breakdown per alasan',
    'overtime.reasonBreakdown': 'Breakdown per Alasan',
    'overtime.value':           'Nilai',
    'overtime.allPeriods':      'Semua Periode',
    'overtime.filter':          'Filter:',
    'overtime.allYears':        'Semua Tahun',
    'overtime.allMonths':       'Semua Bulan',
    'overtime.allBu':           'Semua BU',
    'overtime.searchPh':        '🔍 Nama, kode, dept…',
    'overtime.apply':           'Terapkan',
    'overtime.reset':           '↺ Reset',
    'overtime.totalRecords':    'Total Records',
    'overtime.businessUnits':   'Business Units',
    'overtime.periodsAvail':    'Periode Tersedia',
    'overtime.sourceFiles':     'Source Files',
    'overtime.page':            'Halaman',
    'overtime.totalHoursPer':   '📊 Total Jam OT per',
    'overtime.totalAmountPer':  '💰 Total Amount OT per {by}',
    'overtime.optDept':         'Department',
    'overtime.optSection':      'Section',
    'overtime.optBu':           'Business Unit',
    'overtime.noData':          'Tidak ada data.',
    'overtime.detailTitle':     '📋 Detail Overtime',
    'overtime.records':         '{n} records',
    'overtime.pageShort':       'Hal {p}/{tp}',
    'overtime.loadFail':        'Gagal memuat data.',
    'overtime.emptyTable':      '⏱️ Belum ada data overtime untuk filter yang dipilih.',
    'overtime.colKode':         'Kode',
    'overtime.colNama':         'Nama Karyawan',
    'overtime.colThn':          'Thn',
    'overtime.colBln':          'Bln',
    'overtime.colTgl':          'Tgl Tugas',
    'overtime.colMulai':        'Mulai',
    'overtime.colSelesai':      'Selesai',
    'overtime.colJam':          'Jam OT',
    'overtime.colTotalJam':     'Total Jam',
    'overtime.colAmount':       'Amount (Rp)',
    'overtime.colReason':       'Alasan',

    // ── Cron Scheduler (komponen bersama) ──
    'cron.title':         '⏰ Jadwal Otomatis (Cron)',
    'cron.active':        'Aktif',
    'cron.activeApply':   'Aktif (simpan untuk terapkan)',
    'cron.inactive':      'Nonaktif',
    'cron.noNodeCron':    'node-cron belum terinstall',
    'cron.enable':        'Aktifkan',
    'cron.freqDaily':     'Harian',
    'cron.freqWeekly':    'Mingguan',
    'cron.freqMonthly':   'Bulanan',
    'cron.freqCustom':    'Custom (cron)',
    'cron.dayOfMonth':    'Tanggal',
    'cron.hour':          'Jam',
    'cron.customPlaceholder': 'mis. 0 6 * * 1',
    'cron.tzLabel':       'WIB ({tz})',
    'cron.saveSchedule':  '💾 Simpan Jadwal',
    'cron.saving':        '⏳…',
    'cron.runNow':        '▶️ Jalankan Sekarang',
    'cron.runConfirmDefault': 'Jalankan job ini sekarang? Ini akan menarik data dari AWS.',
    'cron.saved':         'Tersimpan — {state}, jadwal "{schedule}" ({tz}).',
    'cron.stateActive':   'AKTIF',
    'cron.stateInactive': 'nonaktif',
    'cron.runDone':       '✅ {msg} ({n} baris)',
    'cron.runDoneDefault':'Selesai.',
    'cron.runFail':       'Gagal: {err}',
    'cron.lastRun':       'Terakhir jalan:',
    'cron.dowSun':        'Minggu',
    'cron.dowMon':        'Senin',
    'cron.dowTue':        'Selasa',
    'cron.dowWed':        'Rabu',
    'cron.dowThu':        'Kamis',
    'cron.dowFri':        'Jumat',
    'cron.dowSat':        'Sabtu',

    // ── Sybase DR Monitor ──
    'sdr.title':            'Sybase DR Monitor',
    'sdr.desc':             'Monitor Sybase ASE 16 errorlog via SSH. Satu profil = satu server + satu log file. Anomali disimpan beserta 10 baris context dan dikirim via Telegram bot sybase_dr.',
    'sdr.profilesActive':   '{n} profil aktif',
    'sdr.findingsCount':    '{n} findings',
    'sdr.forceScan':        '⚡ Force Scan (test — abaikan baseline)',
    'sdr.forceConfirm':     'Force Scan: abaikan baseline & alert SEMUA match di tail (untuk testing). Lanjut?',
    'sdr.forceDone':        'Force scan selesai — {n} anomali ditemukan ({p} profil).',
    'sdr.runConfirm':       'Jalankan scan Sybase DR sekarang?',
    // Profil
    'sdr.profilesSection':  'Profil SSH',
    'sdr.addProfile':       '+ Tambah Profil',
    'sdr.emptyProfiles':    "Belum ada profil. Klik '+ Tambah Profil' untuk mulai.",
    'sdr.colLabel':         'Label',
    'sdr.colHost':          'Host',
    'sdr.colPort':          'Port',
    'sdr.colUser':          'User',
    'sdr.colKeyFile':       'Key File',
    'sdr.colLogPath':       'Log Path',
    'sdr.colKeywords':      'Keywords',
    'sdr.colStatus':        'Status',
    'sdr.colEmail':         'Email',
    'sdr.colLastTs':        'Last TS',
    'sdr.colActions':       'Aksi',
    'sdr.kwCount':          '{n} kw',
    'sdr.active':           'Aktif',
    'sdr.inactive':         'Nonaktif',
    'sdr.emailOn':          'ON',
    'sdr.emailOff':         'OFF',
    'sdr.emailOffTitle':    'Email nonaktif',
    'sdr.baselineNone':     'Baseline belum ada',
    'sdr.tsNone':           'Belum ada',
    // Tombol aksi
    'sdr.testSsh':          '🔗 Test SSH',
    'sdr.testEmail':        '📧 Test Email',
    'sdr.reset':            '🔄 Reset',
    'sdr.clearFindings':    '🗑️ Findings',
    // Pesan aksi
    'sdr.profileSaved':     'Profil diperbarui.',
    'sdr.profileAdded':     'Profil ditambahkan.',
    'sdr.deleteConfirm':    'Hapus profil "{name}"? Semua findings juga akan dihapus.',
    'sdr.profileDeleted':   'Profil dihapus.',
    'sdr.sshOk':            '✅ SSH OK — response: {res}',
    'sdr.emailSent':        '✅ Email test terkirim ke {to}',
    'sdr.resetConfirm':     'Reset baseline profil "{name}"? Scan berikutnya akan menjadi baseline baru.',
    'sdr.resetDone':        'Baseline direset.',
    'sdr.clearConfirm':     'Hapus semua findings profil "{name}"?',
    'sdr.clearDone':        'Findings dihapus.',
    // Findings
    'sdr.findingsSection':  'Findings (100 terbaru)',
    'sdr.allProfiles':      'Semua profil',
    'sdr.noFindings':       'Tidak ada findings.',
    'sdr.colTime':          'Waktu',
    'sdr.colProfile':       'Profil',
    'sdr.colAnomaly':       'Anomali',
    'sdr.colAlert':         'Alert',
    'sdr.colDetail':        'Detail',
    'sdr.alertSent':        '✓ Terkirim',
    'sdr.alertPending':     'Pending',
    'sdr.contextBtn':       '🔍 Context',
    'sdr.contextTitle':     'Context — {time}',
    'sdr.contextProfile':   'Profil',
    'sdr.contextNone':      '(tidak ada context)',
    // Modal profil
    'sdr.modalAdd':         'Tambah Profil SSH',
    'sdr.modalEdit':        'Edit Profil SSH',
    'sdr.fLabel':           'Label (nama tampilan)',
    'sdr.fHost':            'Host / IP',
    'sdr.fPort':            'Port SSH',
    'sdr.fUser':            'SSH User',
    'sdr.fKeyFile':         'Key File (dari /dashboard/keypairs)',
    'sdr.fKeyFileHint':     'Format OpenSSH (bukan .ppk). Konversi via PuTTYgen jika perlu.',
    'sdr.fKeyFilePick':     '-- Pilih key file --',
    'sdr.fLogPath':         'Path Log File (absolut di remote server)',
    'sdr.fKeywords':        'Keywords anomali (satu per baris, tidak case-sensitive)',
    'sdr.fStatus':          'Status',
    'sdr.fActiveLabel':     'Aktif (akan di-scan oleh cron)',
    'sdr.fEmailAlert':      'Email Alert',
    'sdr.fEmailEnable':     'Kirim alert via email untuk profil ini',
    'sdr.fEmailTo':         'penerima@contoh.com (pisah koma untuk banyak)',
    'sdr.fEmailHint':       'SMTP config di-reuse dari tab ASE Alert. Pastikan SMTP host & kredensial sudah diisi di sana.',
    'sdr.saving':           'Menyimpan…',
    'sdr.save':             'Simpan',
    'sdr.cancel':           'Batal',

    // ── TAHAP 5: Table Maintenance (header & label tab) ──
    'tm.title':            'Table Maintenance',
    'tm.subtitle':         'Kelola data SQLite langsung dari dashboard — hapus, modifikasi, dan kosongkan tabel.',
    'tm.noAccess':         'Tidak ada akses ke tabel ini.',
    'tm.tab.users':        'Pengguna',
    'tm.tab.logs':         'Log Aktivitas',
    'tm.tab.tickets':      'Tiket Solman',
    'tm.tab.sap':          'Penggunaan SAP',
    'tm.tab.billing':      'AWS Billing',
    'tm.tab.aws':          'AWS Cost',
    'tm.tab.idsuim':       'ID SUIM',
    'tm.tab.uploads':      'Riwayat Upload',
    'tm.tab.sapcfg':       'Konfigurasi SAP',
    'tm.tab.notes':        'Catatan',
    'tm.tab.sql':          'SQL Editor',
    'tm.tab.database':     'Database',
    'tm.tab.overtime':     'Lembur Karyawan',
    'tm.tab.asealert':     'ASE Alert',
    'tm.tab.sybasedr':     'Sybase ASE',

    // ── ASE Alert panel ──
    'asealert.title':         'ASE Errorlog Alert',
    'asealert.tgOn':          'Telegram ON',
    'asealert.tgOff':         'Telegram OFF',
    'asealert.emailOn':       'Email ON',
    'asealert.emailOff':      'Email OFF',
    'asealert.descA':         'Pindai ASE errorlog tiap profil SAP (via command ',
    'asealert.descB':         '), cocokkan kata kunci, lalu kirim alert untuk baris baru. Run pertama tiap profil hanya baseline (tidak mengirim backlog lama).',
    'asealert.runConfirm':    'Jalankan scan ASE errorlog sekarang?',
    'asealert.kwLabel':       'Kata kunci (satu per baris, tidak case-sensitive)',
    'asealert.chTelegramA':   'Kirim ke Telegram (bot ',
    'asealert.chTelegramB':   ')',
    'asealert.chEmail':       'Kirim ke Email (SMTP)',
    'asealert.recipients':    'Penerima (pisahkan dengan koma)',
    'asealert.smtpHost':      'SMTP Host',
    'asealert.port':          'Port',
    'asealert.ssl':           'SSL/TLS (secure) — biasanya port 465',
    'asealert.smtpUser':      'SMTP User',
    'asealert.smtpPass':      'SMTP Password',
    'asealert.smtpPassSaved': '(tersimpan — isi untuk ganti)',
    'asealert.from':          'From (alamat pengirim)',
    'asealert.btnTest':       'Test Kirim',
    'asealert.msgSaved':      'Konfigurasi tersimpan.',
    'asealert.msgTest':       'Test — Telegram: {tg}, Email: {email}',

    // ── Users panel ──
    'users.rows':          '{n} baris',
    'users.addBtn':        'Tambah User',
    'users.colId':         'ID',
    'users.colUsername':   'Username',
    'users.colRole':       'Role',
    'users.colLastLogin':  'Login Terakhir',
    'users.colCreated':    'Dibuat',
    'users.empty':         'Belum ada user',
    'users.you':           '(Anda)',
    'users.deleteConfirm': 'Hapus user "{name}"?',
    'users.deleted':       'User "{name}" dihapus.',
    'users.created':       'User "{name}" dibuat.',
    'users.updated':       'User diupdate.',
    'users.modalAdd':      'Tambah User Baru',
    'users.fPassword':     'Password',
    'users.phUsername':    'min. 3 karakter',
    'users.phPassword':    'min. 6 karakter',
    'users.btnCreate':     'Buat User',
    'users.modalEdit':     'Edit: {name}',
    'users.fNewRole':      'Role baru',
    'users.fNewPw':        'Password baru (kosongkan jika tidak diubah)',

    // ── Activity Logs panel ──
    'logs.total':          '{n} total',
    'logs.searchPh':       'Cari action / username…',
    'logs.info':           'Log tidak dapat dihapus — ini adalah audit trail. Menampilkan 100 terbaru dari {n}.',
    'logs.colAction':      'Action',
    'logs.colDetail':      'Detail',
    'logs.colIp':          'IP',
    'logs.colTime':        'Waktu',
    'logs.empty':          'Tidak ada log',

    // ── Solman Tickets panel ──
    'tickets.statTotal':        'Total Tiket',
    'tickets.statSources':      'Source Files',
    'tickets.statPage':         'Halaman',
    'tickets.searchPh':         'Cari ticket ID, company, status…',
    'tickets.btnFetch':         'Fetch from Solman',
    'tickets.selectSource':     '-- Pilih source file --',
    'tickets.btnDelSource':     'Hapus Source',
    'tickets.btnClearAll':      'Kosongkan Semua',
    'tickets.pickSource':       'Pilih source file dulu.',
    'tickets.deleteSourceConfirm': 'Hapus semua tiket dari "{name}"?',
    'tickets.deleteAllConfirm': 'KOSONGKAN seluruh tabel solman_tickets ({n} tiket)? Tidak bisa dibatalkan!',
    'tickets.errFrom':          'Format "Dari" harus YYYYMMDD (contoh: 20160101).',
    'tickets.errTo':            'Format "Sampai" harus YYYYMMDD (contoh: 20160131).',
    'tickets.fetchDone':        'Selesai.',
    'tickets.fetchFail':        'Gagal fetch dari Solman.',
    'tickets.cronConfirm':      'Jalankan fetch Solman sekarang? Menarik tiket ZMIN 20230101→hari ini dari SAP dan me-REPLACE yang sudah ada (key: Ticket ID). Bisa makan waktu.',
    'tickets.spCronConfirm':    'Upload Excel tiket BULAN LALU ke SharePoint sekarang? Satu file per company (OSI/PPI/PMI/PII/PBI) ditulis ke folder tahun data, menimpa file bernama sama bila sudah ada.',
    'tickets.modalTitle':       'Fetch Tiket dari Solman',
    'tickets.fType':            'Transaction Type',
    'tickets.fFrom':            'Dari Tanggal (YYYYMMDD, kosongkan = semua)',
    'tickets.fTo':              'Sampai Tanggal (YYYYMMDD, kosongkan = semua)',
    'tickets.fetchInfo':        'Data diambil langsung dari SAP Solution Manager via RFC. Tiket yang sudah ada (ticket_id sama) akan di-skip otomatis.',
    'tickets.fetching':         'Mengambil…',
    'tickets.btnFetchNow':      'Fetch Sekarang',
    'tickets.empty':            'Belum ada tiket di solman_tickets',
    'tickets.prev':             'Sebelumnya',
    'tickets.next':             'Berikutnya',
    'tickets.pager':            'Halaman {p} dari {tp} ({a} dari {b} tiket)',

    // ── SAP Usage panel ──
    'sap.statTotal':       'Total Records',
    'sap.statPeriods':     'Periods',
    'sap.searchPh':        'Cari user, company, module…',
    'sap.delSourceConfirm':'Hapus SAP data dari "{name}"?',
    'sap.delAllConfirm':   'KOSONGKAN semua data SAP Usage? Tidak bisa dibatalkan!',
    'sap.empty':           'Belum ada data SAP Usage',
    'sap.pager':           'Halaman {p} dari {tp} ({a} dari {b} records)',

    // ── AWS Billing panel ──
    'billing.statPeriods': 'Billing Periods',
    'billing.titleRaw':    'AWS Billing Raw',
    'billing.searchPh':    'Cari product, payer, usage type…',
    'billing.period':      'Periode:',
    'billing.btnFetchAws': 'Ambil dari AWS',
    'billing.fetchConfirm':'Ambil data AWS Billing periode {period} dari Cost Explorer?\nData periode ini di tabel akan ditimpa (mode replace).',
    'billing.fetchResult': '{message} {count} baris — cost ${cost}, tax ${tax}, total ${total}.',
    'billing.delConfirm':  'KOSONGKAN semua data AWS Billing? Tidak bisa dibatalkan!',
    'billing.btnClearTable':'Kosongkan Tabel',
    'billing.empty':       'Belum ada data billing',
    'billing.monthsShort': 'Jan,Feb,Mar,Apr,Mei,Jun,Jul,Agu,Sep,Okt,Nov,Des',

    // ── AWS Cost panel ──
    'aws.statYears':       'Tahun Tersedia',
    'aws.titleRaw':        'AWS Cost Raw',
    'aws.searchPh':        'Cari usage type, product, BU…',
    'aws.from':            'Dari:',
    'aws.to':              'S/d:',
    'aws.empty':           'Belum ada data AWS Cost',
    'aws.delConfirm':      'KOSONGKAN semua data AWS Cost ({n} baris) beserta seluruh upload history? Tidak bisa dibatalkan!',
    'aws.cleared':         'Tabel AWS Cost dikosongkan.',
    'aws.invalidPeriod':   'Periode tidak valid.',
    'aws.invalidRange':    'Periode tidak valid (From > To).',
    'aws.allOutOfRange':   'Semua periode yang dipilih di luar jangkauan AWS Cost Explorer (maks 37 bulan ke belakang). Gunakan Upload CSV untuk data lama.',
    'aws.skipNote':        ' ({n} bulan di-skip — di luar jangkauan: {list})',
    'aws.fetchConfirm':    'Ambil data AWS Cost {label} dari Cost Explorer?{skip}\nSetiap bulan akan ditimpa (mode replace).',
    'aws.rangeLabel':      '{a} – {b} ({n} bulan)',
    'aws.progress':        'Mengambil {period}… ({i}/{n})',
    'aws.monthRows':       '{period}: {count} baris (${total})',
    'aws.successAll':      '✅ Berhasil {n} bulan. {summary}. Grand total ${grand}.{skip}',
    'aws.partial':         '⚠️ {ok} bulan OK, {fail} gagal. OK: {summary}. Gagal: {err}.{skip}',

    // ── SAP Config panel ──
    'sapcfg.errLandscape': 'Landscape wajib diisi.',
    'sapcfg.saved':        'Tersimpan.',
    'sapcfg.delConfirm':   'Hapus profil {name}?',
    'sapcfg.deleted':      'Dihapus.',
    'sapcfg.intro':        'Profil koneksi SAP per Landscape & Environment, tersimpan di SQLite. Password tidak ditampilkan kembali demi keamanan.',
    'sapcfg.btnAdd':       'Tambah',
    'sapcfg.empty':        'Belum ada profil.',
    'sapcfg.colUpdated':   'Diperbarui',
    'sapcfg.modalEdit':    'Edit Profil SAP',
    'sapcfg.modalAdd':     'Tambah Profil SAP',
    'sapcfg.fPwEdit':      'Password (kosongkan = tidak diubah)',
    'sapcfg.fPw':          'Password',
    'sapcfg.bapiTitle':    'BAPI Service Paths — SAP User Maintenance (opsional)',
    'sapcfg.bapiHint':     'Diisi hanya bila profil ini dipakai untuk kelola user. Ambil dari WSDL service yang dipublish di SOAMANAGER.',
    'sapcfg.saving':       'Menyimpan…',

    // ── SQL Editor panel ──
    'sql.writeOk':         '{stmt} OK — {n} baris terpengaruh.',
    'sql.readMsg':         '{n} baris{trunc}.',
    'sql.truncated':       ' (ditampilkan 1000 pertama)',
    'sql.tablesLabel':     'Tabel:',
    'sql.allowWrite':      'Izinkan tulis/DDL (UPDATE/DELETE/DROP/ALTER…)',
    'sql.running':         'Menjalankan…',
    'sql.btnRun':          'Run (Ctrl+Enter)',
    'sql.warnA':           '⚠ Mode tulis aktif — query bisa ',
    'sql.warnBold':        'mengubah/menghapus data permanen',
    'sql.warnB':           ' (mis. DELETE/DROP). Pastikan ada WHERE & backup. Semua aksi tercatat di Activity Log.',
    'sql.empty0':          'Query berhasil, 0 baris.',
    'sql.exportFail':      'Export gagal: ',

    // ── Database maintenance (Debug / Vacuum / Backup / Restore) ──
    'db.stats.title':         'Statistik Database',
    'db.stats.fileSize':      'Ukuran File',
    'db.stats.tables':        'Tabel',
    'db.stats.totalRows':     'Total Baris',
    'db.stats.pages':         'Halaman',
    'db.stats.freelist':      'Freelist',
    'db.stats.reclaimable':   'Bisa Direklamasi',
    'db.loading':             'Memuat…',
    'db.btn.refresh':         'Refresh',
    'db.btn.integrity':       'Integrity Check',
    'db.btn.integrityRunning':'Mengecek…',
    'db.btn.vacuum':          'VACUUM',
    'db.btn.vacuumRunning':   'VACUUM…',
    'db.btn.backup':          'Backup (.db)',
    'db.btn.backupRunning':   'Menyiapkan…',
    'db.btn.restore':         'Restore (.db)',
    'db.btn.restoreRunning':  'Memulihkan…',
    'db.warn.boldA':          'Restore bersifat destruktif',
    'db.warn.mid':            ' — seluruh database aktif diganti dengan file yang diunggah. Lakukan ',
    'db.warn.boldB':          'Backup',
    'db.warn.end':            ' terlebih dahulu.',
    'db.confirm.vacuum':      'Jalankan VACUUM? DB akan dikompaksi (mengunci sebentar). Lanjutkan?',
    'db.confirm.restore':     'RESTORE akan MENGGANTI SELURUH database aktif dengan isi "{name}".\nData saat ini akan hilang dan tidak bisa dibatalkan.\n\nDisarankan Backup dulu. Lanjutkan?',
    'db.alert.integrityOk':   '✅ Integrity check OK — database sehat.',
    'db.alert.integrityBad':  '⚠️ Integrity check menemukan masalah. Lihat detail di bawah.',
    'db.alert.vacuumOk':      '✅ VACUUM selesai. {before} → {after} (reklamasi {reclaimed}).',
    'db.alert.backupOk':      '✅ Backup diunduh: {name}',
    'db.alert.restoreOk':     '✅ {message} ({n} tabel).',
    'db.integrity.healthy':   'Integrity Check: Sehat',
    'db.integrity.problem':   'Integrity Check: Masalah',
    'db.integrity.fkBad':     'Foreign key bermasalah:',
    'db.integrity.ignoredA':  'temuan FK diabaikan (by-design): baris konfigurasi global',
    'db.integrity.ignoredB':  'yang sengaja tanpa induk di',

    // ── Telegram Bots (TelegramSettings) ──
    'tg.title':              'Telegram Bots',
    'tg.subtitle':           'Kelola bot terpisah per dashboard + bot notifikasi',
    'tg.loadingBots':        'Memuat bot...',
    'tg.errLoadBots':        'Gagal memuat bot: {err}',
    'tg.savedOk':            'Bot berhasil disimpan & webhook diset.',
    'tg.testText':           '✅ Test dari {name}',
    'tg.sectionConfig':      '⚙️ Konfigurasi — {name}',
    'tg.typeLabel':          'Tipe:',
    'tg.typeNotify':         'Notifikasi',
    'tg.typeQuery':          'Query/Chat',
    'tg.enableBot':          'Aktifkan Bot',
    'tg.enableBotHint':      'Bot akan merespons & menjalankan jadwal',
    'tg.botName':            'Nama Bot',
    'tg.botToken':           'Bot Token',
    'tg.tokenSet':           '✓ sudah diset',
    'tg.tokenPlaceholderSet':'•••••• (isi untuk ganti)',
    'tg.tokenPlaceholder':   'Token dari @BotFather',
    'tg.tokenHint':          'Buat bot baru via @BotFather → /newbot → copy token',
    'tg.webhookUrl':         'Webhook URL (otomatis)',
    'tg.webhookHint':        'Webhook diset otomatis saat klik Simpan.',
    'tg.saving':             'Menyimpan...',
    'tg.save':               '💾 Simpan',
    'tg.testSend':           '📨 Test Kirim',
    'tg.sectionChatIds':     '👥 Daftar Chat ID yang Diizinkan',
    'tg.chatIdsHint':        'Bot ini hanya merespons Chat ID di sini. Akses data otomatis sesuai scope bot ({scope}).',
    'tg.phName':             'Nama',
    'tg.phChatId':           'Chat ID',
    'tg.phMinYear':          'Thn min',
    'tg.addChatId':          '+ Tambah Chat ID',
    'tg.sectionAnswers':     '💬 Jawaban Bot (AI & Teks)',
    'tg.answersHint':        'Sesuaikan perilaku & teks bot ini. Kosongkan untuk pakai default. Berlaku khusus bot ini.',
    'tg.aiInstr':            'Instruksi AI (custom)',
    'tg.aiInstrPlaceholder': 'Contoh: Kamu asisten khusus SAP Basis & SAP User Management. Jawab ringkas soal kesehatan SAP (job, lock, work process, dump) dan administrasi user (lock/unlock/reset). Jangan menawarkan data AWS/Solman/Cost.',
    'tg.aiInstrHint':        'Ditambahkan ke system prompt AI sebagai "Instruksi Tambahan".',
    'tg.welcome':            'Teks Sambutan (/start) — opsional',
    'tg.welcomePlaceholder': 'Kosong = sama dengan /help',
    'tg.help':               'Teks Bantuan (/help) — opsional',
    'tg.helpPlaceholder':    'Kosong = bantuan otomatis (daftar command sesuai scope bot)',
    'tg.sectionSchedule':    '🕐 Jadwal Notifikasi',
    'tg.scheduleHintNotify': 'Bot notifikasi mengirim snapshot data terjadwal ke semua Chat ID.',
    'tg.scheduleHintQuery':  'Bot ini bisa juga kirim notifikasi terjadwal sesuai scope-nya.',
    'tg.addSchedule':        '+ Tambah Jadwal',
    'tg.saveSchedule':       '💾 Simpan Jadwal',
    'tg.sectionGuide':       '📋 Panduan Setup Multi-Bot',
    'tg.guide1':             'Buat bot terpisah di @BotFather untuk tiap dashboard (5 bot)',
    'tg.guide2':             'Pilih tab bot di atas → isi Token → Simpan (webhook auto-set)',
    'tg.guide3':             'Tambahkan Chat ID user yang boleh akses bot tersebut',
    'tg.guide4':             'User ketik /start ke bot yang relevan',
    'tg.guide5':             'Bot Notifikasi 🔔 khusus jadwal — tidak melayani chat',
    'tg.phScheduleLabel':    'Label jadwal',
    'tg.typeAll':            'Semua (scope)',
    'tg.dow0':               'Min',
    'tg.dow1':               'Sen',
    'tg.dow2':               'Sel',
    'tg.dow3':               'Rab',
    'tg.dow4':               'Kam',
    'tg.dow5':               'Jum',
    'tg.dow6':               'Sab',

    // ── Telegram Chat Log (TelegramChatLog) ──
    'tgLog.title':           'Telegram Chat Log',
    'tgLog.subtitle':        'Riwayat percakapan AI via Telegram beserta estimasi token',
    'tgLog.statTotal':       'Total Chat',
    'tgLog.statTotalToken':  'Total Token',
    'tgLog.statAvgToken':    'Rata² Token/Chat',
    'tgLog.statAvgResp':     'Rata² Respons',
    'tgLog.searchPlaceholder':'Cari pertanyaan, jawaban, atau username...',
    'tgLog.searchBtn':       'Cari',
    'tgLog.loading':         'Memuat log...',
    'tgLog.empty':           'Belum ada percakapan.',
    'tgLog.error':           'error',
    'tgLog.question':        'Pertanyaan',
    'tgLog.answer':          'Jawaban Bot',
    'tgLog.showMore':        'Lihat selengkapnya',
    'tgLog.hide':            'Sembunyikan',
    'tgLog.prev':            '← Sebelumnya',
    'tgLog.next':            'Berikutnya →',
    'tgLog.pageInfo':        'Hal. {page} / {totalPages} · {total} chat',
    'tgLog.unknown':         'unknown',

    // ── AI Chat History (AIChatHistory) ──
    'aih.title':             'AI Chat History',
    'aih.subtitleAdmin':     'Telusuri semua riwayat percakapan AI dari seluruh user',
    'aih.subtitleUser':      'Telusuri riwayat percakapan AI Anda',
    'aih.relSec':            '{n} detik lalu',
    'aih.relMin':            '{n} menit lalu',
    'aih.relHour':           '{n} jam lalu',
    'aih.relDay':            '{n} hari lalu',
    'aih.statMessages':      'Total Pesan',
    'aih.statSessions':      'Sesi',
    'aih.statUsers':         'User',
    'aih.statTokens':        'Total Token',
    'aih.statToday':         'Hari Ini',
    'aih.tokenUsageProvider':'Penggunaan Token per Provider',
    'aih.tabSessions':       'Riwayat Sesi',
    'aih.tabUsage':          'Laporan Penggunaan',
    'aih.usageRange':        'Rentang',
    'aih.usageDays':         '{n} hari',
    'aih.usageTotal':        'Total token',
    'aih.usageEmpty':        'Belum ada konsumsi token pada rentang ini.',
    'aih.usageDailyTitle':   'Konsumsi Token Harian',
    'aih.usageCostTotal':    'Estimasi biaya',
    'aih.usageCostTitle':    'Estimasi Biaya per Model',
    'aih.colModel':          'Provider / Model',
    'aih.colInput':          'Input',
    'aih.colOutput':         'Output',
    'aih.colCost':           'Biaya (USD)',
    'aih.costUnpriced':      'tarif belum diset',
    'aih.costTotalRow':      'Total',
    'aih.costDisclaimer':    'Estimasi berdasarkan tarif yang dikonfigurasi (USD per 1 juta token, input & output terpisah). Verifikasi tarif ke halaman resmi provider — harga dapat berubah & berbeda per region. Provider free tier dihitung $0.',
    'aih.msgCount':          '{n} pesan',
    'aih.searchPlaceholder': 'Cari isi pesan atau dashboard...',
    'aih.filterUser':        'Filter username...',
    'aih.totalSessions':     '{n} sesi total',
    'aih.sessionsCount':     'Sesi ({n})',
    'aih.empty':             'Belum ada riwayat chat.',
    'aih.noQuestion':        '(tidak ada pertanyaan user)',
    'aih.deleteSession':     'Hapus sesi',
    'aih.selectSession':     'Pilih sesi untuk melihat percakapan.',
    'aih.sessionLabel':      'Session',
    'aih.confirmDelete':     'Hapus sesi chat ini secara permanen?',
    'aih.deleteFailed':      'Gagal hapus: {err}',
    'aih.exportAll':         'Export semua chat',
    'aih.exportXlsx':        'Export XLSX',
    'aih.exportJson':        'Export JSON',
    'aih.exporting':         'Mengekspor…',
    'aih.exportEmpty':       'Tidak ada chat untuk diekspor.',
    'aih.exportTruncated':   'Hasil dibatasi ke {n} baris teratas.',
    'aih.exportFailed':      'Export gagal: {err}',
    'aih.tokenTipEst':       'Estimasi (provider tidak mengirim usage) — Prompt: {p} | Completion: {c}',
    'aih.tokenTipReal':      'Token asli dari provider — Prompt: {p} | Completion: {c}',
    'aih.estBadge':          'estimasi',
    'aih.estTitle':          'Jumlah token diperkirakan, bukan angka resmi provider',
    'aih.dataBadge':         'data',

    // ── AI Data Sources (AIDataSources) ──
    'ads.title':             'AI Data Sources',
    'ads.subtitle':          'Kelola data SQLite yang di-inject ke AI Assistant per dashboard',
    'ads.addDs':             'Tambah Data Source',
    'ads.addTitle':          'Tambah Data Source',
    'ads.editTitle':         'Edit Data Source',
    'ads.tabQueries':        'Context Queries',
    'ads.tabSql':            'Mode SQL (Text-to-SQL)',
    'ads.label':             'Label',
    'ads.labelPlaceholder':  'mis. Top Pembuat Tiket',
    'ads.sqlLabel':          'SQL Query (SELECT-only)',
    'ads.sqlPlaceholder':    'SELECT created_by, COUNT(*) as n FROM solman_tickets GROUP BY created_by ORDER BY n DESC LIMIT 15',
    'ads.sqlNotePre':        'Hanya',
    'ads.sqlNotePost':       'Statement tulis (INSERT/UPDATE/DELETE/DROP/dll) ditolak otomatis.',
    'ads.active':            'Aktif',
    'ads.inactive':          'Nonaktif',
    'ads.botTelegram':       '✈️ Bot Telegram:',
    'ads.botNone':           '-- Tidak digunakan --',
    'ads.botBilling':        'Bot AWS Billing',
    'ads.botCost':           'Bot AWS Cost',
    'ads.botSolman':         'Bot SAP Solman',
    'ads.botUsage':          'Bot SAP Usage',
    'ads.botNotify':         'Bot Notifikasi',
    'ads.preview':           'Preview',
    'ads.rowCount':          '{n} baris',
    'ads.first50':           '(menampilkan 50 pertama)',
    'ads.previewNoData':     '(tidak ada data)',
    'ads.saving':            'Menyimpan...',
    'ads.saveChanges':       'Simpan Perubahan',
    'ads.add':               'Tambah',
    'ads.errLabelSql':       'Label dan SQL wajib diisi.',
    'ads.errLoadDs':         'Gagal memuat data source.',
    'ads.errToggle':         'Gagal mengubah status.',
    'ads.errLoadSql':        'Gagal memuat konfigurasi SQL.',
    'ads.errDashKey':        'dashboard_key wajib.',
    'ads.errPickTable':      'Pilih minimal satu tabel.',
    'ads.errSave':           'Gagal menyimpan.',
    'ads.errRemove':         'Gagal menghapus.',
    'ads.sqlSaved':          'Konfigurasi SQL tersimpan.',
    'ads.removed':           'Dihapus.',
    'ads.dsDeleted':         'Data source dihapus.',
    'ads.dsUpdated':         'Data source diperbarui.',
    'ads.dsAdded':           'Data source ditambahkan.',
    'ads.confirmRemoveSql':  'Hapus mode SQL untuk "{dk}"? Dashboard kembali ke mode statis.',
    'ads.confirmDeleteDs':   'Hapus data source "{label}"?',
    'ads.sqlModeInfoBold':   'Mode SQL (text-to-SQL):',
    'ads.sqlModeInfoRest':   'untuk dashboard di sini, AI membuat query SQL sendiri tiap pertanyaan (cocok untuk data multi-dimensi). AI hanya boleh menyentuh tabel yang dipilih, query divalidasi read-only + dibatasi LIMIT di server. Dashboard yang TIDAK terdaftar di sini tetap memakai Context Queries statis.',
    'ads.addSqlDash':        'Tambah Dashboard SQL',
    'ads.editSqlDash':       'Edit: {dk}',
    'ads.noSqlDash':         'Belum ada dashboard ber-mode SQL.',
    'ads.noSqlDashHint':     'Klik "Tambah Dashboard SQL" untuk mengaktifkan text-to-SQL.',
    'ads.dashKeyPlaceholder':'mis. aws_cost, overtime',
    'ads.tablesLabel':       'Tabel yang boleh diakses ({n} dipilih)',
    'ads.hintLabel':         'Hint untuk AI (opsional)',
    'ads.hintPlaceholder':   'Jelaskan arti kolom/satuan agar SQL yang dibuat AI lebih akurat.',
    'ads.fewShotLabel':      'Contoh / Few-shot (opsional)',
    'ads.fewShotPlaceholder':'Contoh pertanyaan → SQL yang benar (pola otoritatif). Mis:\nQ: top 5 reason per company\nSQL: SELECT bu, reason, total FROM (SELECT bu, reason, SUM(amount) total, ROW_NUMBER() OVER(PARTITION BY bu ORDER BY SUM(amount) DESC) rnk FROM employee_overtime GROUP BY bu,reason) WHERE rnk<=5 ORDER BY bu,total DESC',
    'ads.fewShotHelp':       'Ditambahkan ke prompt SQL sebagai pola otoritatif untuk dashboard ini. Kosongkan bila tak perlu.',
    'ads.sqlModeOn':         'Mode SQL aktif',
    'ads.sqlModeOff':        'Nonaktif (mode statis)',
    'ads.noDs':              'Belum ada data source untuk dashboard ini.',
    'ads.noDsHint':          'Klik "Tambah Data Source" untuk membuat query pertama.',
    'ads.enable':            'Aktifkan',
    'ads.disable':           'Nonaktifkan',
    'ads.dsInfoPre':         'Data source aktif untuk',
    'ads.dsInfoMid':         'dirangkai menjadi konteks yang dikirim ke AI setiap kali user bertanya di dashboard ini. Tabel utama:',

    // ── Activity Log (LogViewer) ──
    'log.title':             'Activity Log',
    'log.subtitle':          'Monitoring aktivitas semua user · {n} total records',
    'log.autoRefresh':       'Auto Refresh',
    'log.on':                'ON',
    'log.off':               'OFF',
    'log.exportCsv':         'Export CSV',
    'log.statToday':         'Aktivitas Hari Ini',
    'log.statLoginOk':       'Total Login Sukses',
    'log.statLoginFail':     'Login Gagal',
    'log.statActiveUsers':   'User Aktif',
    'log.topUsers':          'Top User (Aktivitas)',
    'log.actionDist':        'Distribusi Aksi',
    'log.filter':            'Filter:',
    'log.searchPlaceholder': 'Cari username, IP, detail...',
    'log.searchBtn':         'Cari',
    'log.allActions':        'Semua Aksi',
    'log.allUsers':          'Semua User',
    'log.resetFilter':       '× Reset Filter',
    'log.showing':           'Menampilkan {n} dari {total} records',
    'log.colId':             'ID',
    'log.colTime':           'Waktu',
    'log.colUser':           'User',
    'log.colAction':         'Aksi',
    'log.colDetail':         'Detail',
    'log.colIp':             'IP Address',
    'log.colBrowser':        'Browser',
    'log.colRole':           'Role',
    'log.colUsername':       'Username',
    'log.loading':           'Memuat log...',
    'log.empty':             'Tidak ada log ditemukan',
    'log.pageInfo':          'Halaman {page} dari {totalPages}',
    'log.rangeInfo':         '{from}–{to} dari {total}',
    'log.prev':              'Prev',
    'log.next':              'Next',
    'log.relSec':            '{n}d lalu',
    'log.relMin':            '{n}m lalu',
    'log.relHour':           '{n}j lalu',
    'log.relDay':            '{n}h lalu',
    'log.actLoginOk':        'Login',
    'log.actLoginFail':      'Login Gagal',
    'log.actLogout':         'Logout',
    'log.actViewDash':       'Buka Dashboard',
    'log.actOpenAi':         'Buka AI',
    'log.actSaveAiConfig':   'Simpan Config AI',

    // ── AI Workspace (AIWorkspace) ──
    'aiw.pickerLabel':       'Analisis data:',
    'aiw.general':           'Umum (tanpa data dashboard)',
    'aiw.autoDetected':      'Otomatis terpilih',
    'aiw.autoDetectedNote':  'Data dipilih otomatis dari isi pertanyaan Anda.',
    'aiw.sessionNote':       'Sesi terpisah dari panel di header. Ganti pilihan → mulai sesi baru.',
    'aiw.loadingConfig':     'Memuat konfigurasi...',

    // ── User Management (UserManagement) ──
    'um.title':              'User Management',
    'um.subtitle':           '{n} total user terdaftar · {m} role tersedia',
    'um.addUserBtn':         'Tambah User',
    'um.totalUsers':         'Total User',
    'um.searchPlaceholder':  'Cari username...',
    'um.all':                'Semua',
    'um.colNum':             '#',
    'um.colUsername':        'Username',
    'um.colRole':            'Role',
    'um.colAccess':          'Akses',
    'um.colCreated':         'Dibuat',
    'um.colLastLogin':       'Last Login',
    'um.colAction':          'Aksi',
    'um.empty':              'Tidak ada user ditemukan',
    'um.none':               'Tidak ada',
    'um.never':              'Belum pernah',
    'um.tipEdit':            'Edit user',
    'um.tipCopy':            'Salin user',
    'um.copyUser':           'Salin User',
    'um.copyingFrom':        'Salin role dari {name}',
    'um.tipReset':           'Reset password',
    'um.tipDelete':          'Hapus user',
    'um.createdOk':          'User berhasil dibuat.',
    'um.updatedOk':          'User berhasil diupdate.',
    'um.userDeleted':        'User "{name}" berhasil dihapus.',
    'um.deleteUserTitle':    'Hapus User',
    'um.irreversible':       'Tindakan ini tidak dapat dibatalkan',
    'um.confirmDeleteUser':  'Apakah Anda yakin ingin menghapus user "{name}" (role: {role})?',
    'um.yesDelete':          'Ya, Hapus',
    'um.editUser':           'Edit User',
    'um.addUser':            'Tambah User Baru',
    'um.editingUser':        'Editing: {name}',
    'um.createAccount':      'Buat akun baru',
    'um.username':           'Username',
    'um.usernamePlaceholder':'Masukkan username',
    'um.usernameLocked':     'Username tidak dapat diubah.',
    'um.password':           'Password',
    'um.pwOptional':         '(kosongkan jika tidak ingin diubah)',
    'um.pwNewPlaceholder':   'Password baru (opsional)',
    'um.pwPlaceholder':      'Masukkan password',
    'um.role':               'Role',
    'um.access':             'Akses:',
    'um.allAccessAdmin':     'Semua akses (admin)',
    'um.noAccess':           'Tidak ada akses',
    'um.saveChanges':        'Simpan Perubahan',
    'um.createUser':         'Buat User',
    'um.resetPw':            'Reset Password',
    'um.userLabel':          'User:',
    'um.pwResetOk':          'Password berhasil direset!',
    'um.pwResetPlaceholder': 'Password baru (min 6 karakter)',
    'um.allAccess':          'Semua akses',
    'um.errLoad':            'Gagal memuat data.',
    'um.errDelete':          'Gagal menghapus user.',
    'um.errSaveUser':        'Gagal menyimpan user.',
    'um.errReset':           'Gagal reset password.',
    'um.errUserReq':         'Username wajib diisi.',
    'um.errUserMin':         'Username minimal 3 karakter.',
    'um.errPwReq':           'Password wajib diisi untuk user baru.',
    'um.errPwMin':           'Password minimal 6 karakter.',
    'um.errRoleReq':         'Role wajib dipilih.',

    // ── Role Management (RoleManagement) ──
    'rm.title':              'Role Management',
    'rm.subtitle':           'Buat dan kelola role custom untuk mengatur akses dashboard',
    'rm.createRoleBtn':      'Buat Role',
    'rm.totalRoles':         'Total Role',
    'rm.customRoles':        'Role Custom',
    'rm.totalUsers':         'Total User',
    'rm.searchPlaceholder':  'Cari role...',
    'rm.loading':            'Memuat daftar role...',
    'rm.empty':              'Tidak ada role ditemukan',
    'rm.systemBadge':        'System',
    'rm.noDesc':             'Tanpa deskripsi',
    'rm.userUnit':           'user',
    'rm.permUnit':           'permission',
    'rm.updatedAt':          'Diupdate {date}',
    'rm.allAccessBuiltin':   'Semua akses (built-in)',
    'rm.noPerm':             'Tidak ada permission',
    'rm.tipSysNoEdit':       'Role sistem tidak dapat diedit',
    'rm.tipEdit':            'Edit role',
    'rm.tipSysNoDelete':     'Role sistem tidak dapat dihapus',
    'rm.tipInUse':           'Masih digunakan {n} user',
    'rm.tipDelete':          'Hapus role',
    'rm.createdOk':          'Role berhasil dibuat.',
    'rm.updatedOk':          'Role berhasil diupdate.',
    'rm.roleDeleted':        'Role "{name}" berhasil dihapus.',
    'rm.deleteRoleTitle':    'Hapus Role',
    'rm.irreversible':       'Tindakan ini tidak dapat dibatalkan',
    'rm.confirmDelete':      'Apakah Anda yakin ingin menghapus role "{name}"?',
    'rm.yesDelete':          'Ya, Hapus',
    'rm.editRole':           'Edit Role',
    'rm.newRole':            'Buat Role Baru',
    'rm.editing':            'Editing: {name}',
    'rm.subtitleNew':        'Definisikan role custom dengan permission khusus',
    'rm.roleName':           'Nama Role',
    'rm.namePlaceholder':    'Contoh: FINANCE, AUDITOR, MANAGER...',
    'rm.nameLocked':         'Nama role tidak dapat diubah.',
    'rm.nameHint':           'Huruf, angka, underscore atau dash. 2-30 karakter.',
    'rm.description':        'Deskripsi',
    'rm.descPlaceholder':    'Penjelasan singkat tentang role ini',
    'rm.permissions':        'Permissions',
    'rm.selectedCount':      '({n} dipilih)',
    'rm.checkAll':           'Check All',
    'rm.uncheckAll':         'Uncheck All',
    'rm.saveChanges':        'Simpan Perubahan',
    'rm.createRole':         'Buat Role',
    'rm.errLoad':            'Gagal memuat daftar role.',
    'rm.errDelete':          'Gagal menghapus role.',
    'rm.errSave':            'Gagal menyimpan role.',
    'rm.errNameReq':         'Nama role wajib diisi.',
    'rm.errNameFormat':      'Nama role hanya boleh huruf/angka/_/- (2-30 karakter).',
    'rm.errPermReq':         'Pilih minimal 1 permission untuk role ini.',
    'rm.grpDashboard':       'Dashboard',
    'rm.grpAdmin':           'Halaman Admin',
    'rm.grpHr':              'HR',
    'rm.grpOther':           'Lainnya',
    'rm.desc.aws_billing':       'Cost & Usage',
    'rm.desc.aws_cost':          'Analisis biaya',
    'rm.desc.aws_inventory':     'Inventaris resource',
    'rm.desc.aws_cloudtrail':    'Audit & event',
    'rm.desc.solman':            'Tiket & insiden',
    'rm.desc.sap_usage':         'Utilisasi',
    'rm.desc.logs':              'Lihat audit trail',
    'rm.desc.ai_history':        'Riwayat percakapan AI',
    'rm.desc.ai_config':         'Tune-up data source & prompt AI',
    'rm.desc.ai_workspace':      'Chat AI halaman penuh',
    'rm.desc.users':             'Kelola user',
    'rm.desc.role_management':   'Kelola role',
    'rm.desc.table_maintenance': 'Maintain database',
    'rm.desc.telegram':          'Kelola bot Telegram',
    'rm.desc.telegram_log':      'Log chat Telegram',
    'rm.desc.sap_user_mgmt':     'Kelola user SAP',
    'rm.desc.employee_overtime': 'Data lembur karyawan',
    'rm.desc.sap_basis_mon':          'Health: job, lock, WP, sistem',
    'rm.desc.sap_roles':              'Audit role & assignment (read-only); tambah "Modify" untuk assign role dan edit authorization',
    'rm.desc.sap_customizing':        'User exit, BAdI & enhancement',
    'rm.desc.sap_source':             'Lihat source code ABAP program custom',
    'rm.desc.sap_table_peek':         'Lihat sampel isi tabel SAP (data bisnis)',
    'rm.desc.transport':              'Lihat antrean STMS',
    'rm.desc.transport_import':       'Jalankan import ke Q01/P01',
    'rm.desc.monthly_report':         'Laporan bulanan otomatis',
    'rm.desc.notes':                  'Kelola catatan',
    'rm.desc.notes_plain':            'Catatan tanpa indeks RAG',
    'rm.desc.ai_settings':            'Provider, model & API key',
    'rm.desc.ai_coding':              'Asisten coding + tool use',
    'rm.desc.ai_actions':             'Aksi bahasa natural + approval',
    'rm.desc.m365_license':           'Ringkasan lisensi Microsoft 365',
    'rm.desc.m365_pricing_edit':      'Ubah harga lisensi M365',
    'rm.desc.sdp':                    'ManageEngine ticketing & asset',
    'rm.needsParent':        'Perlu "{parent}" juga dicentang',

    // ── Microsoft 365 License ──
    'm365.title':               'Lisensi Microsoft 365',
    'm365.lastSnapshot':        'Snapshot terakhir: {snap}',
    'm365.noDataHint':          'Belum ada data — jalankan fetch di Table Maintenance.',
    'm365.tabOverview':         'Ringkasan',
    'm365.tabUserDetail':       'Detail User',
    'm365.tabPricing':           'Pricing',
    'm365.tabAnalytics':       'Analytics',
    'm365.anHint':             'Analitik ini menampilkan potret kondisi TERKINI (bukan tren) dan dibatasi untuk grup lokasi Indonesia. Nilai biaya memakai harga master di tab Pricing — pastikan harga sudah diisi & klik Calculate agar akurat.',
    'm365.snapshot':           'Snapshot terakhir',
    'm365.anNoPrices':         'Harga master belum diisi — nilai biaya = 0.',
    'm365.anSavings':          'Potensi Penghematan',
    'm365.anUnlicensed':       'User Tanpa Lisensi',
    'm365.anDisabledLicensed': 'Disabled tapi Berlisensi',
    'm365.anPotentialSaving':  'Estimasi Penghematan',
    'm365.anPerFetch':         'berdasarkan snapshot terakhir',
    'm365.anRevokeCandidates': 'Kandidat Pencabutan Lisensi (akun disabled)',
    'm365.anCapacityRisk':     'Risiko Kapasitas',
    'm365.anNearFull':         'Hampir/Penuh (≥90%)',
    'm365.anLowUse':           'Utilisasi Rendah (<50%)',
    'm365.anIdleCost':         'Biaya Idle',
    'm365.anCostByOrg':        'Biaya per Organisasi',
    'm365.anNoOrgData':        'Data departemen/company belum cukup untuk dianalisis.',
    'm365.anByDept':           'Biaya per Departemen',
    'm365.anByCompany':        'Biaya per Company',
    'm365.anDistribution':     'Distribusi & Anomali',
    'm365.anLicenseMix':       'Komposisi Lisensi',
    'm365.anAnomalies':        'Anomali',
    'm365.anPaidNoDept':       'Berlisensi tanpa Departemen',
    'm365.pricingTitle':         'Master Harga Lisensi',
    'm365.pricingReadOnlyHint':  'Hanya admin/role tertentu yang dapat mengubah harga.',
    'm365.calculate':            'Calculate',
    'm365.calcDone':             'Kalkulasi selesai.',
    'm365.calcHint':             'Biaya per domain (grup Indonesia) diperbarui di tab Ringkasan.',
    'm365.refresh':              'Refresh',
    'm365.save':                 'Simpan',
    'm365.saveAll':              'Simpan Semua',
    'm365.yes':                  'Ya',
    'm365.colLicenseType':       'Jenis Lisensi',
    'm365.colCategory':          'Kategori',
    'm365.colPriceUsd':          'Harga (USD)',
    'm365.colNotes':             'Catatan',
    'm365.colUpdated':           'Diperbarui',
    'm365.colAction':            'Aksi',
    'm365.kpiTotalUsers':       'Total User',
    'm365.kpiAssigned':         'Lisensi Terpakai',
    'm365.kpiUnlicensed':       'Tanpa Lisensi',
    'm365.kpiDomains':          'Domain',
    'm365.chartPerDomain':      'Lisensi per Domain — Indonesia',
    'm365.chartCategoryDist':   'Distribusi Kategori Lisensi',
    'm365.totalLicensesLabel':  'total lisensi',
    'm365.capacityTitle':       'Kapasitas Lisensi',
    'm365.distributionTitle':   'Distribusi Lisensi per Domain',
    'm365.perUserTitle':        'Detail Lisensi per User',
    'm365.userDetailTitle':     'Detail User',
    'm365.rows':                'baris',
    'm365.users':               'user',
    'm365.noUsers':             'Tidak ada user.',
    'm365.exportExcel':         'Export Excel',
    'm365.allDomains':          'Semua Domain',
    'm365.allLicenses':         'Semua Lisensi',
    'm365.allStatus':           'Semua Status',
    'm365.allLicenseState':     'Semua Lisensi/Tanpa',
    'm365.licensed':            'Berlisensi',
    'm365.unlicensedOpt':       'Tanpa Lisensi',
    'm365.enabledYes':          'Aktif',
    'm365.enabledNo':           'Nonaktif',
    'm365.search':              'Cari',
    'm365.reset':               'Reset',
    'm365.searchUpnDomain':     'Cari UPN / domain…',
    'm365.searchDetail':        'Cari UPN / nama / email / departemen…',
    'm365.prev':                'Sebelumnya',
    'm365.next':                'Berikutnya',
    'm365.page':                'Hal',
    'm365.colDomain':           'Domain',
    'm365.colLicense':          'Lisensi',
    'm365.colLicenses':         'Lisensi',
    'm365.colSkuPart':          'SKU Part',
    'm365.colAvailable':        'Tersedia',
    'm365.colAssignedTotal':    'Terpakai / Total',
    'm365.colDisplayName':      'Nama',
    'm365.colDepartment':       'Departemen',
    'm365.colCompany':          'Perusahaan',
    'm365.colEnabled':          'Status',

    // ── SAP Note (page) ──
    'sapnote.cancelSelect': 'Batal pilih',
    'sapnote.noContentSaved': 'Belum ada isi note tersimpan. Tarik dari sistem untuk menyimpannya secara permanen (atau tambahkan lampiran PDF lewat ikon lampiran).',
    'sapnote.noAttachments': 'Belum ada lampiran.',
    'sapnote.noNotes': 'Belum ada note. Tambahkan lewat kotak di atas.',
    'sapnote.openPortal': 'Buka di portal',
    'sapnote.remark': 'Catatan',
    'sapnote.htmlUnavailable': 'Isi HTML tidak tersedia untuk note/bahasa ini di sistem. Coba "Isi dari PDF" atau "Buka di portal".',
    'sapnote.noteContentFromSystem': 'Isi note (dari sistem)',
    'sapnote.subtitle': 'Katalog, arsip, dan pelacakan SAP Note untuk landscape — buka di portal, simpan PDF, lacak status.',
    'sapnote.manage': 'Kelola',
    'sapnote.stepperHint': 'Klik tahap untuk mengubah status note (tersimpan langsung).',
    'sapnote.clear': 'Kosongkan',
    'sapnote.snoteStep': 'Langkah SNOTE: transaksi',
    'sapnote.loading': 'Memuat…',
    'sapnote.pullSrsHint': 'Menarik Symptom/Reason/Solution dari sistem SAP lalu mengarsipkannya (bila note sudah di-download ke sistem).',
    'sapnote.pullingArchiving': 'Menarik dari sistem & mengarsipkan…',
    'sapnote.contactingSap': 'Menghubungi sistem SAP…',
    'sapnote.deleteWarnOne': 'Metadata dan semua lampiran note ini akan dihapus permanen.',
    'sapnote.deleteWarnMany': 'Metadata dan semua lampirannya akan dihapus permanen.',
    'sapnote.loadArchive': 'Muat & arsipkan dari sistem',
    'sapnote.loadContent': 'Muat isi dari sistem',
    'sapnote.reloadFromSystem': 'Muat ulang dari sistem',
    'sapnote.reload': 'Muat ulang',
    'sapnote.noteNumber': 'Nomor note',
    'sapnote.notDownloaded': 'Note ini belum di-download ke sistem. Unduh dulu lewat',
    'sapnote.pdfArchivedWith': 'PDF akan diarsipkan bersama note:',
    'sapnote.selectAllShown': 'Pilih semua (tampil)',
    'sapnote.selectNew': 'Pilih yang baru',
    'sapnote.properties': 'Properties',
    'sapnote.sapNote': 'SAP Note',
    'sapnote.snote': 'SNOTE',
    'sapnote.alsoArchive': 'Sekaligus arsipkan isi note (yang punya judul/komponen)',
    'sapnote.allStatus': 'Semua status',
    'sapnote.saveToList': 'Simpan ke daftar',
    'sapnote.applyStatus': 'Status penerapan',
    'sapnote.noMatch': 'Tak ada yang cocok dengan filter.',
    'sapnote.addOpenNote': 'Tambah / buka note',
    'sapnote.pullFromSystem': 'Tarik dari sistem',
    'sapnote.pullNotConfigured': 'Tarik-dari-sistem belum dikonfigurasi di server. Sementara ini pakai "Isi dari PDF" atau "Buka di portal".',
    'sapnote.noNotesInSystem': 'Tidak ada note ditemukan di sistem.',
    'sapnote.uploadHint': 'Tipe apa saja (PDF, script, gambar, .SAR/.CAR, zip…), maks 20 MB/file, hingga 20 file sekali unggah.',
    'sapnote.download': 'Unduh',
    'sapnote.exists': 'sudah ada',
    'sapnote.fetchListTitle': 'Ambil daftar note yang sudah ada di sistem SAP',
    'sapnote.searchPlaceholder': 'Cari nomor / judul / komponen / sistem / isi note',
    'sapnote.searchSysPlaceholder': 'Cari nomor / komponen / status',
    'sapnote.noteDetail': 'Detail note',
    'sapnote.skipHint': 'Dilewati hanya bila judul & komponen dua-duanya kosong',
    'sapnote.noteContentSystem': 'Isi note dari sistem',
    'sapnote.noteContent': 'Isi note',
    'sapnote.manageAttachments': 'Kelola lampiran',
    'sapnote.remarkPlaceholder': 'Konteks, kaitan transport/ticket, dampak…',
    'sapnote.attachments': 'Lampiran',
    'sapnote.viewNoteContent': 'Lihat isi note',
    'sapnote.view': 'Lihat',
    'sapnote.selectDeleteEmpty': 'Pilih & hapus note tanpa judul dan komponen',
    'sapnote.selectAllShownTitle': 'Pilih semua yang sedang tampil',
    'sapnote.titlePlaceholder': 'Ringkasan singkat note',
    'sapnote.repullTitle': 'Tarik ulang isi terbaru dari sistem SAP (arsip diperbarui bila versi berubah)',
    'sapnote.downloadHtmlTitle': 'Unduh berkas HTML ke perangkat Anda',
    'sapnote.uploadPdfTitle': 'Unggah PDF isi note → judul/komponen/prioritas terisi otomatis',
    'sapnote.egNoteNumber': 'mis. 3421567',
    'sapnote.egComponent': 'mis. FI-GL',
    'sapnote.egPriority': 'mis. High / Correction',
    'sapnote.egSystem': 'mis. P01, D01',
    'sapnote.preview': 'preview',
    'sapnote.statusReview': 'Perlu ditinjau',
    'sapnote.statusApplying': 'Sedang diterapkan',
    'sapnote.statusDone': 'Selesai',
    'sapnote.changeStatusTo': 'Ubah status ke "{status}"',
    'sapnote.colNumber': 'Nomor',
    'sapnote.title': 'Judul',
    'sapnote.component': 'Komponen',
    'sapnote.system': 'Sistem',
    'sapnote.status': 'Status',
    'sapnote.priority': 'Prioritas',
    'sapnote.version': 'Versi',
    'sapnote.statusInSystem': 'Status di sistem',
    'sapnote.processedBy': 'Diproses oleh',
    'sapnote.portalBanner': '"Buka di portal" memakai sesi SSO browser Anda. "Isi dari PDF" membaca header note dari PDF (tombol "pdf" di portal, bukan file .SAR) untuk mengisi field otomatis — lalu PDF-nya ikut terarsip saat disimpan. Note belum ada di SNOTE? Klik nomor note (atau ikon mata) → "Muat & arsipkan dari sistem": dashboard otomatis menyuruh SAP men-download lewat SNOTE lalu mengarsipkan isinya. KBA tidak bisa via SNOTE — pakai Buka di portal → PDF → Isi dari PDF.',
    'sapnote.editNote': 'Edit note {n}',
    'sapnote.saveNewNote': 'Simpan note baru',
    'sapnote.deleteNoteTitle': 'Hapus note {n}?',
    'sapnote.attachmentsTitle': 'Lampiran · Note {n}',
    'sapnote.addAttachment': 'Tambah lampiran',
    'sapnote.noteContentTitle': 'Isi Note {n}',
    'sapnote.errNoteNumber': 'Nomor note harus angka (maks 12 digit).',
    'sapnote.pdfFilled': 'Field terisi dari PDF — periksa lalu Simpan.',
    'sapnote.noteUpdated': 'Note {n} diperbarui.',
    'sapnote.saveButAttachFail': 'Note tersimpan, tapi lampiran PDF gagal: ',
    'sapnote.noteSaved': 'Note {n} disimpan.',
    'sapnote.noteSavedPdf': 'Note {n} disimpan + PDF terarsip.',
    'sapnote.noteDeleted': 'Note {n} dihapus.',
    'sapnote.notesDeleted': '{count} note dihapus.',
    'sapnote.attachAdded': '{count} lampiran ditambahkan.',
    'sapnote.attachDeleted': 'Lampiran dihapus.',
    'sapnote.notDownloadedFlash': 'Note belum di-download ke sistem (unduh via SNOTE dulu).',
    'sapnote.contentUnavailable': 'Isi note tidak tersedia di sistem.',
    'sapnote.contentPulled': 'Isi note ditarik dari sistem & diarsipkan.',
    'sapnote.pullNotConfiguredShort': 'Tarik-dari-sistem belum dikonfigurasi di server.',
    'sapnote.contentArchivedAuto': 'Isi {count} note diarsipkan otomatis.',
    'sapnote.selectAtLeastOne': 'Pilih minimal satu note.',
    'sapnote.importResult': '{created} dibuat, {skipped} dilewati',
    'sapnote.importInvalid': ', {invalid} tak valid',
    'sapnote.noEmptyNotes': 'Tidak ada note kosong.',
    'sapnote.fillNumberFirst': 'Isi nomor note dulu.',
    'sapnote.fillFromPdf': 'Isi dari PDF',

    // ── AI Actions (page) ──
    'aiact.title': 'AI Actions',
    'aiact.subtitle': 'Perintah bahasa natural → aksi terkontrol dengan approval & audit',
    'aiact.tabRun': 'Jalankan',
    'aiact.tabManage': 'Kelola Aksi Custom',
    'aiact.send': 'Kirim',
    'aiact.inputPlaceholder': 'Contoh: "buka kunci user BUDI di PRD" atau "tampilkan user terkunci di QAS"',
    'aiact.actionsAvailable': '{count} aksi tersedia',
    'aiact.aiChose': 'AI memilih',
    'aiact.with': 'dengan',
    'aiact.noMatch': 'AI tidak menemukan aksi yang cocok untuk permintaan ini.',
    'aiact.executedDirect': 'Dieksekusi langsung (aksi read) —',
    'aiact.awaitingApproval': 'Menunggu persetujuan —',
    'aiact.expiryHint': 'Kedaluwarsa 10 menit. Periksa target & environment sebelum menyetujui.',
    'aiact.approveRun': 'Approve & jalankan',
    'aiact.reject': 'Tolak',
    'aiact.approvedExecuted': 'Disetujui & dieksekusi.',
    'aiact.rejected': 'Proposal ditolak. Tidak ada yang dieksekusi.',
    'aiact.execFailed': 'Eksekusi gagal:',
    'aiact.history48h': 'Riwayat 48 jam terakhir',
    'aiact.noActionsYet': 'Belum ada aksi. Ketik perintah di atas untuk memulai.',
    'aiact.colTime': 'Waktu',
    'aiact.colParam': 'Parameter',
    'aiact.colSource': 'Sumber',
    'aiact.colRequester': 'Pemohon',
    'aiact.colStatus': 'Status',
    'aiact.colApprover': 'Approver',
    'aiact.tempPassword': 'Password sementara',
    'aiact.tempPasswordHint': 'Sampaikan via kanal aman. User wajib ganti saat login pertama. Nilai ini tidak disimpan di log.',
    'aiact.moreItems': '… +{n} lagi',
    'aiact.showJson':  'Lihat JSON mentah',
    'aih.cachedOnly':      'Hanya cache',
    'ai.modeSql':           'SQL baru',
    'ai.inheritedPeriod':      'periode diwarisi',
    'ai.inheritedPeriodTitle': 'Pertanyaan ini dilengkapi otomatis dengan periode dari giliran sebelumnya: {periods}.',
    'ai.modeSqlTitle':      'Pertanyaan digenerate menjadi SQL baru. Bila ini seharusnya lanjutan, sebutkan periode/filternya secara eksplisit.',
    'ai.modeFollowup':      'follow-up',
    'ai.modeFollowupTitle': 'Diolah dari tabel hasil sebelumnya, tanpa query baru.',
    'ai.modeContext':       'konteks halaman',
    'ai.modeContextTitle':  'Dijawab dari ringkasan data yang sedang tampil di halaman ini.',
    'ai.modeDet':           'deterministik',
    'ai.modeDetTitle':      'Dihitung langsung di server (bukan SQL buatan model) agar angkanya pasti.',
    'aih.cachedOnlyTitle': 'Tampilkan hanya sesi yang punya jawaban dari semantic cache',
    'aiact.hideJson':  'Sembunyikan JSON',
    'aiact.copy':      'Salin',
    'aiact.copied':    'Tersalin',
    'aiact.confirmDelete': 'Hapus aksi "{name}"?',
    'aiact.editForm': 'Edit: {name}',
    'aiact.newAction': 'Aksi Custom Baru',
    'aiact.cancelEdit': 'Batal edit',
    'aiact.lblName': 'Nama (huruf kecil, underscore)',
    'aiact.lblMaxRows': 'Batas baris (max_rows)',
    'aiact.lblDescription': 'Deskripsi (dibaca AI untuk mencocokkan permintaan)',
    'aiact.lblSql': 'SQL Template (SELECT saja; parameter pakai :nama)',
    'aiact.detectedParams': 'Parameter terdeteksi',
    'aiact.required': 'wajib',
    'aiact.lblTables': 'Tabel yang diizinkan (allowlist guard)',
    'aiact.descPlaceholder': 'Tampilkan tiket SAP Solman dengan status tertentu',
    'aiact.saveChanges': 'Simpan perubahan',
    'aiact.createAction': 'Buat aksi',
    'aiact.customActions': 'Aksi Custom',
    'aiact.noCustomActions': 'Belum ada aksi custom. Buat di atas — otomatis bisa dipanggil lewat bahasa natural.',
    'aiact.disabled': '(nonaktif)',

    // ══ Hasil migrasi pola dua-bahasa inline (id ? … : …) ══
    // ── aiChat ──
    'aiChat.aiAssistantNotAvailablePage':            'AI Assistant belum tersedia untuk halaman ini (belum diatur di AI Data Sources).',
    'aiChat.aiNotAvailablePage':                     'AI belum tersedia untuk halaman ini',
    'aiChat.attachImage':                            'Lampirkan gambar (mode Coding)',
    'aiChat.removeImage':                            'Hapus gambar',
    'aiChat.imageTooLarge':                          'Ukuran gambar maksimal 5 MB per file.',
    'aiChat.imageMaxCount':                          'Maksimal {max} gambar per pertanyaan.',
    'aiChat.imageUnsupported':                       'Format gambar tidak didukung ({name}). Gunakan PNG, JPG, WebP, atau GIF.',
    'aiChat.imageFailed':                            'Gagal memproses gambar.',

    // ── aiHist ──
    'aiHist.answerServedAiServiceSemantic':          'Jawaban diambil dari semantic cache AI Service — tanpa panggilan LLM (0 token)',
    'aiHist.copySessionLink':                        'Salin link session',
    'aiHist.deleteSession':                          'Hapus session',
    'aiHist.openNewTab':                             'Buka di tab baru',

    // ── aiRouter ──
    'aiRouter.failsUncertainFallsBackKeyword':       'Gagal/tidak yakin → jatuh ke pencocokan kata kunci dari Hint & Kamus Alias di AI Data Sources.',
    'aiRouter.howWorks':                             'Cara kerja',
    'aiRouter.loading':                              'Memuat…',
    'aiRouter.noMatchKeepsUsingCurrently':           'Tidak match apapun → tetap pakai dashboard yang sedang aktif (dianggap follow-up), bukan kembali ke Umum.',
    'aiRouter.quickClassificationViaGroqSeparate':   'Coba klasifikasi cepat via Groq (terpisah dari provider chat utama — jalan walau provider utama Bedrock/Ollama).',
    'aiRouter.turnOffIfDonT':                        '💡 Matikan toggle bila tidak ingin panggilan LLM tambahan per pertanyaan di mode Umum sama sekali.',
    'aiRouter.whenAiWorkspaceGeneralMode':           'Saat AI Workspace dalam mode "Umum" (tanpa dashboard dipilih), sistem otomatis mendeteksi dashboard yang relevan dari isi pertanyaan (mis. "berapa cost AWS" → AWS Cost Explorer), lalu menjawab pakai data dari sana.',

    // ── basis ──
    'basis.1Session':                                '1 sesi',
    'basis.action':                                  'Aksi',
    'basis.activeSessions':                          'Sesi aktif',
    'basis.busy':                                    'sibuk',
    'basis.busyTotal':                               'sibuk/total',
    'basis.by':                                      'Oleh',
    'basis.clickRowViewDumpContent':                 'Klik baris untuk melihat isi dump.',
    'basis.clickRowViewUserS':                       'Klik baris untuk melihat sesi/mode user (ala SM04).',
    'basis.clickViewUserSSessions':                  'Klik untuk lihat sesi/mode user ini',
    'basis.connectionProfileActive':                 'Profil Koneksi (aktif)',
    'basis.count':                                   'Jumlah',
    'basis.criteriaDataSources':                     'Kriteria & sumber angka',
    'basis.date':                                    'Tanggal Dari',
    'basis.date2':                                   'Tanggal Sampai',
    'basis.date3':                                   'Tanggal',
    'basis.dateCoverage':                            'Cakupan tanggal',
    'basis.daysCovered':                             'Jumlah hari',
    'basis.department':                              'Departemen',
    'basis.departments':                             'Departemen',
    'basis.diffTerminal':                            'Terminal beda',
    'basis.differentTerminals':                      'dari terminal berbeda',
    'basis.diskAseSpaceBackendNot':                  'Disk & Space ASE — backend belum dikonfigurasi (perlu command SM69).',
    'basis.emptyDumpContent':                        'Isi dump kosong.',
    'basis.emptyErrorlog':                           'Errorlog kosong.',
    'basis.failedJobs':                              'Job Gagal',
    'basis.fetchBatches':                            'Batch fetch',
    'basis.fetchUserUsage':                          'Fetch User Usage',
    'basis.fetched':                                 'Diambil',
    'basis.fetchingDump':                            'Mengambil isi dump…',
    'basis.fetchingSessions':                        'Mengambil daftar sesi…',
    'basis.fieldsRead':                              'Field terbaca',
    'basis.firstLogon':                              'Logon pertama',
    'basis.fmReturnedNoSessionsUser':                'FM tidak mengembalikan sesi untuk user ini.',
    'basis.fmsTried':                                'FM yang dicoba',
    'basis.hours':                                   'Jam',
    'basis.jobName':                                 'Nama Job',
    'basis.lastFetch':                               'Fetch terakhir',
    'basis.lastLogon':                               'Logon terakhir',
    'basis.latest':                                  'Terakhir',
    'basis.lines':                                   'baris',
    'basis.listedMldtableButNotParallel':            'Tercatat di {mldTable} tapi tidak paralel sekarang',
    'basis.loadRefresh':                             'Muat / Refresh',
    'basis.loading':                                 'Memuat…',
    'basis.loadingUserUsageStatus':                  'Memuat status data user usage…',
    'basis.locked':                                  'User Lock',
    'basis.logged':                                  'User Logon',
    'basis.loggedUsersSm04ClickLoad':                'User Logon (SM04) — tekan Muat / Refresh untuk mengambil data.',
    'basis.loginDetailRowsStoredAs':                 'Data detail login disimpan APA ADANYA (per baris RESULT) ke tabel sap_usr_utl_raw — tanpa agregasi, terpisah dari dashboard User Usage.',
    'basis.multiLogonCard':                          'Kartu Multi Logon',
    'basis.multiLogonClickLoadRefresh':              'Multi Logon — tekan Muat / Refresh untuk mengambil data.',
    'basis.multipleLogonNotRestricted':              '(multiple logon tidak dibatasi)',
    'basis.multipleLogonRestricted':                 '(multiple logon dibatasi)',
    'basis.no':                                      'Tidak',
    'basis.noCancelledJobs':                         'Tidak ada job cancelled.',
    'basis.noDiskData':                              'Tidak ada data disk.',
    'basis.noLockEntriesSm12':                       'Tidak ada lock entry (SM12).',
    'basis.noLockedUsers':                           'Tidak ada user terkunci.',
    'basis.noRowsMatchFilter':                       'Tidak ada baris yang cocok dengan filter.',
    'basis.noSavedSnapshotProfileYet':               'Belum ada snapshot tersimpan untuk profil ini — tekan Muat / Refresh untuk mengambil data pertama kali.',
    'basis.noSessionListFmAvailable':                'FM daftar sesi tidak tersedia di sistem ini.',
    'basis.noShortDumpsRange':                       'Tidak ada short dump pada rentang ini.',
    'basis.noUpdateErrors':                          'Tidak ada update error.',
    'basis.noUserUsageDataProfile':                  'Belum ada data user usage untuk profil ini.',
    'basis.noUsersCurrentlyLogged':                  'Tidak ada user yang sedang logon.',
    'basis.noUsersParallelSessionsRight':            'Tidak ada user dengan sesi paralel saat ini.',
    'basis.noWpData':                                'Tidak ada data WP.',
    'basis.notCountedAsMultiLogon':                  'Tidak dihitung sebagai multi logon — hanya jejak di tabel kernel.',
    'basis.notWhitelisted':                          'Di luar whitelist',
    'basis.note':                                    'Keterangan',
    'basis.olderThan30DaysConsider':                 'Data sudah lebih dari 30 hari — pertimbangkan fetch ulang.',
    'basis.optional':                                'opsional',
    'basis.outsideRz11Whitelist':                    'di luar whitelist RZ11',
    'basis.parallelSessions':                        'sesi paralel aktif',
    'basis.period':                                  'Per periode',
    'basis.period2':                                 'Periode',
    'basis.range':                                   'Rentang',
    'basis.rangeDays':                               'Rentang (hari)',
    'basis.historyCronRunConfirm':                   'Jalankan sekarang? Ini akan mengecek KPI semua profil SAP dan menulis baris histori baru bila ada perubahan.',
    'basis.historyTitle':                            'Histori KPI (Audit)',
    'basis.historyDiffOnlyNote':                      'baris hanya bertambah bila ada perubahan',
    'basis.historyFrom':                             'Dari tanggal',
    'basis.historyTo':                               'Sampai tanggal',
    'basis.historyLoad':                             'Muat Histori',
    'basis.historyRowCount':                         '{n} baris',
    'basis.historyEmpty':                            'Belum ada histori pada rentang tanggal ini.',
    'basis.historyRecordedAt':                       'Waktu',
    'basis.historyRecordedBy':                       'Oleh',
    'basis.historyBaseline':                         'Data awal (baseline) — belum ada baris pembanding.',
    'basis.historyNoChange':                         'Tidak ada perubahan KPI dibanding baris sebelumnya.',
    'basis.historyChangeIntro':                      'Perubahan:',
    'basis.historyChanges':                          'Perubahan',
    'basis.historyBaselineShort':                    'Baseline',
    'basis.historyLoadingDetail':                   'Memuat detail perubahan...',
    'basis.historyDetailError':                       'Gagal memuat detail perubahan.',
    'basis.historyMoreLines':                         '{n} baris lagi',
    'basis.raw':                                     'Mentah',
    'basis.reason':                                  'Alasan',
    'basis.rows':                                    'baris',
    'basis.rz11Allowed':                             'Diizinkan RZ11',
    'basis.rz11Whitelist':                           'Whitelist RZ11',
    'basis.sapSystemHealthGlance':                   'Health sistem SAP dalam satu layar',
    'basis.sapSystemProfile':                        'Profil Sistem SAP',
    'basis.saveMode':                                'Mode Simpan',
    'basis.savedSnapshot':                           'snapshot tersimpan',
    'basis.searchUserTerminalIp':                    'Cari user / terminal / IP…',
    'basis.selectProfile':                           '— pilih profil —',
    'basis.selectProfileClickLoadView':              'Pilih profil dan klik Muat untuk melihat health sistem.',
    'basis.selectProfileFirst':                      'Pilih profil dulu.',
    'basis.serviceUserSessions':                     'sesi service user',
    'basis.sessions':                                'sesi',
    'basis.sessions2':                               'Sesi',
    'basis.shortDumpDetail':                         'Detail Short Dump',
    'basis.showingFirst500EventsCapped':             'Menampilkan 500 kejadian pertama (capped), dikelompokkan per job.',
    'basis.snapSegments':                            'segmen SNAP',
    'basis.sourceLocalTableSapUsr':                  'Sumber: tabel lokal sap_usr_utl_raw (hasil fetch ZRFC_USR_UTL) — bukan data live SAP. Angka jam dihitung dari kolom durasi tiap sesi.',
    'basis.storedSessions':                          'Sesi tersimpan',
    'basis.summary':                                 'Ringkasan',
    'basis.sybaseLogBackendNotConfigured':           'Sybase Log — backend belum dikonfigurasi (perlu command SM69 ZASE_LOG).',
    'basis.system':                                  'Sistem',
    'basis.time':                                    'Jam',
    'basis.today':                                   'hari ini',
    'basis.topUsersHours':                           'User dengan jam terbanyak',
    'basis.totalHours':                              'Total jam',
    'basis.totalSystemSessions':                     'total sesi sistem',
    'basis.uniqueUsers':                             'User unik',
    'basis.unreadable':                              'tidak terbaca',
    'basis.updateErrorsSm13BackendNot':              'Update Errors (SM13) — backend belum dikonfigurasi (perlu field VBHDR).',
    'basis.updated':                                 'Diperbarui',
    'basis.usageagedaysDaySAgo':                     '{usageAgeDays} hari lalu',
    'basis.userSessions':                            'Sesi user',
    'basis.users':                                   'user',
    'basis.valid':                                   'Berlaku s/d',
    'basis.yes':                                     'Ya',

    // ── dashCtr ──
    'dashCtr.accessDenied':                          'Akses Ditolak',
    'dashCtr.page':                                  'halaman ini',

    // ── noteView ──
    'noteView.by':                                   'oleh',
    'noteView.main':                                 'Utama',
    'noteView.mayHaveBeenDeletedLack':               'Mungkin sudah dihapus, atau Anda tidak punya akses.',
    'noteView.noContent':                            '(belum ada isi)',
    'noteView.noteNotFound':                         'Catatan tidak ditemukan.',
    'noteView.private':                              '🔒 Privat',
    'noteView.shared':                               '👥 Bersama',
    'noteView.untitled':                             '(tanpa judul)',

    // ── notes ──
    'notes.addTab':                                  'Tambah tab',
    'notes.alsoFound':                               'Juga ada di:',
    'notes.anyoneLinkCanViewNote':                   'Siapa pun yang memiliki link ini bisa melihat catatan tanpa login.',
    'notes.back':                                    'Kembali',
    'notes.block':                                   'Blok',
    'notes.blockquote':                              'Kutipan',
    'notes.bullet':                                  'List poin',
    'notes.by':                                      'oleh',
    'notes.cancel':                                  'Batal',
    'notes.clear':                                   'Bersihkan',
    'notes.codeBlock':                               'Blok kode',
    'notes.common':                                  '👥 Bersama',
    'notes.commonAllUsers':                          '👥 Bersama (semua user)',
    'notes.contentMarkdownSupported':                'Isi (mendukung Markdown)',
    'notes.copied':                                  '✅ Tersalin',
    'notes.copy':                                    '📋 Salin',
    'notes.copyLink':                                'Salin tautan',
    'notes.copyMoveNotesPlainNon':                   'Salin / pindahkan ke Notes Plain (non-RAG)',
    'notes.copyPlain':                               'Salin ke Plain',
    'notes.createLink':                              '🔗 Buat Link',
    'notes.creating':                                '⏳ Membuat…',
    'notes.deleteNote':                              'Hapus catatan "',
    'notes.deleted':                                 'Dihapus.',
    'notes.done':                                    'Selesai',
    'notes.dragResizeDoubleClickReset':              'Geser untuk ubah lebar · klik dua kali = reset',
    'notes.editNote':                                '✏️ Edit Catatan',
    'notes.failedCopyLink':                          'Gagal menyalin tautan.',
    'notes.find':                                    'Cari…',
    'notes.find2':                                   '▶ Cari',
    'notes.findReplace':                             'Cari/Ganti',
    'notes.help':                                    'Bantuan',
    'notes.hideList':                                'Sembunyikan daftar',
    'notes.holdTabThenDragReorder':                  'Tahan ⠿ pada tab lalu geser untuk mengurutkan ulang.',
    'notes.holdTabThenDragReorder2':                 'Tahan ⠿ pada tab lalu geser untuk mengurutkan ulang (tersimpan otomatis).',
    'notes.hr':                                      'Garis',
    'notes.lastModified':                            'Terbaru diubah',
    'notes.linkCopied':                              'Tautan disalin.',
    'notes.linkExpiry':                              'Masa berlaku link',
    'notes.linkReadyShare':                          'Link siap dibagikan:',
    'notes.main':                                    'Utama',
    'notes.markdownHelp':                            'Bantuan Markdown',
    'notes.markdownReferenceClickInsert':            'Referensi Markdown — klik untuk sisipkan',
    'notes.move':                                    'Pindah',
    'notes.moveCommon':                              'Pindahkan ke Bersama?',
    'notes.moveCommon2':                             'Pindah ke Bersama',
    'notes.moveMyNotes':                             'Pindahkan ke Catatan Saya?',
    'notes.moveMyNotes2':                            'Pindah ke Catatan Saya',
    'notes.moveRemoveRag':                           'Pindahkan (hapus dari RAG)',
    'notes.myNotes':                                 '🔒 Saya',
    'notes.new':                                     'Baru',
    'notes.newNote':                                 '➕ Catatan Baru',
    'notes.noContent':                               '(belum ada isi)',
    'notes.noContentYet':                            '(belum ada isi)',
    'notes.noMatchingNotes':                         'Tidak ada catatan yang cocok.',
    'notes.noNotesYet':                              'Belum ada catatan.',
    'notes.notFound':                                'Tidak ditemukan',
    'notes.noteIncludingAllTabsWill':                'Catatan (beserta seluruh TAB) akan disalin ke halaman Notes Plain. Pilih Pindahkan bila sekaligus ingin MENGHAPUS dari sini — catatan juga akan DICABUT dari indeks AI (tidak lagi bisa dikutip AI).',
    'notes.noteMoved':                               'Catatan dipindahkan.',
    'notes.noteTitle':                               'Judul catatan',
    'notes.notes':                                   'Catatan',
    'notes.notesPlain':                              'Ke Notes Plain',
    'notes.numbered':                                'List nomor',
    'notes.oldestModified':                          'Terlama diubah',
    'notes.onlyAdminCanMoveShared':                  'Hanya admin yang dapat memindahkan catatan bersama.',
    'notes.openNewTabCleanView':                     'Buka di tab baru (tampilan bersih)',
    'notes.outline':                                 'Daftar isi:',
    'notes.plain':                                   'Ke Plain',
    'notes.privateNotesSharedTeamNotes':             'Catatan pribadi Anda + catatan bersama tim.',
    'notes.privateOnlyMe':                           '🔒 Pribadi (hanya saya)',
    'notes.replace':                                 'Ganti dengan…',
    'notes.replace2':                                'Ganti 1',
    'notes.replaceAll':                              'Ganti Semua',
    'notes.save':                                    '💾 Simpan',
    'notes.saved':                                   'Tersimpan.',
    'notes.saving':                                  '⏳ Menyimpan…',
    'notes.savingOrder':                             'menyimpan urutan…',
    'notes.searchNote':                              'Cari di catatan…',
    'notes.searchTitleContent':                      'Cari judul atau isi…',
    'notes.selectNoteLeftCreateNew':                 'Pilih catatan di kiri, atau buat catatan baru.',
    'notes.selectTextEditorFirstThen':               'Pilih teks di editor lalu klik item di atas untuk membungkusnya.',
    'notes.share':                                   'Bagikan',
    'notes.shareNote':                               'Bagikan Catatan',
    'notes.showList':                                'Tampilkan daftar',
    'notes.sort':                                    'Urut:',
    'notes.svgBlock':                                'Blok SVG',
    'notes.tabTitle':                                'Judul tab',
    'notes.table':                                   'Tabel',
    'notes.text':                                    'Teks',
    'notes.title':                                   'Judul',
    'notes.titleContentRequired':                    'Judul atau isi wajib diisi.',
    'notes.titleZ':                                  'Judul A–Z',
    'notes.titleZ2':                                 'Judul Z–A',
    'notes.untitled':                                '(tanpa judul)',
    'notes.visibility':                              'Visibilitas',

    // ── notesPlain ──
    'notesPlain.addTab':                             'Tambah tab',
    'notesPlain.all':                                'Semua',
    'notesPlain.alsoFound':                          'Juga ada di:',
    'notesPlain.back':                               'Kembali',
    'notesPlain.block':                              'Blok',
    'notesPlain.blockquote':                         'Kutipan',
    'notesPlain.boldText':                           'teks tebal',
    'notesPlain.bullet':                             'List poin',
    'notesPlain.cancel':                             'Batal',
    'notesPlain.close':                              'Tutup',
    'notesPlain.codeBlock':                          'Blok kode',
    'notesPlain.codeHere':                           'kode di sini',
    'notesPlain.collapse':                           'Ciutkan',
    'notesPlain.conversionFailed':                   'Konversi gagal.',
    'notesPlain.converting':                         'Mengonversi…',
    'notesPlain.copyNotesRag':                       'Salin ke Notes (RAG)?',
    'notesPlain.copyNotesRagIndexedInto':            'Salin ke Notes (RAG) — diindeks ke AI KB',
    'notesPlain.copyRag':                            'Salin ke RAG',
    'notesPlain.copyWillAddedNotesRag':              'Salinan catatan akan masuk ke halaman Notes (RAG) dan DIINDEKS ke knowledge base AI. Versi di Notes Plain tetap ada.',
    'notesPlain.dragResizeDoubleClickReset':         'Geser untuk ubah lebar · klik dua kali = reset',
    'notesPlain.editNote':                           'Edit Catatan',
    'notesPlain.empty':                              '(kosong)',
    'notesPlain.find':                               'Cari…',
    'notesPlain.find2':                              '▶ Cari',
    'notesPlain.findReplace':                        'Cari/Ganti',
    'notesPlain.help':                               'Bantuan',
    'notesPlain.holdTabThenDragReorder':             'Tahan ⠿ pada tab lalu geser untuk mengurutkan ulang.',
    'notesPlain.hr':                                 'Garis',
    'notesPlain.imagesLengthClickInsertCursor':      'Gambar ({length}) — klik untuk sisipkan di posisi kursor',
    'notesPlain.importDocument':                     'Impor Dokumen',
    'notesPlain.insertImage':                        'Sisip Gambar',
    'notesPlain.insertImageHint':                    'Sisip gambar (atau tempel/geser-jatuhkan ke editor)',
    'notesPlain.imageOnly':                          'Hanya file gambar (PNG, JPG, WebP, GIF) yang didukung.',
    'notesPlain.imageMax5mb':                        'Gambar maksimal 5 MB per file.',
    'notesPlain.imageInserted':                      '{count} gambar disisipkan ({size}).',
    'notesPlain.imageFailed':                        'Gagal memproses gambar.',
    'notesPlain.imageUnsupportedFormat':             'Format gambar tidak didukung browser ({name}). Foto HEIC/HEIF dari kamera perlu dikonversi ke JPG/PNG dulu.',
    'notesPlain.importPdfWordExcelAs':               'Impor PDF/Word/Excel jadi Markdown (disisipkan di kursor)',
    'notesPlain.insert':                             '➕ Sisip',
    'notesPlain.insertTextCursor':                   'Sisipkan teks di kursor',
    'notesPlain.inserted':                           '✓ Disisipkan',
    'notesPlain.italicText':                         'teks miring',
    'notesPlain.linkTable':                          'Link & Tabel',
    'notesPlain.linkText':                           'teks link',
    'notesPlain.loading':                            'Memuat…',
    'notesPlain.main':                               'Utama',
    'notesPlain.markdownHelp':                       'Bantuan Markdown',
    'notesPlain.markdownImagesInserted':             'Markdown & gambar disisipkan.',
    'notesPlain.markdownReferenceClickInsert':       'Referensi Markdown — klik untuk sisipkan',
    'notesPlain.max10mb':                            'Maksimal 10MB.',
    'notesPlain.moveNotesRag':                       'Pindahkan ke Notes (RAG)?',
    'notesPlain.moveNotesRagRemovedPlain':           'Pindahkan ke Notes (RAG) — dihapus dari Plain',
    'notesPlain.moveRag':                            'Pindah ke RAG',
    'notesPlain.newNote':                            'Catatan Baru',
    'notesPlain.noNotes':                            'Tidak ada catatan.',
    'notesPlain.notFound':                           'Tidak ditemukan',
    'notesPlain.noteDeleted':                        'Catatan dihapus.',
    'notesPlain.noteSaved':                          'Catatan disimpan.',
    'notesPlain.noteTitle':                          'Judul catatan…',
    'notesPlain.noteWillAddedNotesRag':              'Catatan akan masuk ke halaman Notes (RAG), DIINDEKS ke knowledge base AI, dan DIHAPUS dari Notes Plain.',
    'notesPlain.notesDocumentImportNotRag':          'Catatan & impor dokumen — TANPA indeks RAG.',
    'notesPlain.numbered':                           'List nomor',
    'notesPlain.openNotesList':                      'Buka daftar catatan',
    'notesPlain.pdfWordDocxExcelXlsx':               'Hanya PDF, Word (.docx), atau Excel (.xlsx).',
    'notesPlain.preview':                            'Pratinjau',
    'notesPlain.private':                            'Privat',
    'notesPlain.private2':                           '🔒 Privat',
    'notesPlain.promoteRagNotesWhenReady':           'Promote ke Notes RAG bila siap',
    'notesPlain.quote':                              'kutipan',
    'notesPlain.replace':                            'Ganti dengan…',
    'notesPlain.replace2':                           'Ganti 1',
    'notesPlain.replaceAll':                         'Ganti Semua',
    'notesPlain.reviewDocumentConversion':           'Tinjau Hasil Konversi Dokumen',
    'notesPlain.save':                               'Simpan',
    'notesPlain.searchNote':                         'Cari di catatan…',
    'notesPlain.searchNotes':                        'Cari catatan…',
    'notesPlain.selectNoteLeftCreateNew':            'Pilih catatan di kiri, atau buat catatan baru.',
    'notesPlain.selectTextEditorFirstThen':          'Pilih teks di editor lalu klik item di atas untuk membungkusnya.',
    'notesPlain.shared':                             'Bersama',
    'notesPlain.shared2':                            '👥 Bersama',
    'notesPlain.svgBlock':                           'Blok SVG',
    'notesPlain.tabActivetabTitle':                  'Judul Tab {activeTab}…',
    'notesPlain.table':                              'Tabel',
    'notesPlain.text':                               'Teks',
    'notesPlain.title1':                             'Judul 1',
    'notesPlain.title2':                             'Judul 2',
    'notesPlain.title3':                             'Judul 3',
    'notesPlain.titleContentRequired':               'Judul atau isi wajib diisi.',
    'notesPlain.untitled':                           '(tanpa judul)',
    'notesPlain.updated':                            'Diperbarui',
    'notesPlain.writeNoteMarkdown':                  'Tulis catatan dalam Markdown…',
    'notesPlain.yesCopy':                            'Ya, salin',
    'notesPlain.yesMove':                            'Ya, pindahkan',

    // ── sapRole ──
    'sapRole.activeUsers':                           'User aktif yang punya',
    'sapRole.add':                                   'Tambah',
    'sapRole.addChange':                             'Tambah perubahan',
    'sapRole.addRoles':                              'Tambah role',
    'sapRole.applyGenerate':                         'Terapkan + Generate',
    'sapRole.applySap':                              'Terapkan ke SAP?',
    'sapRole.applySap2':                             'Terapkan ke SAP',
    'sapRole.back':                                  'Kembali ke',
    'sapRole.buildObjectCache':                      'Bangun Cache Object',
    'sapRole.cacheClickLoadRolesRefresh':            '(dari cache — klik Muat Role untuk refresh dari SAP)',
    'sapRole.cancel':                                'Batal',
    'sapRole.changeSet':                             'Daftar perubahan',
    'sapRole.changes':                               'perubahan',
    'sapRole.class':                                 'Per Kelas',
    'sapRole.clickBuildObjectCacheStart':            'Klik "Bangun Cache Object" untuk mulai.',
    'sapRole.close':                                 'Tutup',
    'sapRole.confirmRoleChanges':                    'Konfirmasi perubahan role',
    'sapRole.created':                               'Dibuat',
    'sapRole.currentRolesSap':                       'Role sekarang (dari SAP)',
    'sapRole.d':                                     ' hari',
    'sapRole.date':                                  'Tanggal',
    'sapRole.ddDays':                                '≤{dd} hari',
    'sapRole.deleteObjectD':                         'Hapus object (D)',
    'sapRole.eGZEmptyAll':                           'mis. Z_ atau kosong = semua',
    'sapRole.editAuthorizations':                    'Edit Authorization',
    'sapRole.editAuthorizationsWriteSap':            'Edit Authorization (tulis ke SAP)',
    'sapRole.errorOccurred':                         'Terjadi kesalahan.',
    'sapRole.expiring30Days':                        'Expire ≤30 hari',
    'sapRole.failedReadAuthObjects':                 'Auth object gagal dibaca: ',
    'sapRole.fieldEGActvt':                          'Field (mis. ACTVT)',
    'sapRole.finalLengthRolesWrittenSap':            'Daftar final: {length} role. Perubahan langsung ditulis ke SAP dan dicatat di Activity Log.',
    'sapRole.finalListPreview':                      'Preview daftar final',
    'sapRole.from':                                  'Dari',
    'sapRole.generateProfile':                       'Generate profil',
    'sapRole.generateProfile2':                      ' · generate profil',
    'sapRole.iInsertUUpdateO':                       'I=insert, U=update value, O=org level ($BUKRS/$WERKS…), D=hapus object. AUTH instance & detail dieksekusi oleh FM Z.',
    'sapRole.ind':                                   'Jenis',
    'sapRole.insertI':                               'Tambah/isi (I)',
    'sapRole.limitedLatest500':                      ' (dibatasi 500 terbaru)',
    'sapRole.load':                                  'Muat',
    'sapRole.loadRoles':                             'Muat Role',
    'sapRole.loading':                               'Memuat…',
    'sapRole.loadingDetail':                         'Memuat detail…',
    'sapRole.loadingList':                           'Memuat daftar…',
    'sapRole.loadingMenu':                           'Memuat menu…',
    'sapRole.loadingObjects':                        'Memuat object…',
    'sapRole.loadingRolesSap':                       'Memuat role dari SAP…',
    'sapRole.manageRoles':                           'Kelola Role',
    'sapRole.maximize':                              'Perbesar',
    'sapRole.newValue':                              'Nilai Baru',
    'sapRole.noAssignmentsNotLoadedYet':             'Tidak ada assignment / belum dimuat.',
    'sapRole.noAuthorizationObjects':                'Tidak ada authorization object.',
    'sapRole.noCacheYetBuildFirst':                  'Belum ada cache — bangun dulu (baca AGR_1251 sekali).',
    'sapRole.noChangesPeriodPfcgChange':             'Tidak ada perubahan pada periode ini (atau change document PFCG belum aktif).',
    'sapRole.noChangesYet':                          'Belum ada perubahan.',
    'sapRole.noChildRoles':                          'Tidak ada child.',
    'sapRole.noClass':                               '(tanpa kelas)',
    'sapRole.noDataNotLoadedYet':                    'Tidak ada data / belum dimuat.',
    'sapRole.noFieldDetailEmptyCdpos':               'Tidak ada detail field (CDPOS kosong untuk perubahan ini).',
    'sapRole.noFields':                              '(tanpa field)',
    'sapRole.noMatch':                               'Tidak ada yang cocok.',
    'sapRole.noMatchingObjects':                     'Tidak ada object yang cocok.',
    'sapRole.noMatchingTcodes':                      'Tidak ada tcode yang cocok.',
    'sapRole.noRelatedRoles':                        'Tidak ada role terkait.',
    'sapRole.noRoles':                               'Tidak ada role.',
    'sapRole.noRolesActiveUsersNot':                 'Tidak ada role dengan user aktif / belum dimuat.',
    'sapRole.noRolesFound':                          'Tidak ada role.',
    'sapRole.noTcodes':                              '(tidak ada tcode)',
    'sapRole.noTcodesNotLoadedYet':                  'Tidak ada tcode / belum dimuat.',
    'sapRole.noTcodesPossiblyCompositeRole':         'Tidak ada tcode (mungkin composite role).',
    'sapRole.noUsers':                               'Tidak ada user.',
    'sapRole.noUsersAssigned':                       'Tidak ada user.',
    'sapRole.noUsersObjects':                        'Tidak ada user/object.',
    'sapRole.objectEGSTcode':                        'Object (mis. S_TCODE)',
    'sapRole.of':                                    'dari',
    'sapRole.oldValue':                              'Nilai Lama',
    'sapRole.onlyAssignedRoles':                     'Hanya role yang dipakai',
    'sapRole.openRoleDetail':                        'Buka detail role',
    'sapRole.openValueEditorDownloadSap':            'Buka editor value: download .SAP manual dari PFCG (menu Download), edit di sini, lalu upload balik ke PFCG',
    'sapRole.orphan0Users':                          'Orphan (0 user)',
    'sapRole.pageReadOnlyPhase1':                    'Audit role, assignment, tcode, dan komposisi composite role (dibaca via RFC_READ_TABLE dari tabel AGR_*). User dengan akses tulis role bisa assign role dan edit authorization (insert / replace / delete + generate) pada profil yang sudah dikonfigurasi Z_ROLE_AUTH_MODIFY. Client produktif (mis. P01) wajib mencentang "Allow productive client" di editor.',
    'sapRole.period':                                'Periode',
    'sapRole.profileHasNoPasswordSet':               '⚠ Profil belum punya password — isi di Table Maintenance → SAP Config.',
    'sapRole.profileSapConfig':                      'Profil (dari SAP Config)',
    'sapRole.readingAgr1251':                        'Membaca AGR_1251…',
    'sapRole.readingDetailCdpos':                    'Membaca detail (CDPOS)…',
    'sapRole.rebuildCache':                          'Bangun Ulang Cache',
    'sapRole.relatedRoles':                          'Role terkait',
    'sapRole.remove':                                'Hapus',
    'sapRole.removesAllRolesTickAllow':              'Perubahan ini menghapus SEMUA role. Centang "izinkan kosong" untuk melanjutkan.',
    'sapRole.restore':                               'Perkecil',
    'sapRole.rfcReadTableServicePath':               'Service Path RFC_READ_TABLE belum diisi — isi di SAP Config.',
    'sapRole.roleFilterPrefixOptional':              'Filter role (awalan, opsional)',
    'sapRole.roleMenuEmpty':                         'Role menu kosong.',
    'sapRole.roleNameEGZ':                           'Nama role (mis. Z_GENERAL)',
    'sapRole.roleObjectChangeHistory':               'Riwayat Perubahan Role / Object',
    'sapRole.roleUsers':                             'Role → User',
    'sapRole.roles':                                 'role',
    'sapRole.rolesAssigned':                         'role (yang dipakai)',
    'sapRole.rolesContainingTcode':                  'Role yang memuat tcode',
    'sapRole.rolesManageuserUpdated':                'Role {manageUser} berhasil diperbarui.',
    'sapRole.rolesTcode':                            'Role dengan tcode',
    'sapRole.saving':                                'Menyimpan…',
    'sapRole.searchObject':                          'Cari object…',
    'sapRole.searchRoleDescription':                 'Cari role / deskripsi…',
    'sapRole.searchTab':                             'Cari di tab ini…',
    'sapRole.searchTcode':                           'Cari tcode…',
    'sapRole.searchUsername':                        'Cari username…',
    'sapRole.selectProfile':                         '— pilih profil —',
    'sapRole.selectSapSystem':                       'Pilih Sistem SAP',
    'sapRole.showing':                               'menampilkan',
    'sapRole.simulate':                              'Simulasi',
    'sapRole.simulationOk':                          'Simulasi OK: ',
    'sapRole.someTablesFailedRead':                  'Sebagian tabel gagal dibaca: ',
    'sapRole.table':                                 'Tabel',
    'sapRole.tcodeUsers':                            'Tcode → User',
    'sapRole.to':                                    'Sampai',
    'sapRole.totalRoles':                            'Total Role',
    'sapRole.type':                                  'Tipe',
    'sapRole.undo':                                  'Batal',
    'sapRole.unlimited':                             'tanpa batas',
    'sapRole.updateU':                               'Ubah value (U)',
    'sapRole.user':                                  'Untuk user',
    'sapRole.userHasNoRoles':                        'User belum punya role.',
    'sapRole.userObjects':                           'User → Object',
    'sapRole.userRoles':                             'User → Role',
    'sapRole.userSRolesContainingObject':            'Role user ini yang memuat object',
    'sapRole.userTcodes':                            'User → Tcode',
    'sapRole.valueEditorPfcgFile':                   'Editor Value (file PFCG)',
    'sapRole.valueEditorSap':                        'Editor Value .SAP',
    'sapRole.writesSapTestNonPrd':                   'Menulis ke SAP. Uji di sistem non-PRD dulu.',
    'sapRole.writesSapViaZRole':                     'Menulis ke SAP via Z_ROLE_AUTH_MODIFY + generate. Uji di DEV dulu.',
    'sapRole.writtenSapImmediatelyLoggedMake':       'Perubahan langsung ditulis ke SAP dan dicatat di Activity Log. Pastikan ini bukan sistem produksi kecuali memang disengaja.',
    'sapRole.yesApply':                              'Ya, terapkan',

    // ── sapUser ──
    'sapUser.actions':                               'Aksi',
    'sapUser.actionsHereWriteDirectlySap':           'Aksi di halaman ini menulis langsung ke SAP (lock/unlock & reset password). Hanya user dialog yang ditampilkan. Semua aksi tercatat di Activity Log.',
    'sapUser.active':                                'Aktif',
    'sapUser.active2':                               'aktif',
    'sapUser.activeOnly':                            'Aktif saja',
    'sapUser.activeUsers':                           'user aktif dari',
    'sapUser.blank':                                 '(kosong)',
    'sapUser.cancel':                                'Batal',
    'sapUser.clear':                                 'Bersihkan',
    'sapUser.companyAll':                            'Company: semua',
    'sapUser.dataAs':                                'Data per',
    'sapUser.dbSnapshotClickLoadUsers':              'Dari snapshot DB — klik Muat User untuk refresh dari SAP.',
    'sapUser.dialogUsers':                           'User Dialog',
    'sapUser.dialogUsers2':                          'user dialog',
    'sapUser.distributionPerCompany':                'Distribusi per Company',
    'sapUser.eGWelcome1':                            'mis. Welcome1!',
    'sapUser.editDetails':                           'Edit detail',
    'sapUser.editDetails2':                          'Edit Detail',
    'sapUser.editUserDetails':                       'Edit Detail User',
    'sapUser.emptyDateUnlimitedOnlyChanged':         'Kosongkan tanggal = tanpa batas. Hanya field yang diubah yang dikirim ke SAP.',
    'sapUser.errorOccurred':                         'Terjadi kesalahan.',
    'sapUser.failed':                                'gagal',
    'sapUser.firstName':                             'Nama Depan',
    'sapUser.fullName':                              'Nama Lengkap',
    'sapUser.inactiveUsersExcluded':                 'user nonaktif tidak dihitung',
    'sapUser.lastName':                              'Nama Belakang',
    'sapUser.licenseAll':                            'License: semua',
    'sapUser.licenseDistributionAllCompanies':       'Distribusi License (semua company)',
    'sapUser.licenseSummaryActiveUsers':             'Ringkasan License — User Aktif',
    'sapUser.loadUsers':                             'Muat User',
    'sapUser.loading':                               'Memuat…',
    'sapUser.lockReason':                            'Alasan lock',
    'sapUser.lockSelected':                          'Lock terpilih',
    'sapUser.locked':                                'Terkunci',
    'sapUser.lockedOnly':                            'Locked saja',
    'sapUser.missingServicePaths':                   'Service path belum lengkap: ',
    'sapUser.moduleAll':                             'Module: semua',
    'sapUser.newPassword':                           'Password Baru',
    'sapUser.newPasswordInitialUserMust':            'Password baru bersifat initial — user wajib menggantinya saat login berikutnya.',
    'sapUser.noDialogUsers':                         'Tidak ada user dialog.',
    'sapUser.noExpiry':                              'Tanpa batas',
    'sapUser.noExpiry2':                             '∞ (tanpa batas)',
    'sapUser.noLicense':                             '(tanpa license)',
    'sapUser.noUsersMatchFilter':                    'Tidak ada user sesuai filter.',
    'sapUser.ok':                                    'berhasil',
    'sapUser.passwordReset':                         'Password direset',
    'sapUser.processing':                            'Memproses…',
    'sapUser.profileHasNoPasswordSet':               '⚠ Profil belum punya password — isi di Table Maintenance → SAP Config.',
    'sapUser.profileSapConfig':                      'Profil (dari SAP Config)',
    'sapUser.relatedListActionsBlockedUntil':        ' — aksi/list terkait ditolak sampai diisi di SAP Config.',
    'sapUser.saveSap':                               'Simpan ke SAP',
    'sapUser.saving':                                'Menyimpan…',
    'sapUser.searchUserNameEmail':                   'Cari user/nama/email…',
    'sapUser.selectProfile':                         '— pilih profil —',
    'sapUser.selectSapSystem':                       'Pilih Sistem SAP',
    'sapUser.selected':                              'terpilih',
    'sapUser.someEnrichmentFailed':                  'Enrichment sebagian gagal — ',
    'sapUser.summary':                               'Ringkasan',
    'sapUser.totalUsage':                            'Total Pemakaian',
    'sapUser.unlockSelected':                        'Unlock terpilih',
    'sapUser.unlocked':                              'Terbuka',
    'sapUser.userDetailsUpdated':                    'Detail user diperbarui',
    'sapUser.users':                                 'user',
    'sapUser.valid':                                 'Valid Dari',
    'sapUser.validThrough':                          'Valid s/d',

    // ── sdp ──
    'sdp.activeFilter':                              'Filter aktif:',
    'sdp.all':                                       'Semua',
    'sdp.assetAnalytics':                            '— ANALITIK ASSET —',
    'sdp.assetsManufacturerTop10':                   'Asset per Manufacturer (Top 10)',
    'sdp.assetsRegion':                              'Asset per Region',
    'sdp.assetsType':                                'Asset per Tipe',
    'sdp.auditFailed':                               'Audit Gagal',
    'sdp.auditSuccess':                              'Audit Sukses',
    'sdp.auditTime':                                 'Waktu Audit',
    'sdp.avgResolutionDays':                         'Rata² Penyelesaian (hari)',
    'sdp.avgResolutionTimePriorityDays':             'Rata² Waktu Penyelesaian per Priority (hari)',
    'sdp.clickSort':                                 'Klik untuk urutkan',
    'sdp.closedRequests':                            'Request Selesai',
    'sdp.dataCompletenessSerialHaveSerial':          'Kelengkapan data: {serial}% ada serial number, {region}% ada region, {audited}% pernah diaudit, {barcode}% ada barcode.',
    'sdp.description':                               'Keterangan',
    'sdp.escalated':                                 'Ter-eskalasi',
    'sdp.failedAuditAssetsLength':                   'Aset Gagal Audit ({length})',
    'sdp.issueCategoriesTop10':                      'Kategori Masalah (Top 10)',
    'sdp.loading':                                   'Memuat…',
    'sdp.monthlyTicketVolumeTrend':                  'Tren Volume Tiket per Bulan',
    'sdp.name':                                      'Nama',
    'sdp.noData':                                    'Tidak ada data.',
    'sdp.noDataYetRunTable':                         'Belum ada data? Jalankan Run Now di Table Maintenance → SDP Cloud.',
    'sdp.none':                                      'Tidak ada.',
    'sdp.notAudited':                                'Belum Diaudit',
    'sdp.openRequests':                              'Request Terbuka',
    'sdp.overdueTickets':                            'Tiket Overdue',
    'sdp.reload':                                    'Muat ulang',
    'sdp.requestsStatus':                            'Request per Status',
    'sdp.search':                                    'Cari…',
    'sdp.serialNumber':                              '% Ada Serial Number',
    'sdp.sites':                                     'Jumlah Site',
    'sdp.slaOverduePriority':                        'SLA — % Overdue per Priority',
    'sdp.statusClosed':                              'Status: Selesai',
    'sdp.statusOpen':                                'Status: Terbuka',
    'sdp.technician':                                'Teknisi',
    'sdp.technicianWorkloadLength':                  'Beban Kerja Teknisi ({length})',
    'sdp.ticketingAssetsServicedeskPlusCloud':       'Ticketing & Asset dari ServiceDesk Plus Cloud (read-only).',
    'sdp.totalTickets':                              'Total Tiket',
    'sdp.year':                                      'Tahun:',

    // ── shared ──
    'shared.aiAssistant':                            'Asisten AI',
    'shared.aiHasNotBeenEnabled':                    'AI belum diaktifkan untuk link ini. Hubungi pembuat link.',
    'shared.aiModelUsed':                            'Model AI yang dipakai',
    'shared.aiTyping':                               'AI sedang mengetik…',
    'shared.askAboutDashboardSData':                 'Tanya tentang data dashboard ini.',
    'shared.askAi':                                  '✨ Tanya AI',
    'shared.askAnythingAboutTeamS':                  'Tanya apa saja tentang catatan umum tim.',
    'shared.availableCommandsHelpShowHelp':          '**Perintah tersedia:**\n- `/help` — tampilkan bantuan ini\n- `/sql` — tampilkan SQL dari jawaban data terakhir\n- `/clear` (atau `/new`, `/reset`) — mulai sesi baru',
    'shared.avgResponseTime':                        'Rata-rata waktu respons',
    'shared.by':                                     'oleh',
    'shared.cancel':                                 'Batal',
    'shared.clickShowFull':                          'Klik untuk tampil penuh',
    'shared.dashboardNotAvailableSharing':           'Dashboard ini tidak tersedia untuk dibagikan.',
    'shared.editResend':                             'Edit & kirim ulang',
    'shared.failedGetAnswer':                        'Gagal memuat jawaban.',
    'shared.failedLoadNote':                         'Gagal memuat catatan.',
    'shared.general':                                'Umum',
    'shared.invalidLink':                            'Link tidak valid.',
    'shared.linkInvalidHasExpired':                  'Link tidak valid atau sudah kedaluwarsa.',
    'shared.linkUnavailable':                        'Link Tidak Tersedia',
    'shared.loadingNote':                            'Memuat catatan…',
    'shared.maximize':                               'Perbesar',
    'shared.minimize':                               'Perkecil',
    'shared.noContent':                              '(tidak ada isi)',
    'shared.noSqlYetAskData':                        'Belum ada SQL. Ajukan pertanyaan data dulu.',
    'shared.notesCommon':                            'Catatan (umum)',
    'shared.publicViewReadOnly':                     'Tampilan publik · hanya-baca',
    'shared.readOnly':                               'Hanya-baca',
    'shared.resend':                                 'Kirim ulang',
    'shared.resize':                                 'Ubah ukuran',
    'shared.responseTime':                           'Waktu respons',
    'shared.send':                                   'Kirim',
    'shared.sqlLastAnswer':                          'SQL dari jawaban terakhir:',
    'shared.startGeneralConversationAi':             'Mulai percakapan umum dengan AI.',
    'shared.tokensPromptCompletionTotal':            'Token: prompt / jawaban / total',
    'shared.typeQuestion':                           'Tulis pertanyaan…',
    'shared.typeQuestionHelpCommands':               'Tulis pertanyaan… (/help untuk perintah)',
    'shared.unknownCommandCmdTypeHelp':              'Perintah `/{cmd}` tidak dikenal. Ketik `/help`.',
    'shared.untitled':                               '(tanpa judul)',


    // ══ Migrasi lanjutan: AWS Inventory / CloudTrail / Role Auth Editor ══
    // ── awsInv ──
    'awsInv.account':                                'Akun',
    'awsInv.actionsEnabled':                         'Actions Aktif',
    'awsInv.addInboundRule':                         'Tambah inbound rule',
    'awsInv.addRule':                                'Tambah Rule',
    'awsInv.addTag':                                 'Tambah tag',
    'awsInv.adding':                                 'Menambah…',
    'awsInv.analysisStillRunningTryAgain':           'Analisis masih berjalan, coba lagi sebentar.',
    'awsInv.analytics':                              'Analitik',
    'awsInv.analyzingServiceAccess':                 'Menganalisis akses service…',
    'awsInv.associated':                             'Terhubung',
    'awsInv.associatedInstance':                     'Instance Terhubung',
    'awsInv.attachments':                            'Attachment',
    'awsInv.bucketEmpty':                            'Bucket kosong.',
    'awsInv.cancel':                                 'Batal',
    'awsInv.clickObjectsTabLoad':                    'Klik tab Objects untuk memuat.',
    'awsInv.clickRefreshFetchResourcesAws':          'Klik Refresh untuk mengambil data resource dari AWS.',
    'awsInv.clickTabLoadHistory':                    'Klik tab untuk muat riwayat.',
    'awsInv.clickTabLoadRules':                      'Klik tab untuk memuat rules.',
    'awsInv.close':                                  'Tutup',
    'awsInv.consoleLastLogin':                       'Login Konsol Terakhir',
    'awsInv.created':                                'Dibuat',
    'awsInv.details':                                'Detail',
    'awsInv.disabled':                               'Nonaktif',
    'awsInv.eipNotAssociatedAnyInstance':            'EIP ini tidak terhubung ke instance manapun (biaya idle).',
    'awsInv.enabled':                                'Aktif',
    'awsInv.entities':                               'Entitas',
    'awsInv.evaluationPeriods':                      'Periode Evaluasi',
    'awsInv.fetching12Min':                          'Mengambil data… (1–2 menit)',
    'awsInv.fetchingBucketContents':                 'Memuat isi bucket…',
    'awsInv.files':                                  'file',
    'awsInv.folders':                                'folder',
    'awsInv.groupName':                              'Nama Grup',
    'awsInv.groups':                                 'Grup',
    'awsInv.hideSidebar':                            'Sembunyikan sidebar',
    'awsInv.history':                                'Riwayat',
    'awsInv.lastAccessed':                           'Terakhir Diakses',
    'awsInv.lastUsed':                               'Terakhir Dipakai',
    'awsInv.lengthWarningsDuringFetch':              '{length} peringatan saat fetch',
    'awsInv.loadLastAccessDataAccess':               'Muat data Last Access (Access Advisor)',
    'awsInv.loading':                                'Memuat…',
    'awsInv.maxSession':                             'Durasi Sesi Maks',
    'awsInv.never':                                  'Tidak pernah',
    'awsInv.newPasswordCopyShareSecurely':           'Password baru (salin & sampaikan ke user secara aman — hanya tampil sekali):',
    'awsInv.no':                                     'Tidak',
    'awsInv.noAccessKeys':                           'Tidak ada access key.',
    'awsInv.noAttachments':                          'Tidak ada attachment.',
    'awsInv.noBusinessUnit':                         'Tanpa Business Unit',
    'awsInv.noHistoryFound':                         'Tidak ada riwayat.',
    'awsInv.noInboundRules':                         'Tidak ada aturan inbound.',
    'awsInv.noInventoryYet':                         'Belum ada data inventory',
    'awsInv.noOutboundRules':                        'Tidak ada aturan outbound.',
    'awsInv.noPoliciesAttached':                     'Tidak ada policy.',
    'awsInv.noRelatedSnapshots':                     'Tidak ada snapshot terkait.',
    'awsInv.noResources':                            'Tidak ada resource.',
    'awsInv.noResults':                              'Tidak ada hasil.',
    'awsInv.noResultsFound':                         'Tidak ada hasil.',
    'awsInv.noRoutes':                               'Tidak ada route.',
    'awsInv.noSecurityGroups':                       'Tidak ada security group.',
    'awsInv.noServiceAccessRecorded':                'Tidak ada akses service tercatat.',
    'awsInv.noTunnels':                              'Tidak ada tunnel.',
    'awsInv.noVolumes':                              'Tidak ada volume.',
    'awsInv.none':                                   'Tidak ada',
    'awsInv.notAssociated':                          'Tidak terhubung',
    'awsInv.notAttached':                            'Tidak terpasang.',
    'awsInv.notMemberAnyGroup':                      'Bukan anggota grup mana pun.',
    'awsInv.optional':                               'opsional',
    'awsInv.permissions':                            'Permission',
    'awsInv.cronConfirm':                            'Jalankan fetch AWS Inventory sekarang? Memindai 19 region (1–2 menit), me-REPLACE snapshot saat ini, dan mencatat selisihnya ke change log.',
    'awsInv.refreshAws':                             'Refresh dari AWS',
    'awsInv.regionsScanned':                         'Region Discan',
    'awsInv.remediationGuide':                       'Panduan Remediasi',
    'awsInv.removeInboundRuleProtocolPorts':         'Hapus inbound rule {protocol} {ports} dari {source}?',
    'awsInv.resetConsolePassword':                   'Reset Password Konsol',
    'awsInv.resetConsolePasswordNameNew':            'Reset console password untuk "{name}"? Password baru akan digenerate dan user wajib menggantinya saat login pertama.',
    'awsInv.resetPasswordRandom':                    'Reset Password (acak)',
    'awsInv.resetting':                              'Mereset…',
    'awsInv.resourceDetail':                         'Detail resource',
    'awsInv.resources':                              'resource',
    'awsInv.resourcesPerService':                    'Resource per Service',
    'awsInv.results':                                'hasil',
    'awsInv.resultsCapped50RefineQuery':             'Hasil dibatasi 50. Tambah kata kunci untuk mempersempit.',
    'awsInv.roleLastUsed':                           'Role Terakhir Dipakai',
    'awsInv.save':                                   'Simpan',
    'awsInv.saved':                                  'Tersimpan',
    'awsInv.saving':                                 'Menyimpan…',
    'awsInv.search':                                 'Cari…',
    'awsInv.searchAllResourcesIdName':               'Cari semua resource… (ID, nama, IP, tag, status, dll)',
    'awsInv.securityCredentials':                    'Kredensial',
    'awsInv.serviceTypes':                           'Jenis Service',
    'awsInv.showSidebar':                            'Tampilkan sidebar',
    'awsInv.sourceRequired':                         'Source wajib diisi (mis. 0.0.0.0/0 atau sg-xxx).',
    'awsInv.stateReason':                            'Alasan State',
    'awsInv.stateUpdated':                           'State Diperbarui',
    'awsInv.totalResources':                         'Total Resource',
    'awsInv.treatMissingData':                       'Data Hilang',
    'awsInv.updated':                                'Diperbarui',
    'awsInv.userMustChangePasswordFirst':            'User wajib mengganti password saat login pertama.',
    'awsInv.volumes':                                'volume',
    'awsInv.yes':                                    'Ya',

    // ── awsTrail ──
    'awsTrail.account':                              'Akun',
    'awsTrail.action':                               'sebuah aksi',
    'awsTrail.affectedResources':                    'Resource terdampak',
    'awsTrail.allEvents':                            'semua event',
    'awsTrail.allRegions':                           'Semua region',
    'awsTrail.analytics':                            'Analitik',
    'awsTrail.backList':                             'Kembali ke daftar',
    'awsTrail.clickRefreshFetchActivityEvents':      'Klik Refresh untuk mengambil event aktivitas dari AWS.',
    'awsTrail.clickResetFilters':                    'klik utk reset filter',
    'awsTrail.clickViewFailures':                    'klik utk lihat yang gagal',
    'awsTrail.collapseAll':                          'Tutup semua',
    'awsTrail.copied':                               'Disalin',
    'awsTrail.copy':                                 'Salin',
    'awsTrail.copyJson':                             'Salin JSON',
    'awsTrail.days':                                 'hari',
    'awsTrail.days2':                                'Hari',
    'awsTrail.errorsOnly':                           'Hanya gagal',
    'awsTrail.eventDetail':                          'Detail event',
    'awsTrail.eventFailed':                          'Event gagal.',
    'awsTrail.events':                               'event',
    'awsTrail.expandAll':                            'Buka semua',
    'awsTrail.failed':                               'Gagal',
    'awsTrail.failedEvents':                         'Event Gagal',
    'awsTrail.failedRegions':                        'Region gagal',
    'awsTrail.fetching13Min':                        'Mengambil data… (1–3 menit)',
    'awsTrail.hoverBreakdown':                       'arahkan kursor utk rincian',
    'awsTrail.includeReadOnly':                      'Semua event (read-only)',
    'awsTrail.jsonDetail':                           'Detail JSON',
    'awsTrail.lengthRegionSFailedFetch':             '{length} region gagal di-fetch — hasil mungkin tidak lengkap.',
    'awsTrail.loading':                              'Memuat…',
    'awsTrail.name':                                 'Nama',
    'awsTrail.noCloudtrailDataYet':                  'Belum ada data CloudTrail',
    'awsTrail.noEvents':                             'Tidak ada event.',
    'awsTrail.noMfa':                                'Tanpa MFA',
    'awsTrail.noResults':                            'Tidak ada hasil.',
    'awsTrail.oftenCausedCloudtrailApiThrottling':   'Sering disebabkan throttling API CloudTrail saat window besar / banyak region. Klik untuk detail.',
    'awsTrail.publicIp':                             'IP Publik',
    'awsTrail.readOnly':                             'Hanya-baca',
    'awsTrail.refreshAws':                           'Refresh dari AWS',
    'awsTrail.regionsNoEvents':                      'Region tanpa event',
    'awsTrail.regionsScanned':                       'Region Discan',
    'awsTrail.search':                               'Cari…',
    'awsTrail.service':                              'Layanan',
    'awsTrail.success':                              'Berhasil',
    'awsTrail.time':                                 'Waktu',
    'awsTrail.topEvent':                             'Event Teratas',
    'awsTrail.totalEvents':                          'Total Event',
    'awsTrail.unknownUser':                          'Pengguna tak dikenal',
    'awsTrail.updated':                              'Diperbarui',
    'awsTrail.user':                                 'Pengguna',
    'awsTrail.what':                                 'Apa',
    'awsTrail.where':                                'Dari Mana',
    'awsTrail.who':                                  'Siapa',

    // ── roleAuthEd ──
    'roleAuthEd.authorizationValueEditorPfcgFile':   'Editor Value Authorization (file PFCG)',
    'roleAuthEd.downloadResult':                     'Unduh file hasil',
    'roleAuthEd.editFieldValuesThenUpload':          'Edit value field lalu unggah kembali ke PFCG. Tidak menyentuh SAP dari sini.',
    'roleAuthEd.failedLoadFileSap':                  'Gagal memuat file dari SAP: ',
    'roleAuthEd.failedReadFile':                     'Gagal membaca file: ',
    'roleAuthEd.noAgr1251RowsFound':                 'Tidak menemukan baris AGR_1251 (value authorization) di file ini.',
    'roleAuthEd.noChangesYet':                       'Belum ada perubahan',
    'roleAuthEd.noMatchingValues':                   'Tidak ada value yang cocok.',
    'roleAuthEd.searchObjectField':                  'Cari object / field…',
    'roleAuthEd.someValuesExceedVWidth':             'Ada value melebihi {V_WIDTH} karakter. Perbaiki dulu.',
    'roleAuthEd.someValuesTooLong':                  '· ada value terlalu panjang',
    'roleAuthEd.uploadPfcgRoleDownloadFile':         'Unggah file hasil Download role dari PFCG untuk mulai mengedit value.',
    'roleAuthEd.uploadSapFile':                      'Unggah file .SAP',
    'roleAuthEd.valuesChanged':                      'value diubah',


    // ── File Deploy (fdeploy) ──
    'fdeploy.adaPerubahanBelumDisimpanTutup':        'Ada perubahan yang belum disimpan. Tutup?',
    'fdeploy.adaSubfolderFileJsJsx':                 'Tidak ada subfolder / file .js/.jsx di sini.',
    'fdeploy.aiService':                             'AI Service',
    'fdeploy.aiServiceRestartSekaliSetelah':         'AI Service di-restart sekali setelah semua file tertulis.',
    'fdeploy.aiServiceRestartSetelahnya':            'AI Service akan di-restart setelahnya.',
    'fdeploy.aiServiceSedangRestartTunggu':          'AI-service sedang restart — tunggu ±10 detik.',
    'fdeploy.aksi':                                  'Aksi',
    'fdeploy.ambilLogTerbaruSemuaProses':            'Ambil log terbaru semua proses via',
    'fdeploy.autocomplete':                          'autocomplete  ·',
    'fdeploy.backend':                               'Backend',
    'fdeploy.backendRestartSekaliSetelahSemua':      'Backend di-restart sekali setelah semua file tertulis.',
    'fdeploy.backendRestartSetelahnya':              'Backend akan di-restart setelahnya.',
    'fdeploy.backendSedangRestartTunggu10':          'Backend sedang restart — tunggu ±10 detik lalu refresh halaman.',
    'fdeploy.backup2':                               '📸 Backup',
    'fdeploy.backup3':                               ' (backup: {backupName})',
    'fdeploy.backupSekarang':                        '📸 Backup sekarang',
    'fdeploy.backupSemua':                           '💾 Backup SEMUA',
    'fdeploy.backupSemuaFile':                       'Backup SEMUA file',
    'fdeploy.baru':                                  '→ baru',
    'fdeploy.baru2':                                 '→  Baru:',
    'fdeploy.batal':                                 'Batal',
    'fdeploy.batal2':                                '✕ Batal',
    'fdeploy.bedakanHurufBesarKecil':                'Bedakan huruf besar/kecil',
    'fdeploy.belumAdaBackupFile':                    'Belum ada backup untuk file ini.',
    'fdeploy.belumAdaFileKlikTambah':                'Belum ada file. Klik “Tambah file…”, lalu set path tujuan tiap file.',
    'fdeploy.belumAdaRiwayatDiffFile':               'Belum ada riwayat diff untuk file ini (hanya tercatat saat deploy via tab Deploy).',
    'fdeploy.berhasilRename':                        'Berhasil di-rename.',
    'fdeploy.bersihkan':                             '✖ Bersihkan',
    'fdeploy.bersihkanSemua':                        'Bersihkan semua',
    'fdeploy.bisaDibatalkan':                        'tidak bisa dibatalkan',
    'fdeploy.browse':                                '📂 Browse',
    'fdeploy.browseServer':                          '📂 Browse server',
    'fdeploy.btnDeployMixed':                        '🚀 Deploy {n} file, Rebuild & Restart',
    'fdeploy.btnDeployRebuild':                      '🚀 Deploy {n} file & Rebuild',
    'fdeploy.btnDeployRestart':                      '🚀 Deploy {n} file & Restart',
    'fdeploy.buildBerjalan':                         '⏳ Build berjalan…',
    'fdeploy.buildFrontend':                         '🔨 Build frontend',
    'fdeploy.buildFrontendSekarang':                 '🔨 Build frontend sekarang',
    'fdeploy.buildSelesaiHardRefreshCtrl':           'Build selesai. Hard-refresh (Ctrl+Shift+R) untuk memuat versi baru.',
    'fdeploy.building':                              '⏳ Building…',
    'fdeploy.cari2':                                 'Cari',
    'fdeploy.cariBackup':                            'Cari backup',
    'fdeploy.cariDiFile':                            'Cari di file',
    'fdeploy.clear':                                 '🗑 Clear',
    'fdeploy.clearOutput':                           'clear output',
    'fdeploy.confirmBackupAll':                      'Backup semua file .js/.jsx di {type} ({code}) secara rekursif?',
    'fdeploy.confirmDeleteOne':                      'Hapus {code}?',
    'fdeploy.confirmDeleteSelected':                 'Hapus {b} item yang dipilih?',
    'fdeploy.confirmDeployMulti':                    'Deploy {n} file ke {type}? File lama tiap path di-backup otomatis. Tanpa preview/diff.',
    'fdeploy.confirmDeployOne':                      'Deploy {name} ke {type} pada path {code}?',
    'fdeploy.confirmRestore':                        'Pulihkan {code} dari backup {b}?',
    'fdeploy.connectSsh':                            '🔌 Connect SSH',
    'fdeploy.connecting':                            '⏳ Connecting…',
    'fdeploy.copyLog':                               '📄 Copy log',
    'fdeploy.ctrlC':                                 'Ctrl+C',
    'fdeploy.ctrlD':                                 'Ctrl+D',
    'fdeploy.ctrlL':                                 'Ctrl+L',
    'fdeploy.ctrlS':                                 'Ctrl+S',
    'fdeploy.dashboardAiServiceDll':                 '(dashboard, ai-service, dll).',
    'fdeploy.deployRebuildFrontend':                 'Deploy & Rebuild frontend',
    'fdeploy.deployRestartAiService':                'Deploy & Restart AI Service',
    'fdeploy.deployRestartBackend':                  'Deploy & Restart backend',
    'fdeploy.diff':                                  'Diff: {rel}',
    'fdeploy.diff2':                                 'Diff:',
    'fdeploy.diff3':                                 'Diff: {targetPath}',
    'fdeploy.dihapus':                               'Dihapus: {p}',
    'fdeploy.dipulihkanJalankanRebuildTabDeploy':    'Dipulihkan dari {backupName}. Jalankan rebuild di tab Deploy bila ini file frontend.',
    'fdeploy.dipulihkanRestartTunggu10Detik':        'Dipulihkan dari {backupName}. {label} restart — tunggu ±10 detik lalu refresh.',
    'fdeploy.direktoriKosong':                       'Direktori kosong.',
    'fdeploy.disalin':                               '✅ Disalin',
    'fdeploy.disconnect':                            '⏏ Disconnect',
    'fdeploy.diunduh':                               'Diunduh: {download}',
    'fdeploy.download':                              '⬇️ Download',
    'fdeploy.download2':                             'Download',
    'fdeploy.downloadDiffTxt':                       '⬇️ Download .diff.txt',
    'fdeploy.downloadServer':                        '⬇️ Download dari server',
    'fdeploy.dropHere':                              '📂 Lepas file di sini untuk upload ke {code}',
    'fdeploy.ec2UserLocalhostSsh':                   'ec2-user@localhost (SSH)',
    'fdeploy.enter':                                 'Enter',
    'fdeploy.entri':                                 'entri',
    'fdeploy.eof':                                   'EOF  ·',
    'fdeploy.error':                                 'error',
    'fdeploy.escKeTeks':                             'Esc kembali ke teks',
    'fdeploy.posisiKursor':                          'Brs {line}, Kol {col}',
    'fdeploy.jumlahBaris':                           '{total} baris',
    'fdeploy.terpilihKarakter':                      '{n} karakter terpilih',
    'fdeploy.nomorBaris':                            'Nomor baris',
    'fdeploy.explorerBackupNote':                    'File lama akan dibackup otomatis ke folder {code} di direktori ini (10 versi terakhir disimpan) sebelum ditimpa.',
    'fdeploy.file':                                  'file',
    'fdeploy.file2':                                 'File',
    'fdeploy.fileAdaServer':                         'File tidak ada di server.',
    'fdeploy.fileBaruTanpaBackup':                   ' (file baru, tanpa backup)',
    'fdeploy.fileBelumAdaServerDibuat':              'ℹ️ File belum ada di server — ini akan dibuat sebagai file baru (tanpa backup).',
    'fdeploy.fileBerubahBesarDiringkasBukan':        'File berubah besar — diringkas, bukan diff baris-per-baris presisi',
    'fdeploy.fileDeploy':                            '📦 File Deploy',
    'fdeploy.fileLamaBilaAdaBackup':                 'File lama (bila ada) di-backup otomatis, dan riwayat diff-nya disimpan (lihat di tab Backup & Restore) untuk tracing.',
    'fdeploy.fileTerDeployMemulaiRebuild':           'File ter-deploy{bk}. Memulai rebuild frontend…',
    'fdeploy.fileTerDeploySedangRestart':            'File ter-deploy{bk}. {label} sedang restart — tunggu ±10 detik lalu refresh.',
    'fdeploy.fileTerUpload':                         '{ok} file ter-upload ke {curPath}',
    'fdeploy.fileTerUploadMenimpaFile':              '{ok} file ter-upload ke {curPath} ({overwritten} menimpa file lama — backup otomatis tersimpan)',
    'fdeploy.fileTerlaluBesarDitampilkanDiff':       'File terlalu besar untuk ditampilkan diff baris. Lihat ukuran: server',
    'fdeploy.fileTerpilih':                          'file terpilih',
    'fdeploy.folderBeratNodeModulesBuild':           'Folder berat (node_modules, build, backups, dll) dilewati. Tiap file disnapshot ke folder backups (retensi 10 per file).',
    'fdeploy.frontend':                              'Frontend',
    'fdeploy.frontendRebuildBeberapaMenit':          'Frontend akan di-rebuild (beberapa menit).',
    'fdeploy.frontendRebuildSekaliSetelahSemua':     'Frontend di-rebuild sekali setelah semua file tertulis.',
    'fdeploy.gagal':                                 ', {fail} gagal',
    'fdeploy.gagal2':                                ', gagal {fail}',
    'fdeploy.halamanHanyaAdmin':                     'Halaman ini hanya untuk admin.',
    'fdeploy.hanyaFileJsJsxDiizinkan':               'Hanya file .js / .jsx yang diizinkan.',
    'fdeploy.hapus':                                 '🗑️ Hapus',
    'fdeploy.hapus2':                                'Hapus',
    'fdeploy.hasilBerikutnya':                       'Hasil berikutnya',
    'fdeploy.hasilSebelumnya':                       'Hasil sebelumnya',
    'fdeploy.hintAiService':                         'Relatif terhadap /awsbasis/ai-service — contoh: server.js atau aiProxy.js',
    'fdeploy.hintBackend':                           'Relatif terhadap /awsbasis/dashboard/backend — contoh: fileDeployRoutes.js',
    'fdeploy.hintFrontend':                          'Relatif terhadap /awsbasis/dashboard/frontend — contoh: src/pages/FileDeployPage.jsx',
    'fdeploy.histSubtitle':                          'Riwayat semua deploy dari ketiga root, dikelompokkan per sesi. Alat tracing — jejak resmi tetap di audit log.',
    'fdeploy.histAllTypes':                          'Semua root',
    'fdeploy.histSearchPh':                          'Filter path — mis. TableMaintenance',
    'fdeploy.histSearch':                            'Cari',
    'fdeploy.histClear':                             'Bersihkan',
    'fdeploy.histRefresh':                           '↻ Muat ulang',
    'fdeploy.histLoading':                           'Memuat riwayat deploy…',
    'fdeploy.histEmpty':                             'Belum ada riwayat deploy.',
    'fdeploy.histSummary':                           '{s} sesi · {d} diff · sesi dipisah bila jeda > {g} detik',
    'fdeploy.histCapped':                            'Hasil dipotong pada batas pemindaian — sebagian riwayat lama tidak ditampilkan.',
    'fdeploy.histFiles':                             '{n} file',
    'fdeploy.histLoadFailed':                        'Gagal memuat riwayat deploy.',
    'fdeploy.indent2Spasi':                          'indent 2 spasi',
    'fdeploy.interupsi':                             'interupsi  ·',
    'fdeploy.isiDuluPathFileServer':                 'Isi dulu path file di server.',
    'fdeploy.isiDuluPathTujuanServer':               'Isi dulu path tujuan di server.',
    'fdeploy.isiPathFileDulu':                       'Isi path file dulu.',
    'fdeploy.itemDipilih':                           'item dipilih',
    'fdeploy.jalankanRebuildFrontendSekarangProses': 'Jalankan rebuild frontend sekarang? Proses beberapa menit; log tampil live.',
    'fdeploy.jumlahBaris':                           'Jumlah baris:',
    'fdeploy.kembaliDaftar':                         '← Kembali ke daftar',
    'fdeploy.ketikCommandEnterKirim':                'Ketik command, Enter untuk kirim…',
    'fdeploy.kirim':                                 'kirim  ·',
    'fdeploy.kondisiFileSaatBackupDulu':             'Kondisi file saat ini akan di-backup dulu sebelum ditimpa (bisa dibatalkan dengan restore ulang).',
    'fdeploy.konfirmasiBuild':                       'Konfirmasi build',
    'fdeploy.konfirmasiDeploy':                      'Konfirmasi deploy',
    'fdeploy.konfirmasiHapus':                       'Konfirmasi hapus',
    'fdeploy.konfirmasiHapusMassal':                 'Konfirmasi hapus massal',
    'fdeploy.konfirmasiMultiDeploy':                 'Konfirmasi multi-deploy',
    'fdeploy.konfirmasiRestart':                     'Konfirmasi restart',
    'fdeploy.konfirmasiRestartAiService':            'Konfirmasi restart AI-service',
    'fdeploy.konfirmasiRestore':                     'Konfirmasi restore',
    'fdeploy.konfirmasiTimpaFile':                   'Konfirmasi timpa file',
    'fdeploy.konfirmasiTimpaPesan':                  '{n} dari {total} file yang diunggah sudah ada di folder ini dan akan ditimpa:',
    'fdeploy.lama':                                  'Lama:',
    'fdeploy.left':                                  'left',
    'fdeploy.lihat':                                 '👁️ Lihat',
    'fdeploy.lihatDiff':                             'Lihat diff',
    'fdeploy.lihatDiff2':                            '👁️ Lihat diff',
    'fdeploy.logBuild':                              '📋 Log build',
    'fdeploy.logDisalinClipboard':                   'Log disalin ke clipboard.',
    'fdeploy.logKosong':                             '(log kosong)',
    'fdeploy.logSemuaProses':                        '📋 Log semua proses',
    'fdeploy.masukkanPathFileLaluKlik':              'Masukkan path file lalu klik “Cari backup”.',
    'fdeploy.mdBuildFailedNoRestart':                'Build gagal — restart pm2 dibatalkan. File sudah tertulis di server; perbaiki lalu build ulang dari tab Operasi.',
    'fdeploy.mdOrderNote':                           'Build dijalankan lebih dulu, restart pm2 menyusul — restart saat build berjalan itu yang dihindari.',
    'fdeploy.mdPlanTitle':                           'Rencana eksekusi',
    'fdeploy.mdRestarting':                          '{label} sedang di-restart — tunggu sekitar 10 detik.',
    'fdeploy.mdRowTypeTitle':                        'Root tujuan file ini',
    'fdeploy.mdStepBuild':                           'Rebuild frontend (npm run build, log live)',
    'fdeploy.mdStepRestart':                         'Restart pm2: {list}',
    'fdeploy.mdStepWrite':                           'Tulis {n} file (+ backup & riwayat diff)',
    'fdeploy.mdTypeDefault':                         'Tipe default (baris baru)',
    'fdeploy.mdTypeDefaultHint':                     'Tipe bisa diubah per file di daftar — satu batch boleh mencampur root.',
    'fdeploy.memuat':                                '⏳ Memuat…',
    'fdeploy.memuat2':                               'Memuat…',
    'fdeploy.memuatRiwayatDiff':                     'Memuat riwayat diff…',
    'fdeploy.memulaiRebuildFrontend':                '{base}. Memulai rebuild frontend…',
    'fdeploy.menghubungkan':                         'Menghubungkan…',
    'fdeploy.menyimpan':                             '⏳ Menyimpan…',
    'fdeploy.naik':                                  '⬆ Naik',
    'fdeploy.nama':                                  'Nama',
    'fdeploy.namaBaru':                              'Nama baru',
    'fdeploy.namafileJs':                            'namaFile.js',
    'fdeploy.opsRebuildDesc':                        'Jalankan {code} di /awsbasis/dashboard/frontend. Pakai ini setelah upload file frontend tanpa lewat tab Deploy.',
    'fdeploy.opsRestartAiDesc':                      'Jalankan {code} di /awsbasis/ai-service (delete → start dari ecosystem, bukan restart biasa). Berguna setelah deploy file AI-service.',
    'fdeploy.opsRestartBackendDesc':                 'Jalankan {code} di /awsbasis/dashboard/backend — bukan sekadar {plain} — agar env & kode baru dari ecosystem.config.js benar-benar dibaca ulang. Koneksi terputus sesaat (±10 detik).',
    'fdeploy.pathFile':                              'Path file',
    'fdeploy.pathTujuanServer':                      'Path tujuan di server',
    'fdeploy.pilihFile':                             '📄 Pilih file…',
    'fdeploy.pilihFileBackup':                       'Pilih file untuk backup',
    'fdeploy.pilihFileServer':                       'Pilih file di server',
    'fdeploy.pm2DeleteAiServicePm2':                 'pm2 delete ai-service && pm2 start ecosystem.config.js --only ai-service && pm2 save',
    'fdeploy.pm2DeleteDashboardPm2Start':            'pm2 delete dashboard && pm2 start ecosystem.config.js --only dashboard && pm2 save',
    'fdeploy.pm2Logs':                               'pm2 logs',
    'fdeploy.pm2Restart':                            'pm2 restart',
    'fdeploy.primary':                               'primary',
    'fdeploy.pulihkan':                              '↩️ Pulihkan',
    'fdeploy.refresh':                               '🔄 Refresh',
    'fdeploy.rename':                                'Rename',
    'fdeploy.rename2':                               'Rename: {name}',
    'fdeploy.reset':                                 '↩ Reset',
    'fdeploy.restartAiService':                      '🤖 Restart AI-service',
    'fdeploy.restartAiServiceSekarang':              '🤖 Restart AI-service sekarang',
    'fdeploy.restartAiServiceSekarangKoneksi':       'Restart AI-service sekarang? Koneksi AI akan terputus sesaat (±10 detik).',
    'fdeploy.restartBackend':                        '🔄 Restart backend',
    'fdeploy.restartBackendSekarang':                '🔄 Restart backend sekarang',
    'fdeploy.restartBackendSekarangSemuaKoneksi':    'Restart backend sekarang? Semua koneksi terputus sesaat (±10 detik).',
    'fdeploy.restartTunggu10DetikLalu':              '{base}. {label} restart — tunggu ±10 detik lalu refresh.',
    'fdeploy.restarting':                            '⏳ Restarting…',
    'fdeploy.right':                                 'right',
    'fdeploy.ringkasan':                             '⚠ ringkasan',
    'fdeploy.riwayatDiff':                           'Riwayat Diff: {rel}',
    'fdeploy.riwayatDiffDeploy':                     '📝 Riwayat Diff (Deploy)',
    'fdeploy.riwayatDiffTracingDeployTab':           'Riwayat Diff (tracing — dari deploy tab Deploy)',
    'fdeploy.rmRfNodeModulesCache':                  'rm -rf node_modules/.cache && npm run build',
    'fdeploy.sama':                                  'sama)',
    'fdeploy.sebagianFileDilewatiHanyaJs':           'Sebagian file dilewati (hanya .js/.jsx).',
    'fdeploy.seretFileAreaAtasUpload':               '💡 Seret file ke area di atas untuk upload cepat',
    'fdeploy.simpan':                                '💾 Simpan',
    'fdeploy.simpan2':                               'simpan  ·',
    'fdeploy.simpan3':                               '✅ Simpan',
    'fdeploy.success':                               'success',
    'fdeploy.tab':                                   'Tab',
    'fdeploy.tabBackup':                             'Backup & Restore',
    'fdeploy.tabConsole':                            'OS Console',
    'fdeploy.tabDeploy':                             'Deploy',
    'fdeploy.tabExplorer':                           'File Explorer',
    'fdeploy.tabHistory':                            'Riwayat Deploy',
    'fdeploy.tabMulti':                              'Multi Deploy',
    'fdeploy.tabOps':                                'Operasi',
    'fdeploy.tambahFile':                            '📄 Tambah file…',
    'fdeploy.tampilkanLog':                          '📋 Tampilkan log',
    'fdeploy.tekanConnectSshMemulaiSesi':            'Tekan "Connect SSH" untuk memulai sesi terminal…',
    'fdeploy.teks':                                  '{dir}/{name}',
    'fdeploy.teks2':                                 '{curPath}/{name}',
    'fdeploy.terakhirDiubah':                        'Terakhir diubah',
    'fdeploy.terhubung':                             'Tidak terhubung',
    'fdeploy.terhubung2':                            '(tidak terhubung)',
    'fdeploy.tersimpan':                             'Tersimpan: {name}',
    'fdeploy.tindakan':                              'Tindakan ini',
    'fdeploy.tipe':                                  'Tipe',
    'fdeploy.tipeSatuBatchSatuTipe':                 'Tipe (satu batch = satu tipe)',
    'fdeploy.tracingApaBerubahTiapDeploy':           'untuk tracing — apa yang berubah di tiap deploy',
    'fdeploy.tutup':                                 'Tutup',
    'fdeploy.ukuran':                                'Ukuran',
    'fdeploy.unggahFileJsJsxLangsung':               'Unggah file .js/.jsx langsung dari browser — backup otomatis, lalu restart backend atau rebuild frontend.',
    'fdeploy.upload':                                '⬆️ Upload',
    'fdeploy.uploading':                             '⏳ Uploading…',
    'fdeploy.viewEdit':                              'View / Edit',
    'fdeploy.warning':                               'warning',
    'fdeploy.wss':                                   'wss',
    'fdeploy.yaBackupSemua':                         'Ya, backup semua',
    'fdeploy.yaBuild':                               'Ya, build',
    'fdeploy.yaDeploy':                              'Ya, deploy',
    'fdeploy.yaDeploySemua':                         'Ya, deploy semua',
    'fdeploy.yaHapus':                               '🗑️ Ya, hapus',
    'fdeploy.yaHapusSemua':                          '🗑️ Ya, hapus semua',
    'fdeploy.yaPulihkan':                            'Ya, pulihkan',
    'fdeploy.yaRestart':                             'Ya, restart',
    'fdeploy.yaRestartAiService':                    'Ya, restart AI-service',
    'fdeploy.yaTimpa':                               '⚠️ Ya, timpa',


    // ── AI Settings + Table Maintenance ──
    'aiSet2.modelIdContohUsAnthropic':               'Model ID, contoh: us.anthropic.claude-3-5-sonnet-20241022-v2:0',
    'aiSet2.promptGlobalDipakaiSaatAda':             'Prompt global — dipakai saat tidak ada dashboard aktif (mis. AI Workspace "General").',
    'tblMaint.aiServiceDbOperasiRestore':            'ℹ️ AI Service DB: operasi Restore tidak tersedia dari sini. Gunakan file',
    'tblMaint.aktif':                                'Aktif',
    'tblMaint.baris':                                '{total} baris',
    'tblMaint.batal':                                'Batal',
    'tblMaint.belumAdaDataIdSuim':                   'Belum ada data ID SUIM',
    'tblMaint.belumAdaDataKlikRun':                  'Belum ada data — klik Run Now di atas untuk fetch pertama.',
    'tblMaint.belumAdaDataOvertimeUpload':           'Belum ada data overtime. Upload CSV untuk mulai.',
    'tblMaint.belumAdaDataRingkasan':                'Belum ada data ringkasan.',
    'tblMaint.belumAdaDataUser':                     'Belum ada data user.',
    'tblMaint.belumAdaSourceFile':                   'Belum ada source file',
    'tblMaint.belumAdaUpload':                       'Belum ada upload',
    'tblMaint.cari':                                 'Cari',
    'tblMaint.cariNamaKodeDept':                     '🔍 Cari nama, kode, dept…',
    'tblMaint.cariUpnDomain':                        'Cari UPN / domain…',
    'tblMaint.cariUserNamaDeptEmail':                '🔍 Cari user, nama, dept, email…',
    'tblMaint.dataDetailLoginDiagregasiOtomatis':    'Data detail login diagregasi otomatis menjadi jam per User / Periode (YYYY-MM) / Dept, lalu disimpan ke database dashboard (source: SAP:<SID> <range>).',
    'tblMaint.fetchSimpan':                          '📡 Fetch & Simpan',
    'tblMaint.fetchUserUtilizationSapZrfc':          '📡 Fetch User Utilization dari SAP (ZRFC_USR_UTL)',
    'tblMaint.halaman':                              'Halaman',
    'tblMaint.hapus':                                '🗑️ Hapus',
    'tblMaint.hapus2':                               'Hapus',
    'tblMaint.hapusDomainDaftarRingkasan':           'Hapus domain "{dom}" dari daftar ringkasan?',
    'tblMaint.hapusIdSuimData':                      'Hapus ID SUIM data dari "{selSrc}"?',
    'tblMaint.hapusMappingSku':                      'Hapus mapping SKU "{part}"?',
    'tblMaint.hapusOvertimeData':                    'Hapus overtime data dari "{selSrc}"?',
    'tblMaint.hapusSource':                          '🗑️ Hapus Source',
    'tblMaint.hapusUploadBesertaSemuaDatanya':       'Hapus upload "{filename}" beserta semua datanya?',
    'tblMaint.isiLicense':                           '🩹 Isi License',
    'tblMaint.jalankanVacuumAiServiceDb':            'Jalankan VACUUM pada AI Service DB?',
    'tblMaint.kolomKategoriTampilSebagaiKolom':      'Kolom "Kategori" = tampil sebagai kolom di tabel ringkasan.',
    'tblMaint.kosongkanSemua':                       '⚠️ Kosongkan Semua',
    'tblMaint.kosongkanSemuaDataEmployeeOvertime':   'KOSONGKAN semua data Employee Overtime? Tidak bisa dibatalkan!',
    'tblMaint.kosongkanSemuaDataIdSuim':             'KOSONGKAN semua data ID SUIM? Tidak bisa dibatalkan!',
    'tblMaint.memuatData':                           'Memuat data…',
    'tblMaint.modeSimpan':                           'Mode Simpan',
    'tblMaint.namaRamah':                            'Nama Ramah',
    'tblMaint.nonaktif':                             'Nonaktif',
    'tblMaint.pageOfRecords':                        'Halaman {page} dari {totalPages} ({shown} dari {total} records)',
    'tblMaint.penghapusanSourceFileSolmanSap':       'ℹ️ Penghapusan source file Solman/SAP/SUIM tetap dilakukan dari tab masing-masing.',
    'tblMaint.pilihKoneksi':                         '— pilih koneksi —',
    'tblMaint.pilihSourceFile':                      '-- Pilih source file --',
    'tblMaint.ringkasanLisensiPerDomain':            '📊 Ringkasan Lisensi per Domain',
    'tblMaint.riwayatUploadSourceFileSemua':         'Riwayat upload & source file semua tabel',
    'tblMaint.semuaBln':                             'Semua Bln',
    'tblMaint.semuaBu':                              'Semua BU',
    'tblMaint.semuaTahun':                           'Semua Tahun',
    'tblMaint.snapshotTerakhir':                     'Snapshot terakhir: {snap}',
    'tblMaint.tabelAktif':                           'tabel aktif:',
    'tblMaint.tampilkanSebagaiKolomKategoriRingkasan': 'Tampilkan sebagai kolom kategori di ringkasan? OK = ya.',
    'tblMaint.tanggal':                              'Tanggal Dari',
    'tblMaint.tanggalSampai':                        'Tanggal Sampai',
    'tblMaint.total':                                'Total',
    'tblMaint.totalAssets':                          'Total Assets',
    'tblMaint.totalRecords':                         'Total Records',
    'tblMaint.totalRequests':                        'Total Requests',
    'tblMaint.totalUsers':                           'Total Users',


    // ── File Deploy: auto-locate ──
    'fdeploy.locAmbiguous':                    'Ditemukan {n} file bernama {name} di lokasi berbeda.',
    'fdeploy.locAmbiguousShort':               '{n} lokasi — pilih:',
    'fdeploy.locChooseHint':                   'Pilih salah satu di bawah. Tidak ada yang dipilih otomatis, agar tidak salah menimpa file.',
    'fdeploy.locFound':                        'Lokasi terdeteksi otomatis:',
    'fdeploy.locNew':                          '{name} belum ada di proyek — akan dibuat sebagai file baru. Isi path tujuan secara manual.',
    'fdeploy.locNewShort':                     'File baru — isi path manual',
    'fdeploy.locRenamed':                      'Nama file dinormalisasi: {from} → {to} (sufiks hasil unduh berulang dibuang).',
    'fdeploy.locSearching':                    '🔎 Mencari lokasi file di proyek…',
    'fdeploy.locSizeSame':                     'ukuran sama',
    'fdeploy.locUploadSize':                   'file diunggah: {size}',
    'fdeploy.locTypeMismatch':                 '{n} file terdeteksi di root selain "{type}".',
    'fdeploy.locTypeMismatchHint':             'Multi Deploy memakai satu tipe untuk seluruh batch. Pisahkan file ini ke batch tersendiri, atau ubah pilihan Tipe di atas.',
    'fdeploy.nihil':                                 'Nihil',


    // ══ AWS Pricing Calculator (Tahap 3) ══
    'page.awsPricing.title':      'AWS Pricing Calculator',
    'page.awsPricing.subtitle':   'Estimasi biaya AWS dengan perbandingan komitmen berdampingan',
    'sidebar.awsPricing':         'AWS Pricing Calculator',
    'sidebar.awsPricing.sub':     'Estimasi biaya & komitmen',
    'rm.desc.aws_pricing':        'Kalkulator harga & estimasi',
    'awsp.tab.calculator':        'Kalkulator',
    'awsp.tab.catalog':           'Katalog Harga',
    'awsp.tab.sync':              'Sync & Config',
    'awsp.loading':               'Memuat…',
    'awsp.configError':           'Gagal memuat konfigurasi:',
    'awsp.region':                'Region',
    'awsp.service':               'Service',
    'awsp.instanceType':          'Instance type',
    'awsp.os':                    'OS',
    'awsp.tenancy':               'Tenancy',
    'awsp.preInstalledSw':        'Software terpasang',
    'awsp.termType':              'Jenis term',
    'awsp.offeringClass':         'Kelas offering',
    'awsp.lease':                 'Durasi',
    'awsp.payment':               'Pembayaran',
    'awsp.range':                 'Rentang',
    'awsp.upfront':               'Upfront',
    'awsp.rate':                  'Tarif',
    'awsp.unit':                  'Unit',
    'awsp.all':                   'Semua',
    'awsp.search':                'Cari',
    'awsp.clearFilters':          'Bersihkan filter',
    'awsp.save':                  'Simpan',
    'awsp.yes':                   'Ya',
    'awsp.no':                    'Tidak',
    'awsp.mo':                    'bln',
    'awsp.hr':                    'jam',
    'awsp.calc.cart':             'Keranjang',
    'awsp.calc.cartEmpty':        'Belum ada baris. Tambahkan resource di panel tengah.',
    'awsp.calc.addLine':          'Tambah baris',
    'awsp.calc.addToCart':        'Tambahkan ke keranjang',
    'awsp.calc.kindEc2':          'EC2 Instance',
    'awsp.calc.kindUsage':        'Storage / Transfer',
    'awsp.calc.qty':              'Jumlah',
    'awsp.calc.hoursPerMonth':    'Jam per bulan',
    'awsp.calc.volumeGb':         'Volume (GB)',
    'awsp.calc.usageType':        'Usage type',
    'awsp.calc.onDemand':         'On-Demand',
    'awsp.calc.noPrice':          'harga tidak tersedia',
    'awsp.calc.needInstance':     'Pilih instance type, OS, dan tenancy terlebih dahulu.',
    'awsp.calc.needUsageType':    'Pilih usage type terlebih dahulu.',
    'awsp.calc.pickLine':         'Pilih satu baris di keranjang untuk melihat matriks komitmennya.',
    'awsp.calc.noCommitment':     'Baris storage dan data transfer hanya punya harga On-Demand bertingkat — tidak ada opsi komitmen.',
    'awsp.calc.tiers':            'Tier harga',
    'awsp.calc.supportPlan':      'Support plan',
    'awsp.calc.vat':              'PPN / VAT',
    'awsp.calc.vatId':            'PPN Indonesia',
    'awsp.calc.vatSg':            'GST Singapore',
    'awsp.calc.vatNone':          'Tanpa PPN',
    'awsp.calc.hoursNote':        'Jam per bulan default:',
    'awsp.calc.recurring':        'Biaya berulang',
    'awsp.calc.amortizedUpfront': 'Upfront teramortisasi',
    'awsp.calc.usageSubtotal':    'Subtotal usage',
    'awsp.calc.support':          'Support',
    'awsp.calc.totalMonthly':     'Total per bulan',
    'awsp.calc.cashUpfront':      'Uang keluar bulan 0',
    'awsp.calc.cashNote':         'Angka ini terpisah dari total bulanan: total bulanan sudah memakai upfront yang diamortisasi.',
    'awsp.calc.supportBasisNote': 'Basis Support mengecualikan upfront RI, sesuai cara AWS menagih.',
    'awsp.calc.kindRds':      'RDS Instance',
    'awsp.calc.dbEngine':     'Database engine',
    'awsp.calc.dbEdition':    'Edisi',
    'awsp.calc.dbEditionNone':'Tidak ada edisi',
    'awsp.calc.deployment':   'Deployment',
    'awsp.calc.licenseModel': 'Model lisensi',
    'awsp.calc.needRds':      'Pilih database engine, deployment, dan instance type lebih dulu.',
    'awsp.calc.rdsMultiAzNote': 'Multi-AZ adalah produk tersendiri di katalog AWS, bukan kuantitas dua kali — harganya sudah termasuk standby.',
    'awsp.calc.kindOpenSearch': 'OpenSearch',
    'awsp.calc.usageAmount':  'Jumlah pemakaian',
    'awsp.calc.elbNote':      'ALB ditagih dua baris: LoadBalancerUsage per jam dan LCUUsage per LCU-jam. Isi jam/bulan (mis. 730) untuk baris pertama, dan LCU × jam untuk baris kedua.',
    'awsp.calc.needOpenSearch': 'Pilih instance type OpenSearch lebih dulu.',
    'awsp.calc.openSearchNote': 'Harga ini hanya untuk instance domain. Penyimpanan EBS domain adalah baris terpisah — tambahkan lewat tab Storage / Transfer.',
    // ── Ekspor estimate aktif (Excel / PDF) ────────────────────────────────
    'awsp.exp.excel':         'Excel',
    'awsp.exp.pdf':           'PDF',
    'awsp.exp.docTitle':      'Estimasi Biaya AWS',
    'awsp.exp.generatedAt':   'Dibuat',
    'awsp.exp.colKind':       'Jenis',
    'awsp.exp.colItem':       'Item',
    'awsp.exp.colUsageType':  'Usage type / Operation',
    'awsp.exp.colCommitment': 'Komitmen',
    'awsp.exp.colLoad':       'Jam / Volume',
    'awsp.exp.colUnit':       'Satuan',
    'awsp.exp.colUnitPrice':  'Harga satuan',
    'awsp.exp.colRecurring':  'Berulang/bln',
    'awsp.exp.colUpfront':    'Upfront',
    'awsp.exp.colFlags':      'Catatan',
    'awsp.exp.flagDerived':   'harga turunan',
    'awsp.exp.flagAnomaly':   'anomali katalog',
    'awsp.exp.flagDrift':     'harga bergeser',
    'awsp.exp.inIdr':         'Setara Rupiah',
    'awsp.exp.popupBlocked':  'Jendela cetak diblokir browser — izinkan popup untuk situs ini.',
    'awsp.matrix.title':          'Matriks komitmen',
    'awsp.matrix.subtitle':       'Semua opsi berdampingan. Klik satu baris untuk memakainya pada perhitungan.',
    'awsp.matrix.option':         'Opsi',
    'awsp.matrix.upfront':        'Upfront',
    'awsp.matrix.monthly':        '$/bln',
    'awsp.matrix.year1':          'Total 1 tahun',
    'awsp.matrix.saving':         'Hemat',
    'awsp.matrix.missing':        'tidak ada di katalog',
    'awsp.matrix.riStd':          'Reserved Instance — Standard',
    'awsp.matrix.riConv':         'Reserved Instance — Convertible',
    'awsp.matrix.spCompute':      'Savings Plan — Compute',
    'awsp.matrix.spEc2':          'Savings Plan — EC2 Instance',
    'awsp.matrix.derivedHint':    'Arus kas diturunkan dari committed rate',
    'awsp.matrix.derivedNote':    'Savings Plan tidak punya upfront per-tarif; angka upfront diturunkan dari committed rate × jam. Biaya teramortisasinya sama untuk ketiga opsi pembayaran — yang berbeda hanya kapan uangnya keluar.',
    'awsp.matrix.savingNote':     'Hemat dihitung terhadap On-Demand pada jumlah dan jam yang sama.',
    'awsp.matrix.anomalyWarn':    '{n} sel menyimpang dari pola upfront/tarif yang diharapkan. Sel tetap ditampilkan agar katalog yang rusak terlihat, bukan disembunyikan.',
    'awsp.catalog.searchHint':    'instance type, deskripsi, atau usage type',
    'awsp.catalog.rowCount':      '{n} baris cocok',
    'awsp.catalog.page':          'Halaman {p} dari {t}',
    'awsp.catalog.empty':         'Tidak ada baris yang cocok dengan filter ini.',
    'awsp.sync.jobStatus':        'Status job per region',
    'awsp.sync.job':              'Job',
    'awsp.sync.products':         'Produk',
    'awsp.sync.terms':            'Term',
    'awsp.sync.jobsCount':        'Jumlah job',
    'awsp.sync.running':          'Sedang berjalan',
    'awsp.sync.duration':         'Durasi',
    'awsp.sync.lastSync':         'Sync terakhir',
    'awsp.sync.status':           'Status',
    'awsp.sync.never':            'belum pernah',
    'awsp.sync.run':              'Jalankan',
    'awsp.sync.confirm':          'Jalankan sync sekarang? Baris lama untuk job dan region ini akan DIGANTI, bukan ditambah.',
    'awsp.sync.confirmSp':        'Sync Savings Plan memakan waktu sekitar 12 menit dan lebih dari 2000 API call. Jalankan sekarang?',
    'awsp.sync.emptyNote':        'Status "empty" berarti job berjalan tanpa galat tetapi tidak mengembalikan satu produk pun — katalog berlubang, bukan lengkap.',
    'awsp.sync.config':           'Konfigurasi kalkulator',
    'awsp.sync.savedKeys':        'Tersimpan: {keys}',
    'awsp.sync.supportTiers':     'Tier Support',
    'awsp.sync.tierFrom':         'Dari',
    'awsp.sync.tierTo':           'Sampai',
    'awsp.sync.min':              'Minimum',
    'awsp.sync.marginalNote':     'Tier bersifat marginal: tiap persentase hanya dikenakan pada porsi tagihan yang jatuh di dalam rentangnya.',


    // ══ AWS Pricing Calculator — CRUD estimate ══
    'awsp.est.title':         'Estimate',
    'awsp.est.unsaved':       'Belum disimpan — keranjang akan hilang bila tab ditutup.',
    'awsp.est.currentName':   '{name} (#{id})',
    'awsp.est.save':          'Simpan',
    'awsp.est.saveNew':       'Simpan estimate',
    'awsp.est.saveAs':        'Simpan sebagai baru',
    'awsp.est.open':          'Buka',
    'awsp.est.loadBtn':       'Muat',
    'awsp.est.namePrompt':    'Nama estimate:',
    'awsp.est.defaultName':   'Estimate baru',
    'awsp.est.emptyCart':     'Keranjang masih kosong — tidak ada yang bisa disimpan.',
    'awsp.est.saved':         'Tersimpan, {n} baris.',
    'awsp.est.loaded':        'Estimate dimuat. Harga diambil ulang dari katalog dan sama dengan saat disimpan.',
    'awsp.est.loadedEmpty':   'Estimate dimuat, tetapi tidak punya baris.',
    'awsp.est.loadedDrift':   'Estimate dimuat: {d} baris harganya berbeda dari saat disimpan, {x} baris tidak ada lagi di katalog. Angka yang tampil memakai harga TERKINI.',
    'awsp.est.listEmpty':     'Belum ada estimate tersimpan.',
    'awsp.est.lineCount':     '{n} baris',
    'awsp.est.confirmDelete': 'Hapus estimate "{name}"? Seluruh barisnya ikut terhapus dan tidak bisa dikembalikan.',
    'awsp.est.snapshotNote':  'Baris estimate menyimpan harga yang berlaku saat disimpan. Sync katalog mingguan tidak akan mengubah angka estimate lama secara diam-diam — perbedaannya justru ditandai saat dibuka.',
    'awsp.est.driftTitle':    'Harga berubah sejak estimate disimpan',
    'awsp.est.driftSaved':    'Saat disimpan:',


    // ══ AWS Pricing Calculator — No Support option ══
    'awsp.calc.supportNone': 'Tanpa Support (No Support)',


    // ══ AWS Pricing Calculator — konvensi AWS (recurring vs upfront) ══
    'awsp.matrix.leaseTotal':         'Total masa sewa',
    'awsp.calc.totalMonthlyNote':     'Mengikuti konvensi AWS Pricing Calculator: hanya biaya berulang. Upfront tidak termasuk di sini — lihat baris di bawah.',
    'awsp.calc.amortizedCompare':     'Setara/bulan (upfront disebar)',
    'awsp.calc.amortizedCompareNote': 'Angka pembanding saja, tidak termasuk Total per bulan: upfront disebar rata ke seluruh masa sewa, supaya opsi No Upfront dan All Upfront bisa dibandingkan adil.',
    'awsp.calc.oneTime':              'sekali',


    // ══ SearchableSelect ══
    'awsp.searchPlaceholder': 'Ketik untuk mencari…',

  },

  en: {
    // ── Language switcher ──
    'lang.label':       'Language',
    'lang.indonesian':  'Indonesia',
    'lang.english':     'English',

    // ── Common ──
    'common.save':       'Save',
    'common.cancel':     'Cancel',
    'common.delete':     'Delete',
    'common.edit':       'Edit',
    'common.search':     'Search...',
    'common.loading':    'Loading...',
    'common.refresh':    'Refresh',
    'common.yes':        'Yes',
    'common.no':         'No',
    'common.close':      'Close',
    'common.confirm':    'Confirm',
    'common.actions':    'Actions',
    'common.all':        'All',
    'common.noData':     'No data',

    // ── Header: page titles ──
    'page.overview.title':     'Overview',
    'page.overview.subtitle':  'Summary of all systems',
    'page.awsBilling.title':   'AWS Billing',
    'page.awsBilling.subtitle':'AWS cost & usage dashboard',
    'page.awsCost.title':      'AWS Cost Explorer',
    'page.awsCost.subtitle':   'In-depth AWS cost analysis',
    'page.awsInventory.title':    'AWS Inventory',
    'page.awsInventory.subtitle': 'Multi-region AWS resource documentation',
    'page.awsCloudTrail.title':    'AWS CloudTrail',
    'page.awsCloudTrail.subtitle': 'Multi-region AWS activity & audit event log',
    'page.solman.title':       'SAP Solution Manager',
    'page.solman.subtitle':    'SAP ticket & incident monitoring',
    'page.sapUsage.title':     'SAP User Utilization',
    'page.sapUsage.subtitle':  'SAP user utilization analysis',
    'page.sapUserMgmt.title':     'SAP User Maintenance',
    'page.sapUserMgmt.subtitle':  'Manage SAP users — lock, unlock, reset password',
    'sidebar.sapUserMgmt':        'SAP User Maintenance',
    'sidebar.sapUserMgmt.sub':    'Lock / unlock / reset PW',
    'sidebar.sapRoles':           'SAP Role Maintenance',
    'sidebar.sapRoles.sub':       'Audit roles & assignments',
    // Menu tanpa terjemahan sebelumnya (label + subjudul)
    'sidebar.solman_docs': 'Solman Documents',
    'sidebar.solman_docs.sub': 'SolMan project documents (PDF + OCR)',
    'sidebar.sapBasisMon': 'SAP Basis Monitor',
    'sidebar.sapBasisMon.sub': 'Health: jobs, locks, WP, system',
    'sidebar.sapLogonAudit': 'External Access Audit',
    'sidebar.sapLogonAudit.sub': 'SAP access from outside the network',
    'sidebar.linuxLoginAudit': 'Linux Login Audit',
    'sidebar.linuxLoginAudit.sub': 'SSH logins on all Linux EC2',
    'sidebar.claudeActivity': 'Claude Activity',
    'sidebar.claudeActivity.sub': 'Member usage of Claude (OTel)',
    'sidebar.sapRouterLog': 'SAProuter Log',
    'sidebar.sapRouterLog.sub': 'Inbound connections & source public IP',
    'sidebar.transport': 'SAP Transport Request',
    'sidebar.transport.sub': 'STMS queue & import Q01/P01',
    'sidebar.sapNotes': 'SAP Note',
    'sidebar.sapNotes.sub': 'Note catalog, archive & tracking',
    'sidebar.netmap': 'Network Topology',
    'sidebar.netmap.sub': 'Site network diagrams',
    'sidebar.aiActions': 'AI Actions',
    'sidebar.aiActions.sub': 'Natural-language actions + approval',
    'sidebar.shareLinks': 'Share Links',
    'sidebar.shareLinks.sub': 'Read-only public links',
    'sidebar.fileDeploy': 'File Deploy',
    'sidebar.fileDeploy.sub': 'Upload & deploy .js/.jsx files',
    'sidebar.notes': 'Notes',
    'sidebar.notes.sub': 'Team notes & memos',
    'sidebar.notesPlain': 'Notes Plain',
    'sidebar.notesPlain.sub': 'Notes without RAG index',
    // ── SAP Customizing & Enhancement ──
    'sidebar.sapCustomizing':     'SAP Customizing',
    'sidebar.sapCustomizing.sub': 'User exits, BAdIs & enhancements',
    'sidebar.sapConfig':          'SAP Configuration',
    'sidebar.sapConfig.sub':      'SPRO / IMG customizing',
    'page.sapCustomizing.title':    'SAP Customizing & Enhancement',
    'page.sapCustomizing.subtitle': 'Metadata of user exits, screen exits & table appends (CMOD/SMOD) in the SAP system — BAdIs not yet included',

    // ── ABAP Source Viewer ──
    'sidebar.sapSource':          'ABAP Workbench',
    'sidebar.sapSource.sub':      'Custom source, dictionary, classes & enhancements',
    'page.sapSource.title':       'ABAP Workbench',
    'page.sapSource.subtitle':    'Custom repository objects: program/FM/class source, ABAP Dictionary, workbench catalog and enhancements (exits/BAdIs)',
    'sapSrc.scopeNote':           'Custom namespace only (Z*/Y*). Standard SAP programs are rejected by SAP itself — the gate lives in the function module, not in this page. Every read is recorded in the Activity Log.',
    'sapSrc.noPath':              'This connection profile has no ZRFC_READ_SOURCE service path yet. Set it in SAP Config first; without it the read is certain to fail.',
    'sapSrc.progPlaceholder':     'Program / include name, e.g. ZXVVFU02',
    'sapSrc.progInvalid':         'Invalid name. Letters, digits and _ / = < > + - only (max 40 characters).',
    'sapSrc.withIncludes':        'Include sub-includes',
    'sapSrc.read':                'Show',
    'sapSrc.reading':             'Reading...',
    'sapSrc.linesUnit':           'lines',
    'sapSrc.codeLines':           'code lines',
    'sapSrc.progUnit':            'programs',
    'sapSrc.state.code':          'Contains code',
    'sapSrc.state.empty':         'Exists, but comments / blank lines only',
    'sapSrc.state.missing':       'No source',
    'sapSrc.state.denied':        'Rejected by SAP',
    'sapSrc.state.auth':          'Authentication rejected',
    'sapSrc.state.error':         'Read failed',
    'sapSrc.truncWarn':           '{n} lines were truncated by SAP at character 255. What you see is not the full line.',
    'sapSrc.findPlaceholder':     'Find in code...',
    'sapSrc.findNote':            'Find highlights; it does not filter lines.',
    'sapSrc.hits':                '{n} matches',
    'sapSrc.copy':                'Copy',
    'sapSrc.copied':              'Copied',
    'sapSrc.download':            'Download',
    'sapSrc.noLines':             'SAP returned no lines at all for this program.',
    'sapSrc.emptyState':          'Type an ABAP program or include name above, then press Show. Name suggestions come from the Custom Workbench catalog (synced from TADIR), not from a live SAP read — a name missing from the list does not mean it does not exist.',
    'sapSrc.requested':           'requested',
    'sapSrc.expand':              'click to expand',
    'sapSrc.collapse':            'click to collapse',
    'sapSrc.sugNote':             'Suggestions from previously read programs, not a complete list.',
    'sapSrc.sugMore':             'More exist — narrow your input.',
    // ── ABAP Source Viewer · Function Module mode ──
    'sapSrc.mode.prog':           'Program / Report',
    'sapSrc.mode.fm':             'Function Module',
    'sapSrc.fmPlaceholder':       'Function module name, e.g. ZMMFM_PRREL_SEND_MAIL',
    'sapSrc.fmInvalid':           'Invalid name. Letters, digits, _ and / only (max 30 characters).',
    'sapSrc.fmLookup':            'Show',
    'sapSrc.fmLooking':           'Looking up...',
    'sapSrc.fmEmptyState':        'Type a function module name above, then press Show. Suggestions are read straight from TFDIR in SAP, limited to the custom namespace (Z*/Y*). Not full SE37: no Test/Execute and no editing.',
    'sapSrc.fmSugLive':           'Suggestions read live from TFDIR in SAP.',
    'sapSrc.tab.import':          'Import',
    'sapSrc.tab.export':          'Export',
    'sapSrc.tab.changing':        'Changing',
    'sapSrc.tab.tables':          'Tables',
    'sapSrc.tab.exceptions':      'Exceptions',
    'sapSrc.tab.other':           'Other (PARAMTYPE {code})',
    'sapSrc.tab.source':          'Source code',
    'sapSrc.attr.group':          'Function group',
    'sapSrc.attr.mainProg':       'Main program',
    'sapSrc.attr.include':        'Include',
    'sapSrc.attr.remote':         'REMOTE-ENABLED (RFC)',
    'sapSrc.attr.updateModule':   'UPDATE MODULE',
    'sapSrc.attr.normal':         'Normal',
    'sapSrc.col.param':           'Parameter',
    'sapSrc.col.typeRef':         'Associated type',
    'sapSrc.col.default':         'Default',
    'sapSrc.col.optional':        'Optional',
    'sapSrc.col.text':            'Short text',
    'sapSrc.rawCols':             'Show raw SAP columns (PPOSITION, REFERENCE, TYPE, REF_CLASS)',
    'sapSrc.tabEmpty':            'No parameters in this group.',
    'sapSrc.optYes':              'optional',
    'sapSrc.optNo':               'required',
    'sapSrc.warnTitle':           'Worth noting:',
    'sapSrc.orphanTitle':         'Some FUNCT parameter texts have no counterpart in FUPARAREF:',
    'sapSrc.fmSourceNote':        'FM source is read through the function group main program ({prog}) with all its includes — a single include cannot be read on its own in this system. This FM\'s own block ({inc}) is shown first and expanded; includes belonging to other FMs in the same group start collapsed.',
    'sapSrc.reload':              'Read again',
    // ── ABAP Source Viewer · ABAP Dictionary mode ──
    'sapSrc.mode.dd':             'ABAP Dictionary',
    'sapSrc.ddPlaceholder':       'Table / structure name, e.g. EKKO or ZTAMM_PRREL',
    'sapSrc.ddInvalid':           'Invalid name. Letters, digits, _ and / only (max 30 characters).',
    'sapSrc.ddLookup':            'Show',
    'sapSrc.ddLooking':           'Looking up...',
    'sapSrc.ddEmptyState':        'Type a table or structure name above, then press Show. Works for all tables, standard SAP included.',
    'sapSrc.ddSugLive':           'Suggestions read live from DD02L (active version) in SAP.',
    'sapSrc.dd.scopeNote':        'This shows table STRUCTURE — field names, types, lengths, data elements. Table CONTENTS are not read here; that is what the Table Maintenance page is for, with its own permission. Only the active version (AS4LOCAL=A) is used.',
    'sapSrc.dd.maintain':         'Maintainable (SM30)',
    'sapSrc.dd.noMaintain':       'No maintenance view',
    'sapSrc.dd.delivery':         'Delivery class',
    'sapSrc.dd.changed':          'Changed by',
    'sapSrc.dd.fields':           'fields',
    'sapSrc.dd.keys':             'keys',
    'sapSrc.dd.includes':         'includes',
    'sapSrc.dd.textSrc':          'Text taken from {src}, language {lang}.',
    'sapSrc.dd.include':          'INCLUDE',
    'sapSrc.dd.append':           'APPEND',
    'sapSrc.dd.filterPlaceholder': 'Filter field, data element, or text...',
    'sapSrc.dd.noFields':         'No field list for this object.',
    'sapSrc.dd.navHint':          'Open {name}',
    'sapSrc.dd.col.key':          'Key',
    'sapSrc.dd.col.pos':          'Pos',
    'sapSrc.dd.col.field':        'Field',
    'sapSrc.dd.col.de':           'Data element',
    'sapSrc.dd.col.type':         'Type',
    'sapSrc.dd.col.chk':          'Check table',
    'sapSrc.dd.col.text':         'Short text',
    // ── ABAP Source Viewer · table content sample ──
    'sapSrc.peek.open':           'View table content sample',
    'sapSrc.peek.hint':           'Reads business data, not structure. Requires the sap_table_peek permission.',
    'sapSrc.peek.title':          'Table content sample',
    'sapSrc.peek.note':           'This is BUSINESS DATA, not metadata. It is read through standard RFC_READ_TABLE, so the table authorization (S_TABU_DIS) of the RFC user in the connection profile still applies. Every read is recorded in the Activity Log.',
    'sapSrc.peek.wide':           'This table is wide: {total} bytes in total, above the {limit}-byte limit for {fm}. Pick the fields you want, or leave the selection empty to fill up to the limit automatically.',
    'sapSrc.peek.fieldFilter':    'Filter field names...',
    'sapSrc.peek.budget':         '{n} fields selected · {w}/{limit} bytes',
    'sapSrc.peek.autoFit':        'No selection — fields filled automatically up to the limit',
    'sapSrc.peek.clear':          'Clear selection',
    'sapSrc.peek.rows':           'Row count',
    'sapSrc.peek.fetch':          'Fetch sample',
    'sapSrc.peek.fetching':       'Fetching...',
    'sapSrc.peek.overBudget':     'Over the limit: {w}/{limit} bytes. Remove some fields.',
    'sapSrc.peek.got':            '{n} rows returned of {req} requested',
    'sapSrc.peek.exhausted':      'The table is simply shorter — nothing was truncated.',
    'sapSrc.peek.empty':          'This table returned no rows at all.',
    // ── ABAP Source Viewer · Class mode ──
    'sapSrc.mode.cls':            'Class',
    'sapSrc.clsPlaceholder':      'Class name, e.g. CL_GUI_ALV_GRID or ZCL_...',
    'sapSrc.clsInvalid':          'Invalid name. Letters, digits, _ and / only (max 30 characters).',
    'sapSrc.clsLookup':           'Show',
    'sapSrc.clsLooking':          'Looking up...',
    'sapSrc.clsEmptyState':       'Type a class name above, then press Show. Works for all classes including standard SAP; source code is limited to the custom namespace. Not full SE24: no editing and no execution.',
    'sapSrc.clsSugLive':          'Suggestions read live from SEOCLASSDF (active version) in SAP.',
    'sapSrc.cls.super':           'Superclass',
    'sapSrc.cls.implements':      'Implements',
    'sapSrc.cls.relOther':        'Relations with an unrecognised RELTYPE',
    'sapSrc.cls.changed':         'Changed by',
    'sapSrc.cls.tab.methods':     'Methods',
    'sapSrc.cls.tab.attributes':  'Attributes',
    'sapSrc.cls.tab.events':      'Events',
    'sapSrc.cls.tab.other':       'Other (CMPTYPE {code})',
    'sapSrc.cls.otherNote':       'CMPTYPE {code} exists in this system but its meaning is not established, and no view has been verified for it. Only the component NAMES can be shown — not their type, exposure, or description.',
    'sapSrc.cls.filter':          'Filter name or description...',
    'sapSrc.cls.importing':       'IMPORTING',
    'sapSrc.cls.exporting':       'EXPORTING',
    'sapSrc.cls.changing':        'CHANGING',
    'sapSrc.cls.returning':       'RETURNING',
    'sapSrc.cls.paramOther':      'Other (PARDECLTYP {code})',
    'sapSrc.cls.noParams':        'This method has no parameters and no exceptions.',
    'sapSrc.cls.findInSource':    'Find "METHOD ..." in source',
    'sapSrc.cls.sourceNote':      'Source is read from class pool {pool} together with all its includes. There is no jump-to-method button: the per-method include number cannot be derived from the method name in this system, and guessing it would show the wrong method. The button on each method fills the search box with "METHOD <name>" — that is a text search, not a mapping.',
    'sapCust.sync':          'Fetch from SAP',
    'sapCust.syncing':       'Fetching...',
    'sapCust.syncDone':      'Sync complete: {enh} components, {raw} raw rows, {kb} documents indexed to AI.',
    'sapCust.limitTitle':    'Information limit:',
    'sapCust.limitBody':     'This page shows metadata for CLASSIC enhancements (CMOD/SMOD): user exits, screen exits, and table appends. BAdIs and enhancement spots have NOT been scanned — their absence here does not mean they do not exist. ABAP source has not been read yet; click "Read ABAP source" or open the include in SE38/SE80.',
    'sapCust.limitBodySrc':  'Scope of this page: CLASSIC enhancements (CMOD/SMOD) only — user exits, screen exits, table appends. BAdIs and enhancement spots have NOT been scanned; their absence here does not mean they do not exist. ABAP source is available for includes already read and is a copy, not a live view of SAP.',
    'sapCust.limitDetail':   'The ABAP source code of this component is not stored here. Open the include above via SE38/SE80 to inspect the logic. Do not infer the logic from the exit name alone.',
    'sapCust.stat.total':    'Total components',
    'sapCust.stat.active':   'Active',
    'sapCust.stat.project':  'CMOD projects',
    'sapCust.stat.module':   'SAP modules',
    'sapCust.stat.moduleSub':'{n} without module',
    'sapCust.lastSync':      'Last snapshot',
    'sapCust.cronRunConfirm': 'Run the SAP Customizing refresh now? It makes dozens of SOAP calls to SAP (including PRODUCTION) and may take several minutes. Continue?',
    'sapCust.kbPrune.title':     'Knowledge base cleanup',
    'sapCust.kbPrune.check':     'Check',
    'sapCust.kbPrune.hint':      'Sync only writes and updates documents — it never deletes. Documents the indexer no longer produces keep being served to the AI until they are cleaned up. The weekly cron already runs this as its final step.',
    'sapCust.kbPrune.keepTitle': 'Connections whose documents are KEPT:',
    'sapCust.kbPrune.emptyWarn': 'These connections have zero enhancement rows, so their documents will be treated as stale and deleted',
    'sapCust.kbPrune.execute':   'Clean up now',
    'sapCust.kbPrune.running':   'Cleaning up…',
    'sapCust.kbPrune.confirm':   'Delete stale documents from the knowledge base? Documents belonging to the connections listed as kept stay safe; everything else is deleted and cannot be restored without a re-sync. Continue?',
    'sapCust.kbPrune.done':      'Stale documents deleted',
    'sapCust.kbPrune.clean':     'Knowledge base is already clean — no stale documents.',
    'sapCust.srcCopy':       'Copy',
    'sapCust.srcCopied':     'Copied',
    'sapCust.statusLabel':   'Status',
    'sapCust.docs':          'documents',
    'sapCust.badiSync':      'Fetch BAdIs',
    'sapCust.badiSyncing':   'Fetching BAdIs…',
    'sapCust.badiDone':      'BAdIs & enhancements: {total} objects ({classic} classic BAdIs, {new} spot BAdIs, {src} source code).',
    'sapCust.viewEnh':       'Classic enhancements',
    'sapCust.viewBadi':      'BAdIs & enhancements',
    'sapCust.viewConfig':    'Config layer (SPRO)',
    'sapCust.cfg.limitBody':  'This page reads customizing TRs from E070C/E070/E071/E071K on the DEV system only. Three things that are easy to misread: (1) in the "Most frequent tables" panel, key row counts exist only for TABU objects — 68% of object rows show "not recorded", not zero, because a view name never matches E071K; (2) the COMPLETE counts do exist nonetheless — see the "Physical tables whose rows changed" panel, which reads E071K directly and covers every key row; (3) excluded TRs are still stored here, only their contents are left unanalyzed. Figures marked ~ are lower bounds for the object dimension, not overall totals.',
    'sapCust.cfg.sync':       'Pull config from SAP',
    'sapCust.cfg.syncing':    'Pulling config…',
    'sapCust.cfg.syncConfirm':'Re-pull the config layer from SAP? This reads E070C/E070/E07T/E071/E071K over RFC and takes about 40 seconds. Existing data for this connection is REPLACED entirely — no previous snapshot is kept. Continue?',
    'sapCust.cfg.syncDone':   'Config sync complete: {tr} TRs, {obj} object rows.',
    'sapCust.cfg.unknown':    'not recorded',
    'sapCust.cfg.unknownHint':'The key row count is unknown for this object — this does not mean zero. Only TABU objects can be matched against E071K; view and view cluster names never match physical table names.',
    'sapCust.cfg.stat.tr':          'TRs recorded',
    'sapCust.cfg.stat.analyzed':    'Fully analyzed',
    'sapCust.cfg.stat.analyzedSub': '{n} excluded (still recorded)',
    'sapCust.cfg.stat.unreleased':  'Not released',
    'sapCust.cfg.stat.tables':      'Unique config tables',
    'sapCust.cfg.stat.objectRows':  'Object rows',
    'sapCust.cfg.stat.keys':        'Key rows',
    'sapCust.cfg.stat.keysSub':     '{n} rows ({pct}%) have no recorded count — figure above is a lower bound',
    'sapCust.cfg.stat.heavy':       'Flagged heavy',
    'sapCust.cfg.stat.heavySub':    'a marker only, not an exclusion',
    'sapCust.cfg.stat.notArrived':    'Not yet in {sid}',
    'sapCust.cfg.stat.notArrivedSub': 'of {cand} released TRs · {failed} failed (rc≥8) · import log {rows} rows',
    'sapCust.cfg.imp.done':           'imported',
    'sapCust.cfg.imp.failed':         'import FAILED (rc≥8)',
    'sapCust.cfg.imp.pending':        'no import record',
    'sapCust.cfg.imp.naHint':         'Not assessed: TR is unreleased or excluded. This is different from "not yet arrived".',
    'sapCust.cfg.imp.colHint':        'Import status into {sid} ({env}). Sourced from TPALOG on that system itself, taking the LAST step rather than the queue time. This column is not sortable.',
    'sapCust.cfg.byModule':      'Module breakdown',
    'sapCust.cfg.byModuleApp':     'Application component (package)',
    'sapCust.cfg.byModuleAppHint': 'Derived from each object\'s package via TADIR → TDEVC → PS_POSID, not from the TR description. This is the BUSINESS DOMAIN the table serves; the Module column beside it is the TYPE OF WORK per the description. The two can differ and both are correct.',
    'sapCust.cfg.col.moduleApp':    'App component',
    'sapCust.cfg.col.mixed':        'Mixed',
    'sapCust.cfg.mixedHint':        'This TR touches {n} application components; only the most frequent is shown. All of them: {list}',
    'sapCust.cfg.modAppUnknown':    '{n} TRs have no application component — their objects are not reachable via the TADIR chain (e.g. all in the ZD01 developer package). This does not mean they have no module.',
    'sapCust.cfg.modAppNoObj':  '{n} TRs contain no customizing objects at all — typically workbench transports (ABAP programs, packages, backups). Such TRs simply have no application component to derive; this is not a read failure.',
    'sapCust.cfg.modAppUnreach': '{n} TRs do have objects, but those objects are not reachable via the TADIR chain — e.g. all in the ZD01 developer package. This does not mean they have no module.',
    'sapCust.cfg.byTrfunction':  'Transport type',
    'sapCust.cfg.excluded':      'Exclusions',
    'sapCust.cfg.excludedHint':  'The TRs below are still stored and can be opened via the filter — only the analysis of their contents is skipped.',
    'sapCust.cfg.topTables':     'Most frequent tables',
    'sapCust.cfg.topTablesHint':  'What the TR REGISTERS (E071). For non-TABU object types this holds a view or view cluster name, and the key count is unknown because a view name never matches E071K.',
    'sapCust.cfg.keyTables':      'Physical tables whose rows changed',
    'sapCust.cfg.keyTablesHint':  'The PHYSICAL tables behind those views, read straight from E071K. These counts are always measured — there is no "unknown" state here. This list complements the one beside it rather than replacing it.',
    'sapCust.cfg.keyTablesTotal': '{tables} tables in total · {keys} key rows (the list below shows only the top 25)',
    'sapCust.cfg.col.tabname':    'Table',
    'sapCust.cfg.splitSrc':      'split by source',
    'sapCust.cfg.splitSrcHint':  'The backend groups by (module, module_src), so one module can appear on several rows. This page merges them by module by default; tick to see which classifier path produced each one.',
    'sapCust.cfg.noModule':      '(unknown)',
    'sapCust.cfg.total':         'Total',
    'sapCust.cfg.levelTr':       'By TR',
    'sapCust.cfg.levelObject':   'By object',
    'sapCust.cfg.rowCount':      '{n} rows',
    'sapCust.cfg.filterNoteNone': 'Excluded TRs are hidden — change the dropdown to see all',
    'sapCust.cfg.filterNoteOnly': 'showing only excluded TRs',
    'sapCust.cfg.sortHint':       'Click a column header to sort the whole data set, not just this page.',
    'sapCust.cfg.loading':       'Loading…',
    'sapCust.cfg.empty':         'No rows match the current filter.',
    'sapCust.cfg.reset':         'Reset filters',
    'sapCust.cfg.searchTr':      'Search TRKORR / description…',
    'sapCust.cfg.excAll':        'All TRs',
    'sapCust.cfg.excNone':       'Excluding filtered',
    'sapCust.cfg.excOnly':       'Only filtered',
    'sapCust.cfg.heavyHint':     'Flagged heavy: key count exceeds the threshold. A marker only — this TR is still analyzed.',
    'sapCust.cfg.col.module':     'Module',
    'sapCust.cfg.col.moduleSrc':  'Source',
    'sapCust.cfg.col.trfunction': 'Type',
    'sapCust.cfg.col.trstatus':   'Status',
    'sapCust.cfg.col.descr':      'Description',
    'sapCust.cfg.col.objCount':   'Objects',
    'sapCust.cfg.col.keys':       'Keys',
    'sapCust.cfg.col.known':      'Recorded',
    'sapCust.cfg.col.objname':    'Object',
    'sapCust.cfg.col.objtype':    'Type',
    'sapCust.cfg.col.ddText':     'Dictionary text',
    'sapCust.cfg.col.releasedOn': 'Released',
    'sapCust.cfg.rowClickHint':   'Click to see the objects in this TR',
    'sapCust.cfg.secStats':       'Headline figures',
    'sapCust.cfg.secStatsHint':   '{tr} TR · {obj} object rows',
    'sapCust.cfg.secAggr':        'Breakdowns',
    'sapCust.cfg.secAggrHint':    'module · app component · transport type · exclusions',
    'sapCust.cfg.secTables':      'Most frequent tables',
    'sapCust.cfg.secTablesHint':  'registered objects · physical tables changed',
    'sapCust.cfg.notReleased':    'not released',
    'sapCust.cfg.ddNone':         'not in the data dictionary',
    'sapCust.cfg.ddNotSynced':    'descriptions not synced yet',
    'sapCust.cfg.col.analyzed':   'Analyzed',
    'sapCust.cfg.col.excluded':   'Exclusion',
    'sapCust.cfg.exc.sap_delivered':        'SAP delivered',
    'sapCust.cfg.exc.do_not_transport':     'Not transported',
    'sapCust.cfg.exc.client_export':        'Client export',
    'sapCust.cfg.exc.duplicate_piece_list': 'Duplicate piece list',
    'sapCust.cfg.exc.foreign_landscape':    'Other landscape',
    'sapCust.badi.installed':'installed',
    'sapCust.badi.stat.total':      'Total objects',
    'sapCust.badi.stat.inactive':   'Inactive BAdIs',
    'sapCust.badi.stat.inactiveSub':'registered, logic not running',
    'sapCust.badi.stat.local':      'Local objects ($TMP)',
    'sapCust.badi.stat.localSub':   'cannot be transported',
    'sapCust.badi.limit':    'This list covers customer objects only (Z*/Y*). BAdI logic lives in the implementing class and has NOT been read — unlike classic user exits. Active status is available for classic BAdIs only; for spot BAdIs and source code enhancements the source data holds no activation flag.',
    'sapCust.badi.col.name':       'Implementation',
    'sapCust.badi.col.kind':       'Kind',
    'sapCust.badi.col.definition': 'Definition / program',
    'sapCust.badi.col.descr':      'Description',
    'sapCust.badi.col.status':     'Status',
    'sapCust.badi.col.class':      'Implementing class',
    'sapCust.badi.col.package':    'Package',
    'sapCust.badi.col.src':        'Source',
    'sapCust.badi.srcNever':       'not read yet',
    'sapCust.badi.src.code':       'has code',
    'sapCust.badi.src.empty':      'no code',
    'sapCust.badi.src.missing':    'not found',
    'sapCust.badi.src.denied':     'denied',
    'sapCust.badi.src.error':      'failed',
    'sapCust.badi.src.auth':       'authentication denied',
    'sapCust.badiSrcSync':         'Read BAdI source',
    'sapCust.badiSrcSyncing':      'Reading BAdI source…',
    'sapCust.badiSrcDone':         'BAdI source read: {read} classes — {code} with code, {prog} programs, {lines} lines.',
    'sapCust.badiSrc.pool':        'Class pool',
    'sapCust.badiSrc.poolTag':     'class skeleton',
    'sapCust.badiSrc.progs':       '{n} programs · {lines} lines · {code} code lines',
    'sapCust.badiSrc.needSync':    'The implementing class source has never been read. Run "Read BAdI source".',
    'sapCust.searchPh':      'Search component, enhancement, include, project...',
    'sapCust.allTypes':      'All types',
    'sapCust.allProjects':   'All projects',
    'sapCust.allModules':    'All modules',
    'sapCust.noModule':      'No module',
    'sapCust.activeOnly':    'Active only',
    'sapCust.active':        'Active',
    'sapCust.inactive':      'Inactive',
    'sapCust.empty':         'No data yet. Click "Fetch from SAP" to start.',
    'sapCust.col.component':   'Component',
    'sapCust.col.type':        'Type',
    'sapCust.col.enhancement': 'Enhancement',
    'sapCust.col.project':     'Project',
    'sapCust.col.module':      'Module',
    'sapCust.col.include':     'Include',
    'sapCust.col.changed':     'Changed by',
    'sapCust.d.enhancement':   'SAP enhancement',
    'sapCust.d.module':        'SAP module',
    'sapCust.d.appComponent':  'Application component',
    'sapCust.d.project':       'CMOD project',
    'sapCust.d.funcGroup':     'Function group',
    'sapCust.d.include':       'Implementation include',
    'sapCust.d.fgIncludes':    'Other includes in group',
    'sapCust.d.badi':          'BAdI implementation',
    'sapCust.d.package':       'Include package',
    'sapCust.d.projPackage':   'Project package',
    'sapCust.d.createdBy':     'Created by',
    'sapCust.d.activatedBy':   'Activated by',
    'sapCust.d.changedBy':     'Last changed',
    // ── SAP Customizing: code status & ABAP source ──
    'sapCust.col.srcState':   'Code',
    'sapCust.srcSync':        'Read ABAP source',
    'sapCust.srcSyncing':     'Reading source...',
    'sapCust.srcDone':        'Source read: {read} includes — {code} with code, {empty} empty.',
    'sapCust.srcAborted':     'Source reading stopped before completion. The result is incomplete.',
    'sapCust.srcNotConfigured': 'ZRFC_READ_SOURCE service path is not set in SAP Config',
    'sapCust.srcNotRead':     'not read yet',
    'sapCust.srcTitle':       'ABAP source',
    'sapCust.srcReadAt':      'read',
    'sapCust.srcNone':        'No source lines stored.',
    'sapCust.srcMissing':     'Include not found in this system.',
    'sapCust.srcDenied':      'Source cannot be read (access denied by SAP).',
    'sapCust.srcNeedSync':    'Never read. Click "Read ABAP source" above.',
    'sapCust.srcTrunc':       '{n} line(s) longer than 255 characters were truncated.',
    'sapCust.linesShort':     'code lines',
    'sapCust.commentOnly':    'lines, all comments',
    'sapCust.allStates':      'All code statuses',
    'sapCust.stat.activeEmpty':    'Active but empty',
    'sapCust.stat.activeEmptySub': 'registered active, no code',
    'sapCust.emptyWarnTitle': 'Active but contains no code.',
    'sapCust.emptyWarnBody':  'Its CMOD project is active, but the implementation include holds no code at all — only comments or blank lines. No custom logic runs at this point. The content below is shown so you can see what remains; long comment blocks usually mean code once existed and was disabled.',
    'sapCust.limitSrcLive':   'The source above is a copy from the last read and may lag behind the current version in SAP. For certainty, open the include in SE38/SE80.',
    // ── SAP Customizing: transport history ──
    'sapCust.col.transport':  'Transport',
    'sapCust.trSync':         'Read transport history',
    'sapCust.trSyncing':      'Reading transport...',
    'sapCust.trDone':         'Transport read: {ver} version rows, {tr} TRs, {imp} TRs with import history.',
    'sapCust.trTitle':        'Transport history',
    'sapCust.trNone':         'not read yet',
    'sapCust.trNeedSync':     'No data yet. Click "Read transport history" above.',
    'sapCust.trChanged':      'changed',
    'sapCust.trRelease':      'release',
    'sapCust.trImport':       'import',
    'sapCust.trNoImport':     'No import trace in any system yet.',
    'sapCust.trAll':          'In all systems',
    'sapCust.trMissing':      'Not in {sids}',
    'sapCust.trGapTitle':     'Latest change has not arrived.',
    'sapCust.trGapBody':      'TR {tr} has no import record for {sids}. If the object already exists there, an OLD VERSION is probably running — and that raises no visible error. Check the import queue in STMS.',
    'page.default.title':      'Dashboard',

    // ── Header: others ──
    'header.home':            'Home',
    'header.ai':              'AI',
    'header.aiAssistant':     'AI Assistant',
    'header.dashboardAccess': 'Dashboard Access',
    'header.logout':          'Sign Out',
    'pwd.menu':       'Change Password',
    'pwd.title':      'Change Password',
    'pwd.current':    'Current Password',
    'pwd.new':        'New Password',
    'pwd.confirm':    'Confirm New Password',
    'pwd.submit':     'Save',
    'pwd.cancel':     'Cancel',
    'pwd.success':    'Password changed successfully.',
    'pwd.errRequired':  'Current and new password are required.',
    'pwd.errMinLength': 'New password must be at least 6 characters.',
    'pwd.errMismatch':  'Password confirmation does not match.',
    'pwd.errSameAsOld': 'New password must differ from the current one.',
    'pwd.errGeneric':   'Failed to change password.',
    'role.admin':             'Administrator',
    'role.sapOperator':       'SAP Operator',
    'role.awsOperator':       'AWS Operator',

    // ── Sidebar: brand & groups ──
    'sidebar.brand':          'Primary Dashboard',
    'sidebar.brandSub':       'Unified Monitoring',
    'sidebar.group.aws':      'AWS',
    'sidebar.group.sap':      'SAP',
    'sidebar.group.infra':    'INFRA',
    'sidebar.group.docs':     'DOCUMENTATION',
    'sidebar.group.admin':    'ADMIN',
    'sidebar.group.hr':       'HR',
    'sidebar.group.tools':    'TOOLS',
    'sidebar.group.ai':          'AI',
    'sidebar.group.access':      'ACCESS & USERS',
    'sidebar.group.system':      'SYSTEM',
    'sidebar.group.integration': 'INTEGRATIONS',
    'sidebar.m365':           'Microsoft 365 Licensing',
    'sidebar.m365.sub':       'Microsoft 365 license summary',
    'sidebar.sdp':            'SDP Cloud',
    'sidebar.sdp.sub':        'ManageEngine ticketing & assets',

    // ── Sidebar: menu label + sublabel ──
    'sidebar.overview':                 'Overview',
    'sidebar.awsBilling':               'AWS Billing',
    'sidebar.awsBilling.sub':           'Cost & Usage',
    'sidebar.awsCost':                  'AWS Cost Explorer',
    'sidebar.awsCost.sub':              'Cost Analysis',
    'sidebar.awsCostBrief':             'AWS Cost Brief',
    'sidebar.awsCostBrief.sub':         'Monthly cost summary',
    'sidebar.awsInventory':             'AWS Inventory',
    'sidebar.awsInventory.sub':         'Resource Documentation',
    'sidebar.awsCloudTrail':            'AWS CloudTrail',
    'sidebar.awsCloudTrail.sub':        'Activity & Audit Log',
    'sidebar.solman':                   'SAP Solman',
    'sidebar.solman.sub':               'Ticket & Incident',
    'sidebar.sapUsage':                 'SAP User Usage',
    'sidebar.sapUsage.sub':             'Utilization',
    'sidebar.employeeOvertime':         'Employee Overtime',
    'sidebar.employeeOvertime.sub':     'Data Lembur Karyawan',
    'sidebar.logs':                     'Activity Log',
    'sidebar.logs.sub':                 'Audit Trail',
    'sidebar.aiHistory':                'AI Chat History',
    'sidebar.aiHistory.sub':            'AI Conversations',
    'sidebar.aiDataSources':            'AI Data Sources',
    'sidebar.aiDataSources.sub':        'Manage AI Data',
    'sidebar.aiConfig':                 'AI Configuration',
    'sidebar.aiConfig.sub':             'Provider, model & API key',
    'sidebar.aiWorkspace':              'AI Workspace',
    'sidebar.aiWorkspace.sub':          'Full-page AI chat',
    'sidebar.aiCoding':                 'AI Coding',
    'sidebar.aiCoding.sub':             'Coding assistant + tool use',
    // ── AI Coding · project root picker ──────────────────────────────────
    'aiCoding.sbx.open':            'Code sandbox (.zip)',
    'aiCoding.sbx.title':           'Code sandbox',
    'aiCoding.sbx.upload':          'Upload .zip',
    'aiCoding.sbx.close':           'Close',
    'aiCoding.sbx.delete':          'Delete this sandbox',
    'aiCoding.sbx.empty':           'No sandbox yet. Upload a .zip containing the code you want to inspect.',
    'aiCoding.sbx.done':            'Sandbox "{label}" is ready — {files} files. Select it under Project root to start inspecting.',
    'aiCoding.sbx.truncated':       'partially truncated because it exceeded the limit',
    'aiCoding.sbx.skipped':         'skipped:',
    'aiCoding.sbx.limits':          'Only source files are extracted; node_modules, .git, binaries and credential-like files are skipped. Limit {mb} MB / {files} files. Sandboxes are deleted automatically after {days} days.',
    'aiCoding.sbx.noPython':        'Extraction is not active: AI_SANDBOX_PYTHON / PDF2MD_PYTHON is not set in ecosystem.config.js.',
    'aiCoding.sbx.docDone':         'Document "{name}" saved. Mention it in your prompt, e.g. "read {name} then do ...".',
    'aiCoding.sbx.docDelete':       'Delete this document',
    'aiCoding.sbx.docHint':         'Instruction documents (.md / .txt, max {kb} KB) are stored directly in {root} and referenced by name alone. They are not auto-deleted.',
    'aiCoding.dft.open':            'AI drafts',
    'aiCoding.dft.title':           'AI drafts',
    'aiCoding.dft.refresh':         'Reload',
    'aiCoding.dft.download':        'Download this file',
    'aiCoding.dft.delete':          'Delete this draft',
    'aiCoding.dft.empty':           'No drafts yet. Ask the AI to create a file, e.g. "create file x.py ... then save it".',
    'aiCoding.dft.missing':         'The drafts directory does not exist yet. Normal if write_file has never been used — but it can also mean the dashboard root differs from the one ai-service writes to.',
    'aiCoding.dft.blocked':         'This file cannot be downloaded (may contain credentials). It can still be deleted.',
    'aiCoding.projectRoot':             'Project root',
    'aiCoding.rootHint':                'read_file & grep_code are limited to this root',
    'aiCoding.rootUnavailable':         'Could not load the project root list',
    // AI Settings
    'ai.set.title':            'AI Configuration',
    'ai.set.subtitle':         'Provider & API key per user · prompt per dashboard',
    'ai.set.provider':         'AI Provider',
    'ai.set.apiKey':           'API Key',
    'ai.set.noKey':            'No Key',
    'ai.set.baseUrl':          'Base URL / Endpoint',
    'ai.set.baseUrlHintPre':   'Without',
    'ai.set.baseUrlHintPost':  '— added automatically.',
    'ai.set.fetching':         'Fetching...',
    'ai.set.fetchModels':      'Fetch Models',
    'ai.set.modelsFound':      '{n} models found',
    'ai.set.noModelsFound':    'No models found.',
    'ai.set.fetchModelFailed': 'Failed to fetch models.',
    'ai.set.bedrockRegionHint':'Region where the Bedrock model is enabled (e.g. us-east-1, ap-southeast-1).',
    'ai.set.bedrockCredHint':  'Credentials optional — leave empty to use the server IAM role / environment (safest, same as the Cost Explorer integration). Fill only if you want specific credentials.',
    'ai.set.optional':         'AKIA... (optional)',
    'ai.set.hide':             'Hide',
    'ai.set.show':             'Show',
    'ai.set.params':           'Generation Parameters',
    'ai.set.resetDefault':     'Reset default',
    'ai.set.preset':           'Preset',
    'ai.set.presetPrecise':    'Precise',
    'ai.set.presetPreciseDesc':'Accurate & consistent',
    'ai.set.presetBalanced':   'Balanced',
    'ai.set.presetBalancedDesc':'Common default',
    'ai.set.presetCreative':   'Creative',
    'ai.set.presetCreativeDesc':'Varied',
    'ai.set.tempLow':          '0 · Precise/consistent',
    'ai.set.tempHigh':         '2 · Creative/varied',
    'ai.set.tempHint':         'For accurate data Q&A, use 0.1–0.2. Higher values make answers more varied and prone to hallucination.',
    'ai.set.topPHint':         'Leave at 1.0 when temperature is already low. Tune only one (temperature OR Top P), not both at once.',
    'ai.set.maxTokens':        'Max Tokens (answer length)',
    'ai.set.maxTokensHint':    'Range 100–8000. Default 2000.',
    'ai.set.chart':            'Chart',
    'ai.set.chartAuto':        'Automatic — AI adds a chart when relevant',
    'ai.set.chartManual':      'On request only — chart only when the user asks',
    'ai.set.chartHint':        '"On request only": the AI will not create a chart unless you ask (e.g. "make a chart").',
    'ai.set.hideAccuracy':     'Hide accuracy score',
    'ai.set.hideAccuracyHint': 'Hide the "Accuracy %" badge on answers & session summary. This score is only a rough heuristic, not a measure of correctness.',
    'ai.set.followUp':         'Follow-up (chart/insight from previous result)',
    'ai.set.followUpOn':       'On',
    'ai.set.followUpOff':      'Off',
    'ai.set.followUpHint':     'When on, requests like "make a chart of that" or "insight" reuse the last query result without re-querying.',
    'ai.edit.resend':          'Resend',
    'ai.set.advanced':         'Advanced (penalty & seed)',
    'ai.set.penaltyHint':      'For data Q&A, leave both at 0 — penalties can block the repetition of numbers/labels that are actually needed.',
    'ai.set.seed':             'Seed (reproducibility)',
    'ai.set.seedPlaceholder':  'Empty = random each time',
    'ai.set.seedHint':         'Set a fixed number (e.g. 42) + low temperature → more reproducible answers. Not supported by all providers.',
    'ai.set.configured':       'configured',
    'ai.set.autoRotateLong':   'auto-rotate',
    'ai.set.notConfigured':    'Not configured',
    'ai.set.copyFirstKey':     'Copy first key',
    'ai.set.keysPlaceholder':  '(separate with comma or newline for auto-rotation)',
    'ai.set.keyInfoSingle':    'Stored in the database per user. Enter several keys separated by comma/Enter for auto-rotation on rate limit.',
    'ai.set.keyInfoMulti':     '{n} active keys — automatically rotates to the next key when any key hits a rate limit or expires.',
    'ai.set.promptGeneral':    '(general — open inside a dashboard for a specific prompt)',
    'ai.set.default':          'Default',
    'ai.set.reset':            'Reset',
    'ai.set.promptPlaceholder':'Enter custom instructions for the AI assistant on this dashboard...',
    'ai.set.promptScope':      'This prompt is specific to the {dash} dashboard and the {user} account.',
    'ai.set.add':              'Add',
    'ai.set.resetDefaultShort':'Reset (use default)',
    'ai.set.quickPromptHint':  'Empty = use built-in prompts. Stored per dashboard + user.',
    'ai.set.clearAll':         'Clear all',
    'ai.set.quickPromptCleared':'Cleared — no quick prompts shown in chat.',
    'ai.set.cancel':           'Cancel',
    'ai.set.saving':           'Saving...',
    'ai.set.saved':            'Saved!',
    'ai.set.save':             'Save Configuration',
    'ai.set.savedLocal':       'Saved locally. Server:',
    'sidebar.users':                    'User Management',
    'sidebar.users.sub':                'Manage Users',
    'sidebar.roles':                    'Role Management',
    'sidebar.roles.sub':                'Manage Roles',
    'sidebar.monthlyReport':            'Periodic Report',
    'sidebar.monthlyReport.sub':        'Monthly & trimester reports',
    'mreport.title':                    'Periodic Report',
    'mreport.subtitle':                 'Schedule, configuration, and delivery of periodic reports (monthly & trimester)',
    'mreport.loading':              'Loading configuration…',
    'mreport.switches.title':       'Two separate switches.',
    'mreport.switches.body':        'The "Enable" box above controls whether the schedule runs. The "Enable automatic delivery" box below controls whether the report is actually sent when cron fires. Both must be on for automatic delivery. The "Run Now" and "Send now" buttons use a manual trigger, so they still work even when the second switch is off.',
    'mreport.config':               'Configuration',
    'mreport.enableAuto':           'Enable automatic delivery (when cron fires)',
    'mreport.resendEvery':          'Resend on every scheduled run (skip the once-per-period check)',
    'mreport.resendEveryHint':      'When on, every cron run sends the last closed period again even if it was already sent. When off, each period is sent only once.',
    'mreport.to':                   'Recipients (To)',
    'mreport.to.ph':                'name@company.com, other@company.com',
    'mreport.to.hint':              'Multiple addresses allowed, separated by commas. Empty = use env MONTHLY_REPORT_TO. SMTP (host/auth/from) is taken from the ASE Alert tab.',
    'mreport.cc':                   'CC (optional)',
    'mreport.cc.ph':                'cc1@company.com, cc2@company.com',
    'mreport.bcc':                  'BCC (optional)',
    'mreport.bcc.ph':               'bcc@company.com',
    'mreport.ccbcc.hint':           'CC/BCC apply to this report profile only. Empty = use env MONTHLY_REPORT_CC / MONTHLY_REPORT_BCC if set. BCC addresses are not visible to the other recipients.',
    'mreport.senderName':           'Sender name (display name)',
    'mreport.senderName.hint':      'The name recipients see in the From field, e.g. "PIL Group IT — SAP". Empty = Primary Dashboard. The sender address itself comes from smtp_from on the ASE Alert tab and is not per profile.',
    'mreport.modules':              'Included modules',
    'mreport.body':                 'Include the report content in the email body',
    'mreport.body.hint':            'Turn this off for cover-note mode: the email carries only the introductory note, the title and the .xlsx attachment — no tables, no charts, no AI summary. The data is still collected in full and the attachment is unchanged; only its presentation in the email body is skipped.',
    'mreport.body.warn':            'Email body is off. Recipients will see only the introduction, the title and the attachment. Charts are not rendered, and the AI call is skipped entirely (no token cost for this profile).',
    'mreport.body.warnNoIntro':     'The introduction is still empty too — the email would carry almost no text. Fill in the introductory note below.',
    'mreport.layout.bodyOff':       'With the email body off, these two settings only affect the introduction and the title.',
    'mreport.layout':               'Email presentation',
    'mreport.layout.scale':         'Text size',
    'mreport.layout.scale.compact': 'Compact — previous size (12px tables)',
    'mreport.layout.scale.normal':  'Normal — recommended (13px tables)',
    'mreport.layout.scale.large':   'Large — for management (14px tables)',
    'mreport.layout.width':         'Content width',
    'mreport.layout.hint':          'Email clients have no dependable zoom (Outlook desktop renders through the Word engine), so the size has to be chosen by the sender and applies to every recipient of this profile. 900px is the default: a table with only 2-3 columns stretched across 1100px leaves its figures far away from their labels. Narrow tables are now also capped by column count, so their right edge no longer lines up with the wide ones — that is deliberate.',
    'mreport.intro':                'Introductory note (above the title)',
    'mreport.intro.ph':             'Dear all,\n\nPlease find the {{profile}} report for {{period}} below. Full detail is in the attached workbook.',
    'mreport.intro.hint':           'Appears in the email body BEFORE the title, like a cover note — distinct from the subtitle, which sits under the title. Empty = no introductory block at all. A single Enter starts a tight new line; a blank line starts a new paragraph. Formatting: **bold**, *italic*, __underline__, `code` — use the buttons above rather than typing the markers. Available tokens: {{period}}, {{title}}, {{profile}}, {{generated}} — use these rather than typing a month name, because the report is sent automatically every month. HTML is not supported and will be shown as plain text. 4000 characters maximum.',
    'mreport.intro.spacing':          'Line spacing',
    'mreport.intro.spacing.tight':    'Tight',
    'mreport.intro.spacing.normal':   'Normal',
    'mreport.intro.spacing.relaxed':  'Relaxed',
    'mreport.intro.fmt.bold':         'Bold — **text**',
    'mreport.intro.fmt.italic':       'Italic — *text*',
    'mreport.intro.fmt.underline':    'Underline — __text__',
    'mreport.intro.fmt.code':          'Inline code — `text`, use for column/table/file names so they are not read as bold/italic',
    'mreport.intro.fmt.numbered':     'Numbered list — number every selected line',
    'mreport.intro.fmt.bullet':       'Bulleted list — mark every selected line with •',
    'mreport.intro.fmt.clear':        'Clear formatting on the selection (or on all the text if nothing is selected)',
    'mreport.intro.preview':          'Preview',
    'mreport.intro.previewEmpty':     'The introduction is still empty.',
    'mreport.intro.previewNote':      'Approximate rendering. The actual type follows this profile\u2019s Text size; for the exact result use the Preview button below.',
    'mreport.header':               'Report title & header',
    'mreport.header.titlePh':       'IT Operations Monthly Report',
    'mreport.header.subtitlePh':    'Subtitle (optional)',
    'mreport.header.preparedPh':    'Prepared by (e.g. Taufan / IT)',
    'mreport.header.hint':          'The title is also used as the email subject and as the Cover sheet heading.',
    'mreport.ai.enable':            'Include an AI-generated executive summary',
    'mreport.ai.providerPh':        'provider (empty = global)',
    'mreport.ai.modelPh':           'model (empty = provider default)',
    'mreport.ai.warn':              'The AI never computes any figure — all numbers come from the database and the model only writes the prose. What it can still invent is the CAUSE, so the section is always labelled "generated by AI" and needs your review before you forward it. If the AI call fails, the section is dropped and the report is still sent.',
    'mreport.save':                 'Save configuration',
    'mreport.saving':               'Saving…',
    'mreport.saved':                'Configuration saved.',
    'mreport.lastSent':             'Last sent',
    'mreport.status':               'status',
    'mreport.test':                 'Manual test',
    'mreport.year':                 'Year (optional)',
    'mreport.month':                'Month (optional)',
    'mreport.preview':              'Preview (no delivery)',
    'mreport.preview.busy':         'Building…',
    'mreport.xlsx':                 'Download .xlsx attachment',
    'mreport.xlsx.busy':            'Preparing…',
    'mreport.xlsx.done':            'Attachment downloaded: {name}',
    'mreport.send':                 'Send now',
    'mreport.send.busy':            'Sending…',
    'mreport.test.hint':            'Leave year/month empty to use the last closed month. Do not pick a month that is still running — its MoM comparison is always misleading.',
    'mreport.sendConfirm':          'Send the monthly report now to {to}? A real email will be delivered.',
    'mreport.runConfirm':           'Run the {type} monthly report now? A real email will be delivered.',
    'mreport.empty':                '(empty)',
    'mreport.sentOk':               'Sent: {period} to {to} (attachment {size}).',
    'mreport.notSent':              'Not sent: {reason}',
    'mreport.skipped':              'Skipped: {reason}',
    'mreport.previewCard':          'Preview',
    'mreport.period':               'Period',
    'mreport.subject':              'Subject',
    'mreport.attachment':           'Attachment',
    'mreport.profile':              'Profile',
    'mreport.cronJob':              'cron job',
    'mreport.lastSentShort':        'last sent',
    'mreport.schedOn':              'Schedule active',
    'mreport.schedOff':             'Schedule off',
        'mreport.mod.sapUsage':         'SAP User Utilisation',
    'mreport.tab.sap.hint':         'Solman + SAP User Utilisation + Licenses',
    'mreport.tab.sapusage.hint': 'SAP User Usage report per trimester, month or year — download .xlsx',
    'mreport.mod.sapLicenses':      'SAP Licences (snapshot)',
    'mreport.sapLic.conn':          'SAP connection for the licence section (landscape / SID / client)',
    'mreport.sapLic.hint':          'Taken from the SAP User Maintenance snapshot for this connection, not from monthly data. That table is only refilled when "Load Users" is pressed (there is no cron), so the email shows the snapshot date and warns when it is more than 30 days old. Active users only; licence 91 (test/technical) and expired accounts are excluded. The email carries the total only; the breakdown is in the SAP_Licenses sheet of the attachment.',
    'mreport.charts':               'Include charts in the email',
    'mreport.charts.hint':          'The chart type is chosen automatically from the shape of the data: pie/donut for composition, bars for rankings and comparisons, columns for time series. Charts always accompany the tables rather than replacing them. Only pie/donut are images; the rest are plain HTML. The .xlsx attachment is unaffected.',
    'mreport.tab.infra.hint':       'M365 + SDP Cloud',
    'mreport.tab.aws.hint':         'AWS cost only',
    'mreport.tab.s3.hint':          'S3 storage & SAP backup media',
    'mreport.tab.exec.hint':        'All modules combined — for management',
    'sidebar.tableMaintenance':         'Table Maintenance',
    'sidebar.tableMaintenance.sub':     'DB Admin',
    'sidebar.telegram':                 'Telegram Bot',
    'sidebar.telegram.sub':             'Notifications & AI Chat',
    'sidebar.telegramLog':              'Telegram Chat Log',
    'sidebar.telegramLog.sub':          'Bot conversation history',
    'sidebar.sessions':                 'Session Log',
    'sidebar.sessions.sub':             'Active sessions & force-logout',

    // ── Sidebar: bottom controls ──
    'sidebar.collapse':         'Collapse',
    'sidebar.expand':           'Expand sidebar',
    'sidebar.autoHide':         'Auto-hide',
    'sidebar.autoHide.on':      'On',
    'sidebar.autoHide.off':     'Off',

    // ── Overview ──
    'overview.systemOnline':   'System Online',
    'overview.systemOffline':  'System Offline',
    'overview.someUnavailable':'Some systems unavailable',
    'overview.welcome':        'Welcome, {name}!',
    'overview.accessInfo':     'You have access to {count} dashboard(s). Select a dashboard below to begin.',
    'overview.accessInfoBold': '{count} dashboard(s)',
    'overview.allNormal':      'All systems normal',
    'theme.label':             'Color Theme',
    'theme.blue':              'Blue',
    'theme.indigo':            'Indigo',
    'theme.teal':              'Teal',
    'theme.emerald':           'Emerald',
    'theme.violet':            'Violet',
    'theme.amber':             'Amber',
    'theme.rose':              'Rose',
    'theme.black':             'Black',
    'fontScale.label':         'Font Size',
    'fontScale.sm':            'Small',
    'fontScale.md':            'Normal',
    'fontScale.lg':            'Large',
    'overview.statDashboards': 'dashboards',
    'overview.statCategories': 'categories',
    'overview.realtime':       'Real-time data',
    'overview.available':      'Available Dashboards',
    'overview.clickHint':      'Click a card below to open the corresponding dashboard.',
    'overview.openDashboard':  'Open Dashboard',
    'overview.footer':         'Primary Dashboard v1.0 · Data updated automatically',

    // ── Overview: dashboard cards (desc + stat label) ──
    'overview.card.awsBilling.desc':   'Real-time monitoring of AWS service cost and usage.',
    'overview.card.awsBilling.stat':   'Periods',
    'overview.card.awsCost.desc':      'In-depth analysis of AWS spending and cost trends.',
    'overview.card.awsCost.stat':      'Years',
    'overview.card.solman.desc':       'Tracking of SAP incident tickets and service requests.',
    'overview.card.solman.stat':       'Open Tickets',
    'overview.card.sdp.desc':          'Ticketing & assets from ManageEngine ServiceDesk Plus Cloud.',
    'overview.card.sdp.stat':          'Open Tickets',
    'overview.card.sapUsage.desc':     'Analysis of user usage and activity in SAP systems.',
    'overview.card.sapUsage.stat':     'Records',
    'overview.card.sapUserMgmt.desc':  'Manage SAP dialog users — lock, unlock, and reset password.',
    'overview.card.sapUserMgmt.stat':  'Systems Ready',
    'overview.card.awsInventory.desc': 'AWS resource inventory across regions.',
    'overview.card.awsInventory.stat': 'Resources',
    'overview.card.awsCloudTrail.desc':'AWS API activity & audit trail.',
    'overview.card.awsCloudTrail.stat':'Events',
    'overview.card.employeeOvertime.desc':'Employee overtime by company, department & grade.',
    'overview.card.employeeOvertime.stat':'Overtime',
    'overview.card.aiWorkspace.desc':'Full-page AI chat — pick a dashboard to analyze.',
    'overview.card.aiWorkspace.stat':'AI',
    'overview.card.tableMaintenance.desc': 'Manage dashboard table data — upload, delete, and maintain records.',
    'overview.card.tableMaintenance.stat': 'Admin',
    'overview.card.logViewer.desc':        'Monitor user and system activity logs in real-time.',
    'overview.card.logViewer.stat':        'Admin',
    'overview.card.sessionLog.desc':       'Track active login sessions and user access history.',
    'overview.card.sessionLog.stat':       'Admin',
    'overview.card.shareLinks.desc':       'Create and manage public read-only links for sharing dashboards.',
    'overview.card.shareLinks.stat':       'Admin',
    'overview.card.telegram.desc':         'Manage Telegram bots for dashboard notifications and data queries.',
    'overview.card.telegram.stat':         'Admin',
    'overview.card.telegramLog.desc':      'Chat history and user interactions with Telegram bots.',
    'overview.card.telegramLog.stat':      'Admin',
    'overview.card.userMgmt.desc':         'Manage user accounts, passwords, and dashboard access rights.',
    'overview.card.userMgmt.stat':         'Admin',
    'overview.card.roleMgmt.desc':         'Configure roles and permission sets for access control.',
    'overview.card.roleMgmt.stat':         'Admin',
    'overview.card.sapBasisMon.desc':      'Monitor SAP Basis health — jobs, locks, work processes & system.',
    'overview.card.sapBasisMon.stat':      'Connections',
    // Search & recent visits
    'overview.search.placeholder':   'Search dashboards…',
    'overview.search.noResults':     'No dashboards found',
    'overview.search.noResultsHint': 'Nothing matches your search.',
    'overview.search.resultCount':   'results',
    'overview.recent.title':         'Recently Visited',

    // ── AI Chat ──
    'ai.assistant':        'AI Assistant',
    'ai.exportPdf':        'Export to PDF',
    'ai.export':           'Export chat',
    'ai.newSession':       'Start new session',
    'ai.settings':         'Settings',
    'ai.noData':           'No data yet',
    'ai.records':          'records',
    'ai.notConfigured':    'AI configuration incomplete',
    'ai.openSettings':     'Open Settings',
    'ai.notConfiguredAdmin': 'Contact your AI manager to set up the configuration.',
    'ai.quickData':        'Analyze actual data',
    'ai.quick':            'Quick questions',
    'ai.analyzing':        'Analyzing data...',
    'ai.placeholder':      'Type a question... (Enter to send)',
    'ai.placeholderConfig':'Configure AI first...',
    'ai.inputHint':        'Shift+Enter new line · export PDF · history auto-saved',
    'ai.copy':             'Copy',
    'ai.copied':           'Copied!',
    'ai.dataAvailable':    'Actual data available — answers based on real data',
    'ai.dataSourceTitle':  'AI data source',
    'ai.session':          'Session',
    'ai.avg':              'Avg',
    'ai.accuracy':         'Accuracy',
    'ai.accuracyHigh':     'High',
    'ai.accuracyMed':      'Medium',
    'ai.accuracyLow':      'Low',
    'ai.filter':           'Filter',
    'ai.tokens':           'tokens',
    'ai.sources':          'Sources',
    'ai.openNote':         'Open note · Relevance',
    'ai.viewSource':       'View source content',
    'ai.kbRelevance':      'Relevance',
    'ai.kbChunkHint':      'This is the text excerpt the AI read when composing its answer — not the whole document.',
    'ai.kbTruncated':      'Only a snippet was stored for older chats; ask again to see the full text.',
    'ai.kbOpenNote':       'Open original note',
    'ai.kbOpenDashboard':  'Open in dashboard',
    'ai.untitled':         '(untitled)',
    'ai.srcRag':           '📚 Knowledge Base (RAG)',
    'ai.srcSql':           '🗄️ Text-to-SQL',
    'ai.srcChat':          '💬 AI Service',
    'ai.srcSqliteSql':     '🗄️ SQLite (text-to-SQL)',
    'ai.srcSqliteLive':    '🗄️ SQLite DB (real-time)',
    'ai.srcNone':          '⚠️ No data source',
    'ai.autoDetected':     'Auto-detected',
    'ai.grpFlat':          '☰ Show flat',
    'ai.grpBy':            '⊞ Group by',
    'ai.grpEmpty':         '(empty)',
    'ai.skipTyping':       'Click to show full',
    'ai.cmdHelp':          '**Available commands:**\n- `/clear` (alias `/new`, `/reset`) — start a new session & reset conversation context\n- `/sql` — show the SQL query from the last data answer\n- `/examples` — show example questions for this dashboard\n- `/help` — show this command list',
    'ai.cmdSqlLabel':      'SQL from the last data answer:',
    'ai.cmdNoSql':         'No data query in this session yet. Ask a data question first, then type `/sql`.',
    'ai.cmdExamples':      '**Example questions:**',
    'ai.cmdNoExamples':    'No specific examples for this dashboard. Just type your data question.',
    'ai.cmdUnknownPre':    'Command',
    'ai.cmdUnknownPost':   'is unknown. Type `/help` for the command list.',
    // ── AWS Billing Dashboard ──
    'awsb.dashTitle':       'AWS Billing Dashboard',
    'awsb.account':         'Account',
    'awsb.loading':         'Loading billing data from SQLite…',
    'awsb.retry':           'Retry',
    'awsb.backendHint':     'Make sure the backend is running:',
    'awsb.uploadTitle':     'Upload CSV / JSON',
    'awsb.overrideHint1':   'Uploading a file will',
    'awsb.override':        'override',
    'awsb.overrideHint2':   'the dashboard view with CSV data. The SQLite DB is not affected unless you click',
    'awsb.backToSqlite':    'Back to SQLite',
    'awsb.saveToDbBtn':     'Save to DB',
    'awsb.savedToDb':       'Saved to DB',
    'awsb.adminOnly':       'Only admins can upload CSV/JSON files',
    'awsb.uploadHintTitle': 'Upload CSV or JSON billing data',
    'awsb.uploadBtn':       'Upload CSV / JSON',
    'awsb.rows':            'rows',
    'awsb.periodsParen':    'period(s)',
    'awsb.reload':          'Reload',
    'awsb.year':            'Year',
    'awsb.selected':        'selected —',
    'awsb.clear':           'Clear',
    'awsb.holdCtrl1':       'Hold',
    'awsb.holdCtrl2':       'to select multiple',
    'awsb.all':             'All',
    'awsb.periodsWord':     'periods',
    'awsb.billingPeriods':  'Billing Periods',
    'awsb.allPeriods':      'All',
    'awsb.comparing':       '✓ Comparing vs prev',
    'awsb.compareVsPrev':   '⇄ Compare vs prev period',
    'awsb.compareBanner':   '📊 Comparing with previous period:',
    'awsb.trendTitle':      'Total cost trend across periods',
    'awsb.filter':          'Filter:',
    'awsb.allTaxTypes':     'All tax types',
    'awsb.searchService':   'Search service…',
    'awsb.sortTotal':       'Sort by total cost',
    'awsb.sortPretax':      'Sort by pre-tax cost',
    'awsb.sortTax':         'Sort by tax',
    'awsb.sortName':        'Sort by name',
    'awsb.costBeforeTax':   'Cost before tax',
    'awsb.taxAmount':       'Tax amount',
    'awsb.totalInvoice':    'Total invoice',
    'awsb.inclTaxes':       'Incl. all taxes',
    'awsb.creditsApplied':  'Credits applied',
    'awsb.services':        'services',
    'awsb.periodWord':      'Period',
    'awsb.allPeriodsWord':  'All periods',
    'awsb.none':            'None',
    'awsb.costByService':   'Cost by service',
    'awsb.topUsageTypes':   'Top usage types',
    'awsb.noUsageData':     'No usage type data.',
    'awsb.breakdown':       'Service cost breakdown',
    'awsb.showing':         'showing',
    'awsb.of':              'of',
    'awsb.service':         'Service',
    'awsb.code':            'Code',
    'awsb.pretax':          'Pre-tax',
    'awsb.tax':             'Tax',
    'awsb.total':           'Total',
    'awsb.vsPrev':          'vs prev period',
    'awsb.share':           'Share',
    'awsb.ud.tabOverview':  'Overview',
    'awsb.ud.tabUsage':     'Usage Details',
    'awsb.ud.tabReport':     'Report',
    'header.search':         'Search pages',
    'header.search.recent':      'Recently opened',
    'header.search.clearRecent': 'Clear',
    'awsb.ud.totalServices':'Total active services',
    'awsb.ud.totalCharges': 'Total pre-tax service charges',
    'awsb.ud.filterPlaceholder':'Filter by service, region, or description…',
    'awsb.ud.expandAll':    'Expand all',
    'awsb.ud.collapseAll':  'Collapse all',
    'awsb.ud.groupByPeriod':'Group by period',
    'awsb.ud.periodFilter': 'Select period',
    'awsb.ud.allPeriods':   'All periods',
    'awsb.ud.description':  'Description',
    'awsb.ud.usageQty':     'Usage Quantity',
    'awsb.ud.amount':       'Amount',
    'awsb.ud.noQtyNote':    'Your data does not store a Usage Quantity column, so the usage quantity column is hidden. Region is derived from the UsageType prefix.',
    'awsb.noMatch':         'No services match your filter.',
    'awsb.new':             'new',
    'awsb.totalWord':       'Total',
    'awsb.seller':          'Seller',
    'awsb.periodLabel':     'Period',
    'awsb.currency':        'Currency',
    'awsb.uploadedFile':    'Uploaded file',
    'awsb.dragDrop':        'Drag & drop CSV or JSON file here',
    'awsb.browse':          'Browse file',
    'awsb.saveModalTitle':  '💾 Save to SQLite DB',
    'awsb.across':          'across',
    'awsb.saveMode':        'Save mode',
    'awsb.append':          'Append',
    'awsb.appendDesc':      'Add rows — keep existing data',
    'awsb.replace':         'Replace',
    'awsb.replaceDesc':     'Overwrite same period(s) in DB',
    'awsb.saving':          'Saving…',
    'awsb.saved':           'Saved ✓',
    'awsb.productCode':     'Product code',
    'awsb.periodsDrawer':   'Periods',
    'awsb.effectiveTaxRate':'Effective tax rate',
    'awsb.totalCost':       'Total cost',
    'awsb.taxType':         'Tax type',
    'awsb.credits':         'Credits',
    'awsb.topLineItems':    'Top line items',

    // ── AWS Cost Explorer ──
    'awsc.dashTitle':       'AWS Cost Dashboard',
    'awsc.reset':           'Reset',
    'awsc.ctrlMulti':       'Ctrl+click multi',
    'awsc.upload':          'Upload CSV',
    'awsc.uploading':       'Uploading...',
    'awsc.failed':          'Failed',
    'awsc.rowsSaved':       'rows saved',
    'awsc.adminOnly':       'Only admins can upload CSV files',
    'awsc.uploadTitle':     'Upload CSV billing data',
    'awsc.ofTotal':         'of total',
    'awsc.allBuCombined':   'All business units combined',
    'awsc.noData':          'No data',
    'awsc.monthlyCostByBu': 'Monthly Cost by BU',
    'awsc.costShareByBu':   'Cost Share by BU',
    'awsc.yearlyTrend':     'Yearly AWS Cost Trend',
    'awsc.allocated':       'ALLOCATED',
    'awsc.shareNoTags':     'Share & No-Tags split evenly across 3 BUs',
    'awsc.barChart':        'Bar Chart',
    'awsc.lineChart':       'Line Chart',
    'awsc.allMonths':       'All Months',
    'awsc.inclAlloc':       'incl. allocation',
    'awsc.costPerBu':       'Cost per BU (incl. allocation)',
    'awsc.proportion':      'Proportion',
    'awsc.detailPerMonth':  'Monthly Detail (Consolidated)',
    'awsc.month':           'Month',
    'awsc.total':           'Total',
    'awsc.grandTotal':      'Grand Total',
    'awsc.monthlyDetailByBu':'Monthly Detail by Business Unit',
    'awsc.buLabel':         'BU:',
    'awsc.allBu':           'All BU',
    'awsc.monthCol':        'Month',
    'awsc.topProducts':     'Top Services',
    'awsc.monthFilter':     'Month:',
    'awsc.all':             'All',
    'awsc.productFilter':   'Service:',
    'awsc.product':         'Service',
    'awsc.usageDetail':     'Usage Type Detail',
    'awsc.usageType':       'Usage Type',
    'awsc.grandTop50':      'Grand Total (top 50)',
    'awsc.tab.overview':    'Overview',
    'awsc.tab.consolidated':'Consolidated',
    'awsc.tab.monthly':     'Monthly',
    'awsc.tab.products':    'Services',
    'awsc.tab.usage':       'Usage Detail',
    'awsc.loading':         'Loading data from database…',
    'awsc.empty':           'No AWS Cost data yet',
    'awsc.emptyHint1':      'Upload a CSV file via the',
    'awsc.emptyHint2':      'button above.',
    'awsc.requiredCols':    'Required CSV columns:',

    // ── AWS Cost: extra (year selector, multi-year, search) ──
    'awsc.service':         'Service',
    'awsc.allYears':        'All',
    'awsc.searchService':   '🔍 Service / Usage Type…',
    'awsc.perYearSuffix':   '/yr',
    'awsc.multiYearNote':   '{count} years combined ({range}) · monthly figure = total of all years, second line = average per year',
    'awsc.tab.daily':       'Daily Usage',
    'awsc.dailyUsage':      'Daily Breakdown (Day › Service › Usage Type)',
    'awsc.dayCol':          'Day',
    'awsc.expandAll':       'Expand all',
    'awsc.collapseAll':     'Collapse all',
    'awsc.dailyTreeNote':   'Click a row to expand/collapse. Older data (before the daily feature) appears on day 1; new uploads/fetches are filled per day. Tax is placed on day 1.',

    // ── SAP Solution Manager ──
    'solm.title':           'SAP Solution Manager',
    'solm.subtitle':        'SAP Ticket & Incident Monitoring',
    'solm.records':         'records',
    'solm.uploadCsv':       'Upload CSV',
    'solm.uploadTitle':     'Upload CSV file',
    'solm.uploadAdminOnly': 'Only admin can upload CSV',
    'solm.saving':          'Saving...',
    'solm.saved':           'Saved',
    'solm.saveToDb':        'Save to DB',
    'solm.saveToDbTitle':   'Save to Database',
    'solm.saveAdminOnly':   'Only admin can save to database',
    'solm.total':           'Total',
    'solm.open':            'Open',
    'solm.closed':          'Closed',
    'solm.incidentTickets': 'SAP Solution Manager — Incident Tickets',
    'solm.nav.overview':    'Overview',
    'solm.nav.trends':      'Trends',
    'solm.nav.teams':       'Teams',
    'solm.nav.detail':      'Ticket Detail',
    'solm.det.sub':         'Ticket detail — follows the filters above',
    'solm.det.searchPh':    'Search all columns…',
    'solm.det.columns':     'Columns {n}/{total}',
    'solm.det.colsAll':     'Show all',
    'solm.det.colsDefault': 'Back to default',
    'solm.det.clearFilters': 'Clear {n} filter(s)',
    'solm.det.filterPh':    'filter…',
    'solm.det.allValues':   '(all)',
    'solm.det.perPage':     'Rows/page',
    'solm.det.export':      'Export Excel',
    'solm.det.showing':     'Showing {from}–{to} of {total} rows',
    'solm.det.ofFiltered':  '(of {n} from the filters above)',
    'solm.det.pageOf':      'Page {page} / {total}',
    'solm.det.noRows':      'No matching rows. Try loosening the search or the column filters.',
    'solm.det.sortHint':    'Click to sort: ascending / descending',
    'solm.nav.pivot':       'Pivot Table',
    'solm.nav.export':      'Export Excel',
    'solm.nav.aging':       'Status Aging',
    'solm.nav.report':      'Monthly Report',
    'solm.export.title':      'Export to Excel',
    'solm.export.subtitle':   'Download tickets by company & month, in the exact same format as the monthly report file.',
    'solm.export.company':    'Company',
    'solm.export.month':      'Month',
    'solm.export.year':       'Year',
    'solm.export.matchCount': 'Found',
    'solm.export.button':     'Export Excel',
    'solm.export.exporting':  'Exporting…',
    'solm.export.done':       'Downloaded successfully:',
    'solm.export.note':       'Filename & column order follow the monthly Solman report format (MM. Solman tickets Month yyyy - COMPANY). "Created On2" is written as a real date, ID/Client/SAP Installation/Software Release as numbers — same as the source file.',
    'solm.export.spButton':   'Save to SharePoint',
    'solm.export.spUploading':'Saving to SharePoint…',
    'solm.export.spDone':     'SharePoint upload result:',
    'solm.allCompanies':    'All Companies',
    'solm.allTeams':        'All Teams (Impact)',
    'solm.year':            'YEAR:',
    'solm.all':             'All',
    'solm.status':          'STATUS:',
    'solm.clear':           'Clear',
    'solm.showing':         'Showing',
    'solm.tickets':         'tickets',
    'solm.loading':         'Loading data from database...',
    'solm.loadingSub':      'Fetching tickets from SQLite via API',
    'solm.cantLoad':        'Cannot load from DB',
    'solm.cantLoadDesc':    'Cannot connect to server or token invalid. Upload CSV manually, or make sure the server is running.',
    'solm.retry':           'Retry',
    'solm.dbEmpty':         'Database empty',
    'solm.dbEmptyDesc':     'No tickets in the database yet. Upload CSV then click "Save to DB".',
    'solm.noData':          'No data loaded',
    'solm.noDataDesc':      'Drop your Solman ticket CSV into the sidebar on the left, or click the drop zone to browse.',
    'solm.chip1':           'Overview KPIs',
    'solm.chip2':           'Monthly trends',
    'solm.chip3':           'Team workload',
    'solm.chip4':           'Status pivot',
    'solm.chip5':           'Ticket detail drawer',
    'solm.totalTickets':    'Total Tickets',
    'solm.withdrawn':       'Withdrawn',
    'solm.closeRate':       'Close Rate',
    'solm.ofTotal':         '% of total',
    'solm.statusBreakdown': 'Status breakdown',
    'solm.statusBreakdownSub':'All tickets by current status',
    'solm.ticketsByCompany':'Tickets by company',
    'solm.monthlyStacked':  'Monthly tickets — stacked by status',
    'solm.monthlyStackedSub':'Each bar split by Status field',
    'solm.monthStatusTable':'Month × Status detail table',
    'solm.monthStatusSub':  'Count per status per month — from Created On (month = MM of DD.MM.YYYY)',
    'solm.priorityDist':    'Priority distribution',
    'solm.priorityDistSub': 'Tickets grouped by urgency level',
    'solm.monthlyVolume':   'Monthly ticket volume',
    'solm.monthlyVolumeSub':'Total, Closed and Open over time',
    'solm.monthlyStacked2': 'Monthly stacked by status',
    'solm.monthlyStacked2Sub':'All 7 statuses per month',
    'solm.ticketVolPerTeam':'Ticket volume per team',
    'solm.teamStatusMatrix':'Team × Status matrix',
    'solm.teamStatusMatrixSub':'Impact field × Status — count per status per team',
    'solm.monthStatusFilter':'Month × Status (current filter)',
    'solm.monthStatusFilterSub':'Month breakdown of all statuses for the active filter',
    'solm.monthStatusDetail':'Month × Status detail',
    'solm.monthStatusDetailSub':'Full breakdown by month and status',
    'solm.month':           'Month',
    'solm.monthlySummary':  'Monthly summary',
    'solm.monthlySummarySub':'Totals per month with close rate',
    'solm.uploadHeader':    'SAP Solman Dashboard',
    'solm.uploadIntro':     'Upload your Solman ticket CSV export to explore incident trends, team workload, and status breakdown per month.',
    'solm.dropCsv':         'Drop CSV file here',
    'solm.orClick':         'or click to browse — supports Solman exports (.csv)',
    'solm.noTickets':       'No tickets found',
    'solm.totalTicket':     'total ticket',
    'solm.close':           'Close',
    'solm.pivotTitle':      'Pivot: Impact × Status × Month',
    'solm.number':          'number',
    'solm.totalCaps':       'TOTAL',
    'solm.allStatuses':     'All statuses',
    'solm.teamImpact':      'Team (Impact)',
    'solm.clickAny':        'Click any number',
    'solm.toViewDetails':   'to view ticket details ·',
    'solm.scrollHorizontal':'scroll horizontally to see all months',
    'solm.monthsWord':      'months',
    'solm.teamsWord':       'teams',

    // ── SAP User Utilization ──
    'sapu.loadCsvTitle':    '📂 Load CSV Data Source',
    'sapu.csvOnly':         'Only .csv files are supported.',
    'sapu.noValidData':     'No valid data found.',
    'sapu.csvSuccess':      'Success: {n} records from {file}',
    'sapu.dragDrop':        'Drag & drop CSV file or click',
    'sapu.csvFormat':       'Format: Client, Dept., Period, User, Total, Lic., License Type, Landscape (optional)',
    'sapu.activeLabel':     'Active:',
    'sapu.resetDefault':    'Reset to default',
    'sapu.close':           'Close',
    'sapu.loading':         'Loading data from database...',
    'sapu.erpSystem':       'SAP ERP System',
    'sapu.title':           'User Usage Dashboard',
    'sapu.records':         'records',
    'sapu.loadCsv':         'Load CSV',
    'sapu.saving':          '⏳ Saving...',
    'sapu.saveToDb':        '💾 Save to DB',
    'sapu.alreadyFromDb':   'Data from DB (no need to re-save)',
    'sapu.saveTitle':       'Click to save data to database',
    'sapu.loadFromDb':      '🗄️ Load from DB',
    'sapu.totalHours':      'Total Hours',
    'sapu.totalUsers':      'Total Users',
    'sapu.activeUsers':     'Active Users',
    'sapu.rows':            'rows',
    'sapu.year':            'YEAR',
    'sapu.all':             'All',
    'sapu.yearsSelected':   'years selected',
    'sapu.period':          'PERIOD',
    'sapu.selected':        'selected',
    'sapu.ctrlDeselect':    'Ctrl+click to deselect / click to select one',
    'sapu.ctrlMulti':       'Click to select · Ctrl+click for multiselect',
    'sapu.tab.overview':    '📊 Overview',
    'sapu.tab.company':     '🏢 By Company',
    'sapu.tab.module':      '⚙️ By Module',
    'sapu.tab.users':       '👤 Top Users',
    'sapu.tab.table':       '📋 Data Table',
    'sapu.tab.pivot':       '📊 Monthly Usage',
    'sapu.hoursByCompany':  'Hours by Company',
    'sapu.hoursByModule':   'Hours by Module',
    'sapu.usageTrend':      'Usage Trend by Company × Period',
    'sapu.licenseTypeSplit':'License Type Split',
    'sapu.moduleRanking':   'Module Ranking (hrs)',
    'sapu.module':          'MODULE',
    'sapu.allModules':      'All Modules',
    'sapu.hoursPerModule':  'Hours per Module — click bar to drill-down',
    'sapu.clickToSeeUsers': '👆 Click to see users',
    'sapu.back':            '← Back',
    'sapu.totalUsage':      'Total Usage',
    'sapu.activeWord':      'Active',
    'sapu.companies':       'Companies',
    'sapu.usersIn':         'Users in',
    'sapu.userDetail':      'User Detail —',
    'sapu.usersWord':       'users',
    'sapu.ofUsers':         'of {n} users',
    'sapu.showTop':         'Show top',
    'sapu.highest':         'Highest Usage',
    'sapu.lowest':          'Lowest Usage',
    'sapu.ofMax':           '% of max',
    'sapu.searchUserDept':  'Search user / dept...',
    'sapu.showingLimit':    'Showing 100 of {n} rows — use filters to narrow down.',
    'sapu.licenses':        'Licenses:',
    'sapu.moduleLabel':     'MODULE:',
    'sapu.searchUser':      '🔍 Search user...',
    // ── Employee Overtime ──
    'overtime.subtitle':        'Employee overtime data — {recs} total records from {files} source file(s).',
    'overtime.tabOverview':     'Overview',
    'overtime.tabDetail':       'Overtime Detail',
    'overtime.tabPivot':        'Pivot Table',
    'overtime.pivotTitle':      '📐 Pivot: Business Unit × Month',
    'overtime.measure':         'Measure:',
    'overtime.measureHours':    'Total OT Hours',
    'overtime.measureAmount':   'Total Amount',
    'overtime.measureCount':    'Session Count',
    'overtime.rowTotal':        'Row Total',
    'overtime.colTotal':        'Total',
    'overtime.grandTotal':      'Grand Total',
    'overtime.expandAll':       'Expand All',
    'overtime.collapseAll':     'Collapse All',
    'overtime.clickSort':       'Click to sort',
    'overtime.clickReason':     'Click for breakdown by reason',
    'overtime.reasonBreakdown': 'Breakdown by Reason',
    'overtime.value':           'Value',
    'overtime.allPeriods':      'All Periods',
    'overtime.filter':          'Filter:',
    'overtime.allYears':        'All Years',
    'overtime.allMonths':       'All Months',
    'overtime.allBu':           'All BU',
    'overtime.searchPh':        '🔍 Name, code, dept…',
    'overtime.apply':           'Apply',
    'overtime.reset':           '↺ Reset',
    'overtime.totalRecords':    'Total Records',
    'overtime.businessUnits':   'Business Units',
    'overtime.periodsAvail':    'Periods Available',
    'overtime.sourceFiles':     'Source Files',
    'overtime.page':            'Page',
    'overtime.totalHoursPer':   '📊 Total OT Hours per',
    'overtime.totalAmountPer':  '💰 Total OT Amount per {by}',
    'overtime.optDept':         'Department',
    'overtime.optSection':      'Section',
    'overtime.optBu':           'Business Unit',
    'overtime.noData':          'No data.',
    'overtime.detailTitle':     '📋 Overtime Detail',
    'overtime.records':         '{n} records',
    'overtime.pageShort':       'Page {p}/{tp}',
    'overtime.loadFail':        'Failed to load data.',
    'overtime.emptyTable':      '⏱️ No overtime data for the selected filters.',
    'overtime.colKode':         'Code',
    'overtime.colNama':         'Employee Name',
    'overtime.colThn':          'Yr',
    'overtime.colBln':          'Mo',
    'overtime.colTgl':          'Duty Date',
    'overtime.colMulai':        'Start',
    'overtime.colSelesai':      'End',
    'overtime.colJam':          'OT Hrs',
    'overtime.colTotalJam':     'Total Hrs',
    'overtime.colAmount':       'Amount (Rp)',
    'overtime.colReason':       'Reason',

    // ── Cron Scheduler (shared component) ──
    'cron.title':         '⏰ Automatic Schedule (Cron)',
    'cron.active':        'Active',
    'cron.activeApply':   'Active (save to apply)',
    'cron.inactive':      'Inactive',
    'cron.noNodeCron':    'node-cron not installed',
    'cron.enable':        'Enable',
    'cron.freqDaily':     'Daily',
    'cron.freqWeekly':    'Weekly',
    'cron.freqMonthly':   'Monthly',
    'cron.freqCustom':    'Custom (cron)',
    'cron.dayOfMonth':    'Day',
    'cron.hour':          'Hour',
    'cron.customPlaceholder': 'e.g. 0 6 * * 1',
    'cron.tzLabel':       'WIB ({tz})',
    'cron.saveSchedule':  '💾 Save Schedule',
    'cron.saving':        '⏳…',
    'cron.runNow':        '▶️ Run Now',
    'cron.runConfirmDefault': 'Run this job now? This will pull data from AWS.',
    'cron.saved':         'Saved — {state}, schedule "{schedule}" ({tz}).',
    'cron.stateActive':   'ACTIVE',
    'cron.stateInactive': 'inactive',
    'cron.runDone':       '✅ {msg} ({n} rows)',
    'cron.runDoneDefault':'Done.',
    'cron.runFail':       'Failed: {err}',
    'cron.lastRun':       'Last run:',
    'cron.dowSun':        'Sunday',
    'cron.dowMon':        'Monday',
    'cron.dowTue':        'Tuesday',
    'cron.dowWed':        'Wednesday',
    'cron.dowThu':        'Thursday',
    'cron.dowFri':        'Friday',
    'cron.dowSat':        'Saturday',

    // ── Sybase DR Monitor ──
    'sdr.title':            'Sybase DR Monitor',
    'sdr.desc':             'Monitor Sybase ASE 16 errorlog via SSH. One profile = one server + one log file. Anomalies are stored with 10 context lines and sent via the sybase_dr Telegram bot.',
    'sdr.profilesActive':   '{n} active profiles',
    'sdr.findingsCount':    '{n} findings',
    'sdr.forceScan':        '⚡ Force Scan (test — ignore baseline)',
    'sdr.forceConfirm':     'Force Scan: ignore baseline & alert ALL matches in the tail (for testing). Continue?',
    'sdr.forceDone':        'Force scan complete — {n} anomalies found ({p} profiles).',
    'sdr.runConfirm':       'Run Sybase DR scan now?',
    // Profiles
    'sdr.profilesSection':  'SSH Profiles',
    'sdr.addProfile':       '+ Add Profile',
    'sdr.emptyProfiles':    "No profiles yet. Click '+ Add Profile' to start.",
    'sdr.colLabel':         'Label',
    'sdr.colHost':          'Host',
    'sdr.colPort':          'Port',
    'sdr.colUser':          'User',
    'sdr.colKeyFile':       'Key File',
    'sdr.colLogPath':       'Log Path',
    'sdr.colKeywords':      'Keywords',
    'sdr.colStatus':        'Status',
    'sdr.colEmail':         'Email',
    'sdr.colLastTs':        'Last TS',
    'sdr.colActions':       'Actions',
    'sdr.kwCount':          '{n} kw',
    'sdr.active':           'Active',
    'sdr.inactive':         'Inactive',
    'sdr.emailOn':          'ON',
    'sdr.emailOff':         'OFF',
    'sdr.emailOffTitle':    'Email disabled',
    'sdr.baselineNone':     'No baseline yet',
    'sdr.tsNone':           'None yet',
    // Action buttons
    'sdr.testSsh':          '🔗 Test SSH',
    'sdr.testEmail':        '📧 Test Email',
    'sdr.reset':            '🔄 Reset',
    'sdr.clearFindings':    '🗑️ Findings',
    // Action messages
    'sdr.profileSaved':     'Profile updated.',
    'sdr.profileAdded':     'Profile added.',
    'sdr.deleteConfirm':    'Delete profile "{name}"? All findings will also be deleted.',
    'sdr.profileDeleted':   'Profile deleted.',
    'sdr.sshOk':            '✅ SSH OK — response: {res}',
    'sdr.emailSent':        '✅ Test email sent to {to}',
    'sdr.resetConfirm':     'Reset baseline for "{name}"? The next scan will become the new baseline.',
    'sdr.resetDone':        'Baseline reset.',
    'sdr.clearConfirm':     'Delete all findings for "{name}"?',
    'sdr.clearDone':        'Findings deleted.',
    // Findings
    'sdr.findingsSection':  'Findings (latest 100)',
    'sdr.allProfiles':      'All profiles',
    'sdr.noFindings':       'No findings.',
    'sdr.colTime':          'Time',
    'sdr.colProfile':       'Profile',
    'sdr.colAnomaly':       'Anomaly',
    'sdr.colAlert':         'Alert',
    'sdr.colDetail':        'Detail',
    'sdr.alertSent':        '✓ Sent',
    'sdr.alertPending':     'Pending',
    'sdr.contextBtn':       '🔍 Context',
    'sdr.contextTitle':     'Context — {time}',
    'sdr.contextProfile':   'Profile',
    'sdr.contextNone':      '(no context)',
    // Profile modal
    'sdr.modalAdd':         'Add SSH Profile',
    'sdr.modalEdit':        'Edit SSH Profile',
    'sdr.fLabel':           'Label (display name)',
    'sdr.fHost':            'Host / IP',
    'sdr.fPort':            'SSH Port',
    'sdr.fUser':            'SSH User',
    'sdr.fKeyFile':         'Key File (from /dashboard/keypairs)',
    'sdr.fKeyFileHint':     'OpenSSH format (not .ppk). Convert via PuTTYgen if needed.',
    'sdr.fKeyFilePick':     '-- Select key file --',
    'sdr.fLogPath':         'Log File Path (absolute on remote server)',
    'sdr.fKeywords':        'Anomaly keywords (one per line, case-insensitive)',
    'sdr.fStatus':          'Status',
    'sdr.fActiveLabel':     'Active (will be scanned by cron)',
    'sdr.fEmailAlert':      'Email Alert',
    'sdr.fEmailEnable':     'Send email alerts for this profile',
    'sdr.fEmailTo':         'recipient@example.com (comma-separated for multiple)',
    'sdr.fEmailHint':       'SMTP config is reused from the ASE Alert tab. Make sure SMTP host & credentials are set there.',
    'sdr.saving':           'Saving…',
    'sdr.save':             'Save',
    'sdr.cancel':           'Cancel',

    // ── TAHAP 5: Table Maintenance (header & tab labels) ──
    'tm.title':            'Table Maintenance',
    'tm.subtitle':         'Manage SQLite data directly from the dashboard — delete, modify, and clear tables.',
    'tm.noAccess':         'No access to this table.',
    'tm.tab.users':        'Users',
    'tm.tab.logs':         'Activity Logs',
    'tm.tab.tickets':      'Solman Tickets',
    'tm.tab.sap':          'SAP Usage',
    'tm.tab.billing':      'AWS Billing',
    'tm.tab.aws':          'AWS Cost',
    'tm.tab.idsuim':       'ID SUIM',
    'tm.tab.uploads':      'Upload History',
    'tm.tab.sapcfg':       'SAP Config',
    'tm.tab.notes':        'Notes',
    'tm.tab.sql':          'SQL Editor',
    'tm.tab.database':     'Database',
    'tm.tab.overtime':     'Employee Overtime',
    'tm.tab.asealert':     'ASE Alert',
    'tm.tab.sybasedr':     'Sybase ASE',

    // ── ASE Alert panel ──
    'asealert.title':         'ASE Errorlog Alert',
    'asealert.tgOn':          'Telegram ON',
    'asealert.tgOff':         'Telegram OFF',
    'asealert.emailOn':       'Email ON',
    'asealert.emailOff':      'Email OFF',
    'asealert.descA':         'Scan the ASE errorlog of each SAP profile (via command ',
    'asealert.descB':         '), match keywords, then send alerts for new lines. The first run per profile is baseline only (no old backlog).',
    'asealert.runConfirm':    'Run the ASE errorlog scan now?',
    'asealert.kwLabel':       'Keywords (one per line, case-insensitive)',
    'asealert.chTelegramA':   'Send to Telegram (bot ',
    'asealert.chTelegramB':   ')',
    'asealert.chEmail':       'Send to Email (SMTP)',
    'asealert.recipients':    'Recipients (comma-separated)',
    'asealert.smtpHost':      'SMTP Host',
    'asealert.port':          'Port',
    'asealert.ssl':           'SSL/TLS (secure) — usually port 465',
    'asealert.smtpUser':      'SMTP User',
    'asealert.smtpPass':      'SMTP Password',
    'asealert.smtpPassSaved': '(saved — fill to change)',
    'asealert.from':          'From (sender address)',
    'asealert.btnTest':       'Send Test',
    'asealert.msgSaved':      'Configuration saved.',
    'asealert.msgTest':       'Test — Telegram: {tg}, Email: {email}',

    // ── Users panel ──
    'users.rows':          '{n} rows',
    'users.addBtn':        'Add User',
    'users.colId':         'ID',
    'users.colUsername':   'Username',
    'users.colRole':       'Role',
    'users.colLastLogin':  'Last Login',
    'users.colCreated':    'Created',
    'users.empty':         'No users yet',
    'users.you':           '(You)',
    'users.deleteConfirm': 'Delete user "{name}"?',
    'users.deleted':       'User "{name}" deleted.',
    'users.created':       'User "{name}" created.',
    'users.updated':       'User updated.',
    'users.modalAdd':      'Add New User',
    'users.fPassword':     'Password',
    'users.phUsername':    'min. 3 chars',
    'users.phPassword':    'min. 6 chars',
    'users.btnCreate':     'Create User',
    'users.modalEdit':     'Edit: {name}',
    'users.fNewRole':      'New role',
    'users.fNewPw':        'New password (leave blank to keep)',

    // ── Activity Logs panel ──
    'logs.total':          '{n} total',
    'logs.searchPh':       'Search action / username…',
    'logs.info':           'Logs cannot be deleted — this is an audit trail. Showing the latest 100 of {n}.',
    'logs.colAction':      'Action',
    'logs.colDetail':      'Detail',
    'logs.colIp':          'IP',
    'logs.colTime':        'Time',
    'logs.empty':          'No logs',

    // ── Solman Tickets panel ──
    'tickets.statTotal':        'Total Tickets',
    'tickets.statSources':      'Source Files',
    'tickets.statPage':         'Page',
    'tickets.searchPh':         'Search ticket ID, company, status…',
    'tickets.btnFetch':         'Fetch from Solman',
    'tickets.selectSource':     '-- Select source file --',
    'tickets.btnDelSource':     'Delete Source',
    'tickets.btnClearAll':      'Clear All',
    'tickets.pickSource':       'Select a source file first.',
    'tickets.deleteSourceConfirm': 'Delete all tickets from "{name}"?',
    'tickets.deleteAllConfirm': 'CLEAR the entire solman_tickets table ({n} tickets)? Cannot be undone!',
    'tickets.errFrom':          'The "From" format must be YYYYMMDD (e.g. 20160101).',
    'tickets.errTo':            'The "To" format must be YYYYMMDD (e.g. 20160131).',
    'tickets.fetchDone':        'Done.',
    'tickets.fetchFail':        'Failed to fetch from Solman.',
    'tickets.cronConfirm':      'Run the Solman fetch now? Pulls ZMIN tickets 20230101→today from SAP and REPLACES existing ones (key: Ticket ID). May take a while.',
    'tickets.spCronConfirm':    'Upload LAST MONTH ticket Excel to SharePoint now? One file per company (OSI/PPI/PMI/PII/PBI) is written to the data-year folder, overwriting a file of the same name if present.',
    'tickets.modalTitle':       'Fetch Tickets from Solman',
    'tickets.fType':            'Transaction Type',
    'tickets.fFrom':            'From Date (YYYYMMDD, blank = all)',
    'tickets.fTo':              'To Date (YYYYMMDD, blank = all)',
    'tickets.fetchInfo':        'Data is pulled directly from SAP Solution Manager via RFC. Existing tickets (same ticket_id) are skipped automatically.',
    'tickets.fetching':         'Fetching…',
    'tickets.btnFetchNow':      'Fetch Now',
    'tickets.empty':            'No tickets in solman_tickets yet',
    'tickets.prev':             'Prev',
    'tickets.next':             'Next',
    'tickets.pager':            'Page {p} of {tp} ({a} of {b} tickets)',

    // ── SAP Usage panel ──
    'sap.statTotal':       'Total Records',
    'sap.statPeriods':     'Periods',
    'sap.searchPh':        'Search user, company, module…',
    'sap.delSourceConfirm':'Delete SAP data from "{name}"?',
    'sap.delAllConfirm':   'CLEAR all SAP Usage data? Cannot be undone!',
    'sap.empty':           'No SAP Usage data yet',
    'sap.pager':           'Page {p} of {tp} ({a} of {b} records)',

    // ── AWS Billing panel ──
    'billing.statPeriods': 'Billing Periods',
    'billing.titleRaw':    'AWS Billing Raw',
    'billing.searchPh':    'Search product, payer, usage type…',
    'billing.period':      'Period:',
    'billing.btnFetchAws': 'Fetch from AWS',
    'billing.fetchConfirm':'Fetch AWS Billing data for period {period} from Cost Explorer?\nData for this period in the table will be overwritten (replace mode).',
    'billing.fetchResult': '{message} {count} rows — cost ${cost}, tax ${tax}, total ${total}.',
    'billing.delConfirm':  'CLEAR all AWS Billing data? Cannot be undone!',
    'billing.btnClearTable':'Clear Table',
    'billing.empty':       'No billing data yet',
    'billing.monthsShort': 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec',

    // ── AWS Cost panel ──
    'aws.statYears':       'Available Years',
    'aws.titleRaw':        'AWS Cost Raw',
    'aws.searchPh':        'Search usage type, product, BU…',
    'aws.from':            'From:',
    'aws.to':              'To:',
    'aws.empty':           'No AWS Cost data yet',
    'aws.delConfirm':      'CLEAR all AWS Cost data ({n} rows) along with the entire upload history? Cannot be undone!',
    'aws.cleared':         'AWS Cost table cleared.',
    'aws.invalidPeriod':   'Invalid period.',
    'aws.invalidRange':    'Invalid period (From > To).',
    'aws.allOutOfRange':   'All selected periods are out of AWS Cost Explorer range (max 37 months back). Use CSV upload for older data.',
    'aws.skipNote':        ' ({n} months skipped — out of range: {list})',
    'aws.fetchConfirm':    'Fetch AWS Cost data {label} from Cost Explorer?{skip}\nEach month will be overwritten (replace mode).',
    'aws.rangeLabel':      '{a} – {b} ({n} months)',
    'aws.progress':        'Fetching {period}… ({i}/{n})',
    'aws.monthRows':       '{period}: {count} rows (${total})',
    'aws.successAll':      '✅ Done {n} months. {summary}. Grand total ${grand}.{skip}',
    'aws.partial':         '⚠️ {ok} months OK, {fail} failed. OK: {summary}. Failed: {err}.{skip}',

    // ── SAP Config panel ──
    'sapcfg.errLandscape': 'Landscape is required.',
    'sapcfg.saved':        'Saved.',
    'sapcfg.delConfirm':   'Delete profile {name}?',
    'sapcfg.deleted':      'Deleted.',
    'sapcfg.intro':        'SAP connection profiles per Landscape & Environment, stored in SQLite. Passwords are not shown again for security.',
    'sapcfg.btnAdd':       'Add',
    'sapcfg.empty':        'No profiles yet.',
    'sapcfg.colUpdated':   'Updated',
    'sapcfg.modalEdit':    'Edit SAP Profile',
    'sapcfg.modalAdd':     'Add SAP Profile',
    'sapcfg.fPwEdit':      'Password (blank = unchanged)',
    'sapcfg.fPw':          'Password',
    'sapcfg.bapiTitle':    'BAPI Service Paths — SAP User Maintenance (optional)',
    'sapcfg.bapiHint':     'Fill in only if this profile is used to manage users. Take from the WSDL service published in SOAMANAGER.',
    'sapcfg.saving':       'Saving…',

    // ── SQL Editor panel ──
    'sql.writeOk':         '{stmt} OK — {n} rows affected.',
    'sql.readMsg':         '{n} rows{trunc}.',
    'sql.truncated':       ' (showing first 1000)',
    'sql.tablesLabel':     'Tables:',
    'sql.allowWrite':      'Allow write/DDL (UPDATE/DELETE/DROP/ALTER…)',
    'sql.running':         'Running…',
    'sql.btnRun':          'Run (Ctrl+Enter)',
    'sql.warnA':           '⚠ Write mode active — the query can ',
    'sql.warnBold':        'permanently modify/delete data',
    'sql.warnB':           ' (e.g. DELETE/DROP). Make sure you have a WHERE & backup. All actions are recorded in the Activity Log.',
    'sql.empty0':          'Query succeeded, 0 rows.',
    'sql.exportFail':      'Export failed: ',

    // ── Database maintenance (Debug / Vacuum / Backup / Restore) ──
    'db.stats.title':         'Database Statistics',
    'db.stats.fileSize':      'File Size',
    'db.stats.tables':        'Tables',
    'db.stats.totalRows':     'Total Rows',
    'db.stats.pages':         'Pages',
    'db.stats.freelist':      'Freelist',
    'db.stats.reclaimable':   'Reclaimable',
    'db.loading':             'Loading…',
    'db.btn.refresh':         'Refresh',
    'db.btn.integrity':       'Integrity Check',
    'db.btn.integrityRunning':'Checking…',
    'db.btn.vacuum':          'VACUUM',
    'db.btn.vacuumRunning':   'VACUUM…',
    'db.btn.backup':          'Backup (.db)',
    'db.btn.backupRunning':   'Preparing…',
    'db.btn.restore':         'Restore (.db)',
    'db.btn.restoreRunning':  'Restoring…',
    'db.warn.boldA':          'Restore is destructive',
    'db.warn.mid':            ' — the entire active database is replaced with the uploaded file. Make a ',
    'db.warn.boldB':          'Backup',
    'db.warn.end':            ' first.',
    'db.confirm.vacuum':      'Run VACUUM? The DB will be compacted (briefly locked). Continue?',
    'db.confirm.restore':     'RESTORE will REPLACE the ENTIRE active database with the contents of "{name}".\nCurrent data will be lost and cannot be undone.\n\nA Backup first is recommended. Continue?',
    'db.alert.integrityOk':   '✅ Integrity check OK — database healthy.',
    'db.alert.integrityBad':  '⚠️ Integrity check found problems. See details below.',
    'db.alert.vacuumOk':      '✅ VACUUM done. {before} → {after} (reclaimed {reclaimed}).',
    'db.alert.backupOk':      '✅ Backup downloaded: {name}',
    'db.alert.restoreOk':     '✅ {message} ({n} tables).',
    'db.integrity.healthy':   'Integrity Check: Healthy',
    'db.integrity.problem':   'Integrity Check: Problem',
    'db.integrity.fkBad':     'Foreign key problems:',
    'db.integrity.ignoredA':  'FK findings ignored (by-design): the global config row',
    'db.integrity.ignoredB':  'intentionally without a parent in',

    // ── Telegram Bots (TelegramSettings) ──
    'tg.title':              'Telegram Bots',
    'tg.subtitle':           'Manage separate bots per dashboard + a notification bot',
    'tg.loadingBots':        'Loading bots...',
    'tg.errLoadBots':        'Failed to load bots: {err}',
    'tg.savedOk':            'Bot saved successfully & webhook set.',
    'tg.testText':           '✅ Test from {name}',
    'tg.sectionConfig':      '⚙️ Configuration — {name}',
    'tg.typeLabel':          'Type:',
    'tg.typeNotify':         'Notification',
    'tg.typeQuery':          'Query/Chat',
    'tg.enableBot':          'Enable Bot',
    'tg.enableBotHint':      'The bot will respond & run schedules',
    'tg.botName':            'Bot Name',
    'tg.botToken':           'Bot Token',
    'tg.tokenSet':           '✓ already set',
    'tg.tokenPlaceholderSet':'•••••• (enter to replace)',
    'tg.tokenPlaceholder':   'Token from @BotFather',
    'tg.tokenHint':          'Create a new bot via @BotFather → /newbot → copy the token',
    'tg.webhookUrl':         'Webhook URL (automatic)',
    'tg.webhookHint':        'The webhook is set automatically when you click Save.',
    'tg.saving':             'Saving...',
    'tg.save':               '💾 Save',
    'tg.testSend':           '📨 Test Send',
    'tg.sectionChatIds':     '👥 Allowed Chat ID List',
    'tg.chatIdsHint':        'This bot only responds to the Chat IDs listed here. Data access follows the bot scope automatically ({scope}).',
    'tg.phName':             'Name',
    'tg.phChatId':           'Chat ID',
    'tg.phMinYear':          'Min year',
    'tg.addChatId':          '+ Add Chat ID',
    'tg.sectionAnswers':     '💬 Bot Replies (AI & Text)',
    'tg.answersHint':        'Customize this bot\'s behavior & text. Leave empty to use defaults. Applies to this bot only.',
    'tg.aiInstr':            'AI Instructions (custom)',
    'tg.aiInstrPlaceholder': 'Example: You are an assistant specialized in SAP Basis & SAP User Management. Answer concisely about SAP health (jobs, locks, work processes, dumps) and user administration (lock/unlock/reset). Do not offer AWS/Solman/Cost data.',
    'tg.aiInstrHint':        'Added to the AI system prompt as "Additional Instructions".',
    'tg.welcome':            'Welcome Text (/start) — optional',
    'tg.welcomePlaceholder': 'Empty = same as /help',
    'tg.help':               'Help Text (/help) — optional',
    'tg.helpPlaceholder':    'Empty = automatic help (command list based on bot scope)',
    'tg.sectionSchedule':    '🕐 Notification Schedule',
    'tg.scheduleHintNotify': 'The notification bot sends scheduled data snapshots to all Chat IDs.',
    'tg.scheduleHintQuery':  'This bot can also send scheduled notifications within its scope.',
    'tg.addSchedule':        '+ Add Schedule',
    'tg.saveSchedule':       '💾 Save Schedule',
    'tg.sectionGuide':       '📋 Multi-Bot Setup Guide',
    'tg.guide1':             'Create a separate bot in @BotFather for each dashboard (5 bots)',
    'tg.guide2':             'Select a bot tab above → enter Token → Save (webhook auto-set)',
    'tg.guide3':             'Add the Chat IDs of users allowed to access that bot',
    'tg.guide4':             'Users type /start to the relevant bot',
    'tg.guide5':             'The Notification bot 🔔 is schedule-only — it does not handle chat',
    'tg.phScheduleLabel':    'Schedule label',
    'tg.typeAll':            'All (scope)',
    'tg.dow0':               'Sun',
    'tg.dow1':               'Mon',
    'tg.dow2':               'Tue',
    'tg.dow3':               'Wed',
    'tg.dow4':               'Thu',
    'tg.dow5':               'Fri',
    'tg.dow6':               'Sat',

    // ── Telegram Chat Log (TelegramChatLog) ──
    'tgLog.title':           'Telegram Chat Log',
    'tgLog.subtitle':        'History of AI conversations via Telegram with token estimates',
    'tgLog.statTotal':       'Total Chats',
    'tgLog.statTotalToken':  'Total Tokens',
    'tgLog.statAvgToken':    'Avg Tokens/Chat',
    'tgLog.statAvgResp':     'Avg Response',
    'tgLog.searchPlaceholder':'Search question, answer, or username...',
    'tgLog.searchBtn':       'Search',
    'tgLog.loading':         'Loading log...',
    'tgLog.empty':           'No conversations yet.',
    'tgLog.error':           'error',
    'tgLog.question':        'Question',
    'tgLog.answer':          'Bot Answer',
    'tgLog.showMore':        'Show more',
    'tgLog.hide':            'Hide',
    'tgLog.prev':            '← Previous',
    'tgLog.next':            'Next →',
    'tgLog.pageInfo':        'Page {page} / {totalPages} · {total} chats',
    'tgLog.unknown':         'unknown',

    // ── AI Chat History (AIChatHistory) ──
    'aih.title':             'AI Chat History',
    'aih.subtitleAdmin':     'Browse all AI conversation history from every user',
    'aih.subtitleUser':      'Browse your AI conversation history',
    'aih.relSec':            '{n}s ago',
    'aih.relMin':            '{n} min ago',
    'aih.relHour':           '{n}h ago',
    'aih.relDay':            '{n}d ago',
    'aih.statMessages':      'Total Messages',
    'aih.statSessions':      'Sessions',
    'aih.statUsers':         'Users',
    'aih.statTokens':        'Total Tokens',
    'aih.statToday':         'Today',
    'aih.tokenUsageProvider':'Token Usage per Provider',
    'aih.tabSessions':       'Session History',
    'aih.tabUsage':          'Usage Report',
    'aih.usageRange':        'Range',
    'aih.usageDays':         '{n} days',
    'aih.usageTotal':        'Total tokens',
    'aih.usageEmpty':        'No token consumption in this range yet.',
    'aih.usageDailyTitle':   'Daily Token Consumption',
    'aih.usageCostTotal':    'Est. cost',
    'aih.usageCostTitle':    'Estimated Cost per Model',
    'aih.colModel':          'Provider / Model',
    'aih.colInput':          'Input',
    'aih.colOutput':         'Output',
    'aih.colCost':           'Cost (USD)',
    'aih.costUnpriced':      'rate not set',
    'aih.costTotalRow':      'Total',
    'aih.costDisclaimer':    'Estimate based on configured rates (USD per 1M tokens, input & output separate). Verify rates against the provider\u2019s official page — prices change and vary by region. Free-tier providers are counted as $0.',
    'aih.msgCount':          '{n} messages',
    'aih.searchPlaceholder': 'Search message content or dashboard...',
    'aih.filterUser':        'Filter username...',
    'aih.totalSessions':     '{n} sessions total',
    'aih.sessionsCount':     'Sessions ({n})',
    'aih.empty':             'No chat history yet.',
    'aih.noQuestion':        '(no user question)',
    'aih.deleteSession':     'Delete session',
    'aih.selectSession':     'Select a session to view the conversation.',
    'aih.sessionLabel':      'Session',
    'aih.confirmDelete':     'Permanently delete this chat session?',
    'aih.deleteFailed':      'Delete failed: {err}',
    'aih.exportAll':         'Export all chat',
    'aih.exportXlsx':        'Export XLSX',
    'aih.exportJson':        'Export JSON',
    'aih.exporting':         'Exporting…',
    'aih.exportEmpty':       'No chat to export.',
    'aih.exportTruncated':   'Result capped to the top {n} rows.',
    'aih.exportFailed':      'Export failed: {err}',
    'aih.tokenTipEst':       'Estimated (provider did not send usage) — Prompt: {p} | Completion: {c}',
    'aih.tokenTipReal':      'Actual tokens from provider — Prompt: {p} | Completion: {c}',
    'aih.estBadge':          'estimated',
    'aih.estTitle':          'Token count is estimated, not the provider\'s official figure',
    'aih.dataBadge':         'data',

    // ── AI Data Sources (AIDataSources) ──
    'ads.title':             'AI Data Sources',
    'ads.subtitle':          'Manage the SQLite data injected into the AI Assistant per dashboard',
    'ads.addDs':             'Add Data Source',
    'ads.addTitle':          'Add Data Source',
    'ads.editTitle':         'Edit Data Source',
    'ads.tabQueries':        'Context Queries',
    'ads.tabSql':            'SQL Mode (Text-to-SQL)',
    'ads.label':             'Label',
    'ads.labelPlaceholder':  'e.g. Top Ticket Creators',
    'ads.sqlLabel':          'SQL Query (SELECT-only)',
    'ads.sqlPlaceholder':    'SELECT created_by, COUNT(*) as n FROM solman_tickets GROUP BY created_by ORDER BY n DESC LIMIT 15',
    'ads.sqlNotePre':        'Only',
    'ads.sqlNotePost':       'Write statements (INSERT/UPDATE/DELETE/DROP/etc) are rejected automatically.',
    'ads.active':            'Active',
    'ads.inactive':          'Inactive',
    'ads.botTelegram':       '✈️ Telegram Bot:',
    'ads.botNone':           '-- Not used --',
    'ads.botBilling':        'AWS Billing Bot',
    'ads.botCost':           'AWS Cost Bot',
    'ads.botSolman':         'SAP Solman Bot',
    'ads.botUsage':          'SAP Usage Bot',
    'ads.botNotify':         'Notification Bot',
    'ads.preview':           'Preview',
    'ads.rowCount':          '{n} rows',
    'ads.first50':           '(showing first 50)',
    'ads.previewNoData':     '(no data)',
    'ads.saving':            'Saving...',
    'ads.saveChanges':       'Save Changes',
    'ads.add':               'Add',
    'ads.errLabelSql':       'Label and SQL are required.',
    'ads.errLoadDs':         'Failed to load data source.',
    'ads.errToggle':         'Failed to change status.',
    'ads.errLoadSql':        'Failed to load SQL configuration.',
    'ads.errDashKey':        'dashboard_key is required.',
    'ads.errPickTable':      'Select at least one table.',
    'ads.errSave':           'Failed to save.',
    'ads.errRemove':         'Failed to delete.',
    'ads.sqlSaved':          'SQL configuration saved.',
    'ads.removed':           'Deleted.',
    'ads.dsDeleted':         'Data source deleted.',
    'ads.dsUpdated':         'Data source updated.',
    'ads.dsAdded':           'Data source added.',
    'ads.confirmRemoveSql':  'Remove SQL mode for "{dk}"? The dashboard returns to static mode.',
    'ads.confirmDeleteDs':   'Delete data source "{label}"?',
    'ads.sqlModeInfoBold':   'SQL Mode (text-to-SQL):',
    'ads.sqlModeInfoRest':   'for dashboards listed here, the AI writes its own SQL query for each question (suitable for multi-dimensional data). The AI may only touch the selected tables; queries are validated read-only + capped with a LIMIT on the server. Dashboards NOT listed here keep using static Context Queries.',
    'ads.addSqlDash':        'Add SQL Dashboard',
    'ads.editSqlDash':       'Edit: {dk}',
    'ads.noSqlDash':         'No SQL-mode dashboards yet.',
    'ads.noSqlDashHint':     'Click "Add SQL Dashboard" to enable text-to-SQL.',
    'ads.dashKeyPlaceholder':'e.g. aws_cost, overtime',
    'ads.tablesLabel':       'Accessible tables ({n} selected)',
    'ads.hintLabel':         'Hint for the AI (optional)',
    'ads.hintPlaceholder':   'Explain column meanings/units so the AI generates more accurate SQL.',
    'ads.fewShotLabel':      'Examples / Few-shot (optional)',
    'ads.fewShotPlaceholder':'Example question → correct SQL (authoritative pattern). E.g.:\nQ: top 5 reason per company\nSQL: SELECT bu, reason, total FROM (SELECT bu, reason, SUM(amount) total, ROW_NUMBER() OVER(PARTITION BY bu ORDER BY SUM(amount) DESC) rnk FROM employee_overtime GROUP BY bu,reason) WHERE rnk<=5 ORDER BY bu,total DESC',
    'ads.fewShotHelp':       'Added to the SQL prompt as an authoritative pattern for this dashboard. Leave empty if not needed.',
    'ads.sqlModeOn':         'SQL mode active',
    'ads.sqlModeOff':        'Inactive (static mode)',
    'ads.noDs':              'No data sources for this dashboard yet.',
    'ads.noDsHint':          'Click "Add Data Source" to create the first query.',
    'ads.enable':            'Enable',
    'ads.disable':           'Disable',
    'ads.dsInfoPre':         'Active data sources for',
    'ads.dsInfoMid':         'are assembled into the context sent to the AI whenever a user asks on this dashboard. Main table:',

    // ── Activity Log (LogViewer) ──
    'log.title':             'Activity Log',
    'log.subtitle':          'Monitoring all user activity · {n} total records',
    'log.autoRefresh':       'Auto Refresh',
    'log.on':                'ON',
    'log.off':               'OFF',
    'log.exportCsv':         'Export CSV',
    'log.statToday':         'Activity Today',
    'log.statLoginOk':       'Total Successful Logins',
    'log.statLoginFail':     'Failed Logins',
    'log.statActiveUsers':   'Active Users',
    'log.topUsers':          'Top Users (Activity)',
    'log.actionDist':        'Action Distribution',
    'log.filter':            'Filter:',
    'log.searchPlaceholder': 'Search username, IP, detail...',
    'log.searchBtn':         'Search',
    'log.allActions':        'All Actions',
    'log.allUsers':          'All Users',
    'log.resetFilter':       '× Reset Filter',
    'log.showing':           'Showing {n} of {total} records',
    'log.colId':             'ID',
    'log.colTime':           'Time',
    'log.colUser':           'User',
    'log.colAction':         'Action',
    'log.colDetail':         'Detail',
    'log.colIp':             'IP Address',
    'log.colBrowser':        'Browser',
    'log.colRole':           'Role',
    'log.colUsername':       'Username',
    'log.loading':           'Loading log...',
    'log.empty':             'No logs found',
    'log.pageInfo':          'Page {page} of {totalPages}',
    'log.rangeInfo':         '{from}–{to} of {total}',
    'log.prev':              'Prev',
    'log.next':              'Next',
    'log.relSec':            '{n}s ago',
    'log.relMin':            '{n}m ago',
    'log.relHour':           '{n}h ago',
    'log.relDay':            '{n}d ago',
    'log.actLoginOk':        'Login',
    'log.actLoginFail':      'Login Failed',
    'log.actLogout':         'Logout',
    'log.actViewDash':       'Open Dashboard',
    'log.actOpenAi':         'Open AI',
    'log.actSaveAiConfig':   'Save AI Config',

    // ── AI Workspace (AIWorkspace) ──
    'aiw.pickerLabel':       'Analyze data:',
    'aiw.general':           'General (no dashboard data)',
    'aiw.autoDetected':      'Auto-selected',
    'aiw.autoDetectedNote':  'Data source auto-selected from your question.',
    'aiw.sessionNote':       'Separate session from the header panel. Change selection → start a new session.',
    'aiw.loadingConfig':     'Loading configuration...',

    // ── User Management (UserManagement) ──
    'um.title':              'User Management',
    'um.subtitle':           '{n} total registered users · {m} roles available',
    'um.addUserBtn':         'Add User',
    'um.totalUsers':         'Total Users',
    'um.searchPlaceholder':  'Search username...',
    'um.all':                'All',
    'um.colNum':             '#',
    'um.colUsername':        'Username',
    'um.colRole':            'Role',
    'um.colAccess':          'Access',
    'um.colCreated':         'Created',
    'um.colLastLogin':       'Last Login',
    'um.colAction':          'Actions',
    'um.empty':              'No users found',
    'um.none':               'None',
    'um.never':              'Never',
    'um.tipEdit':            'Edit user',
    'um.tipCopy':            'Copy user',
    'um.copyUser':           'Copy User',
    'um.copyingFrom':        'Copying role from {name}',
    'um.tipReset':           'Reset password',
    'um.tipDelete':          'Delete user',
    'um.createdOk':          'User created successfully.',
    'um.updatedOk':          'User updated successfully.',
    'um.userDeleted':        'User "{name}" deleted successfully.',
    'um.deleteUserTitle':    'Delete User',
    'um.irreversible':       'This action cannot be undone',
    'um.confirmDeleteUser':  'Are you sure you want to delete user "{name}" (role: {role})?',
    'um.yesDelete':          'Yes, Delete',
    'um.editUser':           'Edit User',
    'um.addUser':            'Add New User',
    'um.editingUser':        'Editing: {name}',
    'um.createAccount':      'Create a new account',
    'um.username':           'Username',
    'um.usernamePlaceholder':'Enter username',
    'um.usernameLocked':     'Username cannot be changed.',
    'um.password':           'Password',
    'um.pwOptional':         '(leave empty to keep unchanged)',
    'um.pwNewPlaceholder':   'New password (optional)',
    'um.pwPlaceholder':      'Enter password',
    'um.role':               'Role',
    'um.access':             'Access:',
    'um.allAccessAdmin':     'All access (admin)',
    'um.noAccess':           'No access',
    'um.saveChanges':        'Save Changes',
    'um.createUser':         'Create User',
    'um.resetPw':            'Reset Password',
    'um.userLabel':          'User:',
    'um.pwResetOk':          'Password reset successfully!',
    'um.pwResetPlaceholder': 'New password (min 6 characters)',
    'um.allAccess':          'All access',
    'um.errLoad':            'Failed to load data.',
    'um.errDelete':          'Failed to delete user.',
    'um.errSaveUser':        'Failed to save user.',
    'um.errReset':           'Failed to reset password.',
    'um.errUserReq':         'Username is required.',
    'um.errUserMin':         'Username must be at least 3 characters.',
    'um.errPwReq':           'Password is required for a new user.',
    'um.errPwMin':           'Password must be at least 6 characters.',
    'um.errRoleReq':         'Role must be selected.',

    // ── Role Management (RoleManagement) ──
    'rm.title':              'Role Management',
    'rm.subtitle':           'Create and manage custom roles to control dashboard access',
    'rm.createRoleBtn':      'Create Role',
    'rm.totalRoles':         'Total Roles',
    'rm.customRoles':        'Custom Roles',
    'rm.totalUsers':         'Total Users',
    'rm.searchPlaceholder':  'Search role...',
    'rm.loading':            'Loading role list...',
    'rm.empty':              'No roles found',
    'rm.systemBadge':        'System',
    'rm.noDesc':             'No description',
    'rm.userUnit':           'users',
    'rm.permUnit':           'permissions',
    'rm.updatedAt':          'Updated {date}',
    'rm.allAccessBuiltin':   'All access (built-in)',
    'rm.noPerm':             'No permissions',
    'rm.tipSysNoEdit':       'System roles cannot be edited',
    'rm.tipEdit':            'Edit role',
    'rm.tipSysNoDelete':     'System roles cannot be deleted',
    'rm.tipInUse':           'Still used by {n} users',
    'rm.tipDelete':          'Delete role',
    'rm.createdOk':          'Role created successfully.',
    'rm.updatedOk':          'Role updated successfully.',
    'rm.roleDeleted':        'Role "{name}" deleted successfully.',
    'rm.deleteRoleTitle':    'Delete Role',
    'rm.irreversible':       'This action cannot be undone',
    'rm.confirmDelete':      'Are you sure you want to delete role "{name}"?',
    'rm.yesDelete':          'Yes, Delete',
    'rm.editRole':           'Edit Role',
    'rm.newRole':            'Create New Role',
    'rm.editing':            'Editing: {name}',
    'rm.subtitleNew':        'Define a custom role with specific permissions',
    'rm.roleName':           'Role Name',
    'rm.namePlaceholder':    'e.g. FINANCE, AUDITOR, MANAGER...',
    'rm.nameLocked':         'Role name cannot be changed.',
    'rm.nameHint':           'Letters, numbers, underscore or dash. 2-30 characters.',
    'rm.description':        'Description',
    'rm.descPlaceholder':    'A short explanation of this role',
    'rm.permissions':        'Permissions',
    'rm.selectedCount':      '({n} selected)',
    'rm.checkAll':           'Check All',
    'rm.uncheckAll':         'Uncheck All',
    'rm.saveChanges':        'Save Changes',
    'rm.createRole':         'Create Role',
    'rm.errLoad':            'Failed to load role list.',
    'rm.errDelete':          'Failed to delete role.',
    'rm.errSave':            'Failed to save role.',
    'rm.errNameReq':         'Role name is required.',
    'rm.errNameFormat':      'Role name may only contain letters/numbers/_/- (2-30 characters).',
    'rm.errPermReq':         'Select at least 1 permission for this role.',
    'rm.grpDashboard':       'Dashboard',
    'rm.grpAdmin':           'Admin Pages',
    'rm.grpHr':              'HR',
    'rm.grpOther':           'Others',
    'rm.desc.aws_billing':       'Cost & Usage',
    'rm.desc.aws_cost':          'Cost Analysis',
    'rm.desc.aws_inventory':     'Resource Inventory',
    'rm.desc.aws_cloudtrail':    'Audit & Events',
    'rm.desc.solman':            'Ticket & Incident',
    'rm.desc.sap_usage':         'Utilization',
    'rm.desc.logs':              'View audit trail',
    'rm.desc.ai_history':        'AI conversation history',
    'rm.desc.ai_config':         'Tune-up data source & AI prompt',
    'rm.desc.ai_workspace':      'Full-page AI chat',
    'rm.desc.users':             'Manage users',
    'rm.desc.role_management':   'Manage roles',
    'rm.desc.table_maintenance': 'Maintain database',
    'rm.desc.telegram':          'Manage Telegram bots',
    'rm.desc.telegram_log':      'Telegram chat log',
    'rm.desc.sap_user_mgmt':     'Manage SAP users',
    'rm.desc.employee_overtime': 'Employee overtime data',
    'rm.desc.sap_basis_mon':          'Health: jobs, locks, WP, system',
    'rm.desc.sap_roles':              'Audit roles & assignments (read-only); add "Modify" to assign roles and edit authorizations',
    'rm.desc.sap_customizing':        'User exits, BAdIs & enhancements',
    'rm.desc.sap_source':             'View ABAP source code of custom programs',
    'rm.desc.sap_table_peek':         'View a sample of SAP table contents (business data)',
    'rm.desc.transport':              'View STMS queue',
    'rm.desc.transport_import':       'Run import to Q01/P01',
    'rm.desc.monthly_report':         'Automated monthly report',
    'rm.desc.notes':                  'Manage notes',
    'rm.desc.notes_plain':            'Notes without RAG indexing',
    'rm.desc.ai_settings':            'Provider, model & API key',
    'rm.desc.ai_coding':              'Coding assistant + tool use',
    'rm.desc.ai_actions':             'Natural-language actions + approval',
    'rm.desc.m365_license':           'Microsoft 365 license overview',
    'rm.desc.m365_pricing_edit':      'Edit M365 license pricing',
    'rm.desc.sdp':                    'ManageEngine ticketing & assets',
    'rm.needsParent':        'Requires "{parent}" to be checked too',

    // ── Microsoft 365 License ──
    'm365.title':               'Microsoft 365 Licensing',
    'm365.lastSnapshot':        'Last snapshot: {snap}',
    'm365.noDataHint':          'No data yet — run a fetch in Table Maintenance.',
    'm365.tabOverview':         'Overview',
    'm365.tabUserDetail':       'User Detail',
    'm365.tabPricing':           'Pricing',
    'm365.tabAnalytics':       'Analytics',
    'm365.anHint':             'This analysis shows the CURRENT snapshot (not a trend) and is limited to the Indonesia location group. Cost figures use the master prices from the Pricing tab — make sure prices are set and click Calculate for accuracy.',
    'm365.snapshot':           'Last snapshot',
    'm365.anNoPrices':         'Master prices not set — cost values = 0.',
    'm365.anSavings':          'Cost-Saving Potential',
    'm365.anUnlicensed':       'Unlicensed Users',
    'm365.anDisabledLicensed': 'Disabled but Licensed',
    'm365.anPotentialSaving':  'Estimated Saving',
    'm365.anPerFetch':         'based on last snapshot',
    'm365.anRevokeCandidates': 'License Revoke Candidates (disabled accounts)',
    'm365.anCapacityRisk':     'Capacity Risk',
    'm365.anNearFull':         'Near/Full (≥90%)',
    'm365.anLowUse':           'Low Utilization (<50%)',
    'm365.anIdleCost':         'Idle Cost',
    'm365.anCostByOrg':        'Cost by Organization',
    'm365.anNoOrgData':        'Not enough department/company data to analyze.',
    'm365.anByDept':           'Cost by Department',
    'm365.anByCompany':        'Cost by Company',
    'm365.anDistribution':     'Distribution & Anomalies',
    'm365.anLicenseMix':       'License Mix',
    'm365.anAnomalies':        'Anomalies',
    'm365.anPaidNoDept':       'Licensed without Department',
    'm365.pricingTitle':         'License Price Master',
    'm365.pricingReadOnlyHint':  'Only admins/authorized roles can edit prices.',
    'm365.calculate':            'Calculate',
    'm365.calcDone':             'Calculation complete.',
    'm365.calcHint':             'Per-domain cost (Indonesia group) updated in the Overview tab.',
    'm365.refresh':              'Refresh',
    'm365.save':                 'Save',
    'm365.saveAll':              'Save All',
    'm365.yes':                  'Yes',
    'm365.colLicenseType':       'License Type',
    'm365.colCategory':          'Category',
    'm365.colPriceUsd':          'Price (USD)',
    'm365.colNotes':             'Notes',
    'm365.colUpdated':           'Updated',
    'm365.colAction':            'Action',
    'm365.kpiTotalUsers':       'Total Users',
    'm365.kpiAssigned':         'Assigned Licenses',
    'm365.kpiUnlicensed':       'Unlicensed',
    'm365.kpiDomains':          'Domains',
    'm365.chartPerDomain':      'Licenses per Domain — Indonesia',
    'm365.chartCategoryDist':   'License Category Distribution',
    'm365.totalLicensesLabel':  'total licenses',
    'm365.capacityTitle':       'License Capacity',
    'm365.distributionTitle':   'License Distribution',
    'm365.perUserTitle':        'Per-User License Detail',
    'm365.userDetailTitle':     'User Detail',
    'm365.rows':                'rows',
    'm365.users':               'users',
    'm365.noUsers':             'No users.',
    'm365.exportExcel':         'Export Excel',
    'm365.allDomains':          'All Domains',
    'm365.allLicenses':         'All Licenses',
    'm365.allStatus':           'All Status',
    'm365.allLicenseState':     'All Licensed/Unlicensed',
    'm365.licensed':            'Licensed',
    'm365.unlicensedOpt':       'Unlicensed',
    'm365.enabledYes':          'Enabled',
    'm365.enabledNo':           'Disabled',
    'm365.search':              'Search',
    'm365.reset':               'Reset',
    'm365.searchUpnDomain':     'Search UPN / domain…',
    'm365.searchDetail':        'Search UPN / name / email / department…',
    'm365.prev':                'Prev',
    'm365.next':                'Next',
    'm365.page':                'Page',
    'm365.colDomain':           'Domain',
    'm365.colLicense':          'License',
    'm365.colLicenses':         'Licenses',
    'm365.colSkuPart':          'SKU Part',
    'm365.colAvailable':        'Available',
    'm365.colAssignedTotal':    'Assigned / Total',
    'm365.colDisplayName':      'Display Name',
    'm365.colDepartment':       'Department',
    'm365.colCompany':          'Company',
    'm365.colEnabled':          'Status',

    // ── SAP Note (page) ──
    'sapnote.cancelSelect': 'Cancel selection',
    'sapnote.noContentSaved': 'No note content saved yet. Pull from system to store it permanently (or add a PDF attachment via the attachment icon).',
    'sapnote.noAttachments': 'No attachments yet.',
    'sapnote.noNotes': 'No notes yet. Add one via the box above.',
    'sapnote.openPortal': 'Open in portal',
    'sapnote.remark': 'Notes',
    'sapnote.htmlUnavailable': 'HTML content is not available for this note/language in the system. Try "Fill from PDF" or "Open in portal".',
    'sapnote.noteContentFromSystem': 'Note content (from system)',
    'sapnote.subtitle': 'SAP Note catalog, archive and tracking for the landscape — open in portal, save PDF, track status.',
    'sapnote.manage': 'Manage',
    'sapnote.stepperHint': 'Click a stage to change the note status (saved instantly).',
    'sapnote.clear': 'Clear',
    'sapnote.snoteStep': 'SNOTE step: transaction',
    'sapnote.loading': 'Loading…',
    'sapnote.pullSrsHint': 'Pull Symptom/Reason/Solution from SAP then archive it (if the note is already downloaded to the system).',
    'sapnote.pullingArchiving': 'Pulling from system & archiving…',
    'sapnote.contactingSap': 'Contacting SAP system…',
    'sapnote.deleteWarnOne': 'This notes metadata and all attachments will be permanently deleted.',
    'sapnote.deleteWarnMany': 'Their metadata and all attachments will be permanently deleted.',
    'sapnote.loadArchive': 'Load & archive from system',
    'sapnote.loadContent': 'Load content from system',
    'sapnote.reloadFromSystem': 'Reload from system',
    'sapnote.reload': 'Reload',
    'sapnote.noteNumber': 'Note number',
    'sapnote.notDownloaded': 'This note has not been downloaded to the system. Download it first via',
    'sapnote.pdfArchivedWith': 'The PDF will be archived with the note:',
    'sapnote.selectAllShown': 'Select all (shown)',
    'sapnote.selectNew': 'Select new',
    'sapnote.properties': 'Properties',
    'sapnote.sapNote': 'SAP Note',
    'sapnote.snote': 'SNOTE',
    'sapnote.alsoArchive': 'Also archive note content (those with title/component)',
    'sapnote.allStatus': 'All statuses',
    'sapnote.saveToList': 'Save to list',
    'sapnote.applyStatus': 'Implementation status',
    'sapnote.noMatch': 'Nothing matches the filter.',
    'sapnote.addOpenNote': 'Add / open note',
    'sapnote.pullFromSystem': 'Pull from system',
    'sapnote.pullNotConfigured': 'Pull-from-system is not configured on the server. For now use "Fill from PDF" or "Open in portal".',
    'sapnote.noNotesInSystem': 'No notes found in the system.',
    'sapnote.uploadHint': 'Any type (PDF, script, image, .SAR/.CAR, zip…), max 20 MB/file, up to 20 files per upload.',
    'sapnote.download': 'Download',
    'sapnote.exists': 'already exists',
    'sapnote.fetchListTitle': 'Fetch the list of notes already in the SAP system',
    'sapnote.searchPlaceholder': 'Search number / title / component / system / note content',
    'sapnote.searchSysPlaceholder': 'Search number / component / status',
    'sapnote.noteDetail': 'Note detail',
    'sapnote.skipHint': 'Skipped only if both title & component are empty',
    'sapnote.noteContentSystem': 'Note content from system',
    'sapnote.noteContent': 'Note content',
    'sapnote.manageAttachments': 'Manage attachments',
    'sapnote.remarkPlaceholder': 'Context, transport/ticket links, impact…',
    'sapnote.attachments': 'Attachments',
    'sapnote.viewNoteContent': 'View note content',
    'sapnote.view': 'View',
    'sapnote.selectDeleteEmpty': 'Select & delete notes without title and component',
    'sapnote.selectAllShownTitle': 'Select all currently shown',
    'sapnote.titlePlaceholder': 'Short note summary',
    'sapnote.repullTitle': 'Re-pull the latest content from SAP (archive updated if the version changes)',
    'sapnote.downloadHtmlTitle': 'Download the HTML file to your device',
    'sapnote.uploadPdfTitle': 'Upload note content PDF → title/component/priority filled automatically',
    'sapnote.egNoteNumber': 'e.g. 3421567',
    'sapnote.egComponent': 'e.g. FI-GL',
    'sapnote.egPriority': 'e.g. High / Correction',
    'sapnote.egSystem': 'e.g. P01, D01',
    'sapnote.preview': 'preview',
    'sapnote.statusReview': 'To review',
    'sapnote.statusApplying': 'Applying',
    'sapnote.statusDone': 'Done',
    'sapnote.changeStatusTo': 'Change status to "{status}"',
    'sapnote.colNumber': 'Number',
    'sapnote.title': 'Title',
    'sapnote.component': 'Component',
    'sapnote.system': 'System',
    'sapnote.status': 'Status',
    'sapnote.priority': 'Priority',
    'sapnote.version': 'Version',
    'sapnote.statusInSystem': 'Status in system',
    'sapnote.processedBy': 'Processed by',
    'sapnote.portalBanner': '"Open in portal" uses your browser SSO session. "Fill from PDF" reads the note header from the PDF (the "pdf" button in the portal, not the .SAR file) to auto-fill fields — then the PDF is archived when saved. Note not in SNOTE yet? Click the note number (or the eye icon) → "Load & archive from system": the dashboard asks SAP to download it via SNOTE automatically, then archives the content. KBAs cannot be downloaded via SNOTE — use Open in portal → PDF → Fill from PDF.',
    'sapnote.editNote': 'Edit note {n}',
    'sapnote.saveNewNote': 'Save new note',
    'sapnote.deleteNoteTitle': 'Delete note {n}?',
    'sapnote.attachmentsTitle': 'Attachments · Note {n}',
    'sapnote.addAttachment': 'Add attachment',
    'sapnote.noteContentTitle': 'Note content {n}',
    'sapnote.errNoteNumber': 'Note number must be numeric (max 12 digits).',
    'sapnote.pdfFilled': 'Fields filled from PDF — review then save.',
    'sapnote.noteUpdated': 'Note {n} updated.',
    'sapnote.saveButAttachFail': 'Note saved, but PDF attachment failed: ',
    'sapnote.noteSaved': 'Note {n} saved.',
    'sapnote.noteSavedPdf': 'Note {n} saved + PDF archived.',
    'sapnote.noteDeleted': 'Note {n} deleted.',
    'sapnote.notesDeleted': '{count} notes deleted.',
    'sapnote.attachAdded': '{count} attachments added.',
    'sapnote.attachDeleted': 'Attachment deleted.',
    'sapnote.notDownloadedFlash': 'Note is not downloaded to the system (download via SNOTE first).',
    'sapnote.contentUnavailable': 'Note content is not available in the system.',
    'sapnote.contentPulled': 'Note content pulled from system & archived.',
    'sapnote.pullNotConfiguredShort': 'Pull-from-system is not configured on the server.',
    'sapnote.contentArchivedAuto': 'Content of {count} notes archived automatically.',
    'sapnote.selectAtLeastOne': 'Select at least one note.',
    'sapnote.importResult': '{created} created, {skipped} skipped',
    'sapnote.importInvalid': ', {invalid} invalid',
    'sapnote.noEmptyNotes': 'No empty notes.',
    'sapnote.fillNumberFirst': 'Enter the note number first.',
    'sapnote.fillFromPdf': 'Fill from PDF',

    // ── AI Actions (page) ──
    'aiact.title': 'AI Actions',
    'aiact.subtitle': 'Natural-language commands → controlled actions with approval & audit',
    'aiact.tabRun': 'Run',
    'aiact.tabManage': 'Manage Custom Actions',
    'aiact.send': 'Send',
    'aiact.inputPlaceholder': 'e.g. "unlock user BUDI in PRD" or "show locked users in QAS"',
    'aiact.actionsAvailable': '{count} actions available',
    'aiact.aiChose': 'AI chose',
    'aiact.with': 'with',
    'aiact.noMatch': 'AI found no matching action for this request.',
    'aiact.executedDirect': 'Executed directly (read action) —',
    'aiact.awaitingApproval': 'Awaiting approval —',
    'aiact.expiryHint': 'Expires in 10 minutes. Check target & environment before approving.',
    'aiact.approveRun': 'Approve & run',
    'aiact.reject': 'Reject',
    'aiact.approvedExecuted': 'Approved & executed.',
    'aiact.rejected': 'Proposal rejected. Nothing was executed.',
    'aiact.execFailed': 'Execution failed:',
    'aiact.history48h': 'Last 48 hours',
    'aiact.noActionsYet': 'No actions yet. Type a command above to start.',
    'aiact.colTime': 'Time',
    'aiact.colParam': 'Parameters',
    'aiact.colSource': 'Source',
    'aiact.colRequester': 'Requester',
    'aiact.colStatus': 'Status',
    'aiact.colApprover': 'Approver',
    'aiact.tempPassword': 'Temporary password',
    'aiact.tempPasswordHint': 'Share via a secure channel. The user must change it on first login. This value is not stored in logs.',
    'aiact.moreItems': '… +{n} more',
    'aiact.showJson':  'Show raw JSON',
    'aih.cachedOnly':      'Cached only',
    'ai.modeSql':           'new SQL',
    'ai.inheritedPeriod':      'period inherited',
    'ai.inheritedPeriodTitle': 'This question was automatically completed with the period from the previous turn: {periods}.',
    'ai.modeSqlTitle':      'The question was turned into a fresh SQL query. If this was meant as a follow-up, state the period/filter explicitly.',
    'ai.modeFollowup':      'follow-up',
    'ai.modeFollowupTitle': 'Derived from the previous result table, no new query.',
    'ai.modeContext':       'page context',
    'ai.modeContextTitle':  'Answered from a summary of the data currently shown on this page.',
    'ai.modeDet':           'deterministic',
    'ai.modeDetTitle':      'Computed directly on the server (not model-generated SQL) for exact figures.',
    'aih.cachedOnlyTitle': 'Show only sessions containing a semantic-cache answer',
    'aiact.hideJson':  'Hide JSON',
    'aiact.copy':      'Copy',
    'aiact.copied':    'Copied',
    'aiact.confirmDelete': 'Delete action "{name}"?',
    'aiact.editForm': 'Edit: {name}',
    'aiact.newAction': 'New Custom Action',
    'aiact.cancelEdit': 'Cancel edit',
    'aiact.lblName': 'Name (lowercase, underscore)',
    'aiact.lblMaxRows': 'Row limit (max_rows)',
    'aiact.lblDescription': 'Description (read by AI to match requests)',
    'aiact.lblSql': 'SQL Template (SELECT only; parameters use :name)',
    'aiact.detectedParams': 'Detected parameters',
    'aiact.required': 'required',
    'aiact.lblTables': 'Allowed tables (allowlist guard)',
    'aiact.descPlaceholder': 'Show SAP Solman tickets with a given status',
    'aiact.saveChanges': 'Save changes',
    'aiact.createAction': 'Create action',
    'aiact.customActions': 'Custom Actions',
    'aiact.noCustomActions': 'No custom actions yet. Create one above — it becomes callable via natural language automatically.',
    'aiact.disabled': '(disabled)',

    // ══ Hasil migrasi pola dua-bahasa inline (id ? … : …) ══
    // ── aiChat ──
    'aiChat.aiAssistantNotAvailablePage':            'AI Assistant is not available for this page (not configured in AI Data Sources).',
    'aiChat.aiNotAvailablePage':                     'AI not available for this page',
    'aiChat.attachImage':                            'Attach image (Coding mode)',
    'aiChat.removeImage':                            'Remove image',
    'aiChat.imageTooLarge':                          'Images must be 5 MB or smaller.',
    'aiChat.imageMaxCount':                          'Maximum {max} images per question.',
    'aiChat.imageUnsupported':                       'Unsupported image format ({name}). Use PNG, JPG, WebP, or GIF.',
    'aiChat.imageFailed':                            'Failed to process image.',

    // ── aiHist ──
    'aiHist.answerServedAiServiceSemantic':          'Answer served from AI Service semantic cache — no LLM call (0 tokens)',
    'aiHist.copySessionLink':                        'Copy session link',
    'aiHist.deleteSession':                          'Delete session',
    'aiHist.openNewTab':                             'Open in new tab',

    // ── aiRouter ──
    'aiRouter.failsUncertainFallsBackKeyword':       'Fails/uncertain → falls back to keyword matching from Hint & Alias Dictionary in AI Data Sources.',
    'aiRouter.howWorks':                             'How it works',
    'aiRouter.loading':                              'Loading…',
    'aiRouter.noMatchKeepsUsingCurrently':           'No match → keeps using the currently active dashboard (treated as a follow-up), not reset to General.',
    'aiRouter.quickClassificationViaGroqSeparate':   'Quick classification via Groq (separate from main chat provider — works even if main provider is Bedrock/Ollama).',
    'aiRouter.turnOffIfDonT':                        '💡 Turn off if you don\'t want any extra LLM call per question in General mode at all.',
    'aiRouter.whenAiWorkspaceGeneralMode':           'When AI Workspace is in "General" mode (no dashboard selected), the system auto-detects a relevant dashboard from the question (e.g. "AWS cost" → AWS Cost Explorer), then answers using that data.',

    // ── basis ──
    'basis.1Session':                                '1 session',
    'basis.action':                                  'Action',
    'basis.activeSessions':                          'Active sessions',
    'basis.busy':                                    'busy',
    'basis.busyTotal':                               'busy/total',
    'basis.by':                                      'By',
    'basis.clickRowViewDumpContent':                 'Click a row to view the dump content.',
    'basis.clickRowViewUserS':                       'Click a row to view the user’s sessions (SM04-style).',
    'basis.clickViewUserSSessions':                  'Click to view this user’s sessions',
    'basis.connectionProfileActive':                 'Connection Profile (active)',
    'basis.count':                                   'Count',
    'basis.criteriaDataSources':                     'Criteria & data sources',
    'basis.date':                                    'Date From',
    'basis.date2':                                   'Date To',
    'basis.date3':                                   'Date',
    'basis.dateCoverage':                            'Date coverage',
    'basis.daysCovered':                             'Days covered',
    'basis.department':                              'Department',
    'basis.departments':                             'Departments',
    'basis.diffTerminal':                            'Diff. terminal',
    'basis.differentTerminals':                      'from different terminals',
    'basis.diskAseSpaceBackendNot':                  'Disk & ASE space — backend not configured yet (need SM69 command).',
    'basis.emptyDumpContent':                        'Empty dump content.',
    'basis.emptyErrorlog':                           'Empty errorlog.',
    'basis.failedJobs':                              'Failed Jobs',
    'basis.fetchBatches':                            'Fetch batches',
    'basis.fetchUserUsage':                          'Fetch user usage',
    'basis.fetched':                                 'Fetched',
    'basis.fetchingDump':                            'Fetching dump…',
    'basis.fetchingSessions':                        'Fetching sessions…',
    'basis.fieldsRead':                              'Fields read',
    'basis.firstLogon':                              'First logon',
    'basis.fmReturnedNoSessionsUser':                'The FM returned no sessions for this user.',
    'basis.fmsTried':                                'FMs tried',
    'basis.hours':                                   'Hours',
    'basis.jobName':                                 'Job Name',
    'basis.lastFetch':                               'Last fetch',
    'basis.lastLogon':                               'Last logon',
    'basis.latest':                                  'Latest',
    'basis.lines':                                   'lines',
    'basis.listedMldtableButNotParallel':            'Listed in {mldTable} but not parallel now',
    'basis.loadRefresh':                             'Load / Refresh',
    'basis.loading':                                 'Loading…',
    'basis.loadingUserUsageStatus':                  'Loading user usage status…',
    'basis.locked':                                  'Locked',
    'basis.logged':                                  'Logged On',
    'basis.loggedUsersSm04ClickLoad':                'Logged-on users (SM04) — click Load / Refresh to fetch.',
    'basis.loginDetailRowsStoredAs':                 'Login detail rows are stored AS-IS (raw RESULT rows) into table sap_usr_utl_raw — no aggregation, separate from the User Usage dashboard.',
    'basis.multiLogonCard':                          'Multi Logon card',
    'basis.multiLogonClickLoadRefresh':              'Multi logon — click Load / Refresh to fetch.',
    'basis.multipleLogonNotRestricted':              '(multiple logon not restricted)',
    'basis.multipleLogonRestricted':                 '(multiple logon restricted)',
    'basis.no':                                      'No',
    'basis.noCancelledJobs':                         'No cancelled jobs.',
    'basis.noDiskData':                              'No disk data.',
    'basis.noLockEntriesSm12':                       'No lock entries (SM12).',
    'basis.noLockedUsers':                           'No locked users.',
    'basis.noRowsMatchFilter':                       'No rows match the filter.',
    'basis.noSavedSnapshotProfileYet':               'No saved snapshot for this profile yet — click Load / Refresh to fetch it for the first time.',
    'basis.noSessionListFmAvailable':                'No session-list FM available on this system.',
    'basis.noShortDumpsRange':                       'No short dumps in range.',
    'basis.noUpdateErrors':                          'No update errors.',
    'basis.noUserUsageDataProfile':                  'No user usage data for this profile yet.',
    'basis.noUsersCurrentlyLogged':                  'No users currently logged on.',
    'basis.noUsersParallelSessionsRight':            'No users with parallel sessions right now.',
    'basis.noWpData':                                'No WP data.',
    'basis.notCountedAsMultiLogon':                  'Not counted as multi logon — only a trace in the kernel table.',
    'basis.notWhitelisted':                          'Not whitelisted',
    'basis.note':                                    'Note',
    'basis.olderThan30DaysConsider':                 'Older than 30 days — consider re-fetching.',
    'basis.optional':                                'optional',
    'basis.outsideRz11Whitelist':                    'outside RZ11 whitelist',
    'basis.parallelSessions':                        'with parallel sessions',
    'basis.period':                                  'By period',
    'basis.period2':                                 'Period',
    'basis.range':                                   'Range',
    'basis.rangeDays':                               'Range (days)',
    'basis.historyCronRunConfirm':                   'Run now? This will check KPIs for all SAP profiles and write a new history row if anything changed.',
    'basis.historyTitle':                            'KPI History (Audit)',
    'basis.historyDiffOnlyNote':                      'a row is only added when something changed',
    'basis.historyFrom':                             'From date',
    'basis.historyTo':                               'To date',
    'basis.historyLoad':                             'Load History',
    'basis.historyRowCount':                         '{n} rows',
    'basis.historyEmpty':                            'No history in this date range yet.',
    'basis.historyRecordedAt':                       'Time',
    'basis.historyRecordedBy':                       'By',
    'basis.historyBaseline':                         'Initial data (baseline) — no earlier row to compare.',
    'basis.historyNoChange':                         'No KPI change compared to the previous row.',
    'basis.historyChangeIntro':                      'Changes:',
    'basis.historyChanges':                          'Changes',
    'basis.historyBaselineShort':                    'Baseline',
    'basis.historyLoadingDetail':                   'Loading change detail...',
    'basis.historyDetailError':                       'Failed to load change detail.',
    'basis.historyMoreLines':                         '{n} more lines',
    'basis.raw':                                     'Raw',
    'basis.reason':                                  'Reason',
    'basis.rows':                                    'rows',
    'basis.rz11Allowed':                             'RZ11 allowed',
    'basis.rz11Whitelist':                           'RZ11 whitelist',
    'basis.sapSystemHealthGlance':                   'SAP system health at a glance',
    'basis.sapSystemProfile':                        'SAP System Profile',
    'basis.saveMode':                                'Save Mode',
    'basis.savedSnapshot':                           'saved snapshot',
    'basis.searchUserTerminalIp':                    'Search user / terminal / IP…',
    'basis.selectProfile':                           '— select profile —',
    'basis.selectProfileClickLoadView':              'Select a profile and click Load to view system health.',
    'basis.selectProfileFirst':                      'Select a profile first.',
    'basis.serviceUserSessions':                     'service-user sessions',
    'basis.sessions':                                'sessions',
    'basis.sessions2':                               'Sessions',
    'basis.shortDumpDetail':                         'Short Dump Detail',
    'basis.showingFirst500EventsCapped':             'Showing first 500 events (capped), grouped by job.',
    'basis.snapSegments':                            'SNAP segments',
    'basis.sourceLocalTableSapUsr':                  'Source: local table sap_usr_utl_raw (from the ZRFC_USR_UTL fetch) — not live SAP data. Hours are derived from each session duration.',
    'basis.storedSessions':                          'Stored sessions',
    'basis.summary':                                 'Summary',
    'basis.sybaseLogBackendNotConfigured':           'Sybase Log — backend not configured (need SM69 command ZASE_LOG).',
    'basis.system':                                  'System',
    'basis.time':                                    'Time',
    'basis.today':                                   'today',
    'basis.topUsersHours':                           'Top users by hours',
    'basis.totalHours':                              'Total hours',
    'basis.totalSystemSessions':                     'total system sessions',
    'basis.uniqueUsers':                             'Unique users',
    'basis.unreadable':                              'unreadable',
    'basis.updateErrorsSm13BackendNot':              'Update Errors (SM13) — backend not configured yet (need VBHDR fields).',
    'basis.updated':                                 'Updated',
    'basis.usageagedaysDaySAgo':                     '{usageAgeDays} day(s) ago',
    'basis.userSessions':                            'User sessions',
    'basis.users':                                   'users',
    'basis.valid':                                   'Valid to',
    'basis.yes':                                     'Yes',

    // ── dashCtr ──
    'dashCtr.accessDenied':                          'Access Denied',
    'dashCtr.page':                                  'this page',

    // ── noteView ──
    'noteView.by':                                   'by',
    'noteView.main':                                 'Main',
    'noteView.mayHaveBeenDeletedLack':               'It may have been deleted, or you lack access.',
    'noteView.noContent':                            '(no content)',
    'noteView.noteNotFound':                         'Note not found.',
    'noteView.private':                              '🔒 Private',
    'noteView.shared':                               '👥 Shared',
    'noteView.untitled':                             '(untitled)',

    // ── notes ──
    'notes.addTab':                                  'Add tab',
    'notes.alsoFound':                               'Also found in:',
    'notes.anyoneLinkCanViewNote':                   'Anyone with this link can view the note without logging in.',
    'notes.back':                                    'Back',
    'notes.block':                                   'Block',
    'notes.blockquote':                              'Blockquote',
    'notes.bullet':                                  'Bullet',
    'notes.by':                                      'by',
    'notes.cancel':                                  'Cancel',
    'notes.clear':                                   'Clear',
    'notes.codeBlock':                               'Code block',
    'notes.common':                                  '👥 Common',
    'notes.commonAllUsers':                          '👥 Common (all users)',
    'notes.contentMarkdownSupported':                'Content (Markdown supported)',
    'notes.copied':                                  '✅ Copied',
    'notes.copy':                                    '📋 Copy',
    'notes.copyLink':                                'Copy link',
    'notes.copyMoveNotesPlainNon':                   'Copy / move to Notes Plain (non-RAG)',
    'notes.copyPlain':                               'Copy to Plain',
    'notes.createLink':                              '🔗 Create Link',
    'notes.creating':                                '⏳ Creating…',
    'notes.deleteNote':                              'Delete note "',
    'notes.deleted':                                 'Deleted.',
    'notes.done':                                    'Done',
    'notes.dragResizeDoubleClickReset':              'Drag to resize · double-click = reset',
    'notes.editNote':                                '✏️ Edit Note',
    'notes.failedCopyLink':                          'Failed to copy link.',
    'notes.find':                                    'Find…',
    'notes.find2':                                   '▶ Find',
    'notes.findReplace':                             'Find/Replace',
    'notes.help':                                    'Help',
    'notes.hideList':                                'Hide list',
    'notes.holdTabThenDragReorder':                  'Hold ⠿ on a tab, then drag to reorder.',
    'notes.holdTabThenDragReorder2':                 'Hold ⠿ on a tab, then drag to reorder (auto-saved).',
    'notes.hr':                                      'HR',
    'notes.lastModified':                            'Last modified',
    'notes.linkCopied':                              'Link copied.',
    'notes.linkExpiry':                              'Link expiry',
    'notes.linkReadyShare':                          'Link ready to share:',
    'notes.main':                                    'Main',
    'notes.markdownHelp':                            'Markdown Help',
    'notes.markdownReferenceClickInsert':            'Markdown Reference — click to insert',
    'notes.move':                                    'Move',
    'notes.moveCommon':                              'Move to Common?',
    'notes.moveCommon2':                             'Move to Common',
    'notes.moveMyNotes':                             'Move to My Notes?',
    'notes.moveMyNotes2':                            'Move to My Notes',
    'notes.moveRemoveRag':                           'Move (remove from RAG)',
    'notes.myNotes':                                 '🔒 My Notes',
    'notes.new':                                     'New',
    'notes.newNote':                                 '➕ New Note',
    'notes.noContent':                               '(no content)',
    'notes.noContentYet':                            '(no content yet)',
    'notes.noMatchingNotes':                         'No matching notes.',
    'notes.noNotesYet':                              'No notes yet.',
    'notes.notFound':                                'Not found',
    'notes.noteIncludingAllTabsWill':                'The note (including all TABS) will be copied to Notes Plain. Choose Move to also REMOVE it from here — it will be REMOVED from the AI index (no longer citable by AI).',
    'notes.noteMoved':                               'Note moved.',
    'notes.noteTitle':                               'Note title',
    'notes.notes':                                   'Notes',
    'notes.notesPlain':                              'To Notes Plain',
    'notes.numbered':                                'Numbered',
    'notes.oldestModified':                          'Oldest modified',
    'notes.onlyAdminCanMoveShared':                  'Only admin can move a shared note.',
    'notes.openNewTabCleanView':                     'Open in new tab (clean view)',
    'notes.outline':                                 'Outline:',
    'notes.plain':                                   'To Plain',
    'notes.privateNotesSharedTeamNotes':             'Your private notes + shared team notes.',
    'notes.privateOnlyMe':                           '🔒 Private (only me)',
    'notes.replace':                                 'Replace with…',
    'notes.replace2':                                'Replace',
    'notes.replaceAll':                              'Replace All',
    'notes.save':                                    '💾 Save',
    'notes.saved':                                   'Saved.',
    'notes.saving':                                  '⏳ Saving…',
    'notes.savingOrder':                             'saving order…',
    'notes.searchNote':                              'Search in note…',
    'notes.searchTitleContent':                      'Search title or content…',
    'notes.selectNoteLeftCreateNew':                 'Select a note on the left, or create a new one.',
    'notes.selectTextEditorFirstThen':               'Select text in editor first, then click an item to wrap it.',
    'notes.share':                                   'Share',
    'notes.shareNote':                               'Share Note',
    'notes.showList':                                'Show list',
    'notes.sort':                                    'Sort:',
    'notes.svgBlock':                                'SVG block',
    'notes.tabTitle':                                'Tab title',
    'notes.table':                                   'Table',
    'notes.text':                                    'Text',
    'notes.title':                                   'Title',
    'notes.titleContentRequired':                    'Title or content is required.',
    'notes.titleZ':                                  'Title A–Z',
    'notes.titleZ2':                                 'Title Z–A',
    'notes.untitled':                                '(untitled)',
    'notes.visibility':                              'Visibility',

    // ── notesPlain ──
    'notesPlain.addTab':                             'Add tab',
    'notesPlain.all':                                'All',
    'notesPlain.alsoFound':                          'Also found in:',
    'notesPlain.back':                               'Back',
    'notesPlain.block':                              'Block',
    'notesPlain.blockquote':                         'Blockquote',
    'notesPlain.boldText':                           'bold text',
    'notesPlain.bullet':                             'Bullet',
    'notesPlain.cancel':                             'Cancel',
    'notesPlain.close':                              'Close',
    'notesPlain.codeBlock':                          'Code block',
    'notesPlain.codeHere':                           'code here',
    'notesPlain.collapse':                           'Collapse',
    'notesPlain.conversionFailed':                   'Conversion failed.',
    'notesPlain.converting':                         'Converting…',
    'notesPlain.copyNotesRag':                       'Copy to Notes (RAG)?',
    'notesPlain.copyNotesRagIndexedInto':            'Copy to Notes (RAG) — indexed into AI KB',
    'notesPlain.copyRag':                            'Copy to RAG',
    'notesPlain.copyWillAddedNotesRag':              'A copy will be added to the Notes (RAG) page and INDEXED into the AI knowledge base. The Notes Plain version stays.',
    'notesPlain.dragResizeDoubleClickReset':         'Drag to resize · double-click = reset',
    'notesPlain.editNote':                           'Edit Note',
    'notesPlain.empty':                              '(empty)',
    'notesPlain.find':                               'Find…',
    'notesPlain.find2':                              '▶ Find',
    'notesPlain.findReplace':                        'Find/Replace',
    'notesPlain.help':                               'Help',
    'notesPlain.holdTabThenDragReorder':             'Hold ⠿ on a tab, then drag to reorder.',
    'notesPlain.hr':                                 'HR',
    'notesPlain.imagesLengthClickInsertCursor':      'Images ({length}) — click to insert at cursor',
    'notesPlain.importDocument':                     'Import Document',
    'notesPlain.insertImage':                        'Insert Image',
    'notesPlain.insertImageHint':                    'Insert image (or paste / drag-and-drop into the editor)',
    'notesPlain.imageOnly':                          'Only image files (PNG, JPG, WebP, GIF) are supported.',
    'notesPlain.imageMax5mb':                        'Images must be 5 MB or smaller.',
    'notesPlain.imageInserted':                      '{count} image(s) inserted ({size}).',
    'notesPlain.imageFailed':                        'Failed to process image.',
    'notesPlain.imageUnsupportedFormat':             'Image format not supported by the browser ({name}). HEIC/HEIF camera photos must be converted to JPG/PNG first.',
    'notesPlain.importPdfWordExcelAs':               'Import PDF/Word/Excel as Markdown (inserted at cursor)',
    'notesPlain.insert':                             '➕ Insert',
    'notesPlain.insertTextCursor':                   'Insert text at cursor',
    'notesPlain.inserted':                           '✓ Inserted',
    'notesPlain.italicText':                         'italic text',
    'notesPlain.linkTable':                          'Link & Table',
    'notesPlain.linkText':                           'link text',
    'notesPlain.loading':                            'Loading…',
    'notesPlain.main':                               'Main',
    'notesPlain.markdownHelp':                       'Markdown Help',
    'notesPlain.markdownImagesInserted':             'Markdown & images inserted.',
    'notesPlain.markdownReferenceClickInsert':       'Markdown Reference — click to insert',
    'notesPlain.max10mb':                            'Max 10MB.',
    'notesPlain.moveNotesRag':                       'Move to Notes (RAG)?',
    'notesPlain.moveNotesRagRemovedPlain':           'Move to Notes (RAG) — removed from Plain',
    'notesPlain.moveRag':                            'Move to RAG',
    'notesPlain.newNote':                            'New Note',
    'notesPlain.noNotes':                            'No notes.',
    'notesPlain.notFound':                           'Not found',
    'notesPlain.noteDeleted':                        'Note deleted.',
    'notesPlain.noteSaved':                          'Note saved.',
    'notesPlain.noteTitle':                          'Note title…',
    'notesPlain.noteWillAddedNotesRag':              'The note will be added to the Notes (RAG) page, INDEXED into the AI knowledge base, and REMOVED from Notes Plain.',
    'notesPlain.notesDocumentImportNotRag':          'Notes & document import — NOT RAG-indexed.',
    'notesPlain.numbered':                           'Numbered',
    'notesPlain.openNotesList':                      'Open notes list',
    'notesPlain.pdfWordDocxExcelXlsx':               'PDF, Word (.docx), or Excel (.xlsx) only.',
    'notesPlain.preview':                            'Preview',
    'notesPlain.private':                            'Private',
    'notesPlain.private2':                           '🔒 Private',
    'notesPlain.promoteRagNotesWhenReady':           'Promote to RAG Notes when ready',
    'notesPlain.quote':                              'quote',
    'notesPlain.replace':                            'Replace with…',
    'notesPlain.replace2':                           'Replace',
    'notesPlain.replaceAll':                         'Replace All',
    'notesPlain.reviewDocumentConversion':           'Review Document Conversion',
    'notesPlain.save':                               'Save',
    'notesPlain.searchNote':                         'Search in note…',
    'notesPlain.searchNotes':                        'Search notes…',
    'notesPlain.selectNoteLeftCreateNew':            'Select a note on the left, or create a new one.',
    'notesPlain.selectTextEditorFirstThen':          'Select text in editor first, then click an item to wrap it.',
    'notesPlain.shared':                             'Shared',
    'notesPlain.shared2':                            '👥 Shared',
    'notesPlain.svgBlock':                           'SVG block',
    'notesPlain.tabActivetabTitle':                  'Tab {activeTab} title…',
    'notesPlain.table':                              'Table',
    'notesPlain.text':                               'Text',
    'notesPlain.title1':                             'Title 1',
    'notesPlain.title2':                             'Title 2',
    'notesPlain.title3':                             'Title 3',
    'notesPlain.titleContentRequired':               'Title or content is required.',
    'notesPlain.untitled':                           '(untitled)',
    'notesPlain.updated':                            'Updated',
    'notesPlain.writeNoteMarkdown':                  'Write your note in Markdown…',
    'notesPlain.yesCopy':                            'Yes, copy',
    'notesPlain.yesMove':                            'Yes, move',

    // ── sapRole ──
    'sapRole.activeUsers':                           'Active users with it',
    'sapRole.add':                                   'Add',
    'sapRole.addChange':                             'Add a change',
    'sapRole.addRoles':                              'Add roles',
    'sapRole.applyGenerate':                         'Apply + Generate',
    'sapRole.applySap':                              'Apply to SAP?',
    'sapRole.applySap2':                             'Apply to SAP',
    'sapRole.back':                                  'Back to',
    'sapRole.buildObjectCache':                      'Build Object Cache',
    'sapRole.cacheClickLoadRolesRefresh':            '(from cache — click Load Roles to refresh from SAP)',
    'sapRole.cancel':                                'Cancel',
    'sapRole.changeSet':                             'Change set',
    'sapRole.changes':                               'changes',
    'sapRole.class':                                 'By Class',
    'sapRole.clickBuildObjectCacheStart':            'Click "Build Object Cache" to start.',
    'sapRole.close':                                 'Close',
    'sapRole.confirmRoleChanges':                    'Confirm role changes',
    'sapRole.created':                               'Created',
    'sapRole.currentRolesSap':                       'Current roles (from SAP)',
    'sapRole.d':                                     'd',
    'sapRole.date':                                  'Date',
    'sapRole.ddDays':                                '≤{dd} days',
    'sapRole.deleteObjectD':                         'Delete object (D)',
    'sapRole.eGZEmptyAll':                           'e.g. Z_ or empty = all',
    'sapRole.editAuthorizations':                    'Edit Authorizations',
    'sapRole.editAuthorizationsWriteSap':            'Edit Authorizations (write to SAP)',
    'sapRole.errorOccurred':                         'An error occurred.',
    'sapRole.expiring30Days':                        'Expiring ≤30 days',
    'sapRole.failedReadAuthObjects':                 'Failed to read auth objects: ',
    'sapRole.fieldEGActvt':                          'Field (e.g. ACTVT)',
    'sapRole.finalLengthRolesWrittenSap':            'Final: {length} roles. Written to SAP immediately and logged.',
    'sapRole.finalListPreview':                      'Final list preview',
    'sapRole.from':                                  'From',
    'sapRole.generateProfile':                       'Generate profile',
    'sapRole.generateProfile2':                      ' · generate profile',
    'sapRole.iInsertUUpdateO':                       'I=insert, U=update, O=org level, D=delete object. FM Z resolves AUTH instance.',
    'sapRole.ind':                                   'Ind',
    'sapRole.insertI':                               'Insert (I)',
    'sapRole.limitedLatest500':                      ' (limited to latest 500)',
    'sapRole.load':                                  'Load',
    'sapRole.loadRoles':                             'Load Roles',
    'sapRole.loading':                               'Loading…',
    'sapRole.loadingDetail':                         'Loading detail…',
    'sapRole.loadingList':                           'Loading list…',
    'sapRole.loadingMenu':                           'Loading menu…',
    'sapRole.loadingObjects':                        'Loading objects…',
    'sapRole.loadingRolesSap':                       'Loading roles from SAP…',
    'sapRole.manageRoles':                           'Manage Roles',
    'sapRole.maximize':                              'Maximize',
    'sapRole.newValue':                              'New Value',
    'sapRole.noAssignmentsNotLoadedYet':             'No assignments / not loaded yet.',
    'sapRole.noAuthorizationObjects':                'No authorization objects.',
    'sapRole.noCacheYetBuildFirst':                  'No cache yet — build first (reads AGR_1251 once).',
    'sapRole.noChangesPeriodPfcgChange':             'No changes in this period (or PFCG change documents are not active).',
    'sapRole.noChangesYet':                          'No changes yet.',
    'sapRole.noChildRoles':                          'No child roles.',
    'sapRole.noClass':                               '(no class)',
    'sapRole.noDataNotLoadedYet':                    'No data / not loaded yet.',
    'sapRole.noFieldDetailEmptyCdpos':               'No field detail (empty CDPOS for this change).',
    'sapRole.noFields':                              '(no fields)',
    'sapRole.noMatch':                               'No match.',
    'sapRole.noMatchingObjects':                     'No matching objects.',
    'sapRole.noMatchingTcodes':                      'No matching tcodes.',
    'sapRole.noRelatedRoles':                        'No related roles.',
    'sapRole.noRoles':                               'No roles.',
    'sapRole.noRolesActiveUsersNot':                 'No roles with active users / not loaded yet.',
    'sapRole.noRolesFound':                          'No roles found.',
    'sapRole.noTcodes':                              '(no tcodes)',
    'sapRole.noTcodesNotLoadedYet':                  'No tcodes / not loaded yet.',
    'sapRole.noTcodesPossiblyCompositeRole':         'No tcodes (possibly a composite role).',
    'sapRole.noUsers':                               'No users.',
    'sapRole.noUsersAssigned':                       'No users assigned.',
    'sapRole.noUsersObjects':                        'No users/objects.',
    'sapRole.objectEGSTcode':                        'Object (e.g. S_TCODE)',
    'sapRole.of':                                    'of',
    'sapRole.oldValue':                              'Old Value',
    'sapRole.onlyAssignedRoles':                     'Only assigned roles',
    'sapRole.openRoleDetail':                        'Open role detail',
    'sapRole.openValueEditorDownloadSap':            'Open value editor: download the .SAP manually from PFCG (Download menu), edit here, then upload back to PFCG',
    'sapRole.orphan0Users':                          'Orphan (0 users)',
    'sapRole.pageReadOnlyPhase1':                    'Audit roles, assignments, tcodes, and composite role composition (read via RFC_READ_TABLE from AGR_* tables). Users with SAP role write access can assign roles and edit authorizations (insert / replace / delete + generate) on profiles where Z_ROLE_AUTH_MODIFY is configured. Productive clients (e.g. P01) require ticking "Allow productive client" in the editor.',
    'sapRole.period':                                'Period',
    'sapRole.profileHasNoPasswordSet':               '⚠ Profile has no password — set it in Table Maintenance → SAP Config.',
    'sapRole.profileSapConfig':                      'Profile (from SAP Config)',
    'sapRole.readingAgr1251':                        'Reading AGR_1251…',
    'sapRole.readingDetailCdpos':                    'Reading detail (CDPOS)…',
    'sapRole.rebuildCache':                          'Rebuild Cache',
    'sapRole.relatedRoles':                          'Related roles',
    'sapRole.remove':                                'Remove',
    'sapRole.removesAllRolesTickAllow':              'This removes ALL roles. Tick "allow empty" to proceed.',
    'sapRole.restore':                               'Restore',
    'sapRole.rfcReadTableServicePath':               'RFC_READ_TABLE service path missing — set it in SAP Config.',
    'sapRole.roleFilterPrefixOptional':              'Role filter (prefix, optional)',
    'sapRole.roleMenuEmpty':                         'Role menu is empty.',
    'sapRole.roleNameEGZ':                           'Role name (e.g. Z_GENERAL)',
    'sapRole.roleObjectChangeHistory':               'Role / Object Change History',
    'sapRole.roleUsers':                             'Role → Users',
    'sapRole.roles':                                 'roles',
    'sapRole.rolesAssigned':                         'roles (assigned)',
    'sapRole.rolesContainingTcode':                  'Roles containing the tcode',
    'sapRole.rolesManageuserUpdated':                'Roles for {manageUser} updated.',
    'sapRole.rolesTcode':                            'Roles with tcode',
    'sapRole.saving':                                'Saving…',
    'sapRole.searchObject':                          'Search object…',
    'sapRole.searchRoleDescription':                 'Search role / description…',
    'sapRole.searchTab':                             'Search this tab…',
    'sapRole.searchTcode':                           'Search tcode…',
    'sapRole.searchUsername':                        'Search username…',
    'sapRole.selectProfile':                         '— select profile —',
    'sapRole.selectSapSystem':                       'Select SAP System',
    'sapRole.showing':                               'showing',
    'sapRole.simulate':                              'Simulate',
    'sapRole.simulationOk':                          'Simulation OK: ',
    'sapRole.someTablesFailedRead':                  'Some tables failed to read: ',
    'sapRole.table':                                 'Table',
    'sapRole.tcodeUsers':                            'Tcode → Users',
    'sapRole.to':                                    'To',
    'sapRole.totalRoles':                            'Total Roles',
    'sapRole.type':                                  'Type',
    'sapRole.undo':                                  'Undo',
    'sapRole.unlimited':                             'unlimited',
    'sapRole.updateU':                               'Update (U)',
    'sapRole.user':                                  'For user',
    'sapRole.userHasNoRoles':                        'User has no roles.',
    'sapRole.userObjects':                           'User → Objects',
    'sapRole.userRoles':                             'User → Roles',
    'sapRole.userSRolesContainingObject':            'This user\'s roles containing the object',
    'sapRole.userTcodes':                            'User → Tcodes',
    'sapRole.valueEditorPfcgFile':                   'Value Editor (PFCG file)',
    'sapRole.valueEditorSap':                        'Value Editor (.SAP)',
    'sapRole.writesSapTestNonPrd':                   'Writes to SAP. Test on non-PRD first.',
    'sapRole.writesSapViaZRole':                     'Writes directly to SAP via Z_ROLE_AUTH_MODIFY + generate. Run Simulate before Apply.',
    'sapRole.writtenSapImmediatelyLoggedMake':       'Written to SAP immediately and logged. Make sure this is not production unless intended.',
    'sapRole.yesApply':                              'Yes, apply',

    // ── sapUser ──
    'sapUser.actions':                               'Actions',
    'sapUser.actionsHereWriteDirectlySap':           'Actions here write directly to SAP (lock/unlock & password reset). Only dialog users are shown. All actions are logged in the Activity Log.',
    'sapUser.active':                                'Active',
    'sapUser.active2':                               'active',
    'sapUser.activeOnly':                            'Active only',
    'sapUser.activeUsers':                           'active users of',
    'sapUser.blank':                                 '(blank)',
    'sapUser.cancel':                                'Cancel',
    'sapUser.clear':                                 'Clear',
    'sapUser.companyAll':                            'Company: all',
    'sapUser.dataAs':                                'Data as of',
    'sapUser.dbSnapshotClickLoadUsers':              'From DB snapshot — click Load Users to refresh from SAP.',
    'sapUser.dialogUsers':                           'Dialog Users',
    'sapUser.dialogUsers2':                          'dialog users',
    'sapUser.distributionPerCompany':                'Distribution per Company',
    'sapUser.eGWelcome1':                            'e.g. Welcome1!',
    'sapUser.editDetails':                           'Edit details',
    'sapUser.editDetails2':                          'Edit Details',
    'sapUser.editUserDetails':                       'Edit User Details',
    'sapUser.emptyDateUnlimitedOnlyChanged':         'Empty date = unlimited. Only changed fields are sent to SAP.',
    'sapUser.errorOccurred':                         'An error occurred.',
    'sapUser.failed':                                'failed',
    'sapUser.firstName':                             'First Name',
    'sapUser.fullName':                              'Full Name',
    'sapUser.inactiveUsersExcluded':                 'inactive users excluded',
    'sapUser.lastName':                              'Last Name',
    'sapUser.licenseAll':                            'License: all',
    'sapUser.licenseDistributionAllCompanies':       'License Distribution (all companies)',
    'sapUser.licenseSummaryActiveUsers':             'License Summary — Active Users',
    'sapUser.loadUsers':                             'Load Users',
    'sapUser.loading':                               'Loading…',
    'sapUser.lockReason':                            'Lock reason',
    'sapUser.lockSelected':                          'Lock selected',
    'sapUser.locked':                                'Locked',
    'sapUser.lockedOnly':                            'Locked only',
    'sapUser.missingServicePaths':                   'Missing service paths: ',
    'sapUser.moduleAll':                             'Module: all',
    'sapUser.newPassword':                           'New Password',
    'sapUser.newPasswordInitialUserMust':            'The new password is initial — the user must change it at next logon.',
    'sapUser.noDialogUsers':                         'No dialog users.',
    'sapUser.noExpiry':                              'No expiry',
    'sapUser.noExpiry2':                             '∞ (no expiry)',
    'sapUser.noLicense':                             '(no license)',
    'sapUser.noUsersMatchFilter':                    'No users match the filter.',
    'sapUser.ok':                                    'ok',
    'sapUser.passwordReset':                         'Password reset',
    'sapUser.processing':                            'Processing…',
    'sapUser.profileHasNoPasswordSet':               '⚠ Profile has no password — set it in Table Maintenance → SAP Config.',
    'sapUser.profileSapConfig':                      'Profile (from SAP Config)',
    'sapUser.relatedListActionsBlockedUntil':        ' — related list/actions blocked until configured.',
    'sapUser.saveSap':                               'Save to SAP',
    'sapUser.saving':                                'Saving…',
    'sapUser.searchUserNameEmail':                   'Search user/name/email…',
    'sapUser.selectProfile':                         '— select profile —',
    'sapUser.selectSapSystem':                       'Select SAP System',
    'sapUser.selected':                              'selected',
    'sapUser.someEnrichmentFailed':                  'Some enrichment failed — ',
    'sapUser.summary':                               'Summary',
    'sapUser.totalUsage':                            'Total Usage',
    'sapUser.unlockSelected':                        'Unlock selected',
    'sapUser.unlocked':                              'Unlocked',
    'sapUser.userDetailsUpdated':                    'User details updated',
    'sapUser.users':                                 'users',
    'sapUser.valid':                                 'Valid From',
    'sapUser.validThrough':                          'Valid Through',

    // ── sdp ──
    'sdp.activeFilter':                              'Active filter:',
    'sdp.all':                                       'All',
    'sdp.assetAnalytics':                            '— ASSET ANALYTICS —',
    'sdp.assetsManufacturerTop10':                   'Assets by Manufacturer (Top 10)',
    'sdp.assetsRegion':                              'Assets by Region',
    'sdp.assetsType':                                'Assets by Type',
    'sdp.auditFailed':                               'Audit Failed',
    'sdp.auditSuccess':                              'Audit Success',
    'sdp.auditTime':                                 'Audit Time',
    'sdp.avgResolutionDays':                         'Avg Resolution (days)',
    'sdp.avgResolutionTimePriorityDays':             'Avg Resolution Time by Priority (days)',
    'sdp.clickSort':                                 'Click to sort',
    'sdp.closedRequests':                            'Closed Requests',
    'sdp.dataCompletenessSerialHaveSerial':          'Data completeness: {serial}% have serial number, {region}% have region, {audited}% have been audited, {barcode}% have barcode.',
    'sdp.description':                               'Description',
    'sdp.escalated':                                 'Escalated',
    'sdp.failedAuditAssetsLength':                   'Failed Audit Assets ({length})',
    'sdp.issueCategoriesTop10':                      'Issue Categories (Top 10)',
    'sdp.loading':                                   'Loading…',
    'sdp.monthlyTicketVolumeTrend':                  'Monthly Ticket Volume Trend',
    'sdp.name':                                      'Name',
    'sdp.noData':                                    'No data.',
    'sdp.noDataYetRunTable':                         'No data yet? Run it from Table Maintenance → SDP Cloud.',
    'sdp.none':                                      'None.',
    'sdp.notAudited':                                'Not Audited',
    'sdp.openRequests':                              'Open Requests',
    'sdp.overdueTickets':                            'Overdue Tickets',
    'sdp.reload':                                    'Reload',
    'sdp.requestsStatus':                            'Requests by Status',
    'sdp.search':                                    'Search…',
    'sdp.serialNumber':                              '% With Serial Number',
    'sdp.sites':                                     'Sites',
    'sdp.slaOverduePriority':                        'SLA — % Overdue by Priority',
    'sdp.statusClosed':                              'Status: Closed',
    'sdp.statusOpen':                                'Status: Open',
    'sdp.technician':                                'Technician',
    'sdp.technicianWorkloadLength':                  'Technician Workload ({length})',
    'sdp.ticketingAssetsServicedeskPlusCloud':       'Ticketing & Assets from ServiceDesk Plus Cloud (read-only).',
    'sdp.totalTickets':                              'Total Tickets',
    'sdp.year':                                      'Year:',

    // ── shared ──
    'shared.aiAssistant':                            'AI Assistant',
    'shared.aiHasNotBeenEnabled':                    'AI has not been enabled for this link. Contact the link owner.',
    'shared.aiModelUsed':                            'AI model used',
    'shared.aiTyping':                               'AI is typing…',
    'shared.askAboutDashboardSData':                 'Ask about this dashboard’s data.',
    'shared.askAi':                                  '✨ Ask AI',
    'shared.askAnythingAboutTeamS':                  'Ask anything about the team’s common notes.',
    'shared.availableCommandsHelpShowHelp':          '**Available commands:**\n- `/help` — show this help\n- `/sql` — show SQL from the last data answer\n- `/clear` (or `/new`, `/reset`) — start a new session',
    'shared.avgResponseTime':                        'Avg response time',
    'shared.by':                                     'by',
    'shared.cancel':                                 'Cancel',
    'shared.clickShowFull':                          'Click to show full',
    'shared.dashboardNotAvailableSharing':           'This dashboard is not available for sharing.',
    'shared.editResend':                             'Edit & resend',
    'shared.failedGetAnswer':                        'Failed to get an answer.',
    'shared.failedLoadNote':                         'Failed to load note.',
    'shared.general':                                'General',
    'shared.invalidLink':                            'Invalid link.',
    'shared.linkInvalidHasExpired':                  'This link is invalid or has expired.',
    'shared.linkUnavailable':                        'Link Unavailable',
    'shared.loadingNote':                            'Loading note…',
    'shared.maximize':                               'Maximize',
    'shared.minimize':                               'Minimize',
    'shared.noContent':                              '(no content)',
    'shared.noSqlYetAskData':                        'No SQL yet. Ask a data question first.',
    'shared.notesCommon':                            'Notes (common)',
    'shared.publicViewReadOnly':                     'Public view · read-only',
    'shared.readOnly':                               'Read-only',
    'shared.resend':                                 'Resend',
    'shared.resize':                                 'Resize',
    'shared.responseTime':                           'Response time',
    'shared.send':                                   'Send',
    'shared.sqlLastAnswer':                          'SQL from the last answer:',
    'shared.startGeneralConversationAi':             'Start a general conversation with the AI.',
    'shared.tokensPromptCompletionTotal':            'Tokens: prompt / completion / total',
    'shared.typeQuestion':                           'Type a question…',
    'shared.typeQuestionHelpCommands':               'Type a question… (/help for commands)',
    'shared.unknownCommandCmdTypeHelp':              'Unknown command `/{cmd}`. Type `/help`.',
    'shared.untitled':                               '(untitled)',


    // ══ Migrasi lanjutan: AWS Inventory / CloudTrail / Role Auth Editor ══
    // ── awsInv ──
    'awsInv.account':                                'Account',
    'awsInv.actionsEnabled':                         'Actions Enabled',
    'awsInv.addInboundRule':                         'Add inbound rule',
    'awsInv.addRule':                                'Add Rule',
    'awsInv.addTag':                                 'Add tag',
    'awsInv.adding':                                 'Adding…',
    'awsInv.analysisStillRunningTryAgain':           'Analysis still running, try again shortly.',
    'awsInv.analytics':                              'Analytics',
    'awsInv.analyzingServiceAccess':                 'Analyzing service access…',
    'awsInv.associated':                             'Associated',
    'awsInv.associatedInstance':                     'Associated Instance',
    'awsInv.attachments':                            'Attachments',
    'awsInv.bucketEmpty':                            'Bucket is empty.',
    'awsInv.cancel':                                 'Cancel',
    'awsInv.clickObjectsTabLoad':                    'Click Objects tab to load.',
    'awsInv.clickRefreshFetchResourcesAws':          'Click Refresh to fetch resources from AWS.',
    'awsInv.clickTabLoadHistory':                    'Click tab to load history.',
    'awsInv.clickTabLoadRules':                      'Click tab to load rules.',
    'awsInv.close':                                  'Close',
    'awsInv.consoleLastLogin':                       'Console Last Login',
    'awsInv.created':                                'Created',
    'awsInv.details':                                'Details',
    'awsInv.disabled':                               'Disabled',
    'awsInv.eipNotAssociatedAnyInstance':            'This EIP is not associated with any instance (idle charge applies).',
    'awsInv.enabled':                                'Enabled',
    'awsInv.entities':                               'Entities',
    'awsInv.evaluationPeriods':                      'Evaluation Periods',
    'awsInv.fetching12Min':                          'Fetching… (1–2 min)',
    'awsInv.fetchingBucketContents':                 'Fetching bucket contents…',
    'awsInv.files':                                  'files',
    'awsInv.folders':                                'folders',
    'awsInv.groupName':                              'Group Name',
    'awsInv.groups':                                 'Groups',
    'awsInv.hideSidebar':                            'Hide sidebar',
    'awsInv.history':                                'History',
    'awsInv.lastAccessed':                           'Last Accessed',
    'awsInv.lastUsed':                               'Last Used',
    'awsInv.lengthWarningsDuringFetch':              '{length} warnings during fetch',
    'awsInv.loadLastAccessDataAccess':               'Load Last Access data (Access Advisor)',
    'awsInv.loading':                                'Loading…',
    'awsInv.maxSession':                             'Max Session',
    'awsInv.never':                                  'Never',
    'awsInv.newPasswordCopyShareSecurely':           'New password (copy & share securely — shown once):',
    'awsInv.no':                                     'No',
    'awsInv.noAccessKeys':                           'No access keys.',
    'awsInv.noAttachments':                          'No attachments.',
    'awsInv.noBusinessUnit':                         'No Business Unit',
    'awsInv.noHistoryFound':                         'No history found.',
    'awsInv.noInboundRules':                         'No inbound rules.',
    'awsInv.noInventoryYet':                         'No inventory yet',
    'awsInv.noOutboundRules':                        'No outbound rules.',
    'awsInv.noPoliciesAttached':                     'No policies attached.',
    'awsInv.noRelatedSnapshots':                     'No related snapshots.',
    'awsInv.noResources':                            'No resources.',
    'awsInv.noResults':                              'No results.',
    'awsInv.noResultsFound':                         'No results found.',
    'awsInv.noRoutes':                               'No routes.',
    'awsInv.noSecurityGroups':                       'No security groups.',
    'awsInv.noServiceAccessRecorded':                'No service access recorded.',
    'awsInv.noTunnels':                              'No tunnels.',
    'awsInv.noVolumes':                              'No volumes.',
    'awsInv.none':                                   'None',
    'awsInv.notAssociated':                          'Not associated',
    'awsInv.notAttached':                            'Not attached.',
    'awsInv.notMemberAnyGroup':                      'Not a member of any group.',
    'awsInv.optional':                               'optional',
    'awsInv.permissions':                            'Permissions',
    'awsInv.cronConfirm':                            'Run the AWS Inventory fetch now? Scans 19 regions (1–2 minutes), REPLACES the current snapshot, and records the diff to the change log.',
    'awsInv.refreshAws':                             'Refresh from AWS',
    'awsInv.regionsScanned':                         'Regions Scanned',
    'awsInv.remediationGuide':                       'Remediation Guide',
    'awsInv.removeInboundRuleProtocolPorts':         'Remove inbound rule {protocol} {ports} from {source}?',
    'awsInv.resetConsolePassword':                   'Reset Console Password',
    'awsInv.resetConsolePasswordNameNew':            'Reset console password for "{name}"? A new password will be generated and the user must change it on first login.',
    'awsInv.resetPasswordRandom':                    'Reset Password (random)',
    'awsInv.resetting':                              'Resetting…',
    'awsInv.resourceDetail':                         'Resource detail',
    'awsInv.resources':                              'resources',
    'awsInv.resourcesPerService':                    'Resources per Service',
    'awsInv.results':                                'results',
    'awsInv.resultsCapped50RefineQuery':             'Results capped at 50. Refine your query.',
    'awsInv.roleLastUsed':                           'Role Last Used',
    'awsInv.save':                                   'Save',
    'awsInv.saved':                                  'Saved',
    'awsInv.saving':                                 'Saving…',
    'awsInv.search':                                 'Search…',
    'awsInv.searchAllResourcesIdName':               'Search all resources… (ID, name, IP, tag, state, etc.)',
    'awsInv.securityCredentials':                    'Security Credentials',
    'awsInv.serviceTypes':                           'Service Types',
    'awsInv.showSidebar':                            'Show sidebar',
    'awsInv.sourceRequired':                         'Source required.',
    'awsInv.stateReason':                            'State Reason',
    'awsInv.stateUpdated':                           'State Updated',
    'awsInv.totalResources':                         'Total Resources',
    'awsInv.treatMissingData':                       'Treat Missing Data',
    'awsInv.updated':                                'Updated',
    'awsInv.userMustChangePasswordFirst':            'User must change password on first login.',
    'awsInv.volumes':                                'volumes',
    'awsInv.yes':                                    'Yes',

    // ── awsTrail ──
    'awsTrail.account':                              'Account',
    'awsTrail.action':                               'an action',
    'awsTrail.affectedResources':                    'Affected resources',
    'awsTrail.allEvents':                            'all events',
    'awsTrail.allRegions':                           'All regions',
    'awsTrail.analytics':                            'Analytics',
    'awsTrail.backList':                             'Back to list',
    'awsTrail.clickRefreshFetchActivityEvents':      'Click Refresh to fetch activity events from AWS.',
    'awsTrail.clickResetFilters':                    'click to reset filters',
    'awsTrail.clickViewFailures':                    'click to view failures',
    'awsTrail.collapseAll':                          'Collapse all',
    'awsTrail.copied':                               'Copied',
    'awsTrail.copy':                                 'Copy',
    'awsTrail.copyJson':                             'Copy JSON',
    'awsTrail.days':                                 'days',
    'awsTrail.days2':                                'Days',
    'awsTrail.errorsOnly':                           'Errors only',
    'awsTrail.eventDetail':                          'Event detail',
    'awsTrail.eventFailed':                          'Event failed.',
    'awsTrail.events':                               'events',
    'awsTrail.expandAll':                            'Expand all',
    'awsTrail.failed':                               'Failed',
    'awsTrail.failedEvents':                         'Failed Events',
    'awsTrail.failedRegions':                        'Failed regions',
    'awsTrail.fetching13Min':                        'Fetching… (1–3 min)',
    'awsTrail.hoverBreakdown':                       'hover for breakdown',
    'awsTrail.includeReadOnly':                      'Include read-only',
    'awsTrail.jsonDetail':                           'JSON Detail',
    'awsTrail.lengthRegionSFailedFetch':             '{length} region(s) failed to fetch — results may be incomplete.',
    'awsTrail.loading':                              'Loading…',
    'awsTrail.name':                                 'Name',
    'awsTrail.noCloudtrailDataYet':                  'No CloudTrail data yet',
    'awsTrail.noEvents':                             'No events.',
    'awsTrail.noMfa':                                'No MFA',
    'awsTrail.noResults':                            'No results.',
    'awsTrail.oftenCausedCloudtrailApiThrottling':   'Often caused by CloudTrail API throttling on large windows / many regions. Click for details.',
    'awsTrail.publicIp':                             'Public IP',
    'awsTrail.readOnly':                             'Read-only',
    'awsTrail.refreshAws':                           'Refresh from AWS',
    'awsTrail.regionsNoEvents':                      'Regions with no events',
    'awsTrail.regionsScanned':                       'Regions Scanned',
    'awsTrail.search':                               'Search…',
    'awsTrail.service':                              'Service',
    'awsTrail.success':                              'Success',
    'awsTrail.time':                                 'Time',
    'awsTrail.topEvent':                             'Top Event',
    'awsTrail.totalEvents':                          'Total Events',
    'awsTrail.unknownUser':                          'An unknown user',
    'awsTrail.updated':                              'Updated',
    'awsTrail.user':                                 'User',
    'awsTrail.what':                                 'What',
    'awsTrail.where':                                'Where',
    'awsTrail.who':                                  'Who',

    // ── roleAuthEd ──
    'roleAuthEd.authorizationValueEditorPfcgFile':   'Authorization Value Editor (PFCG file)',
    'roleAuthEd.downloadResult':                     'Download result',
    'roleAuthEd.editFieldValuesThenUpload':          'Edit field values, then upload back to PFCG. Does not touch SAP from here.',
    'roleAuthEd.failedLoadFileSap':                  'Failed to load file from SAP: ',
    'roleAuthEd.failedReadFile':                     'Failed to read file: ',
    'roleAuthEd.noAgr1251RowsFound':                 'No AGR_1251 rows found.',
    'roleAuthEd.noChangesYet':                       'No changes yet',
    'roleAuthEd.noMatchingValues':                   'No matching values.',
    'roleAuthEd.searchObjectField':                  'Search object / field…',
    'roleAuthEd.someValuesExceedVWidth':             'Some values exceed {V_WIDTH} characters. Fix first.',
    'roleAuthEd.someValuesTooLong':                  '· some values too long',
    'roleAuthEd.uploadPfcgRoleDownloadFile':         'Upload a PFCG role download file to start editing values.',
    'roleAuthEd.uploadSapFile':                      'Upload .SAP file',
    'roleAuthEd.valuesChanged':                      'values changed',


    // ── File Deploy (fdeploy) ──
    'fdeploy.adaPerubahanBelumDisimpanTutup':        'There are unsaved changes. Close anyway?',
    'fdeploy.adaSubfolderFileJsJsx':                 'No subfolders / .js/.jsx files here.',
    'fdeploy.aiService':                             'AI Service',
    'fdeploy.aiServiceRestartSekaliSetelah':         'AI Service is restarted once after all files are written.',
    'fdeploy.aiServiceRestartSetelahnya':            'AI Service will be restarted afterwards.',
    'fdeploy.aiServiceSedangRestartTunggu':          'AI Service is restarting — wait about 10 seconds.',
    'fdeploy.aksi':                                  'Actions',
    'fdeploy.ambilLogTerbaruSemuaProses':            'Fetch the latest logs of all processes via',
    'fdeploy.autocomplete':                          'autocomplete  ·',
    'fdeploy.backend':                               'Backend',
    'fdeploy.backendRestartSekaliSetelahSemua':      'Backend is restarted once after all files are written.',
    'fdeploy.backendRestartSetelahnya':              'Backend will be restarted afterwards.',
    'fdeploy.backendSedangRestartTunggu10':          'Backend is restarting — wait about 10 seconds, then refresh the page.',
    'fdeploy.backup2':                               '📸 Backup',
    'fdeploy.backup3':                               ' (backup: {backupName})',
    'fdeploy.backupSekarang':                        '📸 Back up now',
    'fdeploy.backupSemua':                           '💾 Back up ALL',
    'fdeploy.backupSemuaFile':                       'Back up ALL files',
    'fdeploy.baru':                                  '→ new',
    'fdeploy.baru2':                                 '→  New:',
    'fdeploy.batal':                                 'Cancel',
    'fdeploy.batal2':                                '✕ Cancel',
    'fdeploy.bedakanHurufBesarKecil':                'Match case',
    'fdeploy.belumAdaBackupFile':                    'No backups for this file yet.',
    'fdeploy.belumAdaFileKlikTambah':                'No files yet. Click “Add file…”, then set a target path for each file.',
    'fdeploy.belumAdaRiwayatDiffFile':               'No diff history for this file yet (only recorded when deployed via the Deploy tab).',
    'fdeploy.berhasilRename':                        'Renamed successfully.',
    'fdeploy.bersihkan':                             '✖ Clear',
    'fdeploy.bersihkanSemua':                        'Clear all',
    'fdeploy.bisaDibatalkan':                        'cannot be undone',
    'fdeploy.browse':                                '📂 Browse',
    'fdeploy.browseServer':                          '📂 Browse server',
    'fdeploy.btnDeployMixed':                        '🚀 Deploy {n} files, Rebuild & Restart',
    'fdeploy.btnDeployRebuild':                      '🚀 Deploy {n} files & Rebuild',
    'fdeploy.btnDeployRestart':                      '🚀 Deploy {n} files & Restart',
    'fdeploy.buildBerjalan':                         '⏳ Build running…',
    'fdeploy.buildFrontend':                         '🔨 Build frontend',
    'fdeploy.buildFrontendSekarang':                 '🔨 Build frontend now',
    'fdeploy.buildSelesaiHardRefreshCtrl':           'Build finished. Hard-refresh (Ctrl+Shift+R) to load the new version.',
    'fdeploy.building':                              '⏳ Building…',
    'fdeploy.cari2':                                 'Search',
    'fdeploy.cariBackup':                            'Find backups',
    'fdeploy.cariDiFile':                            'Search in file',
    'fdeploy.clear':                                 '🗑 Clear',
    'fdeploy.clearOutput':                           'clear output',
    'fdeploy.confirmBackupAll':                      'Back up all .js/.jsx files in {type} ({code}) recursively?',
    'fdeploy.confirmDeleteOne':                      'Delete {code}?',
    'fdeploy.confirmDeleteSelected':                 'Delete the {b} selected items?',
    'fdeploy.confirmDeployMulti':                    'Deploy {n} files to {type}? The previous file at each path is backed up automatically. No preview/diff.',
    'fdeploy.confirmDeployOne':                      'Deploy {name} to {type} at path {code}?',
    'fdeploy.confirmRestore':                        'Restore {code} from backup {b}?',
    'fdeploy.connectSsh':                            '🔌 Connect SSH',
    'fdeploy.connecting':                            '⏳ Connecting…',
    'fdeploy.copyLog':                               '📄 Copy log',
    'fdeploy.ctrlC':                                 'Ctrl+C',
    'fdeploy.ctrlD':                                 'Ctrl+D',
    'fdeploy.ctrlL':                                 'Ctrl+L',
    'fdeploy.ctrlS':                                 'Ctrl+S',
    'fdeploy.dashboardAiServiceDll':                 '(dashboard, ai-service, etc).',
    'fdeploy.deployRebuildFrontend':                 'Deploy & Rebuild frontend',
    'fdeploy.deployRestartAiService':                'Deploy & Restart AI Service',
    'fdeploy.deployRestartBackend':                  'Deploy & Restart backend',
    'fdeploy.diff':                                  'Diff: {rel}',
    'fdeploy.diff2':                                 'Diff:',
    'fdeploy.diff3':                                 'Diff: {targetPath}',
    'fdeploy.dihapus':                               'Deleted: {p}',
    'fdeploy.dipulihkanJalankanRebuildTabDeploy':    'Restored from {backupName}. Run a rebuild in the Deploy tab if this is a frontend file.',
    'fdeploy.dipulihkanRestartTunggu10Detik':        'Restored from {backupName}. {label} is restarting — wait about 10 seconds, then refresh.',
    'fdeploy.direktoriKosong':                       'Directory is empty.',
    'fdeploy.disalin':                               '✅ Copied',
    'fdeploy.disconnect':                            '⏏ Disconnect',
    'fdeploy.diunduh':                               'Downloaded: {download}',
    'fdeploy.download':                              '⬇️ Download',
    'fdeploy.download2':                             'Download',
    'fdeploy.downloadDiffTxt':                       '⬇️ Download .diff.txt',
    'fdeploy.downloadServer':                        '⬇️ Download from server',
    'fdeploy.dropHere':                              '📂 Drop files here to upload to {code}',
    'fdeploy.ec2UserLocalhostSsh':                   'ec2-user@localhost (SSH)',
    'fdeploy.enter':                                 'Enter',
    'fdeploy.entri':                                 'entries',
    'fdeploy.eof':                                   'EOF  ·',
    'fdeploy.error':                                 'error',
    'fdeploy.escKeTeks':                             'Esc to return to text',
    'fdeploy.posisiKursor':                          'Ln {line}, Col {col}',
    'fdeploy.jumlahBaris':                           '{total} lines',
    'fdeploy.terpilihKarakter':                      '{n} selected',
    'fdeploy.nomorBaris':                            'Line numbers',
    'fdeploy.explorerBackupNote':                    'The previous file is backed up automatically to the {code} folder in this directory (last 10 versions kept) before being overwritten.',
    'fdeploy.file':                                  'file',
    'fdeploy.file2':                                 'File',
    'fdeploy.fileAdaServer':                         'File does not exist on the server.',
    'fdeploy.fileBaruTanpaBackup':                   ' (new file, no backup)',
    'fdeploy.fileBelumAdaServerDibuat':              'ℹ️ File does not exist on the server yet — it will be created as a new file (no backup).',
    'fdeploy.fileBerubahBesarDiringkasBukan':        'File changed substantially — summarised, not a precise line-by-line diff',
    'fdeploy.fileDeploy':                            '📦 File Deploy',
    'fdeploy.fileLamaBilaAdaBackup':                 'The previous file (if any) is backed up automatically, and its diff history is kept (see the Backup & Restore tab) for tracing.',
    'fdeploy.fileTerDeployMemulaiRebuild':           'File deployed{bk}. Starting frontend rebuild…',
    'fdeploy.fileTerDeploySedangRestart':            'File deployed{bk}. {label} is restarting — wait about 10 seconds, then refresh.',
    'fdeploy.fileTerUpload':                         '{ok} files uploaded to {curPath}',
    'fdeploy.fileTerUploadMenimpaFile':              '{ok} files uploaded to {curPath} ({overwritten} overwrote existing files — backups saved automatically)',
    'fdeploy.fileTerlaluBesarDitampilkanDiff':       'File is too large to show a line diff. Check the size: server',
    'fdeploy.fileTerpilih':                          'files selected',
    'fdeploy.folderBeratNodeModulesBuild':           'Heavy folders (node_modules, build, backups, etc) are skipped. Each file is snapshotted to the backups folder (10 kept per file).',
    'fdeploy.frontend':                              'Frontend',
    'fdeploy.frontendRebuildBeberapaMenit':          'Frontend will be rebuilt (takes a few minutes).',
    'fdeploy.frontendRebuildSekaliSetelahSemua':     'Frontend is rebuilt once after all files are written.',
    'fdeploy.gagal':                                 ', {fail} failed',
    'fdeploy.gagal2':                                ', {fail} failed',
    'fdeploy.halamanHanyaAdmin':                     'This page is for administrators only.',
    'fdeploy.hanyaFileJsJsxDiizinkan':               'Only .js / .jsx files are allowed.',
    'fdeploy.hapus':                                 '🗑️ Delete',
    'fdeploy.hapus2':                                'Delete',
    'fdeploy.hasilBerikutnya':                       'Next result',
    'fdeploy.hasilSebelumnya':                       'Previous result',
    'fdeploy.hintAiService':                         'Relative to /awsbasis/ai-service — e.g. server.js or aiProxy.js',
    'fdeploy.hintBackend':                           'Relative to /awsbasis/dashboard/backend — e.g. fileDeployRoutes.js',
    'fdeploy.hintFrontend':                          'Relative to /awsbasis/dashboard/frontend — e.g. src/pages/FileDeployPage.jsx',
    'fdeploy.histSubtitle':                          'History of every deploy across all three roots, grouped by session. A tracing aid — the official trail is still the audit log.',
    'fdeploy.histAllTypes':                          'All roots',
    'fdeploy.histSearchPh':                          'Filter path — e.g. TableMaintenance',
    'fdeploy.histSearch':                            'Search',
    'fdeploy.histClear':                             'Clear',
    'fdeploy.histRefresh':                           '↻ Reload',
    'fdeploy.histLoading':                           'Loading deploy history…',
    'fdeploy.histEmpty':                             'No deploy history yet.',
    'fdeploy.histSummary':                           '{s} sessions · {d} diffs · sessions split when the gap exceeds {g} s',
    'fdeploy.histCapped':                            'Results were capped by the scan limit — some older history is not shown.',
    'fdeploy.histFiles':                             '{n} files',
    'fdeploy.histLoadFailed':                        'Failed to load deploy history.',
    'fdeploy.indent2Spasi':                          'indent 2 spaces',
    'fdeploy.interupsi':                             'interrupt  ·',
    'fdeploy.isiDuluPathFileServer':                 'Enter the file path on the server first.',
    'fdeploy.isiDuluPathTujuanServer':               'Enter the target path on the server first.',
    'fdeploy.isiPathFileDulu':                       'Enter the file path first.',
    'fdeploy.itemDipilih':                           'items selected',
    'fdeploy.jalankanRebuildFrontendSekarangProses': 'Rebuild the frontend now? This takes a few minutes; logs are shown live.',
    'fdeploy.jumlahBaris':                           'Line count:',
    'fdeploy.kembaliDaftar':                         '← Back to list',
    'fdeploy.ketikCommandEnterKirim':                'Type a command, Enter to send…',
    'fdeploy.kirim':                                 'send  ·',
    'fdeploy.kondisiFileSaatBackupDulu':             'The current file is backed up first before being overwritten (you can undo by restoring again).',
    'fdeploy.konfirmasiBuild':                       'Confirm build',
    'fdeploy.konfirmasiDeploy':                      'Confirm deploy',
    'fdeploy.konfirmasiHapus':                       'Confirm delete',
    'fdeploy.konfirmasiHapusMassal':                 'Confirm bulk delete',
    'fdeploy.konfirmasiMultiDeploy':                 'Confirm multi-deploy',
    'fdeploy.konfirmasiRestart':                     'Confirm restart',
    'fdeploy.konfirmasiRestartAiService':            'Confirm AI Service restart',
    'fdeploy.konfirmasiRestore':                     'Confirm restore',
    'fdeploy.konfirmasiTimpaFile':                   'Confirm overwrite',
    'fdeploy.konfirmasiTimpaPesan':                  '{n} of {total} uploaded files already exist in this folder and will be overwritten:',
    'fdeploy.lama':                                  'Old:',
    'fdeploy.left':                                  'left',
    'fdeploy.lihat':                                 '👁️ View',
    'fdeploy.lihatDiff':                             'View diff',
    'fdeploy.lihatDiff2':                            '👁️ View diff',
    'fdeploy.logBuild':                              '📋 Build log',
    'fdeploy.logDisalinClipboard':                   'Log copied to clipboard.',
    'fdeploy.logKosong':                             '(log is empty)',
    'fdeploy.logSemuaProses':                        '📋 Log of all processes',
    'fdeploy.masukkanPathFileLaluKlik':              'Enter a file path, then click “Find backups”.',
    'fdeploy.mdBuildFailedNoRestart':                'Build failed — pm2 restart cancelled. The files are already written on the server; fix the error, then rebuild from the Operations tab.',
    'fdeploy.mdOrderNote':                           'The build runs first and pm2 restarts follow — restarting during a build is exactly what we avoid.',
    'fdeploy.mdPlanTitle':                           'Execution plan',
    'fdeploy.mdRestarting':                          '{label} is restarting — wait about 10 seconds.',
    'fdeploy.mdRowTypeTitle':                        'Target root for this file',
    'fdeploy.mdStepBuild':                           'Rebuild frontend (npm run build, live log)',
    'fdeploy.mdStepRestart':                         'Restart pm2: {list}',
    'fdeploy.mdStepWrite':                           'Write {n} files (+ backup & diff history)',
    'fdeploy.mdTypeDefault':                         'Default type (new rows)',
    'fdeploy.mdTypeDefaultHint':                     'Type can be changed per file in the list — one batch may mix roots.',
    'fdeploy.memuat':                                '⏳ Loading…',
    'fdeploy.memuat2':                               'Loading…',
    'fdeploy.memuatRiwayatDiff':                     'Loading diff history…',
    'fdeploy.memulaiRebuildFrontend':                '{base}. Starting frontend rebuild…',
    'fdeploy.menghubungkan':                         'Connecting…',
    'fdeploy.menyimpan':                             '⏳ Saving…',
    'fdeploy.naik':                                  '⬆ Up',
    'fdeploy.nama':                                  'Name',
    'fdeploy.namaBaru':                              'New name',
    'fdeploy.namafileJs':                            'fileName.js',
    'fdeploy.opsRebuildDesc':                        'Run {code} in /awsbasis/dashboard/frontend. Use this after uploading frontend files without going through the Deploy tab.',
    'fdeploy.opsRestartAiDesc':                      'Run {code} in /awsbasis/ai-service (delete → start from ecosystem, not a plain restart). Useful after deploying AI Service files.',
    'fdeploy.opsRestartBackendDesc':                 'Run {code} in /awsbasis/dashboard/backend — not just {plain} — so that the new env and code from ecosystem.config.js are genuinely reloaded. Connections drop briefly (about 10 seconds).',
    'fdeploy.pathFile':                              'File path',
    'fdeploy.pathTujuanServer':                      'Target path on server',
    'fdeploy.pilihFile':                             '📄 Choose file…',
    'fdeploy.pilihFileBackup':                       'Choose a file to back up',
    'fdeploy.pilihFileServer':                       'Choose a file on the server',
    'fdeploy.pm2DeleteAiServicePm2':                 'pm2 delete ai-service && pm2 start ecosystem.config.js --only ai-service && pm2 save',
    'fdeploy.pm2DeleteDashboardPm2Start':            'pm2 delete dashboard && pm2 start ecosystem.config.js --only dashboard && pm2 save',
    'fdeploy.pm2Logs':                               'pm2 logs',
    'fdeploy.pm2Restart':                            'pm2 restart',
    'fdeploy.primary':                               'primary',
    'fdeploy.pulihkan':                              '↩️ Restore',
    'fdeploy.refresh':                               '🔄 Refresh',
    'fdeploy.rename':                                'Rename',
    'fdeploy.rename2':                               'Rename: {name}',
    'fdeploy.reset':                                 '↩ Reset',
    'fdeploy.restartAiService':                      '🤖 Restart AI Service',
    'fdeploy.restartAiServiceSekarang':              '🤖 Restart AI Service now',
    'fdeploy.restartAiServiceSekarangKoneksi':       'Restart the AI Service now? The AI connection will drop briefly (about 10 seconds).',
    'fdeploy.restartBackend':                        '🔄 Restart backend',
    'fdeploy.restartBackendSekarang':                '🔄 Restart backend now',
    'fdeploy.restartBackendSekarangSemuaKoneksi':    'Restart the backend now? All connections drop briefly (about 10 seconds).',
    'fdeploy.restartTunggu10DetikLalu':              '{base}. {label} is restarting — wait about 10 seconds, then refresh.',
    'fdeploy.restarting':                            '⏳ Restarting…',
    'fdeploy.right':                                 'right',
    'fdeploy.ringkasan':                             '⚠ summary',
    'fdeploy.riwayatDiff':                           'Diff history: {rel}',
    'fdeploy.riwayatDiffDeploy':                     '📝 Diff History (Deploy)',
    'fdeploy.riwayatDiffTracingDeployTab':           'Diff history (tracing — from deploys via the Deploy tab)',
    'fdeploy.rmRfNodeModulesCache':                  'rm -rf node_modules/.cache && npm run build',
    'fdeploy.sama':                                  'same)',
    'fdeploy.sebagianFileDilewatiHanyaJs':           'Some files were skipped (.js/.jsx only).',
    'fdeploy.seretFileAreaAtasUpload':               '💡 Drag files onto the area above for a quick upload',
    'fdeploy.simpan':                                '💾 Save',
    'fdeploy.simpan2':                               'save  ·',
    'fdeploy.simpan3':                               '✅ Save',
    'fdeploy.success':                               'success',
    'fdeploy.tab':                                   'Tab',
    'fdeploy.tabBackup':                             'Backup & Restore',
    'fdeploy.tabConsole':                            'OS Console',
    'fdeploy.tabDeploy':                             'Deploy',
    'fdeploy.tabExplorer':                           'File Explorer',
    'fdeploy.tabHistory':                            'Deploy History',
    'fdeploy.tabMulti':                              'Multi Deploy',
    'fdeploy.tabOps':                                'Operations',
    'fdeploy.tambahFile':                            '📄 Add file…',
    'fdeploy.tampilkanLog':                          '📋 Show log',
    'fdeploy.tekanConnectSshMemulaiSesi':            'Press "Connect SSH" to start a terminal session…',
    'fdeploy.teks':                                  '{dir}/{name}',
    'fdeploy.teks2':                                 '{curPath}/{name}',
    'fdeploy.terakhirDiubah':                        'Last modified',
    'fdeploy.terhubung':                             'Not connected',
    'fdeploy.terhubung2':                            '(not connected)',
    'fdeploy.tersimpan':                             'Saved: {name}',
    'fdeploy.tindakan':                              'This action',
    'fdeploy.tipe':                                  'Type',
    'fdeploy.tipeSatuBatchSatuTipe':                 'Type (one batch = one type)',
    'fdeploy.tracingApaBerubahTiapDeploy':           'for tracing — what changed in each deploy',
    'fdeploy.tutup':                                 'Close',
    'fdeploy.ukuran':                                'Size',
    'fdeploy.unggahFileJsJsxLangsung':               'Upload .js/.jsx files straight from your browser — automatic backup, then restart the backend or rebuild the frontend.',
    'fdeploy.upload':                                '⬆️ Upload',
    'fdeploy.uploading':                             '⏳ Uploading…',
    'fdeploy.viewEdit':                              'View / Edit',
    'fdeploy.warning':                               'warning',
    'fdeploy.wss':                                   'wss',
    'fdeploy.yaBackupSemua':                         'Yes, back up all',
    'fdeploy.yaBuild':                               'Yes, build',
    'fdeploy.yaDeploy':                              'Yes, deploy',
    'fdeploy.yaDeploySemua':                         'Yes, deploy all',
    'fdeploy.yaHapus':                               '🗑️ Yes, delete',
    'fdeploy.yaHapusSemua':                          '🗑️ Yes, delete all',
    'fdeploy.yaPulihkan':                            'Yes, restore',
    'fdeploy.yaRestart':                             'Yes, restart',
    'fdeploy.yaRestartAiService':                    'Yes, restart AI Service',
    'fdeploy.yaTimpa':                               '⚠️ Yes, overwrite',


    // ── AI Settings + Table Maintenance ──
    'aiSet2.modelIdContohUsAnthropic':               'Model ID, e.g. us.anthropic.claude-3-5-sonnet-20241022-v2:0',
    'aiSet2.promptGlobalDipakaiSaatAda':             'Global prompt — used when no dashboard is active (e.g. AI Workspace "General").',
    'tblMaint.aiServiceDbOperasiRestore':            'ℹ️ AI Service DB: Restore is not available from here. Use the file',
    'tblMaint.aktif':                                'Active',
    'tblMaint.baris':                                '{total} rows',
    'tblMaint.batal':                                'Cancel',
    'tblMaint.belumAdaDataIdSuim':                   'No SUIM ID data yet',
    'tblMaint.belumAdaDataKlikRun':                  'No data yet — click Run Now above for the first fetch.',
    'tblMaint.belumAdaDataOvertimeUpload':           'No overtime data yet. Upload a CSV to get started.',
    'tblMaint.belumAdaDataRingkasan':                'No summary data yet.',
    'tblMaint.belumAdaDataUser':                     'No user data yet.',
    'tblMaint.belumAdaSourceFile':                   'No source files yet',
    'tblMaint.belumAdaUpload':                       'No uploads yet',
    'tblMaint.cari':                                 'Search',
    'tblMaint.cariNamaKodeDept':                     '🔍 Search name, code, dept…',
    'tblMaint.cariUpnDomain':                        'Search UPN / domain…',
    'tblMaint.cariUserNamaDeptEmail':                '🔍 Search user, name, dept, email…',
    'tblMaint.dataDetailLoginDiagregasiOtomatis':    'Login detail data is aggregated automatically into hours per User / Period (YYYY-MM) / Dept, then stored in the dashboard database (source: SAP:<SID> <range>).',
    'tblMaint.fetchSimpan':                          '📡 Fetch & Save',
    'tblMaint.fetchUserUtilizationSapZrfc':          '📡 Fetch User Utilization from SAP (ZRFC_USR_UTL)',
    'tblMaint.halaman':                              'Page',
    'tblMaint.hapus':                                '🗑️ Delete',
    'tblMaint.hapus2':                               'Delete',
    'tblMaint.hapusDomainDaftarRingkasan':           'Remove domain "{dom}" from the summary list?',
    'tblMaint.hapusIdSuimData':                      'Delete SUIM ID data from "{selSrc}"?',
    'tblMaint.hapusMappingSku':                      'Delete SKU mapping "{part}"?',
    'tblMaint.hapusOvertimeData':                    'Delete overtime data from "{selSrc}"?',
    'tblMaint.hapusSource':                          '🗑️ Delete Source',
    'tblMaint.hapusUploadBesertaSemuaDatanya':       'Delete upload "{filename}" and all of its data?',
    'tblMaint.isiLicense':                           '🩹 Fill License',
    'tblMaint.jalankanVacuumAiServiceDb':            'Run VACUUM on the AI Service DB?',
    'tblMaint.kolomKategoriTampilSebagaiKolom':      'The "Category" column appears as a column in the summary table.',
    'tblMaint.kosongkanSemua':                       '⚠️ Clear All',
    'tblMaint.kosongkanSemuaDataEmployeeOvertime':   'CLEAR all Employee Overtime data? This cannot be undone!',
    'tblMaint.kosongkanSemuaDataIdSuim':             'CLEAR all SUIM ID data? This cannot be undone!',
    'tblMaint.memuatData':                           'Loading data…',
    'tblMaint.modeSimpan':                           'Save Mode',
    'tblMaint.namaRamah':                            'Friendly Name',
    'tblMaint.nonaktif':                             'Inactive',
    'tblMaint.pageOfRecords':                        'Page {page} of {totalPages} ({shown} of {total} records)',
    'tblMaint.penghapusanSourceFileSolmanSap':       'ℹ️ Deleting Solman/SAP/SUIM source files is still done from their own tabs.',
    'tblMaint.pilihKoneksi':                         '— choose a connection —',
    'tblMaint.pilihSourceFile':                      '-- Choose a source file --',
    'tblMaint.ringkasanLisensiPerDomain':            '📊 License Summary by Domain',
    'tblMaint.riwayatUploadSourceFileSemua':         'Upload history & source files for all tables',
    'tblMaint.semuaBln':                             'All Months',
    'tblMaint.semuaBu':                              'All BUs',
    'tblMaint.semuaTahun':                           'All Years',
    'tblMaint.snapshotTerakhir':                     'Last snapshot: {snap}',
    'tblMaint.tabelAktif':                           'active table:',
    'tblMaint.tampilkanSebagaiKolomKategoriRingkasan': 'Show as a category column in the summary? OK = yes.',
    'tblMaint.tanggal':                              'Date From',
    'tblMaint.tanggalSampai':                        'Date To',
    'tblMaint.total':                                'Total',
    'tblMaint.totalAssets':                          'Total Assets',
    'tblMaint.totalRecords':                         'Total Records',
    'tblMaint.totalRequests':                        'Total Requests',
    'tblMaint.totalUsers':                           'Total Users',


    // ── File Deploy: auto-locate ──
    'fdeploy.locAmbiguous':                    'Found {n} files named {name} in different locations.',
    'fdeploy.locAmbiguousShort':               '{n} locations — choose:',
    'fdeploy.locChooseHint':                   'Pick one below. Nothing is selected automatically, to avoid overwriting the wrong file.',
    'fdeploy.locFound':                        'Location detected automatically:',
    'fdeploy.locNew':                          '{name} does not exist in the project yet — it will be created as a new file. Enter the target path manually.',
    'fdeploy.locNewShort':                     'New file — enter the path manually',
    'fdeploy.locRenamed':                      'Filename normalised: {from} → {to} (repeat-download suffix removed).',
    'fdeploy.locSearching':                    '🔎 Locating the file in the project…',
    'fdeploy.locSizeSame':                     'same size',
    'fdeploy.locUploadSize':                   'uploaded file: {size}',
    'fdeploy.locTypeMismatch':                 '{n} file(s) were detected in a root other than "{type}".',
    'fdeploy.locTypeMismatchHint':             'Multi Deploy uses one type for the whole batch. Move these files into a separate batch, or change the Type above.',
    'fdeploy.nihil':                                 'None',


    // ══ AWS Pricing Calculator (Tahap 3) ══
    'page.awsPricing.title':      'AWS Pricing Calculator',
    'page.awsPricing.subtitle':   'AWS cost estimation with side-by-side commitment comparison',
    'sidebar.awsPricing':         'AWS Pricing Calculator',
    'sidebar.awsPricing.sub':     'Cost & commitment estimation',
    'rm.desc.aws_pricing':        'Pricing calculator & estimates',
    'awsp.tab.calculator':        'Calculator',
    'awsp.tab.catalog':           'Price Catalog',
    'awsp.tab.sync':              'Sync & Config',
    'awsp.loading':               'Loading…',
    'awsp.configError':           'Failed to load configuration:',
    'awsp.region':                'Region',
    'awsp.service':               'Service',
    'awsp.instanceType':          'Instance type',
    'awsp.os':                    'OS',
    'awsp.tenancy':               'Tenancy',
    'awsp.preInstalledSw':        'Pre-installed SW',
    'awsp.termType':              'Term type',
    'awsp.offeringClass':         'Offering class',
    'awsp.lease':                 'Lease',
    'awsp.payment':               'Payment',
    'awsp.range':                 'Range',
    'awsp.upfront':               'Upfront',
    'awsp.rate':                  'Rate',
    'awsp.unit':                  'Unit',
    'awsp.all':                   'All',
    'awsp.search':                'Search',
    'awsp.clearFilters':          'Clear filters',
    'awsp.save':                  'Save',
    'awsp.yes':                   'Yes',
    'awsp.no':                    'No',
    'awsp.mo':                    'mo',
    'awsp.hr':                    'hr',
    'awsp.calc.cart':             'Cart',
    'awsp.calc.cartEmpty':        'No lines yet. Add a resource in the middle panel.',
    'awsp.calc.addLine':          'Add line',
    'awsp.calc.addToCart':        'Add to cart',
    'awsp.calc.kindEc2':          'EC2 Instance',
    'awsp.calc.kindUsage':        'Storage / Transfer',
    'awsp.calc.qty':              'Quantity',
    'awsp.calc.hoursPerMonth':    'Hours per month',
    'awsp.calc.volumeGb':         'Volume (GB)',
    'awsp.calc.usageType':        'Usage type',
    'awsp.calc.onDemand':         'On-Demand',
    'awsp.calc.noPrice':          'no price available',
    'awsp.calc.needInstance':     'Select instance type, OS, and tenancy first.',
    'awsp.calc.needUsageType':    'Select a usage type first.',
    'awsp.calc.pickLine':         'Select a line in the cart to see its commitment matrix.',
    'awsp.calc.noCommitment':     'Storage and data transfer lines only have tiered On-Demand pricing — no commitment options.',
    'awsp.calc.tiers':            'Price tiers',
    'awsp.calc.supportPlan':      'Support plan',
    'awsp.calc.vat':              'VAT',
    'awsp.calc.vatId':            'Indonesia VAT',
    'awsp.calc.vatSg':            'Singapore GST',
    'awsp.calc.vatNone':          'No VAT',
    'awsp.calc.hoursNote':        'Default hours per month:',
    'awsp.calc.recurring':        'Recurring',
    'awsp.calc.amortizedUpfront': 'Amortized upfront',
    'awsp.calc.usageSubtotal':    'Usage subtotal',
    'awsp.calc.support':          'Support',
    'awsp.calc.totalMonthly':     'Total per month',
    'awsp.calc.cashUpfront':      'Cash upfront (month 0)',
    'awsp.calc.cashNote':         'This is separate from the monthly total, which already uses the amortized upfront.',
    'awsp.calc.supportBasisNote': 'The Support basis excludes RI upfront, matching how AWS bills it.',
    'awsp.calc.kindRds':      'RDS Instance',
    'awsp.calc.dbEngine':     'Database engine',
    'awsp.calc.dbEdition':    'Edition',
    'awsp.calc.dbEditionNone':'No edition',
    'awsp.calc.deployment':   'Deployment',
    'awsp.calc.licenseModel': 'License model',
    'awsp.calc.needRds':      'Pick a database engine, deployment, and instance type first.',
    'awsp.calc.rdsMultiAzNote': 'Multi-AZ is a separate product in the AWS catalog, not a quantity of two — the price already covers the standby.',
    'awsp.calc.kindOpenSearch': 'OpenSearch',
    'awsp.calc.usageAmount':  'Usage amount',
    'awsp.calc.elbNote':      'An ALB bills as two lines: LoadBalancerUsage per hour and LCUUsage per LCU-hour. Enter hours/month (e.g. 730) for the first, and LCU × hours for the second.',
    'awsp.calc.needOpenSearch': 'Pick an OpenSearch instance type first.',
    'awsp.calc.openSearchNote': 'This price covers the domain instance only. Domain EBS storage is a separate line — add it from the Storage / Transfer tab.',
    // ── Active estimate export (Excel / PDF) ───────────────────────────────
    'awsp.exp.excel':         'Excel',
    'awsp.exp.pdf':           'PDF',
    'awsp.exp.docTitle':      'AWS Cost Estimate',
    'awsp.exp.generatedAt':   'Generated',
    'awsp.exp.colKind':       'Kind',
    'awsp.exp.colItem':       'Item',
    'awsp.exp.colUsageType':  'Usage type / Operation',
    'awsp.exp.colCommitment': 'Commitment',
    'awsp.exp.colLoad':       'Hours / Volume',
    'awsp.exp.colUnit':       'Unit',
    'awsp.exp.colUnitPrice':  'Unit price',
    'awsp.exp.colRecurring':  'Recurring/mo',
    'awsp.exp.colUpfront':    'Upfront',
    'awsp.exp.colFlags':      'Notes',
    'awsp.exp.flagDerived':   'derived price',
    'awsp.exp.flagAnomaly':   'catalog anomaly',
    'awsp.exp.flagDrift':     'price drifted',
    'awsp.exp.inIdr':         'In Rupiah',
    'awsp.exp.popupBlocked':  'The print window was blocked — allow popups for this site.',
    'awsp.matrix.title':          'Commitment matrix',
    'awsp.matrix.subtitle':       'All options side by side. Click a row to apply it to the calculation.',
    'awsp.matrix.option':         'Option',
    'awsp.matrix.upfront':        'Upfront',
    'awsp.matrix.monthly':        '$/mo',
    'awsp.matrix.year1':          '1-year total',
    'awsp.matrix.saving':         'Saving',
    'awsp.matrix.missing':        'not in catalog',
    'awsp.matrix.riStd':          'Reserved Instance — Standard',
    'awsp.matrix.riConv':         'Reserved Instance — Convertible',
    'awsp.matrix.spCompute':      'Savings Plan — Compute',
    'awsp.matrix.spEc2':          'Savings Plan — EC2 Instance',
    'awsp.matrix.derivedHint':    'Cash flow derived from the committed rate',
    'awsp.matrix.derivedNote':    'Savings Plans have no per-rate upfront; the upfront figure is derived from committed rate × hours. The amortized cost is identical across all three payment options — only the timing of the cash differs.',
    'awsp.matrix.savingNote':     'Saving is computed against On-Demand at the same quantity and hours.',
    'awsp.matrix.anomalyWarn':    '{n} cells deviate from the expected upfront/rate pattern. They are still shown so a broken catalog is visible rather than hidden.',
    'awsp.catalog.searchHint':    'instance type, description, or usage type',
    'awsp.catalog.rowCount':      '{n} matching rows',
    'awsp.catalog.page':          'Page {p} of {t}',
    'awsp.catalog.empty':         'No rows match these filters.',
    'awsp.sync.jobStatus':        'Job status per region',
    'awsp.sync.job':              'Job',
    'awsp.sync.products':         'Products',
    'awsp.sync.terms':            'Terms',
    'awsp.sync.jobsCount':        'Job count',
    'awsp.sync.running':          'Running',
    'awsp.sync.duration':         'Duration',
    'awsp.sync.lastSync':         'Last sync',
    'awsp.sync.status':           'Status',
    'awsp.sync.never':            'never',
    'awsp.sync.run':              'Run',
    'awsp.sync.confirm':          'Run sync now? Existing rows for this job and region will be REPLACED, not appended.',
    'awsp.sync.confirmSp':        'A Savings Plan sync takes roughly 12 minutes and over 2000 API calls. Run it now?',
    'awsp.sync.emptyNote':        'An "empty" status means the job ran without error but returned no products at all — the catalog has a gap, it is not complete.',
    'awsp.sync.config':           'Calculator configuration',
    'awsp.sync.savedKeys':        'Saved: {keys}',
    'awsp.sync.supportTiers':     'Support tiers',
    'awsp.sync.tierFrom':         'From',
    'awsp.sync.tierTo':           'To',
    'awsp.sync.min':              'Minimum',
    'awsp.sync.marginalNote':     'Tiers are marginal: each percentage applies only to the portion of the bill falling within its range.',


    // ══ AWS Pricing Calculator — CRUD estimate ══
    'awsp.est.title':         'Estimate',
    'awsp.est.unsaved':       'Not saved — the cart is lost if the tab closes.',
    'awsp.est.currentName':   '{name} (#{id})',
    'awsp.est.save':          'Save',
    'awsp.est.saveNew':       'Save estimate',
    'awsp.est.saveAs':        'Save as new',
    'awsp.est.open':          'Open',
    'awsp.est.loadBtn':       'Load',
    'awsp.est.namePrompt':    'Estimate name:',
    'awsp.est.defaultName':   'New estimate',
    'awsp.est.emptyCart':     'The cart is empty — there is nothing to save.',
    'awsp.est.saved':         'Saved, {n} lines.',
    'awsp.est.loaded':        'Estimate loaded. Prices were re-fetched from the catalog and match what was saved.',
    'awsp.est.loadedEmpty':   'Estimate loaded, but it has no lines.',
    'awsp.est.loadedDrift':   'Estimate loaded: {d} lines differ in price from when they were saved, {x} lines no longer exist in the catalog. The figures shown use CURRENT prices.',
    'awsp.est.listEmpty':     'No saved estimates yet.',
    'awsp.est.lineCount':     '{n} lines',
    'awsp.est.confirmDelete': 'Delete estimate "{name}"? All of its lines go with it and cannot be recovered.',
    'awsp.est.snapshotNote':  'Estimate lines store the price in effect when they were saved. The weekly catalog sync will not silently change an old estimate — any difference is flagged when you open it.',
    'awsp.est.driftTitle':    'Price changed since the estimate was saved',
    'awsp.est.driftSaved':    'When saved:',


    // ══ AWS Pricing Calculator — No Support option ══
    'awsp.calc.supportNone': 'No Support',


    // ══ AWS Pricing Calculator — konvensi AWS (recurring vs upfront) ══
    'awsp.matrix.leaseTotal':         'Lease total',
    'awsp.calc.totalMonthlyNote':     'Follows the AWS Pricing Calculator convention: recurring cost only. Upfront is not included here — see the row below.',
    'awsp.calc.amortizedCompare':     'Amortized equivalent/mo',
    'awsp.calc.amortizedCompareNote': 'Comparison figure only, not part of the Total per month: upfront is spread evenly across the full lease term so No Upfront and All Upfront can be compared fairly.',
    'awsp.calc.oneTime':              'one-time',


    // ══ SearchableSelect ══
    'awsp.searchPlaceholder': 'Type to search…',

  },

  ar: {
    // ── Language switcher ──
    'lang.label':       'اللغة',
    'lang.indonesian':  'الإندونيسية',
    'lang.english':     'الإنجليزية',

    // ── Common ──
    'common.save':       'حفظ',
    'common.cancel':     'إلغاء',
    'common.delete':     'حذف',
    'common.edit':       'تعديل',
    'common.search':     'بحث...',
    'common.loading':    'جارٍ التحميل...',
    'common.refresh':    'تحديث',
    'common.yes':        'نعم',
    'common.no':         'لا',
    'common.close':      'إغلاق',
    'common.confirm':    'تأكيد',
    'common.actions':    'إجراءات',
    'common.all':        'الكل',
    'common.noData':     'لا توجد بيانات',

    // ── Header: judul halaman ──
    'page.overview.title':     'نظرة عامة',
    'page.overview.subtitle':  'ملخّص جميع الأنظمة',
    'page.awsBilling.title':   'AWS Billing',
    'page.awsBilling.subtitle':'لوحة تكاليف واستخدام AWS',
    'page.awsCost.title':      'AWS Cost Explorer',
    'page.awsCost.subtitle':   'تحليل معمّق لتكاليف AWS',
    'page.awsInventory.title':    'AWS Inventory',
    'page.awsInventory.subtitle': 'توثيق موارد AWS عبر عدة مناطق',
    'page.awsCloudTrail.title':    'AWS CloudTrail',
    'page.awsCloudTrail.subtitle': 'سجل النشاط وتدقيق أحداث AWS عبر عدة مناطق',
    'page.solman.title':       'SAP Solution Manager',
    'page.solman.subtitle':    'مراقبة تذاكر وحوادث SAP',
    'page.sapUsage.title':     'SAP User Utilization',
    'page.sapUsage.subtitle':  'تحليل استخدام مستخدمي SAP',
    'page.sapUserMgmt.title':     'SAP User Maintenance',
    'page.sapUserMgmt.subtitle':  'إدارة مستخدمي SAP — قفل، فتح، إعادة تعيين كلمة المرور',
    'sidebar.sapUserMgmt':        'SAP User Maintenance',
    'sidebar.sapUserMgmt.sub':    'قفل / فتح / إعادة تعيين كلمة المرور',
    'sidebar.sapRoles':           'SAP Role Maintenance',
    'sidebar.sapRoles.sub':       'تدقيق الأدوار والتعيينات',
    // Menu tanpa terjemahan sebelumnya (label + subjudul)
    'sidebar.solman_docs': 'Solman Documents',
    'sidebar.solman_docs.sub': 'مستندات مشاريع SolMan (PDF + OCR)',
    'sidebar.sapBasisMon': 'SAP Basis Monitor',
    'sidebar.sapBasisMon.sub': 'الصحة: المهام، الأقفال، العمليات، النظام',
    'sidebar.sapLogonAudit': 'تدقيق الوصول الخارجي',
    'sidebar.sapLogonAudit.sub': 'الوصول إلى SAP من خارج الشبكة',
    'sidebar.linuxLoginAudit': 'تدقيق تسجيل دخول Linux',
    'sidebar.linuxLoginAudit.sub': 'عمليات دخول SSH على جميع خوادم EC2 Linux',
    'sidebar.claudeActivity': 'نشاط Claude',
    'sidebar.claudeActivity.sub': 'استخدام الأعضاء لـ Claude (OTel)',
    'sidebar.sapRouterLog': 'سجل SAProuter',
    'sidebar.sapRouterLog.sub': 'الاتصالات الواردة وعنوان IP العام المصدر',
    'sidebar.transport': 'SAP Transport Request',
    'sidebar.transport.sub': 'قائمة STMS والاستيراد إلى Q01/P01',
    'sidebar.sapNotes': 'SAP Note',
    'sidebar.sapNotes.sub': 'فهرس الملاحظات والأرشيف والمتابعة',
    'sidebar.netmap': 'طوبولوجيا الشبكة',
    'sidebar.netmap.sub': 'مخططات شبكات المواقع',
    'sidebar.aiActions': 'إجراءات الذكاء الاصطناعي',
    'sidebar.aiActions.sub': 'إجراءات باللغة الطبيعية مع الموافقة',
    'sidebar.shareLinks': 'روابط المشاركة',
    'sidebar.shareLinks.sub': 'روابط عامة للقراءة فقط',
    'sidebar.fileDeploy': 'نشر الملفات',
    'sidebar.fileDeploy.sub': 'رفع ونشر ملفات .js/.jsx',
    'sidebar.notes': 'الملاحظات',
    'sidebar.notes.sub': 'ملاحظات ومذكرات الفريق',
    'sidebar.notesPlain': 'ملاحظات بسيطة',
    'sidebar.notesPlain.sub': 'ملاحظات بدون فهرس RAG',
    // ── SAP Customizing & Enhancement ──
    'sidebar.sapCustomizing':     'تخصيص SAP',
    'sidebar.sapCustomizing.sub': 'مخارج المستخدم و BAdI والتحسينات',
    'sidebar.sapConfig':          'تهيئة SAP',
    'sidebar.sapConfig.sub':      'تخصيص SPRO / IMG',
    'page.sapCustomizing.title':    'تخصيص وتحسينات SAP',
    'page.sapCustomizing.subtitle': 'بيانات وصفية لمخارج المستخدم وشاشات الإضافة وملحقات الجداول (CMOD/SMOD) في نظام SAP — BAdI غير مشمول بعد',

    // ── ABAP Source Viewer ──
    'sidebar.sapSource':          'ABAP Workbench',
    'sidebar.sapSource.sub':      'عرض الشيفرة المصدرية للبرامج المخصصة',
    'page.sapSource.title':       'ABAP Workbench',
    'page.sapSource.subtitle':    'اقرأ الشيفرة المصدرية لبرنامج أو include في ABAP مباشرة من SAP',
    'sapSrc.scopeNote':           'النطاق المخصص فقط (Z*/Y*). برامج SAP القياسية يرفضها SAP نفسه — الحاجز موجود في وحدة الدوال، لا في هذه الصفحة. كل عملية قراءة تُسجَّل في سجل النشاط.',
    'sapSrc.noPath':              'ملف الاتصال هذا لا يحتوي بعد على مسار خدمة ZRFC_READ_SOURCE. اضبطه أولاً في SAP Config؛ بدونه ستفشل القراءة بالتأكيد.',
    'sapSrc.progPlaceholder':     'اسم البرنامج / include، مثل ZXVVFU02',
    'sapSrc.progInvalid':         'اسم غير صالح. حروف وأرقام و _ / = < > + - فقط (40 حرفاً كحد أقصى).',
    'sapSrc.withIncludes':        'تضمين الـ includes',
    'sapSrc.read':                'إظهار',
    'sapSrc.reading':             'جارٍ القراءة...',
    'sapSrc.linesUnit':           'سطر',
    'sapSrc.codeLines':           'سطر شيفرة',
    'sapSrc.progUnit':            'برنامج',
    'sapSrc.state.code':          'يحتوي على شيفرة',
    'sapSrc.state.empty':         'موجود، لكنه تعليقات وأسطر فارغة فقط',
    'sapSrc.state.missing':       'لا توجد شيفرة مصدرية',
    'sapSrc.state.denied':        'مرفوض من SAP',
    'sapSrc.state.auth':          'رُفضت المصادقة',
    'sapSrc.state.error':         'فشلت القراءة',
    'sapSrc.truncWarn':           'تم قطع {n} سطراً بواسطة SAP عند الحرف 255. ما يظهر ليس السطر الكامل.',
    'sapSrc.findPlaceholder':     'بحث داخل الشيفرة...',
    'sapSrc.findNote':            'البحث يُبرز النتائج ولا يُرشّح الأسطر.',
    'sapSrc.hits':                '{n} نتيجة',
    'sapSrc.copy':                'نسخ',
    'sapSrc.copied':              'تم النسخ',
    'sapSrc.download':            'تنزيل',
    'sapSrc.noLines':             'لم يُرجع SAP أي سطر لهذا البرنامج.',
    'sapSrc.emptyState':          'اكتب اسم برنامج أو include في ABAP أعلاه ثم اضغط إظهار. تأتي اقتراحات الأسماء من فهرس Custom Workbench (المزامَن من TADIR) وليس من قراءة مباشرة من SAP — وغياب الاسم عن القائمة لا يعني أنه غير موجود.',
    'sapSrc.requested':           'المطلوب',
    'sapSrc.expand':              'انقر للتوسيع',
    'sapSrc.collapse':            'انقر للطي',
    'sapSrc.sugNote':             'اقتراحات من برامج قُرئت سابقاً، وليست قائمة كاملة.',
    'sapSrc.sugMore':             'هناك المزيد — ضيّق ما تكتبه.',
    // ── ABAP Source Viewer · Function Module mode ──
    'sapSrc.mode.prog':           'برنامج / تقرير',
    'sapSrc.mode.fm':             'وحدة دوال',
    'sapSrc.fmPlaceholder':       'اسم وحدة الدوال، مثل ZMMFM_PRREL_SEND_MAIL',
    'sapSrc.fmInvalid':           'اسم غير صالح. حروف وأرقام و _ و / فقط (30 حرفاً كحد أقصى).',
    'sapSrc.fmLookup':            'إظهار',
    'sapSrc.fmLooking':           'جارٍ البحث...',
    'sapSrc.fmEmptyState':        'اكتب اسم وحدة دوال أعلاه ثم اضغط إظهار. الاقتراحات تُقرأ مباشرة من TFDIR في SAP، ومحدودة بالنطاق المخصص (Z*/Y*). ليست SE37 كاملة: لا يوجد تشغيل/اختبار ولا تحرير.',
    'sapSrc.fmSugLive':           'الاقتراحات تُقرأ مباشرة من TFDIR في SAP.',
    'sapSrc.tab.import':          'Import',
    'sapSrc.tab.export':          'Export',
    'sapSrc.tab.changing':        'Changing',
    'sapSrc.tab.tables':          'Tables',
    'sapSrc.tab.exceptions':      'Exceptions',
    'sapSrc.tab.other':           'أخرى (PARAMTYPE {code})',
    'sapSrc.tab.source':          'الشيفرة المصدرية',
    'sapSrc.attr.group':          'مجموعة الدوال',
    'sapSrc.attr.mainProg':       'البرنامج الرئيسي',
    'sapSrc.attr.include':        'Include',
    'sapSrc.attr.remote':         'REMOTE-ENABLED (RFC)',
    'sapSrc.attr.updateModule':   'UPDATE MODULE',
    'sapSrc.attr.normal':         'عادي',
    'sapSrc.col.param':           'المعامل',
    'sapSrc.col.typeRef':         'النوع المرتبط',
    'sapSrc.col.default':         'القيمة الافتراضية',
    'sapSrc.col.optional':        'اختياري',
    'sapSrc.col.text':            'وصف مختصر',
    'sapSrc.rawCols':             'إظهار أعمدة SAP الخام (PPOSITION, REFERENCE, TYPE, REF_CLASS)',
    'sapSrc.tabEmpty':            'لا توجد معاملات في هذه المجموعة.',
    'sapSrc.optYes':              'اختياري',
    'sapSrc.optNo':               'إلزامي',
    'sapSrc.warnTitle':           'جدير بالملاحظة:',
    'sapSrc.orphanTitle':         'بعض نصوص المعاملات في FUNCT لا يوجد لها مقابل في FUPARAREF:',
    'sapSrc.fmSourceNote':        'تُقرأ شيفرة وحدة الدوال عبر البرنامج الرئيسي لمجموعة الدوال ({prog}) مع جميع الـ includes — لا يمكن قراءة include منفرد وحده في هذا النظام. يُعرض الجزء الخاص بهذه الوحدة ({inc}) أولاً ومفتوحاً، أما includes الوحدات الأخرى في المجموعة نفسها فتبدأ مطويّة.',
    'sapSrc.reload':              'إعادة القراءة',
    // ── ABAP Source Viewer · ABAP Dictionary mode ──
    'sapSrc.mode.dd':             'قاموس ABAP',
    'sapSrc.ddPlaceholder':       'اسم الجدول / البنية، مثل EKKO أو ZTAMM_PRREL',
    'sapSrc.ddInvalid':           'اسم غير صالح. حروف وأرقام و _ و / فقط (30 حرفاً كحد أقصى).',
    'sapSrc.ddLookup':            'إظهار',
    'sapSrc.ddLooking':           'جارٍ البحث...',
    'sapSrc.ddEmptyState':        'اكتب اسم جدول أو بنية أعلاه ثم اضغط إظهار. يعمل مع جميع الجداول بما فيها جداول SAP القياسية.',
    'sapSrc.ddSugLive':           'الاقتراحات تُقرأ مباشرة من DD02L (النسخة النشطة) في SAP.',
    'sapSrc.dd.scopeNote':        'ما يُعرض هو بنية الجدول — أسماء الحقول وأنواعها وأطوالها وعناصر البيانات. محتويات الجدول لا تُقرأ هنا؛ فذلك عمل صفحة Table Maintenance بإذنها الخاص. تُستخدم النسخة النشطة فقط (AS4LOCAL=A).',
    'sapSrc.dd.maintain':         'قابل للصيانة (SM30)',
    'sapSrc.dd.noMaintain':       'بدون عرض صيانة',
    'sapSrc.dd.delivery':         'فئة التسليم',
    'sapSrc.dd.changed':          'عُدِّل بواسطة',
    'sapSrc.dd.fields':           'حقل',
    'sapSrc.dd.keys':             'مفتاح',
    'sapSrc.dd.includes':         'include',
    'sapSrc.dd.textSrc':          'النص مأخوذ من {src}، اللغة {lang}.',
    'sapSrc.dd.include':          'INCLUDE',
    'sapSrc.dd.append':           'APPEND',
    'sapSrc.dd.filterPlaceholder': 'تصفية الحقل أو عنصر البيانات أو الوصف...',
    'sapSrc.dd.noFields':         'لا توجد قائمة حقول لهذا الكائن.',
    'sapSrc.dd.navHint':          'فتح {name}',
    'sapSrc.dd.col.key':          'مفتاح',
    'sapSrc.dd.col.pos':          'الموضع',
    'sapSrc.dd.col.field':        'الحقل',
    'sapSrc.dd.col.de':           'عنصر البيانات',
    'sapSrc.dd.col.type':         'النوع',
    'sapSrc.dd.col.chk':          'جدول التحقق',
    'sapSrc.dd.col.text':         'وصف مختصر',
    // ── ABAP Source Viewer · table content sample ──
    'sapSrc.peek.open':           'عرض عيّنة من محتوى الجدول',
    'sapSrc.peek.hint':           'يقرأ بيانات العمل، لا البنية. يتطلب إذن sap_table_peek.',
    'sapSrc.peek.title':          'عيّنة من محتوى الجدول',
    'sapSrc.peek.note':           'هذه بيانات عمل، وليست بيانات وصفية. تُقرأ عبر RFC_READ_TABLE القياسي، لذا يظل تصريح الجدول (S_TABU_DIS) لمستخدم RFC في ملف الاتصال ساري المفعول. وكل عملية قراءة تُسجَّل في سجل النشاط.',
    'sapSrc.peek.wide':           'هذا الجدول عريض: {total} بايت إجمالاً، أي أكثر من حد {limit} بايت الخاص بـ {fm}. اختر الحقول التي تريدها، أو اترك التحديد فارغاً ليُملأ تلقائياً حتى الحد.',
    'sapSrc.peek.fieldFilter':    'تصفية أسماء الحقول...',
    'sapSrc.peek.budget':         'تم تحديد {n} حقل · {w}/{limit} بايت',
    'sapSrc.peek.autoFit':        'بلا تحديد — تُملأ الحقول تلقائياً حتى الحد',
    'sapSrc.peek.clear':          'إلغاء التحديد',
    'sapSrc.peek.rows':           'عدد الصفوف',
    'sapSrc.peek.fetch':          'جلب العيّنة',
    'sapSrc.peek.fetching':       'جارٍ الجلب...',
    'sapSrc.peek.overBudget':     'تجاوز الحد: {w}/{limit} بايت. أزل بعض الحقول.',
    'sapSrc.peek.got':            'أُرجع {n} صفاً من {req} مطلوباً',
    'sapSrc.peek.exhausted':      'الجدول أقصر فعلاً — لم يُقتطع شيء.',
    'sapSrc.peek.empty':          'لم يُرجع هذا الجدول أي صف.',
    // ── ABAP Source Viewer · Class mode ──
    'sapSrc.mode.cls':            'الفئات',
    'sapSrc.clsPlaceholder':      'اسم الفئة، مثل CL_GUI_ALV_GRID أو ZCL_...',
    'sapSrc.clsInvalid':          'اسم غير صالح. حروف وأرقام و _ و / فقط (30 حرفاً كحد أقصى).',
    'sapSrc.clsLookup':           'إظهار',
    'sapSrc.clsLooking':          'جارٍ البحث...',
    'sapSrc.clsEmptyState':       'اكتب اسم فئة أعلاه ثم اضغط إظهار. يعمل مع جميع الفئات بما فيها فئات SAP القياسية؛ أما الشيفرة المصدرية فتقتصر على النطاق المخصص. ليست SE24 كاملة: لا تحرير ولا تنفيذ.',
    'sapSrc.clsSugLive':          'الاقتراحات تُقرأ مباشرة من SEOCLASSDF (النسخة النشطة) في SAP.',
    'sapSrc.cls.super':           'الفئة الأب',
    'sapSrc.cls.implements':      'تُنفِّذ',
    'sapSrc.cls.relOther':        'علاقات بقيمة RELTYPE غير معروفة',
    'sapSrc.cls.changed':         'عُدِّل بواسطة',
    'sapSrc.cls.tab.methods':     'الدوال',
    'sapSrc.cls.tab.attributes':  'السمات',
    'sapSrc.cls.tab.events':      'الأحداث',
    'sapSrc.cls.tab.other':       'أخرى (CMPTYPE {code})',
    'sapSrc.cls.otherNote':       'القيمة CMPTYPE {code} موجودة في هذا النظام لكن معناها غير مُثبَت، ولا يوجد view مُتحقَّق منه لها. ما يمكن عرضه هو أسماء المكوّنات فقط — لا نوعها ولا مستوى ظهورها ولا وصفها.',
    'sapSrc.cls.filter':          'تصفية الاسم أو الوصف...',
    'sapSrc.cls.importing':       'IMPORTING',
    'sapSrc.cls.exporting':       'EXPORTING',
    'sapSrc.cls.changing':        'CHANGING',
    'sapSrc.cls.returning':       'RETURNING',
    'sapSrc.cls.paramOther':      'أخرى (PARDECLTYP {code})',
    'sapSrc.cls.noParams':        'هذه الدالة بلا معاملات وبلا استثناءات.',
    'sapSrc.cls.findInSource':    'ابحث عن "METHOD ..." في الشيفرة',
    'sapSrc.cls.sourceNote':      'تُقرأ الشيفرة من class pool {pool} مع جميع الـ includes التابعة له. لا يوجد زر انتقال إلى دالة معيّنة: رقم الـ include لكل دالة لا يمكن استنتاجه من اسم الدالة في هذا النظام، وتخمينه سيعرض الدالة الخطأ. الزر في كل دالة يملأ خانة البحث بـ "METHOD <الاسم>" — وهذا بحث نصي، لا تعيين.',
    'sapCust.sync':          'جلب من SAP',
    'sapCust.syncing':       'جارٍ الجلب...',
    'sapCust.syncDone':      'اكتملت المزامنة: {enh} مكوّنًا، {raw} صفًا خامًا، {kb} مستندًا مفهرسًا للذكاء الاصطناعي.',
    'sapCust.limitTitle':    'حدود المعلومات:',
    'sapCust.limitBody':     'تعرض هذه الصفحة بيانات وصفية للتحسينات الكلاسيكية (CMOD/SMOD): مخارج المستخدم وشاشات الإضافة وملحقات الجداول. لم يتم فحص BAdI ومواضع التحسين — غيابها هنا لا يعني عدم وجودها. لم تُقرأ شفرة ABAP بعد؛ اضغط "قراءة شفرة ABAP" أو افتح ملف الإدراج في SE38/SE80.',
    'sapCust.limitBodySrc':  'نطاق هذه الصفحة: التحسينات الكلاسيكية (CMOD/SMOD) فقط — مخارج المستخدم وشاشات الإضافة وملحقات الجداول. لم يتم فحص BAdI ومواضع التحسين؛ غيابها هنا لا يعني عدم وجودها. شفرة ABAP متاحة لملفات الإدراج المقروءة وهي نسخة وليست عرضًا مباشرًا من SAP.',
    'sapCust.limitDetail':   'شفرة ABAP لهذا المكوّن غير مخزّنة هنا. افتح ملف الإدراج أعلاه عبر SE38/SE80 لفحص المنطق. لا تستنتج المنطق من اسم المخرج وحده.',
    'sapCust.stat.total':    'إجمالي المكوّنات',
    'sapCust.stat.active':   'مفعّل',
    'sapCust.stat.project':  'مشاريع CMOD',
    'sapCust.stat.module':   'وحدات SAP',
    'sapCust.stat.moduleSub':'{n} بدون وحدة',
    'sapCust.lastSync':      'آخر لقطة',
    'sapCust.cronRunConfirm': 'تشغيل تحديث تخصيص SAP الآن؟ يقوم بعشرات من استدعاءات SOAP إلى SAP (بما في ذلك الإنتاج) وقد يستغرق عدة دقائق. متابعة؟',
    'sapCust.kbPrune.title':     'تنظيف قاعدة المعرفة',
    'sapCust.kbPrune.check':     'فحص',
    'sapCust.kbPrune.hint':      'المزامنة تكتب وتحدّث المستندات فقط — ولا تحذف أبداً. المستندات التي لم يعد المفهرس ينتجها تبقى تُقدَّم للذكاء الاصطناعي حتى يتم تنظيفها. المهمة الأسبوعية تنفذ هذا في خطوتها الأخيرة.',
    'sapCust.kbPrune.keepTitle': 'الاتصالات التي يُحتفظ بمستنداتها:',
    'sapCust.kbPrune.emptyWarn': 'هذه الاتصالات لا تحتوي على أي صفوف تحسين، لذا ستُعتبر مستنداتها قديمة وستُحذف',
    'sapCust.kbPrune.execute':   'نظّف الآن',
    'sapCust.kbPrune.running':   'جارٍ التنظيف…',
    'sapCust.kbPrune.confirm':   'حذف المستندات القديمة من قاعدة المعرفة؟ مستندات الاتصالات المدرجة كمحتفظ بها تبقى آمنة؛ وما عداها سيُحذف ولا يمكن استعادته دون إعادة مزامنة. متابعة؟',
    'sapCust.kbPrune.done':      'تم حذف المستندات القديمة',
    'sapCust.kbPrune.clean':     'قاعدة المعرفة نظيفة بالفعل — لا توجد مستندات قديمة.',
    'sapCust.srcCopy':       'نسخ',
    'sapCust.srcCopied':     'تم النسخ',
    'sapCust.statusLabel':   'الحالة',
    'sapCust.docs':          'مستند',
    'sapCust.badiSync':      'جلب BAdI',
    'sapCust.badiSyncing':   'جارٍ جلب BAdI…',
    'sapCust.badiDone':      'BAdI والتحسينات: {total} كائن ({classic} BAdI كلاسيكي، {new} BAdI على موضع، {src} شفرة مصدر).',
    'sapCust.viewEnh':       'التحسينات الكلاسيكية',
    'sapCust.viewBadi':      'BAdI والتحسينات',
    'sapCust.viewConfig':    'طبقة الإعدادات (SPRO)',
    'sapCust.cfg.limitBody':  'تقرأ هذه الصفحة طلبات النقل الخاصة بالإعدادات من E070C/E070/E071/E071K في نظام التطوير فقط. ثلاثة أمور يسهل إساءة قراءتها: (١) في لوحة «الجداول الأكثر تكرارًا»، عدد صفوف المفاتيح متاح فقط لكائنات من نوع TABU — و٦٨٪ من صفوف الكائنات تُعرض بعبارة «غير مسجّل» لا بصفر، لأن اسم العرض لا يطابق E071K أبدًا؛ (٢) ومع ذلك فإن الأعداد الكاملة موجودة — انظر لوحة «الجداول الفعلية التي تغيّرت صفوفها»، التي تقرأ E071K مباشرة وتغطي كل صف مفاتيح؛ (٣) طلبات النقل المستثناة تبقى مسجّلة هنا، ولا يُترك سوى تحليل محتواها. الأرقام المسبوقة بعلامة ~ هي حدود دنيا لبُعد الكائنات، وليست مجاميع كلية.',
    'sapCust.cfg.sync':       'سحب الإعدادات من SAP',
    'sapCust.cfg.syncing':    'جارٍ سحب الإعدادات…',
    'sapCust.cfg.syncConfirm':'إعادة سحب طبقة الإعدادات من SAP؟ تقرأ هذه العملية E070C/E070/E07T/E071/E071K عبر RFC وتستغرق نحو ٤٠ ثانية. البيانات الحالية لهذا الاتصال ستُستبدل بالكامل — ولا يُحفظ أي لقطة سابقة. هل تريد المتابعة؟',
    'sapCust.cfg.syncDone':   'اكتملت مزامنة الإعدادات: {tr} طلب نقل، {obj} صف كائن.',
    'sapCust.cfg.unknown':    'غير مسجّل',
    'sapCust.cfg.unknownHint':'عدد صفوف المفاتيح غير معروف لهذا الكائن — وهذا لا يعني صفرًا. كائنات TABU وحدها يمكن مطابقتها مع E071K؛ أسماء العروض ومجموعات العروض لا تطابق أبدًا أسماء الجداول الفعلية.',
    'sapCust.cfg.stat.tr':          'طلبات النقل المسجّلة',
    'sapCust.cfg.stat.analyzed':    'محلّلة بالكامل',
    'sapCust.cfg.stat.analyzedSub': '{n} مستثناة (وتبقى مسجّلة)',
    'sapCust.cfg.stat.unreleased':  'غير مُصدَرة',
    'sapCust.cfg.stat.tables':      'جداول إعدادات فريدة',
    'sapCust.cfg.stat.objectRows':  'صفوف الكائنات',
    'sapCust.cfg.stat.keys':        'صفوف المفاتيح',
    'sapCust.cfg.stat.keysSub':     '{n} صفًا ({pct}٪) بلا عدد مسجّل — الرقم أعلاه حدّ أدنى',
    'sapCust.cfg.stat.heavy':       'موسومة بالثقيلة',
    'sapCust.cfg.stat.heavySub':    'مجرد وسم، وليس استثناءً',
    'sapCust.cfg.stat.notArrived':    'لم يصل إلى {sid}',
    'sapCust.cfg.stat.notArrivedSub': 'من {cand} طلب نقل مُحرَّر · {failed} فشل (rc≥8) · سجل الاستيراد {rows} صفوف',
    'sapCust.cfg.imp.done':           'تم الاستيراد',
    'sapCust.cfg.imp.failed':         'فشل الاستيراد (rc≥8)',
    'sapCust.cfg.imp.pending':        'لا يوجد سجل استيراد',
    'sapCust.cfg.imp.naHint':         'غير مُقيَّم: طلب النقل غير مُحرَّر أو مُستثنى. هذا يختلف عن «لم يصل».',
    'sapCust.cfg.imp.colHint':        'حالة الاستيراد إلى {sid} ({env}). المصدر TPALOG على النظام نفسه، مع أخذ الخطوة الأخيرة لا وقت الإدراج في قائمة الانتظار. لا يمكن ترتيب هذا العمود.',
    'sapCust.cfg.byModule':      'توزيع الوحدات',
    'sapCust.cfg.byModuleApp':     'مكوّن التطبيق (الحزمة)',
    'sapCust.cfg.byModuleAppHint': 'مستنتج من حزمة كل كائن عبر TADIR ← TDEVC ← PS_POSID، وليس من وصف طلب النقل. هذا هو مجال الأعمال الذي يخدمه الجدول؛ أما عمود «الوحدة» المجاور فهو نوع العمل وفق الوصف. قد يختلفان وكلاهما صحيح.',
    'sapCust.cfg.col.moduleApp':    'مكوّن التطبيق',
    'sapCust.cfg.col.mixed':        'مختلط',
    'sapCust.cfg.mixedHint':        'يلمس طلب النقل هذا {n} من مكوّنات التطبيق، ويُعرض الأكثر تكرارًا فقط. وجميعها: {list}',
    'sapCust.cfg.modAppUnknown':    '{n} من طلبات النقل بلا مكوّن تطبيق — كائناتها غير قابلة للوصول عبر سلسلة TADIR (مثلًا جميعها في حزمة المطوّرين ZD01). وهذا لا يعني أنها بلا وحدة.',
    'sapCust.cfg.modAppNoObj':  '{n} من طلبات النقل لا تحتوي على أي كائنات إعداد — وهي عادةً نقل تطوير (برامج ABAP أو حزم أو نسخ احتياطية). هذه الطلبات ليس لديها أصلًا مكوّن تطبيق يمكن استنتاجه، وليست فشلًا في القراءة.',
    'sapCust.cfg.modAppUnreach': '{n} من طلبات النقل لديها كائنات، لكن تلك الكائنات غير قابلة للوصول عبر سلسلة TADIR — مثلًا جميعها في حزمة المطوّرين ZD01. وهذا لا يعني أنها بلا وحدة.',
    'sapCust.cfg.byTrfunction':  'نوع النقل',
    'sapCust.cfg.excluded':      'الاستثناءات',
    'sapCust.cfg.excludedHint':  'طلبات النقل أدناه تبقى مخزّنة ويمكن عرضها عبر المرشّح — ولا يُتخطّى سوى تحليل محتواها.',
    'sapCust.cfg.topTables':     'الجداول الأكثر تكرارًا',
    'sapCust.cfg.topTablesHint':  'ما يُسجِّله طلب النقل (E071). لأنواع الكائنات غير TABU يحتوي هذا على اسم عرض أو مجموعة عروض، وعدد المفاتيح غير معروف لأن اسم العرض لا يطابق E071K أبدًا.',
    'sapCust.cfg.keyTables':      'الجداول الفعلية التي تغيّرت صفوفها',
    'sapCust.cfg.keyTablesHint':  'الجداول الفعلية خلف تلك العروض، مقروءة مباشرة من E071K. هذه الأعداد مقيسة دائمًا — لا توجد حالة «غير معروف» هنا. هذه القائمة تُكمّل القائمة المجاورة ولا تحل محلها.',
    'sapCust.cfg.keyTablesTotal': 'إجمالي {tables} جدول · {keys} صف مفاتيح (تعرض القائمة أدناه أعلى 25 فقط)',
    'sapCust.cfg.col.tabname':    'الجدول',
    'sapCust.cfg.splitSrc':      'التقسيم حسب المصدر',
    'sapCust.cfg.splitSrcHint':  'يجمّع الخادم حسب (module, module_src)، لذا قد تظهر الوحدة الواحدة في عدة صفوف. تدمجها هذه الصفحة حسب الوحدة افتراضيًا؛ فعّل الخيار لمعرفة أي مسار تصنيف أنتج كلًا منها.',
    'sapCust.cfg.noModule':      '(غير معروف)',
    'sapCust.cfg.total':         'الإجمالي',
    'sapCust.cfg.levelTr':       'حسب طلب النقل',
    'sapCust.cfg.levelObject':   'حسب الكائن',
    'sapCust.cfg.rowCount':      '{n} صفًا',
    'sapCust.cfg.filterNoteNone': 'طلبات النقل المستثناة مخفيّة — غيّر القائمة لعرض الكل',
    'sapCust.cfg.filterNoteOnly': 'عرض الطلبات المستثناة فقط',
    'sapCust.cfg.sortHint':       'انقر على عنوان العمود لترتيب البيانات كاملةً، وليس هذه الصفحة وحدها.',
    'sapCust.cfg.loading':       'جارٍ التحميل…',
    'sapCust.cfg.empty':         'لا توجد صفوف مطابقة للمرشّح الحالي.',
    'sapCust.cfg.reset':         'إعادة ضبط المرشّحات',
    'sapCust.cfg.searchTr':      'ابحث في رقم الطلب / الوصف…',
    'sapCust.cfg.excAll':        'كل الطلبات',
    'sapCust.cfg.excNone':       'دون المستثناة',
    'sapCust.cfg.excOnly':       'المستثناة فقط',
    'sapCust.cfg.heavyHint':     'موسوم بالثقيل: عدد المفاتيح تجاوز الحد. مجرد وسم — ولا يزال هذا الطلب محلّلًا.',
    'sapCust.cfg.col.module':     'الوحدة',
    'sapCust.cfg.col.moduleSrc':  'المصدر',
    'sapCust.cfg.col.trfunction': 'النوع',
    'sapCust.cfg.col.trstatus':   'الحالة',
    'sapCust.cfg.col.descr':      'الوصف',
    'sapCust.cfg.col.objCount':   'الكائنات',
    'sapCust.cfg.col.keys':       'المفاتيح',
    'sapCust.cfg.col.known':      'مسجّل',
    'sapCust.cfg.col.objname':    'الكائن',
    'sapCust.cfg.col.objtype':    'النوع',
    'sapCust.cfg.col.ddText':     'نص القاموس',
    'sapCust.cfg.col.releasedOn': 'الإصدار',
    'sapCust.cfg.rowClickHint':   'انقر لعرض الكائنات في طلب النقل هذا',
    'sapCust.cfg.secStats':       'الأرقام الرئيسية',
    'sapCust.cfg.secStatsHint':   '{tr} طلب نقل · {obj} صف كائن',
    'sapCust.cfg.secAggr':        'التجميعات',
    'sapCust.cfg.secAggrHint':    'الوحدة · مكوّن التطبيق · نوع النقل · الاستثناءات',
    'sapCust.cfg.secTables':      'الجداول الأكثر تكرارًا',
    'sapCust.cfg.secTablesHint':  'الكائنات المسجّلة · الجداول الفعلية المتغيّرة',
    'sapCust.cfg.notReleased':    'لم يتم الإصدار',
    'sapCust.cfg.ddNone':         'غير موجود في قاموس البيانات',
    'sapCust.cfg.ddNotSynced':    'لم تتم مزامنة الأوصاف بعد',
    'sapCust.cfg.col.analyzed':   'محلّلة',
    'sapCust.cfg.col.excluded':   'الاستثناء',
    'sapCust.cfg.exc.sap_delivered':        'من توريد SAP',
    'sapCust.cfg.exc.do_not_transport':     'غير منقولة',
    'sapCust.cfg.exc.client_export':        'تصدير عميل',
    'sapCust.cfg.exc.duplicate_piece_list': 'قائمة قطع مكرّرة',
    'sapCust.cfg.exc.foreign_landscape':    'بيئة أخرى',
    'sapCust.badi.installed':'مثبّت',
    'sapCust.badi.stat.total':      'إجمالي الكائنات',
    'sapCust.badi.stat.inactive':   'BAdI غير مفعّل',
    'sapCust.badi.stat.inactiveSub':'مسجّل، المنطق لا يُنفّذ',
    'sapCust.badi.stat.local':      'كائنات محلية ($TMP)',
    'sapCust.badi.stat.localSub':   'لا يمكن نقلها',
    'sapCust.badi.limit':    'تشمل هذه القائمة كائنات العميل فقط (Z*/Y*). منطق BAdI موجود في فئة التنفيذ ولم تُقرأ بعد — بخلاف مخارج المستخدم الكلاسيكية. حالة التفعيل متاحة لـ BAdI الكلاسيكي فقط؛ أما BAdI على المواضع وشفرة المصدر فمصدر بياناتها لا يحتفظ بعلم التفعيل.',
    'sapCust.badi.col.name':       'التنفيذ',
    'sapCust.badi.col.kind':       'النوع',
    'sapCust.badi.col.definition': 'التعريف / البرنامج',
    'sapCust.badi.col.descr':      'الوصف',
    'sapCust.badi.col.status':     'الحالة',
    'sapCust.badi.col.class':      'فئة التنفيذ',
    'sapCust.badi.col.package':    'الحزمة',
    'sapCust.badi.col.src':        'المصدر',
    'sapCust.badi.srcNever':       'لم تُقرأ بعد',
    'sapCust.badi.src.code':       'بها شفرة',
    'sapCust.badi.src.empty':      'بلا شفرة',
    'sapCust.badi.src.missing':    'غير موجودة',
    'sapCust.badi.src.denied':     'مرفوضة',
    'sapCust.badi.src.error':      'فشلت',
    'sapCust.badi.src.auth':       'رُفضت المصادقة',
    'sapCust.badiSrcSync':         'قراءة مصدر BAdI',
    'sapCust.badiSrcSyncing':      'جارٍ قراءة مصدر BAdI…',
    'sapCust.badiSrcDone':         'تمت قراءة مصدر BAdI: {read} فئة — {code} بها شفرة، {prog} برنامج، {lines} سطر.',
    'sapCust.badiSrc.pool':        'مجمّع الفئة',
    'sapCust.badiSrc.poolTag':     'هيكل الفئة',
    'sapCust.badiSrc.progs':       '{n} برنامج · {lines} سطر · {code} سطر شفرة',
    'sapCust.badiSrc.needSync':    'لم تُقرأ شفرة فئة التنفيذ من قبل. شغّل «قراءة مصدر BAdI».',
    'sapCust.searchPh':      'ابحث عن مكوّن أو تحسين أو ملف إدراج أو مشروع...',
    'sapCust.allTypes':      'كل الأنواع',
    'sapCust.allProjects':   'كل المشاريع',
    'sapCust.allModules':    'كل الوحدات',
    'sapCust.noModule':      'بدون وحدة',
    'sapCust.activeOnly':    'المفعّل فقط',
    'sapCust.active':        'مفعّل',
    'sapCust.inactive':      'غير مفعّل',
    'sapCust.empty':         'لا توجد بيانات بعد. اضغط "جلب من SAP" للبدء.',
    'sapCust.col.component':   'المكوّن',
    'sapCust.col.type':        'النوع',
    'sapCust.col.enhancement': 'التحسين',
    'sapCust.col.project':     'المشروع',
    'sapCust.col.module':      'الوحدة',
    'sapCust.col.include':     'ملف الإدراج',
    'sapCust.col.changed':     'غُيّر بواسطة',
    'sapCust.d.enhancement':   'تحسين SAP',
    'sapCust.d.module':        'وحدة SAP',
    'sapCust.d.appComponent':  'مكوّن التطبيق',
    'sapCust.d.project':       'مشروع CMOD',
    'sapCust.d.funcGroup':     'مجموعة الدوال',
    'sapCust.d.include':       'ملف إدراج التنفيذ',
    'sapCust.d.fgIncludes':    'ملفات إدراج أخرى في المجموعة',
    'sapCust.d.badi':          'تنفيذ BAdI',
    'sapCust.d.package':       'حزمة ملف الإدراج',
    'sapCust.d.projPackage':   'حزمة المشروع',
    'sapCust.d.createdBy':     'أنشأه',
    'sapCust.d.activatedBy':   'فعّله',
    'sapCust.d.changedBy':     'آخر تغيير',
    // ── SAP Customizing: حالة الشفرة والمصدر ──
    'sapCust.col.srcState':   'الشفرة',
    'sapCust.srcSync':        'قراءة مصدر ABAP',
    'sapCust.srcSyncing':     'جارٍ قراءة المصدر...',
    'sapCust.srcDone':        'تمت قراءة المصدر: {read} ملف إدراج — {code} بها شفرة، {empty} فارغة.',
    'sapCust.srcAborted':     'توقفت قراءة المصدر قبل الاكتمال. النتيجة غير كاملة.',
    'sapCust.srcNotConfigured': 'مسار خدمة ZRFC_READ_SOURCE غير مُعد في إعدادات SAP',
    'sapCust.srcNotRead':     'لم تُقرأ بعد',
    'sapCust.srcTitle':       'مصدر ABAP',
    'sapCust.srcReadAt':      'قُرئ',
    'sapCust.srcNone':        'لا توجد أسطر مصدر مخزّنة.',
    'sapCust.srcMissing':     'ملف الإدراج غير موجود في هذا النظام.',
    'sapCust.srcDenied':      'لا يمكن قراءة المصدر (رُفض الوصول من SAP).',
    'sapCust.srcNeedSync':    'لم يُقرأ من قبل. اضغط "قراءة مصدر ABAP" أعلاه.',
    'sapCust.srcTrunc':       'تم اقتطاع {n} سطرًا يتجاوز 255 حرفًا.',
    'sapCust.linesShort':     'أسطر شفرة',
    'sapCust.commentOnly':    'سطرًا، كلها تعليقات',
    'sapCust.allStates':      'كل حالات الشفرة',
    'sapCust.stat.activeEmpty':    'مفعّل لكن فارغ',
    'sapCust.stat.activeEmptySub': 'مسجّل كمفعّل، بلا شفرة',
    'sapCust.emptyWarnTitle': 'مفعّل لكنه لا يحتوي شفرة.',
    'sapCust.emptyWarnBody':  'مشروع CMOD مفعّل، لكن ملف إدراج التنفيذ لا يحتوي أي سطر شفرة — تعليقات أو أسطر فارغة فقط. لا يوجد منطق مخصّص يُنفَّذ هنا. يُعرض المحتوى أدناه لترى ما تبقّى؛ كتل التعليقات الطويلة تعني عادةً أن شفرة كانت موجودة ثم تم تعطيلها.',
    'sapCust.limitSrcLive':   'المصدر أعلاه نسخة من آخر قراءة وقد يكون متأخرًا عن النسخة الحالية في SAP. للتأكد، افتح ملف الإدراج في SE38/SE80.',
    // ── SAP Customizing: سجل النقل ──
    'sapCust.col.transport':  'النقل',
    'sapCust.trSync':         'قراءة سجل النقل',
    'sapCust.trSyncing':      'جارٍ قراءة النقل...',
    'sapCust.trDone':         'تمت قراءة النقل: {ver} صف إصدار، {tr} طلب نقل، {imp} طلبًا له سجل استيراد.',
    'sapCust.trTitle':        'سجل النقل',
    'sapCust.trNone':         'لم يُقرأ بعد',
    'sapCust.trNeedSync':     'لا توجد بيانات. اضغط "قراءة سجل النقل" أعلاه.',
    'sapCust.trChanged':      'غُيّر',
    'sapCust.trRelease':      'إصدار',
    'sapCust.trImport':       'استيراد',
    'sapCust.trNoImport':     'لا يوجد أثر استيراد في أي نظام بعد.',
    'sapCust.trAll':          'في كل الأنظمة',
    'sapCust.trMissing':      'ليس في {sids}',
    'sapCust.trGapTitle':     'آخر تغيير لم يصل بعد.',
    'sapCust.trGapBody':      'طلب النقل {tr} ليس له سجل استيراد إلى {sids}. إذا كان الكائن موجودًا هناك، فالأرجح أن نسخة قديمة هي التي تعمل — وهذا لا يُظهر أي خطأ. تحقّق من قائمة الاستيراد في STMS.',
    'page.default.title':      'لوحة التحكم',

    // ── Header: lainnya ──
    'header.home':            'الرئيسية',
    'header.ai':              'AI',
    'header.aiAssistant':     'مساعد AI',
    'header.dashboardAccess': 'صلاحية الوصول إلى اللوحات',
    'header.logout':          'تسجيل الخروج من النظام',
    'pwd.menu':       'تغيير كلمة المرور',
    'pwd.title':      'تغيير كلمة المرور',
    'pwd.current':    'كلمة المرور الحالية',
    'pwd.new':        'كلمة المرور الجديدة',
    'pwd.confirm':    'تأكيد كلمة المرور الجديدة',
    'pwd.submit':     'حفظ',
    'pwd.cancel':     'إلغاء',
    'pwd.success':    'تم تغيير كلمة المرور بنجاح.',
    'pwd.errRequired':  'كلمة المرور الحالية والجديدة مطلوبتان.',
    'pwd.errMinLength': 'يجب ألّا تقل كلمة المرور الجديدة عن 6 أحرف.',
    'pwd.errMismatch':  'تأكيد كلمة المرور غير متطابق.',
    'pwd.errSameAsOld': 'يجب أن تختلف كلمة المرور الجديدة عن القديمة.',
    'pwd.errGeneric':   'تعذّر تغيير كلمة المرور.',
    'role.admin':             'مسؤول النظام',
    'role.sapOperator':       'مشغّل SAP',
    'role.awsOperator':       'مشغّل AWS',

    // ── Sidebar: brand & grup ──
    'sidebar.brand':          'Primary Dashboard',
    'sidebar.brandSub':       'مراقبة موحّدة',
    'sidebar.group.aws':      'AWS',
    'sidebar.group.sap':      'SAP',
    'sidebar.group.infra':    'INFRA',
    'sidebar.group.docs':     'التوثيق',
    'sidebar.group.admin':    'الإدارة',
    'sidebar.group.hr':       'الموارد البشرية',
    'sidebar.group.tools':    'الأدوات',
    'sidebar.group.ai':          'الذكاء الاصطناعي',
    'sidebar.group.access':      'الوصول والمستخدمون',
    'sidebar.group.system':      'النظام',
    'sidebar.group.integration': 'التكاملات',
    'sidebar.m365':           'تراخيص Microsoft 365',
    'sidebar.m365.sub':       'ملخّص تراخيص Microsoft 365',
    'sidebar.sdp':            'SDP Cloud',
    'sidebar.sdp.sub':        'تذاكر وأصول ManageEngine',

    // ── Sidebar: menu label + sublabel ──
    'sidebar.overview':                 'نظرة عامة',
    'sidebar.awsBilling':               'AWS Billing',
    'sidebar.awsBilling.sub':           'التكلفة والاستخدام',
    'sidebar.awsCost':                  'AWS Cost Explorer',
    'sidebar.awsCost.sub':              'تحليل التكاليف',
    'sidebar.awsCostBrief':             'AWS Cost Brief',
    'sidebar.awsCostBrief.sub':         'ملخص التكاليف الشهري',
    'sidebar.awsInventory':             'AWS Inventory',
    'sidebar.awsInventory.sub':         'توثيق الموارد',
    'sidebar.awsCloudTrail':            'AWS CloudTrail',
    'sidebar.awsCloudTrail.sub':        'سجل النشاط والتدقيق',
    'sidebar.solman':                   'SAP Solman',
    'sidebar.solman.sub':               'التذاكر والحوادث',
    'sidebar.sapUsage':                 'SAP User Usage',
    'sidebar.sapUsage.sub':             'الاستخدام',
    'sidebar.employeeOvertime':         'العمل الإضافي للموظفين',
    'sidebar.employeeOvertime.sub':     'بيانات العمل الإضافي',
    'sidebar.logs':                     'سجل النشاط',
    'sidebar.logs.sub':                 'سجل التدقيق',
    'sidebar.aiHistory':                'سجل محادثات AI',
    'sidebar.aiHistory.sub':            'محادثات AI',
    'sidebar.aiDataSources':            'مصادر بيانات AI',
    'sidebar.aiDataSources.sub':        'إدارة بيانات AI',
    'sidebar.aiConfig':                 'إعدادات AI',
    'sidebar.aiConfig.sub':             'المزوّد والنموذج ومفتاح API',
    'sidebar.aiWorkspace':              'مساحة عمل AI',
    'sidebar.aiWorkspace.sub':          'محادثة AI بملء الصفحة',
    'sidebar.aiCoding':                 'برمجة AI',
    'sidebar.aiCoding.sub':             'مساعد برمجة + استخدام الأدوات',
    // ── AI Coding · محدد جذر المشروع ─────────────────────────────────────
    'aiCoding.sbx.open':            'صندوق الكود (.zip)',
    'aiCoding.sbx.title':           'صندوق الكود',
    'aiCoding.sbx.upload':          'رفع ملف .zip',
    'aiCoding.sbx.close':           'إغلاق',
    'aiCoding.sbx.delete':          'حذف هذا الصندوق',
    'aiCoding.sbx.empty':           'لا يوجد صندوق بعد. ارفع ملف .zip يحتوي الكود الذي تريد فحصه.',
    'aiCoding.sbx.done':            'الصندوق "{label}" جاهز — {files} ملفاً. اختره من Project root لبدء الفحص.',
    'aiCoding.sbx.truncated':       'تم اقتطاع جزء منه لتجاوزه الحد',
    'aiCoding.sbx.skipped':         'تم تخطّي:',
    'aiCoding.sbx.limits':          'تُستخرج ملفات المصدر فقط؛ ويُتخطّى node_modules و.git والملفات الثنائية والملفات التي قد تحتوي بيانات اعتماد. الحد {mb} ميغابايت / {files} ملف. تُحذف الصناديق تلقائياً بعد {days} أيام.',
    'aiCoding.sbx.noPython':        'الاستخراج غير مُفعّل: لم يُضبط AI_SANDBOX_PYTHON / PDF2MD_PYTHON في ecosystem.config.js.',
    'aiCoding.sbx.docDone':         'تم حفظ المستند "{name}". اذكر اسمه في طلبك، مثل: "اقرأ {name} ثم نفّذ ...".',
    'aiCoding.sbx.docDelete':       'حذف هذا المستند',
    'aiCoding.sbx.docHint':         'مستندات التعليمات (.md / .txt، بحد أقصى {kb} كيلوبايت) تُحفظ مباشرة في {root} ويُشار إليها بالاسم فقط. لا تُحذف تلقائيًا.',
    'aiCoding.dft.open':            'مسودات الذكاء الاصطناعي',
    'aiCoding.dft.title':           'مسودات الذكاء الاصطناعي',
    'aiCoding.dft.refresh':         'إعادة التحميل',
    'aiCoding.dft.download':        'تنزيل هذا الملف',
    'aiCoding.dft.delete':          'حذف هذه المسودة',
    'aiCoding.dft.empty':           'لا توجد مسودات بعد. اطلب من الذكاء الاصطناعي إنشاء ملف، مثل: "أنشئ الملف x.py ... ثم احفظه".',
    'aiCoding.dft.missing':         'مجلد المسودات غير موجود بعد. هذا طبيعي إذا لم يُستخدم write_file من قبل، لكنه قد يعني أيضًا أن المسار في لوحة التحكم يختلف عن المسار الذي يكتب إليه ai-service.',
    'aiCoding.dft.blocked':         'لا يمكن تنزيل هذا الملف (قد يحتوي على بيانات اعتماد). لا يزال بإمكانك حذفه.',
    'aiCoding.projectRoot':             'جذر المشروع',
    'aiCoding.rootHint':                'read_file و grep_code مقيّدان بهذا الجذر',
    'aiCoding.rootUnavailable':         'تعذّر تحميل قائمة جذور المشروع',
    // AI Settings (Konfigurasi AI)
    'ai.set.title':            'إعدادات AI',
    'ai.set.subtitle':         'المزوّد ومفتاح API لكل مستخدم · التوجيه لكل لوحة',
    'ai.set.provider':         'مزوّد AI',
    'ai.set.apiKey':           'مفتاح API',
    'ai.set.noKey':            'بدون مفتاح',
    'ai.set.baseUrl':          'Base URL / Endpoint',
    'ai.set.baseUrlHintPre':   'بدون',
    'ai.set.baseUrlHintPost':  '— يُضاف تلقائيًا.',
    'ai.set.fetching':         'جارٍ الجلب...',
    'ai.set.fetchModels':      'جلب النماذج',
    'ai.set.modelsFound':      'تم العثور على {n} نموذج',
    'ai.set.noModelsFound':    'لم يتم العثور على أي نموذج.',
    'ai.set.fetchModelFailed': 'تعذّر جلب النماذج.',
    'ai.set.bedrockRegionHint':'المنطقة التي فُعِّل فيها نموذج Bedrock (مثل us-east-1، ap-southeast-1).',
    'ai.set.bedrockCredHint':  'بيانات الاعتماد اختيارية — اتركها فارغة لاستخدام IAM role / بيئة الخادم (الطريقة الأكثر أمانًا، كما في تكامل Cost Explorer). املأها فقط إذا رغبت في بيانات اعتماد مخصّصة.',
    'ai.set.optional':         'AKIA... (اختياري)',
    'ai.set.hide':             'إخفاء',
    'ai.set.show':             'إظهار',
    'ai.set.params':           'معاملات التوليد',
    'ai.set.resetDefault':     'إعادة التعيين الافتراضي',
    'ai.set.preset':           'إعداد مسبق',
    'ai.set.presetPrecise':    'دقيق',
    'ai.set.presetPreciseDesc':'دقيق ومتّسق',
    'ai.set.presetBalanced':   'متوازن',
    'ai.set.presetBalancedDesc':'الإعداد العام الافتراضي',
    'ai.set.presetCreative':   'إبداعي',
    'ai.set.presetCreativeDesc':'متنوّع',
    'ai.set.tempLow':          '0 · دقيق/متّسق',
    'ai.set.tempHigh':         '2 · إبداعي/متنوّع',
    'ai.set.tempHint':         'للأسئلة والأجوبة الدقيقة على البيانات، استخدم 0.1–0.2. القيم المرتفعة تجعل الإجابات أكثر تنوّعًا وعرضة للتلفيق.',
    'ai.set.topPHint':         'اترك القيمة 1.0 عندما تكون درجة الحرارة منخفضة. يُفضّل ضبط أحدهما فقط (temperature أو Top P) وليس كليهما معًا.',
    'ai.set.maxTokens':        'Max Tokens (طول الإجابة)',
    'ai.set.maxTokensHint':    'النطاق 100–8000. الافتراضي 2000.',
    'ai.set.chart':            'الرسم البياني',
    'ai.set.chartAuto':        'تلقائي — يُنشئ AI رسمًا بيانيًا عند الحاجة',
    'ai.set.chartManual':      'عند الطلب فقط — يُنشأ الرسم البياني إذا طلبه المستخدم',
    'ai.set.chartHint':        '"عند الطلب فقط": لا يُنشئ AI رسمًا بيانيًا إلا إذا طلبته (مثل "أنشئ رسمًا بيانيًا").',
    'ai.set.hideAccuracy':     'إخفاء درجة الدقة',
    'ai.set.hideAccuracyHint': 'إخفاء شارة "Accuracy %" على الإجابات وملخّص الجلسة. هذه الدرجة تقدير تقريبي استرشادي فقط وليست مقياسًا للصحّة.',
    'ai.set.followUp':         'المتابعة (رسم بياني/تحليل من النتيجة السابقة)',
    'ai.set.followUpOn':       'مُفعّل',
    'ai.set.followUpOff':      'مُعطّل',
    'ai.set.followUpHint':     'عند التفعيل، تستخدم الطلبات مثل "أنشئ رسمًا بيانيًا من ذلك" أو "تحليل" نتيجة آخر استعلام دون إعادة الاستعلام.',
    'ai.edit.resend':          'إعادة الإرسال',
    'ai.set.advanced':         'متقدّم (العقوبات والبذرة)',
    'ai.set.penaltyHint':      'للأسئلة والأجوبة على البيانات، اترك كليهما عند 0 — قد تمنع العقوبات تكرار الأرقام/التسميات المطلوبة فعلًا.',
    'ai.set.seed':             'Seed (قابلية إعادة الإنتاج)',
    'ai.set.seedPlaceholder':  'فارغ = عشوائي في كل مرة',
    'ai.set.seedHint':         'أدخل رقمًا ثابتًا (مثل 42) + درجة حرارة منخفضة → إجابات أكثر قابلية لإعادة الإنتاج. غير مدعوم لدى جميع المزوّدين.',
    'ai.set.configured':       'مُهيّأ',
    'ai.set.autoRotateLong':   'تدوير تلقائي',
    'ai.set.notConfigured':    'لم تتم التهيئة بعد',
    'ai.set.copyFirstKey':     'نسخ المفتاح الأول',
    'ai.set.keysPlaceholder':  '(افصل بفاصلة أو سطر جديد للتدوير التلقائي)',
    'ai.set.keyInfoSingle':    'يُحفظ في قاعدة البيانات لكل مستخدم. أدخل عدة مفاتيح مفصولة بفاصلة/Enter للتدوير التلقائي عند بلوغ حد المعدّل.',
    'ai.set.keyInfoMulti':     '{n} مفتاح نشط — تدوير تلقائي إلى المفتاح التالي عند بلوغ أي مفتاح حدّ المعدّل أو انتهاء صلاحيته.',
    'ai.set.promptGeneral':    '(عام — افتح داخل اللوحة للحصول على توجيه مخصّص)',
    'ai.set.default':          'الافتراضي',
    'ai.set.reset':            'إعادة تعيين',
    'ai.set.promptPlaceholder':'أدخل تعليمات خاصة لمساعد AI في هذه اللوحة...',
    'ai.set.promptScope':      'هذا التوجيه خاص باللوحة {dash} والحساب {user}.',
    'ai.set.add':              'إضافة',
    'ai.set.resetDefaultShort':'إعادة التعيين (استخدام الافتراضي)',
    'ai.set.quickPromptHint':  'فارغ = استخدام التوجيه الافتراضي. يُحفظ لكل لوحة + مستخدم.',
    'ai.set.clearAll':         'تفريغ',
    'ai.set.quickPromptCleared':'تم التفريغ — لا تظهر أي مطالبات سريعة في المحادثة.',
    'ai.set.cancel':           'إلغاء',
    'ai.set.saving':           'جارٍ الحفظ...',
    'ai.set.saved':            'تم الحفظ!',
    'ai.set.save':             'حفظ الإعدادات',
    'ai.set.savedLocal':       'حُفظ محليًا. الخادم:',
    'sidebar.users':                    'إدارة المستخدمين',
    'sidebar.users.sub':                'إدارة المستخدمين',
    'sidebar.roles':                    'إدارة الأدوار',
    'sidebar.roles.sub':                'إدارة الأدوار',
    'sidebar.monthlyReport':            'التقرير الشهري',
    'sidebar.monthlyReport.sub':        'تقرير شهري تلقائي',
    'mreport.title':                    'التقرير الشهري',
    'mreport.subtitle':                 'جدولة التقرير الشهري وإعداده وإرساله',
    'mreport.loading':              'جارٍ تحميل الإعدادات…',
    'mreport.switches.title':       'مفتاحان منفصلان.',
    'mreport.switches.body':        'مربّع "Enable" في الأعلى يحدّد ما إذا كان الجدول الزمني يعمل. مربّع "تمكين الإرسال التلقائي" في الأسفل يحدّد ما إذا كان التقرير يُرسل فعلاً عند تنفيذ cron. يجب تشغيل الاثنين معاً للإرسال التلقائي. زرّا "Run Now" و"إرسال الآن" يستخدمان تشغيلاً يدوياً، لذا يعملان حتى لو كان المفتاح الثاني مُعطّلاً.',
    'mreport.config':               'الإعدادات',
    'mreport.enableAuto':           'تمكين الإرسال التلقائي (عند تنفيذ cron)',
    'mreport.resendEvery':          'Resend on every scheduled run (skip the once-per-period check)',
    'mreport.resendEveryHint':      'When on, every cron run sends the last closed period again even if it was already sent. When off, each period is sent only once.',
    'mreport.to':                   'المستلمون (To)',
    'mreport.to.ph':                'name@company.com, other@company.com',
    'mreport.to.hint':              'يمكن إدخال أكثر من عنوان، مفصولة بفواصل. الفراغ = استخدام متغيّر البيئة MONTHLY_REPORT_TO. إعدادات SMTP (host/auth/from) تُؤخذ من تبويب ASE Alert.',
    'mreport.cc':                   'نسخة CC (اختياري)',
    'mreport.cc.ph':                'cc1@company.com, cc2@company.com',
    'mreport.bcc':                  'نسخة مخفية BCC (اختياري)',
    'mreport.bcc.ph':               'bcc@company.com',
    'mreport.ccbcc.hint':           'حقلا CC/BCC يخصّان ملف التقرير هذا فقط. الفراغ = استخدام متغيّرات البيئة MONTHLY_REPORT_CC / MONTHLY_REPORT_BCC إن كانت مضبوطة. عناوين BCC غير مرئية لبقية المستلمين.',
    'mreport.senderName':           'اسم المُرسِل (الاسم الظاهر)',
    'mreport.senderName.hint':      'الاسم الذي يظهر للمستلمين في خانة From، مثال "PIL Group IT — SAP". الفراغ = Primary Dashboard. عنوان المُرسِل نفسه يُؤخذ من smtp_from في تبويب ASE Alert ولا يُضبط لكل ملف تقرير على حدة.',
    'mreport.modules':              'الوحدات المُدرجة',
    'mreport.body':                 'إدراج محتوى التقرير في متن البريد',
    'mreport.body.hint':            'أطفئ هذا الخيار لوضع الرسالة التمهيدية: يحمل البريد العبارة التمهيدية والعنوان والملف المرفق .xlsx فقط — بلا جداول ولا رسوم ولا ملخّص ذكاء اصطناعي. تُجمع البيانات كاملة ويبقى المرفق كما هو؛ ما يُتخطّى هو عرضها في متن البريد فحسب.',
    'mreport.body.warn':            'متن البريد مُطفأ. لن يرى المستلمون سوى المقدمة والعنوان والمرفق. لا تُرسم الرسوم البيانية، ويُتخطّى نداء الذكاء الاصطناعي بالكامل (بلا تكلفة رموز لهذا الملف).',
    'mreport.body.warnNoIntro':     'المقدمة ما زالت فارغة أيضاً — سيصل البريد بلا نص تقريباً. املأ العبارة التمهيدية أدناه.',
    'mreport.layout.bodyOff':       'مع إطفاء متن البريد، لا يؤثر هذان الإعدادان إلا على المقدمة والعنوان.',
    'mreport.layout':               'مظهر البريد',
    'mreport.layout.scale':         'حجم النص',
    'mreport.layout.scale.compact': 'مضغوط — الحجم السابق (جداول 12px)',
    'mreport.layout.scale.normal':  'عادي — موصى به (جداول 13px)',
    'mreport.layout.scale.large':   'كبير — للإدارة (جداول 14px)',
    'mreport.layout.width':         'عرض المحتوى',
    'mreport.layout.hint':          'برامج البريد لا تملك تكبيراً يُعتمد عليه (Outlook على سطح المكتب يعرض عبر محرك Word)، لذا يجب اختيار الحجم من جهة المُرسِل وهو يسري على جميع مستلمي هذا الملف. 900px هو الافتراضي: الجدول ذو العمودين أو الثلاثة الممدود على 1100px يترك أرقامه بعيدة عن عناوينها. الجداول الضيقة صار عرضها محدوداً بحسب عدد الأعمدة، لذا لن تتحاذى حافتها اليمنى مع الجداول العريضة — وهذا مقصود.',
    'mreport.intro':                'عبارة تمهيدية (فوق العنوان)',
    'mreport.intro.ph':             'حضرة السادة،\n\nنرفق تقرير {{profile}} لفترة {{period}}. التفاصيل الكاملة في الملف المرفق.',
    'mreport.intro.hint':           'تظهر في متن البريد قبل العنوان، كرسالة تمهيدية — وهي غير العنوان الفرعي الذي يظهر تحت العنوان. الفراغ = لا يوجد بلوك تمهيدي إطلاقاً. ضغطة Enter واحدة تبدأ سطراً جديداً متقارباً؛ والسطر الفارغ يبدأ فقرة جديدة. التنسيق: **عريض**، *مائل*، __تسطير__، `كود` — استخدم الأزرار أعلاه بدلاً من كتابة الرموز. الرموز المتاحة: {{period}}، {{title}}، {{profile}}، {{generated}} — استخدمها بدلاً من كتابة اسم الشهر، لأن التقرير يُرسل تلقائياً كل شهر. لا يُدعم HTML وسيظهر كنص عادي. الحد الأقصى 4000 حرف.',
    'mreport.intro.spacing':          'تباعد الأسطر',
    'mreport.intro.spacing.tight':    'متقارب',
    'mreport.intro.spacing.normal':   'عادي',
    'mreport.intro.spacing.relaxed':  'متباعد',
    'mreport.intro.fmt.bold':         'عريض — **نص**',
    'mreport.intro.fmt.italic':       'مائل — *نص*',
    'mreport.intro.fmt.underline':    'تسطير — __نص__',
    'mreport.intro.fmt.code':          'كود مضمّن — `نص`، يُستخدم لأسماء الأعمدة/الجداول/الملفات حتى لا تُقرأ كعريض أو مائل',
    'mreport.intro.fmt.numbered':     'قائمة مرقّمة — ترقيم كل سطر محدّد',
    'mreport.intro.fmt.bullet':       'قائمة نقطية — وضع • أمام كل سطر محدّد',
    'mreport.intro.fmt.clear':        'إزالة التنسيق من التحديد (أو من النص كله إن لم يكن هناك تحديد)',
    'mreport.intro.preview':          'معاينة',
    'mreport.intro.previewEmpty':     'المقدمة ما زالت فارغة.',
    'mreport.intro.previewNote':      'عرض تقريبي. حجم الخط الفعلي يتبع إعداد حجم النص لهذا الملف؛ للنتيجة الدقيقة استخدم زر المعاينة أدناه.',
    'mreport.header':               'عنوان التقرير وترويسته',
    'mreport.header.titlePh':       'IT Operations Monthly Report',
    'mreport.header.subtitlePh':    'عنوان فرعي (اختياري)',
    'mreport.header.preparedPh':    'أُعِدّ بواسطة (مثال: Taufan / IT)',
    'mreport.header.hint':          'العنوان يُستخدم أيضاً كموضوع البريد الإلكتروني وكعنوان ورقة الغلاف.',
    'mreport.ai.enable':            'إدراج ملخّص تنفيذي مُولَّد بالذكاء الاصطناعي',
    'mreport.ai.providerPh':        'المزوّد (الفراغ = الإعداد العام)',
    'mreport.ai.modelPh':           'الموديل (الفراغ = افتراضي المزوّد)',
    'mreport.ai.warn':              'الذكاء الاصطناعي لا يحسب أي رقم — كل الأرقام تأتي من قاعدة البيانات، والموديل يصوغ النص فقط. ما قد يختلقه هو السبب، لذا يُوسم هذا القسم دائماً بعبارة "generated by AI" ويحتاج مراجعتك قبل إعادة إرساله. إذا فشل نداء الذكاء الاصطناعي، يُحذف القسم ويُرسل التقرير كما هو.',
    'mreport.save':                 'حفظ الإعدادات',
    'mreport.saving':               'جارٍ الحفظ…',
    'mreport.saved':                'تم حفظ الإعدادات.',
    'mreport.lastSent':             'آخر إرسال',
    'mreport.status':               'الحالة',
    'mreport.test':                 'اختبار يدوي',
    'mreport.year':                 'السنة (اختياري)',
    'mreport.month':                'الشهر (اختياري)',
    'mreport.preview':              'معاينة (بدون إرسال)',
    'mreport.preview.busy':         'جارٍ الإنشاء…',
    'mreport.xlsx':                 'تنزيل المرفق .xlsx',
    'mreport.xlsx.busy':            'جارٍ التحضير…',
    'mreport.xlsx.done':            'تم تنزيل المرفق: {name}',
    'mreport.send':                 'إرسال الآن',
    'mreport.send.busy':            'جارٍ الإرسال…',
    'mreport.test.hint':            'اترك السنة/الشهر فارغين لاستخدام آخر شهر مُغلق. لا تختر شهراً لا يزال جارياً — فمقارنته الشهرية مُضلِّلة دائماً.',
    'mreport.sendConfirm':          'إرسال التقرير الشهري الآن إلى {to}؟ سيتم إرسال بريد إلكتروني حقيقي.',
    'mreport.runConfirm':           'تشغيل التقرير الشهري {type} الآن؟ سيتم إرسال بريد إلكتروني حقيقي.',
    'mreport.empty':                '(فارغ)',
    'mreport.sentOk':               'تم الإرسال: {period} إلى {to} (المرفق {size}).',
    'mreport.notSent':              'لم يُرسل: {reason}',
    'mreport.skipped':              'تم التخطي: {reason}',
    'mreport.previewCard':          'معاينة',
    'mreport.period':               'الفترة',
    'mreport.subject':              'الموضوع',
    'mreport.attachment':           'المرفق',
    'mreport.profile':              'الملف',
    'mreport.cronJob':              'مهمة cron',
    'mreport.lastSentShort':        'آخر إرسال',
    'mreport.schedOn':              'الجدول مُفعّل',
    'mreport.schedOff':             'الجدول مُعطّل',
        'mreport.mod.sapUsage':         'استخدام مستخدمي SAP',
    'mreport.tab.sap.hint':         'Solman + استخدام مستخدمي SAP + التراخيص',
    'mreport.tab.sapusage.hint': 'SAP User Usage report per trimester, month or year — download .xlsx',
    'mreport.mod.sapLicenses':      'تراخيص SAP (لقطة)',
    'mreport.sapLic.conn':          'اتصال SAP لقسم التراخيص (المشهد / SID / العميل)',
    'mreport.sapLic.hint':          'مأخوذة من لقطة صفحة صيانة مستخدمي SAP لهذا الاتصال، وليست بيانات شهرية. لا يُعاد تعبئة ذلك الجدول إلا عند الضغط على "Load Users" (لا توجد مهمة cron)، لذلك يعرض البريد تاريخ اللقطة وينبّه إذا تجاوز عمرها 30 يوماً. المستخدمون النشطون فقط؛ ويُستثنى الترخيص 91 (اختبار/تقني) والحسابات المنتهية. يحتوي البريد على الإجمالي فقط، والتفصيل في ورقة SAP_Licenses بالمرفق.',
    'mreport.charts':               'تضمين المخطّطات في البريد',
    'mreport.charts.hint':          'يُختار نوع المخطّط تلقائياً بحسب شكل البيانات: دائري/حلقي للتركيب، أعمدة أفقية للترتيب والمقارنة، أعمدة رأسية للسلاسل الزمنية. تظهر المخطّطات دائماً بجانب الجداول لا بدلاً منها. الصور تخصّ الدائري/الحلقي فقط، والبقية HTML عادي. المرفق .xlsx لا يتأثر.',
    'mreport.tab.infra.hint':       'M365 + SDP Cloud',
    'mreport.tab.aws.hint':         'تكاليف AWS فقط',
    'mreport.tab.s3.hint':          'تخزين S3 ووسائط نسخ SAP الاحتياطي',
    'mreport.tab.exec.hint':        'كل الوحدات مجتمعة — للإدارة',
    'sidebar.tableMaintenance':         'صيانة الجداول',
    'sidebar.tableMaintenance.sub':     'إدارة قاعدة البيانات',
    'sidebar.telegram':                 'بوت Telegram',
    'sidebar.telegram.sub':             'الإشعارات ومحادثة AI',
    'sidebar.telegramLog':              'سجل محادثات Telegram',
    'sidebar.telegramLog.sub':          'سجل محادثات البوت',
    'sidebar.sessions':                 'سجل الجلسات',
    'sidebar.sessions.sub':             'الجلسات النشطة والإخراج القسري',

    // ── Sidebar: kontrol bawah ──
    'sidebar.collapse':         'طيّ',
    'sidebar.expand':           'توسيع الشريط الجانبي',
    'sidebar.autoHide':         'إخفاء تلقائي',
    'sidebar.autoHide.on':      'مُفعّل',
    'sidebar.autoHide.off':     'مُعطّل',

    // ── Overview ──
    'overview.systemOnline':   'النظام متّصل',
    'overview.systemOffline':  'النظام غير متّصل',
    'overview.someUnavailable':'بعض الأنظمة غير متاحة',
    'overview.welcome':        'مرحبًا، {name}!',
    'overview.accessInfo':     'لديك صلاحية الوصول إلى {count} لوحة. اختر لوحة أدناه للبدء.',
    'overview.accessInfoBold': '{count} لوحة',
    'overview.allNormal':      'جميع الأنظمة طبيعية',
    'theme.label':             'سمة الألوان',
    'theme.blue':              'أزرق',
    'theme.indigo':            'نيلي',
    'theme.teal':              'أزرق مخضر',
    'theme.emerald':           'أخضر',
    'theme.violet':            'بنفسجي',
    'theme.amber':             'كهرماني',
    'theme.rose':              'وردي',
    'theme.black':             'أسود',
    'fontScale.label':         'حجم الخط',
    'fontScale.sm':            'صغير',
    'fontScale.md':            'عادي',
    'fontScale.lg':            'كبير',
    'overview.statDashboards': 'لوحة',
    'overview.statCategories': 'فئة',
    'overview.realtime':       'بيانات لحظية',
    'overview.available':      'اللوحات المتاحة',
    'overview.clickHint':      'انقر على البطاقة أدناه لفتح اللوحة المناسبة.',
    'overview.openDashboard':  'فتح اللوحة',
    'overview.footer':         'Primary Dashboard v1.0 · يتم تحديث البيانات تلقائيًا',

    // ── Overview: kartu dashboard (desc + stat label) ──
    'overview.card.awsBilling.desc':   'مراقبة تكاليف واستخدام خدمات AWS بشكل لحظي.',
    'overview.card.awsBilling.stat':   'الفترة',
    'overview.card.awsCost.desc':      'تحليل معمّق لنفقات AWS واتجاهات التكلفة.',
    'overview.card.awsCost.stat':      'السنة',
    'overview.card.solman.desc':       'تتبّع تذاكر الحوادث وطلبات الخدمة في SAP.',
    'overview.card.solman.stat':       'تذاكر مفتوحة',
    'overview.card.sdp.desc':          'التذاكر والأصول من ManageEngine ServiceDesk Plus Cloud.',
    'overview.card.sdp.stat':          'تذاكر مفتوحة',
    'overview.card.sapUsage.desc':     'تحليل استخدام ونشاط المستخدمين في نظام SAP.',
    'overview.card.sapUsage.stat':     'صفوف البيانات',
    'overview.card.sapUserMgmt.desc':  'إدارة مستخدمي SAP — قفل وفتح وإعادة تعيين كلمة المرور.',
    'overview.card.sapUserMgmt.stat':  'النظام جاهز',
    'overview.card.awsInventory.desc': 'جرد موارد AWS عبر عدة مناطق.',
    'overview.card.awsInventory.stat': 'الموارد',
    'overview.card.awsCloudTrail.desc':'أثر النشاط وتدقيق واجهات AWS البرمجية.',
    'overview.card.awsCloudTrail.stat':'الأحداث',
    'overview.card.employeeOvertime.desc':'بيانات العمل الإضافي للموظفين حسب الشركة والقسم والدرجة.',
    'overview.card.employeeOvertime.stat':'العمل الإضافي',
    'overview.card.aiWorkspace.desc':'محادثة AI بملء الصفحة — اختر لوحة لتحليلها.',
    'overview.card.aiWorkspace.stat':'AI',
    'overview.card.tableMaintenance.desc': 'إدارة بيانات جداول اللوحات — رفع وحذف وصيانة البيانات.',
    'overview.card.tableMaintenance.stat': 'الإدارة',
    'overview.card.logViewer.desc':        'مراقبة سجل نشاط المستخدمين والنظام بشكل لحظي.',
    'overview.card.logViewer.stat':        'الإدارة',
    'overview.card.sessionLog.desc':       'مراقبة جلسات الدخول النشطة وسجل وصول المستخدمين.',
    'overview.card.sessionLog.stat':       'الإدارة',
    'overview.card.shareLinks.desc':       'إنشاء وإدارة روابط عامة للقراءة فقط لمشاركة اللوحات.',
    'overview.card.shareLinks.stat':       'الإدارة',
    'overview.card.telegram.desc':         'إدارة بوتات Telegram للإشعارات واستعلام بيانات اللوحات.',
    'overview.card.telegram.stat':         'الإدارة',
    'overview.card.telegramLog.desc':      'سجل المحادثات وتفاعلات المستخدمين مع بوت Telegram.',
    'overview.card.telegramLog.stat':      'الإدارة',
    'overview.card.userMgmt.desc':         'إدارة حسابات المستخدمين وكلمات المرور وصلاحيات الوصول.',
    'overview.card.userMgmt.stat':         'الإدارة',
    'overview.card.roleMgmt.desc':         'تهيئة الأدوار ومجموعات الصلاحيات للتحكّم في الوصول.',
    'overview.card.roleMgmt.stat':         'الإدارة',
    'overview.card.sapBasisMon.desc':      'مراقبة صحّة SAP Basis — المهام والأقفال وعمليات العمل والنظام.',
    'overview.card.sapBasisMon.stat':      'الاتصال',
    // Pencarian & kunjungan terakhir
    'overview.search.placeholder':   'بحث عن لوحة…',
    'overview.search.noResults':     'لم يتم العثور على لوحة',
    'overview.search.noResultsHint': 'لا يوجد ما يطابق كلماتك المفتاحية.',
    'overview.search.resultCount':   'نتيجة',
    'overview.recent.title':         'زُرت مؤخرًا',

    // ── AI Chat ──
    'ai.assistant':        'مساعد AI',
    'ai.exportPdf':        'تصدير إلى PDF',
    'ai.export':           'تصدير المحادثة',
    'ai.newSession':       'بدء جلسة جديدة',
    'ai.settings':         'الإعدادات',
    'ai.noData':           'لا توجد بيانات بعد',
    'ai.records':          'سجلات',
    'ai.notConfigured':    'إعدادات AI غير مكتملة',
    'ai.openSettings':     'فتح الإعدادات',
    'ai.notConfiguredAdmin': 'تواصل مع مسؤول AI لضبط الإعدادات.',
    'ai.quickData':        'تحليل البيانات الفعلية',
    'ai.quick':            'أسئلة سريعة',
    'ai.analyzing':        'جارٍ تحليل البيانات...',
    'ai.placeholder':      'اكتب سؤالك... (Enter للإرسال)',
    'ai.placeholderConfig':'اضبط إعدادات AI أولًا...',
    'ai.inputHint':        'Shift+Enter لسطر جديد · تصدير PDF · يُحفظ السجل تلقائيًا',
    'ai.copy':             'نسخ',
    'ai.copied':           'تم النسخ!',
    'ai.dataAvailable':    'البيانات الفعلية متاحة — الإجابات مبنية على بيانات حقيقية',
    'ai.dataSourceTitle':  'مصدر بيانات AI',
    'ai.session':          'الجلسة',
    'ai.avg':              'المتوسط',
    'ai.accuracy':         'الدقة',
    'ai.accuracyHigh':     'مرتفعة',
    'ai.accuracyMed':      'متوسطة',
    'ai.accuracyLow':      'منخفضة',
    'ai.filter':           'تصفية',
    'ai.tokens':           'tokens',
    'ai.sources':          'المصادر',
    'ai.openNote':         'فتح الملاحظة · الصلة',
    'ai.viewSource':       'عرض محتوى المصدر',
    'ai.kbRelevance':      'الصلة',
    'ai.kbChunkHint':      'هذا مقتطف النص الذي قرأه الذكاء الاصطناعي عند صياغة إجابته — وليس المستند كاملاً.',
    'ai.kbTruncated':      'لم يُحفظ سوى مقتطف للمحادثات القديمة؛ اطرح السؤال مجدداً لعرض النص الكامل.',
    'ai.kbOpenNote':       'فتح الملاحظة الأصلية',
    'ai.kbOpenDashboard':  'فتح في لوحة المعلومات',
    'ai.untitled':         '(بدون عنوان)',
    'ai.srcRag':           '📚 قاعدة المعرفة (RAG)',
    'ai.srcSql':           '🗄️ Text-to-SQL',
    'ai.srcChat':          '💬 AI Service',
    'ai.srcSqliteSql':     '🗄️ SQLite (text-to-SQL)',
    'ai.srcSqliteLive':    '🗄️ SQLite DB (لحظي)',
    'ai.srcNone':          '⚠️ لا يوجد مصدر بيانات',
    'ai.autoDetected':     'اكتشاف تلقائي',
    'ai.grpFlat':          '☰ عرض مسطّح',
    'ai.grpBy':            '⊞ تجميع حسب',
    'ai.grpEmpty':         '(فارغ)',
    'ai.skipTyping':       'انقر للعرض الكامل',
    'ai.cmdHelp':          '**الأوامر المتاحة:**\n- `/clear` (بدائل `/new`، `/reset`) — بدء جلسة جديدة وإعادة تعيين سياق المحادثة\n- `/sql` — عرض استعلام SQL من آخر إجابة بيانات\n- `/examples` — عرض أمثلة أسئلة لهذه اللوحة\n- `/help` — عرض قائمة الأوامر هذه',
    'ai.cmdSqlLabel':      'SQL من آخر إجابة بيانات:',
    'ai.cmdNoSql':         'لا يوجد استعلام بيانات في هذه الجلسة بعد. اطرح سؤال بيانات أولًا ثم اكتب `/sql`.',
    'ai.cmdExamples':      '**أمثلة على الأسئلة:**',
    'ai.cmdNoExamples':    'لا توجد أمثلة خاصة لهذه اللوحة. اكتب سؤال بياناتك مباشرة.',
    'ai.cmdUnknownPre':    'الأمر',
    'ai.cmdUnknownPost':   'غير معروف. اكتب `/help` لعرض قائمة الأوامر.',

    // ── AWS Billing Dashboard ──
    'awsb.dashTitle':       'AWS Billing Dashboard',
    'awsb.account':         'الحساب',
    'awsb.loading':         'جارٍ تحميل بيانات الفوترة من SQLite…',
    'awsb.retry':           'إعادة المحاولة',
    'awsb.backendHint':     'تأكّد من تشغيل الـ backend:',
    'awsb.uploadTitle':     'رفع CSV / JSON',
    'awsb.overrideHint1':   'رفع الملف سوف',
    'awsb.override':        'يستبدل',
    'awsb.overrideHint2':   'عرض اللوحة ببيانات CSV. لا تتأثر قاعدة بيانات SQLite إلا إذا نقرت',
    'awsb.backToSqlite':    'العودة إلى SQLite',
    'awsb.saveToDbBtn':     'حفظ إلى DB',
    'awsb.savedToDb':       'تم الحفظ إلى DB',
    'awsb.adminOnly':       'رفع ملفات CSV/JSON متاح للمسؤول فقط',
    'awsb.uploadHintTitle': 'رفع بيانات فوترة بصيغة CSV أو JSON',
    'awsb.uploadBtn':       'رفع CSV / JSON',
    'awsb.rows':            'صفوف',
    'awsb.periodsParen':    'فترات',
    'awsb.reload':          'إعادة التحميل',
    'awsb.year':            'السنة',
    'awsb.selected':        'محدّد —',
    'awsb.clear':           'مسح',
    'awsb.holdCtrl1':       'اضغط باستمرار',
    'awsb.holdCtrl2':       'لاختيار عدة عناصر',
    'awsb.all':             'الكل',
    'awsb.periodsWord':     'فترات',
    'awsb.billingPeriods':  'فترات الفوترة',
    'awsb.allPeriods':      'الكل',
    'awsb.comparing':       '✓ مقارنة مع السابق',
    'awsb.compareVsPrev':   '⇄ مقارنة مع الفترة السابقة',
    'awsb.compareBanner':   '📊 مقارنة مع الفترة السابقة:',
    'awsb.trendTitle':      'اتجاه إجمالي التكاليف بين الفترات',
    'awsb.filter':          'تصفية:',
    'awsb.allTaxTypes':     'جميع أنواع الضرائب',
    'awsb.searchService':   'بحث عن service…',
    'awsb.sortTotal':       'ترتيب: إجمالي التكلفة',
    'awsb.sortPretax':      'ترتيب: التكلفة قبل الضريبة',
    'awsb.sortTax':         'ترتيب: الضريبة',
    'awsb.sortName':        'ترتيب: الاسم',
    'awsb.costBeforeTax':   'التكلفة قبل الضريبة',
    'awsb.taxAmount':       'مبلغ الضريبة',
    'awsb.totalInvoice':    'إجمالي الفاتورة',
    'awsb.inclTaxes':       'شامل جميع الضرائب',
    'awsb.creditsApplied':  'الأرصدة المطبَّقة',
    'awsb.services':        'service',
    'awsb.periodWord':      'الفترة',
    'awsb.allPeriodsWord':  'جميع الفترات',
    'awsb.none':            'لا يوجد',
    'awsb.costByService':   'التكلفة لكل service',
    'awsb.topUsageTypes':   'أعلى Usage type',
    'awsb.noUsageData':     'لا توجد بيانات Usage type.',
    'awsb.breakdown':       'تفصيل التكلفة لكل service',
    'awsb.showing':         'عرض',
    'awsb.of':              'من',
    'awsb.service':         'Service',
    'awsb.code':            'الرمز',
    'awsb.pretax':          'قبل الضريبة',
    'awsb.tax':             'الضريبة',
    'awsb.total':           'الإجمالي',
    'awsb.vsPrev':          'مقارنة بالفترة السابقة',
    'awsb.share':           'الحصّة',
    'awsb.ud.tabOverview':  'ملخّص',
    'awsb.ud.tabUsage':     'تفاصيل الاستخدام',
    'awsb.ud.tabReport':     'تقرير',
    'header.search':         'ابحث في الصفحات',
    'header.search.recent':      'المفتوحة مؤخرًا',
    'header.search.clearRecent': 'مسح',
    'awsb.ud.totalServices':'إجمالي الـ service النشطة',
    'awsb.ud.totalCharges': 'إجمالي التكلفة قبل الضريبة',
    'awsb.ud.filterPlaceholder':'تصفية حسب اسم الـ service أو المنطقة أو الوصف…',
    'awsb.ud.expandAll':    'توسيع الكل',
    'awsb.ud.collapseAll':  'طيّ الكل',
    'awsb.ud.groupByPeriod':'تجميع حسب الفترة',
    'awsb.ud.periodFilter': 'اختيار الفترة',
    'awsb.ud.allPeriods':   'جميع الفترات',
    'awsb.ud.description':  'الوصف',
    'awsb.ud.usageQty':     'كمية الاستخدام',
    'awsb.ud.amount':       'المبلغ',
    'awsb.ud.noQtyNote':    'بياناتك لا تحفظ عمود Usage Quantity، لذا أُخفي عمود كمية الاستخدام. تُشتقّ المنطقة من بادئة UsageType.',
    'awsb.noMatch':         'لا يوجد service يطابق التصفية.',
    'awsb.new':             'جديد',
    'awsb.totalWord':       'الإجمالي',
    'awsb.seller':          'البائع',
    'awsb.periodLabel':     'الفترة',
    'awsb.currency':        'العملة',
    'awsb.uploadedFile':    'الملف المرفوع',
    'awsb.dragDrop':        'اسحب وأفلت ملف CSV أو JSON هنا',
    'awsb.browse':          'اختيار ملف',
    'awsb.saveModalTitle':  '💾 حفظ إلى قاعدة بيانات SQLite',
    'awsb.across':          'عبر',
    'awsb.saveMode':        'وضع الحفظ',
    'awsb.append':          'إضافة',
    'awsb.appendDesc':      'إضافة صفوف — تبقى البيانات القديمة',
    'awsb.replace':         'استبدال',
    'awsb.replaceDesc':     'استبدال نفس الفترة في DB',
    'awsb.saving':          'جارٍ الحفظ…',
    'awsb.saved':           'تم الحفظ ✓',
    'awsb.productCode':     'رمز المنتج',
    'awsb.periodsDrawer':   'الفترة',
    'awsb.effectiveTaxRate':'معدّل الضريبة الفعلي',
    'awsb.totalCost':       'إجمالي التكلفة',
    'awsb.taxType':         'نوع الضريبة',
    'awsb.credits':         'الأرصدة',
    'awsb.topLineItems':    'أعلى البنود',

    // ── AWS Cost Explorer ──
    'awsc.dashTitle':       'AWS Cost Dashboard',
    'awsc.reset':           'إعادة تعيين',
    'awsc.ctrlMulti':       'Ctrl+نقر للاختيار المتعدد',
    'awsc.upload':          'رفع CSV',
    'awsc.uploading':       'جارٍ الرفع...',
    'awsc.failed':          'فشل',
    'awsc.rowsSaved':       'صفوف محفوظة',
    'awsc.adminOnly':       'رفع ملفات CSV متاح للمسؤول فقط',
    'awsc.uploadTitle':     'رفع بيانات فوترة CSV',
    'awsc.ofTotal':         'من الإجمالي',
    'awsc.allBuCombined':   'جميع وحدات الأعمال مجمّعة',
    'awsc.noData':          'لا توجد بيانات',
    'awsc.monthlyCostByBu': 'التكلفة الشهرية لكل BU',
    'awsc.costShareByBu':   'حصّة التكلفة لكل BU',
    'awsc.yearlyTrend':     'اتجاه تكاليف AWS السنوي',
    'awsc.allocated':       'مخصَّص',
    'awsc.shareNoTags':     'Share و No-Tags مقسّمة بالتساوي على 3 وحدات أعمال',
    'awsc.barChart':        'رسم بياني شريطي',
    'awsc.lineChart':       'رسم بياني خطّي',
    'awsc.allMonths':       'جميع الأشهر',
    'awsc.inclAlloc':       'شامل التخصيص',
    'awsc.costPerBu':       'التكلفة لكل BU (شامل التخصيص)',
    'awsc.proportion':      'النسبة',
    'awsc.detailPerMonth':  'التفاصيل الشهرية (مجمّعة)',
    'awsc.month':           'الشهر',
    'awsc.total':           'الإجمالي',
    'awsc.grandTotal':      'الإجمالي الكلّي',
    'awsc.monthlyDetailByBu':'التفاصيل الشهرية لكل وحدة أعمال',
    'awsc.buLabel':         'BU:',
    'awsc.allBu':           'جميع وحدات الأعمال',
    'awsc.monthCol':        'الشهر',
    'awsc.topProducts':     'أعلى الـ service',
    'awsc.monthFilter':     'الشهر:',
    'awsc.all':             'الكل',
    'awsc.productFilter':   'Service:',
    'awsc.product':         'Service',
    'awsc.usageDetail':     'تفاصيل Usage Type',
    'awsc.usageType':       'Usage Type',
    'awsc.grandTop50':      'الإجمالي الكلّي (أعلى 50)',
    'awsc.tab.overview':    'نظرة عامة',
    'awsc.tab.consolidated':'مجمّع',
    'awsc.tab.monthly':     'شهري',
    'awsc.tab.products':    'Services',
    'awsc.tab.usage':       'تفاصيل الاستخدام',
    'awsc.loading':         'جارٍ تحميل البيانات من قاعدة البيانات…',
    'awsc.empty':           'لا توجد بيانات AWS Cost بعد',
    'awsc.emptyHint1':      'ارفع ملف CSV عبر زر',
    'awsc.emptyHint2':      'في الأعلى.',
    'awsc.requiredCols':    'الأعمدة المطلوبة في CSV:',

    // ── AWS Cost: tambahan (year selector, multi-year, search) ──
    'awsc.service':         'Service',
    'awsc.allYears':        'الكل',
    'awsc.searchService':   '🔍 Service / Usage Type…',
    'awsc.perYearSuffix':   '/سنة',
    'awsc.multiYearNote':   '{count} سنة مجمّعة ({range}) · الرقم لكل شهر = إجمالي كل السنوات، السطر الثاني = المتوسط/السنة',
    'awsc.tab.daily':       'الاستخدام اليومي',
    'awsc.dailyUsage':      'التفصيل اليومي (اليوم › Service › Usage Type)',
    'awsc.dayCol':          'اليوم',
    'awsc.expandAll':       'توسيع الكل',
    'awsc.collapseAll':     'طيّ الكل',
    'awsc.dailyTreeNote':   'انقر على الصف للتوسيع/الطيّ. البيانات القديمة (قبل ميزة التفصيل اليومي) تظهر في اليوم 1؛ عمليات الرفع/الجلب الجديدة تُملأ لكل يوم. تُوضع الضريبة في اليوم 1.',

    // ── SAP Solution Manager ──
    'solm.title':           'SAP Solution Manager',
    'solm.subtitle':        'مراقبة تذاكر وحوادث SAP',
    'solm.records':         'سجلات',
    'solm.uploadCsv':       'رفع CSV',
    'solm.uploadTitle':     'رفع ملف CSV',
    'solm.uploadAdminOnly': 'رفع CSV متاح للمسؤول فقط',
    'solm.saving':          'جارٍ الحفظ...',
    'solm.saved':           'تم الحفظ',
    'solm.saveToDb':        'حفظ إلى DB',
    'solm.saveToDbTitle':   'حفظ إلى قاعدة البيانات',
    'solm.saveAdminOnly':   'الحفظ إلى قاعدة البيانات متاح للمسؤول فقط',
    'solm.total':           'الإجمالي',
    'solm.open':            'مفتوح',
    'solm.closed':          'مغلق',
    'solm.incidentTickets': 'SAP Solution Manager — تذاكر الحوادث',
    'solm.nav.overview':    'نظرة عامة',
    'solm.nav.trends':      'الاتجاهات',
    'solm.nav.teams':       'الفِرق',
    'solm.nav.detail':      'تفاصيل التذاكر',
    'solm.det.sub':         'تفاصيل التذاكر — تتبع عوامل التصفية أعلاه',
    'solm.det.searchPh':    'ابحث في كل الأعمدة…',
    'solm.det.columns':     'الأعمدة {n}/{total}',
    'solm.det.colsAll':     'إظهار الكل',
    'solm.det.colsDefault': 'العودة إلى الافتراضي',
    'solm.det.clearFilters': 'مسح {n} عامل تصفية',
    'solm.det.filterPh':    'تصفية…',
    'solm.det.allValues':   '(الكل)',
    'solm.det.perPage':     'صفوف/صفحة',
    'solm.det.export':      'تصدير إلى Excel',
    'solm.det.showing':     'إظهار {from}–{to} من {total} صف',
    'solm.det.ofFiltered':  '(من {n} حسب عوامل التصفية أعلاه)',
    'solm.det.pageOf':      'صفحة {page} / {total}',
    'solm.det.noRows':      'لا توجد صفوف مطابقة. جرّب تخفيف البحث أو تصفية الأعمدة.',
    'solm.det.sortHint':    'انقر للترتيب: تصاعدي / تنازلي',
    'solm.nav.pivot':       'جدول محوري',
    'solm.nav.export':      'تصدير Excel',
    'solm.nav.aging':       'عمر الحالة',
    'solm.nav.report':      'التقرير الشهري',
    'solm.export.title':      'تصدير إلى Excel',
    'solm.export.subtitle':   'تنزيل التذاكر حسب الشركة والشهر، بنفس تنسيق ملف التقرير الشهري تمامًا.',
    'solm.export.company':    'الشركة',
    'solm.export.month':      'الشهر',
    'solm.export.year':       'السنة',
    'solm.export.matchCount': 'تم العثور على',
    'solm.export.button':     'تصدير Excel',
    'solm.export.exporting':  'جارٍ التصدير…',
    'solm.export.done':       'تم التنزيل بنجاح:',
    'solm.export.note':       'اسم الملف وترتيب الأعمدة يتبعان تنسيق تقرير Solman الشهري (MM. Solman tickets Month yyyy - COMPANY). يُكتب "Created On2" كتاريخ حقيقي، وتُكتب ID/Client/SAP Installation/Software Release كأرقام — تمامًا كما في الملف المصدر.',
    'solm.export.spButton':   'حفظ إلى SharePoint',
    'solm.export.spUploading':'جارٍ الحفظ إلى SharePoint…',
    'solm.export.spDone':     'نتيجة الرفع إلى SharePoint:',
    'solm.allCompanies':    'جميع الشركات',
    'solm.allTeams':        'جميع الفِرق (Impact)',
    'solm.year':            'السنة:',
    'solm.all':             'الكل',
    'solm.status':          'الحالة:',
    'solm.clear':           'مسح',
    'solm.showing':         'عرض',
    'solm.tickets':         'تذكرة',
    'solm.loading':         'جارٍ تحميل البيانات من قاعدة البيانات...',
    'solm.loadingSub':      'جلب التذاكر من SQLite عبر API',
    'solm.cantLoad':        'تعذّر التحميل من DB',
    'solm.cantLoadDesc':    'تعذّر الاتصال بالخادم أو أن الرمز غير صالح. ارفع CSV يدويًا، أو تأكّد من تشغيل الخادم.',
    'solm.retry':           'إعادة المحاولة',
    'solm.dbEmpty':         'قاعدة البيانات فارغة',
    'solm.dbEmptyDesc':     'لا توجد تذاكر في قاعدة البيانات بعد. ارفع CSV ثم انقر "Save to DB".',
    'solm.noData':          'لا توجد بيانات بعد',
    'solm.noDataDesc':      'أفلت ملف CSV الخاص بـ Solman في الشريط الجانبي على اليسار، أو انقر منطقة الإفلات للتصفّح.',
    'solm.chip1':           'ملخّص المؤشرات',
    'solm.chip2':           'الاتجاه الشهري',
    'solm.chip3':           'عبء عمل الفريق',
    'solm.chip4':           'محور الحالة',
    'solm.chip5':           'تفاصيل التذكرة',
    'solm.totalTickets':    'إجمالي التذاكر',
    'solm.withdrawn':       'مسحوبة',
    'solm.closeRate':       'معدّل الإغلاق',
    'solm.ofTotal':         '% من الإجمالي',
    'solm.statusBreakdown': 'تفصيل الحالة',
    'solm.statusBreakdownSub':'جميع التذاكر حسب الحالة الراهنة',
    'solm.ticketsByCompany':'التذاكر لكل شركة',
    'solm.monthlyStacked':  'التذاكر الشهرية — مكدّسة حسب الحالة',
    'solm.monthlyStackedSub':'كل شريط مقسّم حسب حقل الحالة',
    'solm.monthStatusTable':'جدول تفصيلي: الشهر × الحالة',
    'solm.monthStatusSub':  'العدد لكل حالة لكل شهر — من Created On (الشهر = MM من DD.MM.YYYY)',
    'solm.priorityDist':    'توزيع الأولوية',
    'solm.priorityDistSub': 'التذاكر مجمّعة حسب مستوى الإلحاح',
    'solm.monthlyVolume':   'حجم التذاكر الشهري',
    'solm.monthlyVolumeSub':'الإجمالي والمغلق والمفتوح عبر الزمن',
    'solm.monthlyStacked2': 'مكدّس شهري حسب الحالة',
    'solm.monthlyStacked2Sub':'جميع الحالات السبع لكل شهر',
    'solm.ticketVolPerTeam':'حجم التذاكر لكل فريق',
    'solm.teamStatusMatrix':'مصفوفة الفريق × الحالة',
    'solm.teamStatusMatrixSub':'حقل Impact × الحالة — العدد لكل حالة لكل فريق',
    'solm.monthStatusFilter':'الشهر × الحالة (التصفية النشطة)',
    'solm.monthStatusFilterSub':'تفصيل شهري لجميع الحالات ضمن التصفية النشطة',
    'solm.monthStatusDetail':'تفاصيل الشهر × الحالة',
    'solm.monthStatusDetailSub':'تفصيل كامل لكل شهر وحالة',
    'solm.month':           'الشهر',
    'solm.monthlySummary':  'الملخّص الشهري',
    'solm.monthlySummarySub':'الإجمالي لكل شهر مع معدّل الإغلاق',
    'solm.uploadHeader':    'SAP Solman Dashboard',
    'solm.uploadIntro':     'ارفع تصدير CSV لتذاكر Solman لاستكشاف اتجاهات الحوادث وعبء عمل الفِرق وتفصيل الحالات لكل شهر.',
    'solm.dropCsv':         'أفلت ملف CSV هنا',
    'solm.orClick':         'أو انقر للتصفّح — يدعم تصدير Solman (.csv)',
    'solm.noTickets':       'لم يتم العثور على تذاكر',
    'solm.totalTicket':     'إجمالي التذاكر',
    'solm.close':           'إغلاق',
    'solm.pivotTitle':      'محوري: Impact × الحالة × الشهر',
    'solm.number':          'عدد',
    'solm.totalCaps':       'الإجمالي',
    'solm.allStatuses':     'جميع الحالات',
    'solm.teamImpact':      'الفريق (Impact)',
    'solm.clickAny':        'انقر رقمًا',
    'solm.toViewDetails':   'لعرض تفاصيل التذكرة ·',
    'solm.scrollHorizontal':'مرّر أفقيًا لعرض جميع الأشهر',
    'solm.monthsWord':      'شهر',
    'solm.teamsWord':       'فريق',

    // ── SAP User Utilization ──
    'sapu.loadCsvTitle':    '📂 تحميل مصدر بيانات CSV',
    'sapu.csvOnly':         'صيغة .csv فقط مدعومة.',
    'sapu.noValidData':     'لا توجد بيانات صالحة.',
    'sapu.csvSuccess':      'تم بنجاح: {n} سجل من {file}',
    'sapu.dragDrop':        'اسحب وأفلت ملف CSV أو انقر',
    'sapu.csvFormat':       'الصيغة: Client, Dept., Period, User, Total, Lic., License Type, Landscape (اختياري)',
    'sapu.activeLabel':     'نشط:',
    'sapu.resetDefault':    'إعادة التعيين الافتراضي',
    'sapu.close':           'إغلاق',
    'sapu.loading':         'جارٍ تحميل البيانات من قاعدة البيانات...',
    'sapu.erpSystem':       'SAP ERP System',
    'sapu.title':           'User Usage Dashboard',
    'sapu.records':         'سجلات',
    'sapu.loadCsv':         'تحميل CSV',
    'sapu.saving':          '⏳ جارٍ الحفظ...',
    'sapu.saveToDb':        '💾 Save to DB',
    'sapu.alreadyFromDb':   'البيانات من DB (لا حاجة لإعادة الحفظ)',
    'sapu.saveTitle':       'انقر لحفظ البيانات إلى قاعدة البيانات',
    'sapu.loadFromDb':      '🗄️ Load from DB',
    'sapu.totalHours':      'إجمالي الساعات',
    'sapu.totalUsers':      'إجمالي المستخدمين',
    'sapu.activeUsers':     'المستخدمون النشطون',
    'sapu.rows':            'صفوف',
    'sapu.year':            'السنة',
    'sapu.all':             'الكل',
    'sapu.yearsSelected':   'سنة محدّدة',
    'sapu.period':          'الفترة',
    'sapu.selected':        'محدّد',
    'sapu.ctrlDeselect':    'Ctrl+نقر لإلغاء التحديد / نقر لاختيار عنصر واحد',
    'sapu.ctrlMulti':       'انقر للاختيار · Ctrl+نقر للاختيار المتعدد',
    'sapu.tab.overview':    '📊 نظرة عامة',
    'sapu.tab.company':     '🏢 لكل شركة',
    'sapu.tab.module':      '⚙️ لكل وحدة',
    'sapu.tab.users':       '👤 أعلى المستخدمين',
    'sapu.tab.table':       '📋 جدول البيانات',
    'sapu.tab.pivot':       '📊 الاستخدام الشهري',
    'sapu.hoursByCompany':  'الساعات لكل شركة',
    'sapu.hoursByModule':   'الساعات لكل وحدة',
    'sapu.usageTrend':      'اتجاه الاستخدام لكل شركة × فترة',
    'sapu.licenseTypeSplit':'توزيع License Type',
    'sapu.moduleRanking':   'ترتيب الوحدات (الساعات)',
    'sapu.module':          'الوحدة',
    'sapu.allModules':      'جميع الوحدات',
    'sapu.hoursPerModule':  'الساعات لكل وحدة — انقر الشريط للتفصيل',
    'sapu.clickToSeeUsers': '👆 انقر لعرض المستخدمين',
    'sapu.back':            '← رجوع',
    'sapu.totalUsage':      'إجمالي الاستخدام',
    'sapu.activeWord':      'نشط',
    'sapu.companies':       'الشركة',
    'sapu.usersIn':         'المستخدمون في',
    'sapu.userDetail':      'تفاصيل المستخدم —',
    'sapu.usersWord':       'مستخدم',
    'sapu.ofUsers':         'من {n} مستخدم',
    'sapu.showTop':         'عرض الأعلى',
    'sapu.highest':         'الأعلى استخدامًا',
    'sapu.lowest':          'الأدنى استخدامًا',
    'sapu.ofMax':           '% من الحد الأقصى',
    'sapu.searchUserDept':  'بحث عن user / dept...',
    'sapu.showingLimit':    'عرض 100 من {n} صف — استخدم التصفية للتضييق.',
    'sapu.licenses':        'التراخيص:',
    'sapu.moduleLabel':     'الوحدة:',
    'sapu.searchUser':      '🔍 بحث عن مستخدم...',
    // ── Employee Overtime ──
    'overtime.subtitle':        'بيانات العمل الإضافي للموظفين — {recs} إجمالي السجلات من {files} ملف مصدر.',
    'overtime.tabOverview':     'نظرة عامة',
    'overtime.tabDetail':       'تفاصيل العمل الإضافي',
    'overtime.tabPivot':        'جدول محوري',
    'overtime.pivotTitle':      '📐 محوري: Business Unit × الشهر',
    'overtime.measure':         'القيمة:',
    'overtime.measureHours':    'إجمالي ساعات OT',
    'overtime.measureAmount':   'إجمالي المبلغ',
    'overtime.measureCount':    'عدد الجلسات',
    'overtime.rowTotal':        'إجمالي الصفوف',
    'overtime.colTotal':        'الإجمالي',
    'overtime.grandTotal':      'الإجمالي الكلّي',
    'overtime.expandAll':       'توسيع الكل',
    'overtime.collapseAll':     'طيّ الكل',
    'overtime.clickSort':       'انقر للترتيب',
    'overtime.clickReason':     'انقر للتفصيل حسب السبب',
    'overtime.reasonBreakdown': 'تفصيل حسب السبب',
    'overtime.value':           'القيمة',
    'overtime.allPeriods':      'جميع الفترات',
    'overtime.filter':          'تصفية:',
    'overtime.allYears':        'جميع السنوات',
    'overtime.allMonths':       'جميع الأشهر',
    'overtime.allBu':           'جميع BU',
    'overtime.searchPh':        '🔍 الاسم، الرمز، القسم…',
    'overtime.apply':           'تطبيق',
    'overtime.reset':           '↺ إعادة تعيين',
    'overtime.totalRecords':    'إجمالي السجلات',
    'overtime.businessUnits':   'وحدات الأعمال',
    'overtime.periodsAvail':    'الفترات المتاحة',
    'overtime.sourceFiles':     'ملفات المصدر',
    'overtime.page':            'الصفحة',
    'overtime.totalHoursPer':   '📊 إجمالي ساعات OT لكل',
    'overtime.totalAmountPer':  '💰 إجمالي مبلغ OT لكل {by}',
    'overtime.optDept':         'القسم',
    'overtime.optSection':      'الشعبة',
    'overtime.optBu':           'وحدة الأعمال',
    'overtime.noData':          'لا توجد بيانات.',
    'overtime.detailTitle':     '📋 تفاصيل العمل الإضافي',
    'overtime.records':         '{n} سجل',
    'overtime.pageShort':       'ص {p}/{tp}',
    'overtime.loadFail':        'تعذّر تحميل البيانات.',
    'overtime.emptyTable':      '⏱️ لا توجد بيانات عمل إضافي للتصفية المحدّدة بعد.',
    'overtime.colKode':         'الرمز',
    'overtime.colNama':         'اسم الموظف',
    'overtime.colThn':          'السنة',
    'overtime.colBln':          'الشهر',
    'overtime.colTgl':          'تاريخ المهمة',
    'overtime.colMulai':        'البداية',
    'overtime.colSelesai':      'النهاية',
    'overtime.colJam':          'ساعات OT',
    'overtime.colTotalJam':     'إجمالي الساعات',
    'overtime.colAmount':       'المبلغ (Rp)',
    'overtime.colReason':       'السبب',

    // ── Cron Scheduler (komponen bersama) ──
    'cron.title':         '⏰ الجدولة التلقائية (Cron)',
    'cron.active':        'نشط',
    'cron.activeApply':   'نشط (احفظ للتطبيق)',
    'cron.inactive':      'غير نشط',
    'cron.noNodeCron':    'node-cron غير مثبّت بعد',
    'cron.enable':        'تفعيل',
    'cron.freqDaily':     'يومي',
    'cron.freqWeekly':    'أسبوعي',
    'cron.freqMonthly':   'شهري',
    'cron.freqCustom':    'مخصّص (cron)',
    'cron.dayOfMonth':    'اليوم',
    'cron.hour':          'الساعة',
    'cron.customPlaceholder': 'مثل 0 6 * * 1',
    'cron.tzLabel':       'WIB ({tz})',
    'cron.saveSchedule':  '💾 حفظ الجدول',
    'cron.saving':        '⏳…',
    'cron.runNow':        '▶️ تشغيل الآن',
    'cron.runConfirmDefault': 'تشغيل هذه المهمة الآن؟ سيؤدّي ذلك إلى سحب البيانات من AWS.',
    'cron.saved':         'تم الحفظ — {state}، الجدول "{schedule}" ({tz}).',
    'cron.stateActive':   'نشط',
    'cron.stateInactive': 'غير نشط',
    'cron.runDone':       '✅ {msg} ({n} صف)',
    'cron.runDoneDefault':'اكتمل.',
    'cron.runFail':       'فشل: {err}',
    'cron.lastRun':       'آخر تشغيل:',
    'cron.dowSun':        'الأحد',
    'cron.dowMon':        'الاثنين',
    'cron.dowTue':        'الثلاثاء',
    'cron.dowWed':        'الأربعاء',
    'cron.dowThu':        'الخميس',
    'cron.dowFri':        'الجمعة',
    'cron.dowSat':        'السبت',

    // ── Sybase DR Monitor ──
    'sdr.title':            'Sybase DR Monitor',
    'sdr.desc':             'مراقبة errorlog الخاص بـ Sybase ASE 16 عبر SSH. ملف تعريف واحد = خادم واحد + ملف سجل واحد. تُحفظ الحالات الشاذة مع 10 أسطر سياق وتُرسل عبر بوت Telegram المسمّى sybase_dr.',
    'sdr.profilesActive':   '{n} ملف تعريف نشط',
    'sdr.findingsCount':    '{n} نتيجة',
    'sdr.forceScan':        '⚡ فحص إجباري (اختبار — تجاهل الأساس)',
    'sdr.forceConfirm':     'الفحص الإجباري: تجاهل الأساس وتنبيه جميع المطابقات في الذيل (للاختبار). متابعة؟',
    'sdr.forceDone':        'اكتمل الفحص الإجباري — {n} حالة شاذة ({p} ملف تعريف).',
    'sdr.runConfirm':       'تشغيل فحص Sybase DR الآن؟',
    // Profil
    'sdr.profilesSection':  'ملفات تعريف SSH',
    'sdr.addProfile':       '+ إضافة ملف تعريف',
    'sdr.emptyProfiles':    "لا توجد ملفات تعريف بعد. انقر '+ إضافة ملف تعريف' للبدء.",
    'sdr.colLabel':         'التسمية',
    'sdr.colHost':          'المضيف',
    'sdr.colPort':          'المنفذ',
    'sdr.colUser':          'المستخدم',
    'sdr.colKeyFile':       'ملف المفتاح',
    'sdr.colLogPath':       'مسار السجل',
    'sdr.colKeywords':      'الكلمات المفتاحية',
    'sdr.colStatus':        'الحالة',
    'sdr.colEmail':         'البريد الإلكتروني',
    'sdr.colLastTs':        'آخر طابع زمني',
    'sdr.colActions':       'إجراءات',
    'sdr.kwCount':          '{n} كلمة',
    'sdr.active':           'نشط',
    'sdr.inactive':         'غير نشط',
    'sdr.emailOn':          'ON',
    'sdr.emailOff':         'OFF',
    'sdr.emailOffTitle':    'البريد الإلكتروني معطّل',
    'sdr.baselineNone':     'لا يوجد أساس بعد',
    'sdr.tsNone':           'لا يوجد بعد',
    // Tombol aksi
    'sdr.testSsh':          '🔗 اختبار SSH',
    'sdr.testEmail':        '📧 اختبار البريد',
    'sdr.reset':            '🔄 إعادة تعيين',
    'sdr.clearFindings':    '🗑️ النتائج',
    // Pesan aksi
    'sdr.profileSaved':     'تم تحديث ملف التعريف.',
    'sdr.profileAdded':     'تمت إضافة ملف التعريف.',
    'sdr.deleteConfirm':    'حذف ملف التعريف "{name}"؟ ستُحذف جميع النتائج أيضًا.',
    'sdr.profileDeleted':   'تم حذف ملف التعريف.',
    'sdr.sshOk':            '✅ SSH سليم — الاستجابة: {res}',
    'sdr.emailSent':        '✅ تم إرسال بريد الاختبار إلى {to}',
    'sdr.resetConfirm':     'إعادة تعيين أساس ملف التعريف "{name}"؟ الفحص التالي سيصبح الأساس الجديد.',
    'sdr.resetDone':        'تمت إعادة تعيين الأساس.',
    'sdr.clearConfirm':     'حذف جميع نتائج ملف التعريف "{name}"؟',
    'sdr.clearDone':        'تم حذف النتائج.',
    // Findings
    'sdr.findingsSection':  'النتائج (أحدث 100)',
    'sdr.allProfiles':      'جميع ملفات التعريف',
    'sdr.noFindings':       'لا توجد نتائج.',
    'sdr.colTime':          'الوقت',
    'sdr.colProfile':       'ملف التعريف',
    'sdr.colAnomaly':       'الحالة الشاذة',
    'sdr.colAlert':         'التنبيه',
    'sdr.colDetail':        'التفاصيل',
    'sdr.alertSent':        '✓ أُرسل',
    'sdr.alertPending':     'قيد الانتظار',
    'sdr.contextBtn':       '🔍 السياق',
    'sdr.contextTitle':     'السياق — {time}',
    'sdr.contextProfile':   'ملف التعريف',
    'sdr.contextNone':      '(لا يوجد سياق)',
    // Modal profil
    'sdr.modalAdd':         'إضافة ملف تعريف SSH',
    'sdr.modalEdit':        'تعديل ملف تعريف SSH',
    'sdr.fLabel':           'التسمية (اسم العرض)',
    'sdr.fHost':            'المضيف / IP',
    'sdr.fPort':            'منفذ SSH',
    'sdr.fUser':            'مستخدم SSH',
    'sdr.fKeyFile':         'ملف المفتاح (من /dashboard/keypairs)',
    'sdr.fKeyFileHint':     'صيغة OpenSSH (وليس .ppk). حوّله عبر PuTTYgen عند الحاجة.',
    'sdr.fKeyFilePick':     '-- اختر ملف المفتاح --',
    'sdr.fLogPath':         'مسار ملف السجل (مطلق على الخادم البعيد)',
    'sdr.fKeywords':        'الكلمات المفتاحية للحالات الشاذة (واحدة لكل سطر، غير حسّاسة لحالة الأحرف)',
    'sdr.fStatus':          'الحالة',
    'sdr.fActiveLabel':     'نشط (سيُفحص بواسطة cron)',
    'sdr.fEmailAlert':      'تنبيه البريد الإلكتروني',
    'sdr.fEmailEnable':     'إرسال التنبيهات عبر البريد لهذا الملف',
    'sdr.fEmailTo':         'penerima@contoh.com (افصل بفاصلة للعديد)',
    'sdr.fEmailHint':       'يُعاد استخدام إعداد SMTP من تبويب ASE Alert. تأكّد من إدخال مضيف SMTP وبيانات الاعتماد هناك.',
    'sdr.saving':           'جارٍ الحفظ…',
    'sdr.save':             'حفظ',
    'sdr.cancel':           'إلغاء',

    // ── TAHAP 5: Table Maintenance (header & label tab) ──
    'tm.title':            'Table Maintenance',
    'tm.subtitle':         'إدارة بيانات SQLite مباشرة من اللوحة — حذف وتعديل وتفريغ الجداول.',
    'tm.noAccess':         'لا صلاحية للوصول إلى هذا الجدول.',
    'tm.tab.users':        'المستخدمون',
    'tm.tab.logs':         'سجل النشاط',
    'tm.tab.tickets':      'تذاكر Solman',
    'tm.tab.sap':          'استخدام SAP',
    'tm.tab.billing':      'AWS Billing',
    'tm.tab.aws':          'AWS Cost',
    'tm.tab.idsuim':       'ID SUIM',
    'tm.tab.uploads':      'سجل الرفع',
    'tm.tab.sapcfg':       'إعدادات SAP',
    'tm.tab.notes':        'الملاحظات',
    'tm.tab.sql':          'SQL Editor',
    'tm.tab.database':     'قاعدة البيانات',
    'tm.tab.overtime':     'العمل الإضافي للموظفين',
    'tm.tab.asealert':     'ASE Alert',
    'tm.tab.sybasedr':     'Sybase ASE',

    // ── ASE Alert panel ──
    'asealert.title':         'ASE Errorlog Alert',
    'asealert.tgOn':          'Telegram ON',
    'asealert.tgOff':         'Telegram OFF',
    'asealert.emailOn':       'Email ON',
    'asealert.emailOff':      'Email OFF',
    'asealert.descA':         'يفحص ASE errorlog لكل ملف تعريف SAP (عبر الأمر ',
    'asealert.descB':         ')، يطابق الكلمات المفتاحية، ثم يرسل تنبيهًا للأسطر الجديدة. أول تشغيل لكل ملف تعريف يكون أساسًا فقط (لا يرسل السجل القديم المتراكم).',
    'asealert.runConfirm':    'تشغيل فحص ASE errorlog الآن؟',
    'asealert.kwLabel':       'الكلمات المفتاحية (واحدة لكل سطر، غير حسّاسة لحالة الأحرف)',
    'asealert.chTelegramA':   'الإرسال إلى Telegram (البوت ',
    'asealert.chTelegramB':   ')',
    'asealert.chEmail':       'الإرسال إلى البريد الإلكتروني (SMTP)',
    'asealert.recipients':    'المستلمون (افصل بفاصلة)',
    'asealert.smtpHost':      'SMTP Host',
    'asealert.port':          'المنفذ',
    'asealert.ssl':           'SSL/TLS (آمن) — عادةً المنفذ 465',
    'asealert.smtpUser':      'SMTP User',
    'asealert.smtpPass':      'SMTP Password',
    'asealert.smtpPassSaved': '(محفوظة — املأ للتغيير)',
    'asealert.from':          'From (عنوان المرسل)',
    'asealert.btnTest':       'اختبار الإرسال',
    'asealert.msgSaved':      'تم حفظ الإعدادات.',
    'asealert.msgTest':       'اختبار — Telegram: {tg}، Email: {email}',

    // ── Users panel ──
    'users.rows':          '{n} صف',
    'users.addBtn':        'إضافة مستخدم',
    'users.colId':         'ID',
    'users.colUsername':   'اسم المستخدم',
    'users.colRole':       'الدور',
    'users.colLastLogin':  'آخر تسجيل دخول',
    'users.colCreated':    'تاريخ الإنشاء',
    'users.empty':         'لا يوجد مستخدمون بعد',
    'users.you':           '(أنت)',
    'users.deleteConfirm': 'حذف المستخدم "{name}"؟',
    'users.deleted':       'تم حذف المستخدم "{name}".',
    'users.created':       'تم إنشاء المستخدم "{name}".',
    'users.updated':       'تم تحديث المستخدم.',
    'users.modalAdd':      'إضافة مستخدم جديد',
    'users.fPassword':     'كلمة المرور',
    'users.phUsername':    '3 أحرف على الأقل',
    'users.phPassword':    '6 أحرف على الأقل',
    'users.btnCreate':     'إنشاء مستخدم',
    'users.modalEdit':     'تعديل: {name}',
    'users.fNewRole':      'دور جديد',
    'users.fNewPw':        'كلمة مرور جديدة (اتركها فارغة إن لم تُغيَّر)',

    // ── Activity Logs panel ──
    'logs.total':          '{n} إجمالي',
    'logs.searchPh':       'بحث عن action / اسم مستخدم…',
    'logs.info':           'لا يمكن حذف السجل — هذا سجل تدقيق. يُعرض أحدث 100 من {n}.',
    'logs.colAction':      'الإجراء',
    'logs.colDetail':      'التفاصيل',
    'logs.colIp':          'IP',
    'logs.colTime':        'الوقت',
    'logs.empty':          'لا توجد سجلات',

    // ── Solman Tickets panel ──
    'tickets.statTotal':        'إجمالي التذاكر',
    'tickets.statSources':      'ملفات المصدر',
    'tickets.statPage':         'الصفحة',
    'tickets.searchPh':         'بحث عن ticket ID، شركة، حالة…',
    'tickets.btnFetch':         'جلب من Solman',
    'tickets.selectSource':     '-- اختر ملف مصدر --',
    'tickets.btnDelSource':     'حذف المصدر',
    'tickets.btnClearAll':      'تفريغ الكل',
    'tickets.pickSource':       'اختر ملف مصدر أولًا.',
    'tickets.deleteSourceConfirm': 'حذف جميع التذاكر من "{name}"؟',
    'tickets.deleteAllConfirm': 'تفريغ جدول solman_tickets بالكامل ({n} تذكرة)؟ لا يمكن التراجع!',
    'tickets.errFrom':          'صيغة "من" يجب أن تكون YYYYMMDD (مثال: 20160101).',
    'tickets.errTo':            'صيغة "إلى" يجب أن تكون YYYYMMDD (مثال: 20160131).',
    'tickets.fetchDone':        'اكتمل.',
    'tickets.fetchFail':        'تعذّر الجلب من Solman.',
    'tickets.cronConfirm':      'تشغيل جلب Solman الآن؟ يسحب تذاكر ZMIN من 20230101 حتى اليوم من SAP ويستبدل الموجودة (المفتاح: Ticket ID). قد يستغرق وقتًا.',
    'tickets.spCronConfirm':    'رفع ملف Excel لتذاكر الشهر الماضي إلى SharePoint الآن؟ ملف واحد لكل شركة (OSI/PPI/PMI/PII/PBI) يُكتب في مجلد سنة البيانات، ويستبدل ملفًا بالاسم نفسه إن وُجد.',
    'tickets.modalTitle':       'جلب التذاكر من Solman',
    'tickets.fType':            'Transaction Type',
    'tickets.fFrom':            'من تاريخ (YYYYMMDD، فارغ = الكل)',
    'tickets.fTo':              'إلى تاريخ (YYYYMMDD، فارغ = الكل)',
    'tickets.fetchInfo':        'تُجلب البيانات مباشرة من SAP Solution Manager عبر RFC. التذاكر الموجودة (نفس ticket_id) تُتخطّى تلقائيًا.',
    'tickets.fetching':         'جارٍ الجلب…',
    'tickets.btnFetchNow':      'جلب الآن',
    'tickets.empty':            'لا توجد تذاكر في solman_tickets بعد',
    'tickets.prev':             'السابق',
    'tickets.next':             'التالي',
    'tickets.pager':            'الصفحة {p} من {tp} ({a} من {b} تذكرة)',

    // ── SAP Usage panel ──
    'sap.statTotal':       'إجمالي السجلات',
    'sap.statPeriods':     'الفترات',
    'sap.searchPh':        'بحث عن مستخدم، شركة، وحدة…',
    'sap.delSourceConfirm':'حذف بيانات SAP من "{name}"؟',
    'sap.delAllConfirm':   'تفريغ جميع بيانات SAP Usage؟ لا يمكن التراجع!',
    'sap.empty':           'لا توجد بيانات SAP Usage بعد',
    'sap.pager':           'الصفحة {p} من {tp} ({a} من {b} سجل)',

    // ── AWS Billing panel ──
    'billing.statPeriods': 'فترات الفوترة',
    'billing.titleRaw':    'AWS Billing Raw',
    'billing.searchPh':    'بحث عن product، payer، usage type…',
    'billing.period':      'الفترة:',
    'billing.btnFetchAws': 'جلب من AWS',
    'billing.fetchConfirm':'جلب بيانات AWS Billing للفترة {period} من Cost Explorer؟\nستُستبدل بيانات هذه الفترة في الجدول (وضع الاستبدال).',
    'billing.fetchResult': '{message} {count} صف — التكلفة ${cost}، الضريبة ${tax}، الإجمالي ${total}.',
    'billing.delConfirm':  'تفريغ جميع بيانات AWS Billing؟ لا يمكن التراجع!',
    'billing.btnClearTable':'تفريغ الجدول',
    'billing.empty':       'لا توجد بيانات فوترة بعد',
    'billing.monthsShort': 'ينا,فبر,مار,أبر,ماي,يون,يول,أغس,سبت,أكت,نوف,ديس',

    // ── AWS Cost panel ──
    'aws.statYears':       'السنوات المتاحة',
    'aws.titleRaw':        'AWS Cost Raw',
    'aws.searchPh':        'بحث عن usage type، product، BU…',
    'aws.from':            'من:',
    'aws.to':              'إلى:',
    'aws.empty':           'لا توجد بيانات AWS Cost بعد',
    'aws.delConfirm':      'تفريغ جميع بيانات AWS Cost ({n} صف) مع كامل سجل الرفع؟ لا يمكن التراجع!',
    'aws.cleared':         'تم تفريغ جدول AWS Cost.',
    'aws.invalidPeriod':   'الفترة غير صالحة.',
    'aws.invalidRange':    'الفترة غير صالحة (من > إلى).',
    'aws.allOutOfRange':   'جميع الفترات المحدّدة خارج نطاق AWS Cost Explorer (بحد أقصى 37 شهرًا للخلف). استخدم رفع CSV للبيانات القديمة.',
    'aws.skipNote':        ' ({n} شهر مُتخطّى — خارج النطاق: {list})',
    'aws.fetchConfirm':    'جلب بيانات AWS Cost {label} من Cost Explorer؟{skip}\nسيُستبدل كل شهر (وضع الاستبدال).',
    'aws.rangeLabel':      '{a} – {b} ({n} شهر)',
    'aws.progress':        'جارٍ جلب {period}… ({i}/{n})',
    'aws.monthRows':       '{period}: {count} صف (${total})',
    'aws.successAll':      '✅ نجح {n} شهر. {summary}. الإجمالي الكلّي ${grand}.{skip}',
    'aws.partial':         '⚠️ {ok} شهر ناجح، {fail} فاشل. الناجح: {summary}. الفاشل: {err}.{skip}',

    // ── SAP Config panel ──
    'sapcfg.errLandscape': 'حقل Landscape مطلوب.',
    'sapcfg.saved':        'تم الحفظ.',
    'sapcfg.delConfirm':   'حذف ملف التعريف {name}؟',
    'sapcfg.deleted':      'تم الحذف.',
    'sapcfg.intro':        'ملفات تعريف اتصال SAP لكل Landscape وEnvironment، محفوظة في SQLite. لا تُعرض كلمة المرور مجددًا لأغراض الأمان.',
    'sapcfg.btnAdd':       'إضافة',
    'sapcfg.empty':        'لا توجد ملفات تعريف بعد.',
    'sapcfg.colUpdated':   'آخر تحديث',
    'sapcfg.modalEdit':    'تعديل ملف تعريف SAP',
    'sapcfg.modalAdd':     'إضافة ملف تعريف SAP',
    'sapcfg.fPwEdit':      'كلمة المرور (فارغ = لا تُغيَّر)',
    'sapcfg.fPw':          'كلمة المرور',
    'sapcfg.bapiTitle':    'BAPI Service Paths — SAP User Maintenance (اختياري)',
    'sapcfg.bapiHint':     'يُملأ فقط إذا استُخدم هذا الملف لإدارة المستخدمين. خذه من خدمة WSDL المنشورة في SOAMANAGER.',
    'sapcfg.saving':       'جارٍ الحفظ…',

    // ── SQL Editor panel ──
    'sql.writeOk':         '{stmt} تم — تأثّر {n} صف.',
    'sql.readMsg':         '{n} صف{trunc}.',
    'sql.truncated':       ' (يُعرض أول 1000)',
    'sql.tablesLabel':     'الجداول:',
    'sql.allowWrite':      'السماح بالكتابة/DDL (UPDATE/DELETE/DROP/ALTER…)',
    'sql.running':         'جارٍ التنفيذ…',
    'sql.btnRun':          'تشغيل (Ctrl+Enter)',
    'sql.warnA':           '⚠ وضع الكتابة نشط — قد يؤدّي الاستعلام إلى ',
    'sql.warnBold':        'تعديل/حذف بيانات بشكل دائم',
    'sql.warnB':           ' (مثل DELETE/DROP). تأكّد من وجود WHERE ونسخة احتياطية. تُسجَّل جميع الإجراءات في سجل النشاط.',
    'sql.empty0':          'نجح الاستعلام، 0 صف.',
    'sql.exportFail':      'فشل التصدير: ',

    // ── Database maintenance (Debug / Vacuum / Backup / Restore) ──
    'db.stats.title':         'إحصائيات قاعدة البيانات',
    'db.stats.fileSize':      'حجم الملف',
    'db.stats.tables':        'الجداول',
    'db.stats.totalRows':     'إجمالي الصفوف',
    'db.stats.pages':         'الصفحات',
    'db.stats.freelist':      'Freelist',
    'db.stats.reclaimable':   'قابل للاسترجاع',
    'db.loading':             'جارٍ التحميل…',
    'db.btn.refresh':         'تحديث',
    'db.btn.integrity':       'فحص السلامة',
    'db.btn.integrityRunning':'جارٍ الفحص…',
    'db.btn.vacuum':          'VACUUM',
    'db.btn.vacuumRunning':   'VACUUM…',
    'db.btn.backup':          'نسخ احتياطي (.db)',
    'db.btn.backupRunning':   'جارٍ التحضير…',
    'db.btn.restore':         'استعادة (.db)',
    'db.btn.restoreRunning':  'جارٍ الاستعادة…',
    'db.warn.boldA':          'الاستعادة إجراء مُدمِّر',
    'db.warn.mid':            ' — تُستبدل قاعدة البيانات النشطة بالكامل بالملف المرفوع. نفّذ ',
    'db.warn.boldB':          'نسخًا احتياطيًا',
    'db.warn.end':            ' أولًا.',
    'db.confirm.vacuum':      'تشغيل VACUUM؟ ستُضغط قاعدة البيانات (قفل مؤقت). متابعة؟',
    'db.confirm.restore':     'الاستعادة ستستبدل قاعدة البيانات النشطة بالكامل بمحتوى "{name}".\nستُفقد البيانات الحالية ولا يمكن التراجع.\n\nيُنصح بعمل نسخة احتياطية أولًا. متابعة؟',
    'db.alert.integrityOk':   '✅ فحص السلامة سليم — قاعدة البيانات صحّية.',
    'db.alert.integrityBad':  '⚠️ عثر فحص السلامة على مشكلات. راجع التفاصيل أدناه.',
    'db.alert.vacuumOk':      '✅ اكتمل VACUUM. {before} → {after} (استُرجع {reclaimed}).',
    'db.alert.backupOk':      '✅ تم تنزيل النسخة الاحتياطية: {name}',
    'db.alert.restoreOk':     '✅ {message} ({n} جدول).',
    'db.integrity.healthy':   'فحص السلامة: صحّي',
    'db.integrity.problem':   'فحص السلامة: مشكلة',
    'db.integrity.fkBad':     'مفتاح خارجي به مشكلة:',
    'db.integrity.ignoredA':  'نتيجة FK متجاهَلة (بحكم التصميم): صف الإعداد العام',
    'db.integrity.ignoredB':  'المقصود بلا أصل في',

    // ── Telegram Bots (TelegramSettings) ──
    'tg.title':              'Telegram Bots',
    'tg.subtitle':           'إدارة بوت منفصل لكل لوحة + بوت الإشعارات',
    'tg.loadingBots':        'جارٍ تحميل البوتات...',
    'tg.errLoadBots':        'تعذّر تحميل البوتات: {err}',
    'tg.savedOk':            'تم حفظ البوت وضبط الـ webhook بنجاح.',
    'tg.testText':           '✅ اختبار من {name}',
    'tg.sectionConfig':      '⚙️ الإعدادات — {name}',
    'tg.typeLabel':          'النوع:',
    'tg.typeNotify':         'إشعارات',
    'tg.typeQuery':          'استعلام/محادثة',
    'tg.enableBot':          'تفعيل البوت',
    'tg.enableBotHint':      'سيستجيب البوت ويشغّل الجدول',
    'tg.botName':            'اسم البوت',
    'tg.botToken':           'رمز البوت',
    'tg.tokenSet':           '✓ تم ضبطه',
    'tg.tokenPlaceholderSet':'•••••• (املأ للتغيير)',
    'tg.tokenPlaceholder':   'الرمز من @BotFather',
    'tg.tokenHint':          'أنشئ بوتًا جديدًا عبر @BotFather ← /newbot ← انسخ الرمز',
    'tg.webhookUrl':         'Webhook URL (تلقائي)',
    'tg.webhookHint':        'يُضبط الـ webhook تلقائيًا عند النقر على حفظ.',
    'tg.saving':             'جارٍ الحفظ...',
    'tg.save':               '💾 حفظ',
    'tg.testSend':           '📨 اختبار الإرسال',
    'tg.sectionChatIds':     '👥 قائمة Chat ID المسموح بها',
    'tg.chatIdsHint':        'يستجيب هذا البوت فقط لـ Chat ID المدرجة هنا. الوصول إلى البيانات تلقائي حسب نطاق البوت ({scope}).',
    'tg.phName':             'الاسم',
    'tg.phChatId':           'Chat ID',
    'tg.phMinYear':          'أدنى سنة',
    'tg.addChatId':          '+ إضافة Chat ID',
    'tg.sectionAnswers':     '💬 ردود البوت (AI ونصوص)',
    'tg.answersHint':        'خصّص سلوك ونصوص هذا البوت. اتركها فارغة لاستخدام الافتراضي. تنطبق على هذا البوت فقط.',
    'tg.aiInstr':            'تعليمات AI (مخصّصة)',
    'tg.aiInstrPlaceholder': 'مثال: أنت مساعد خاص بـ SAP Basis وإدارة مستخدمي SAP. أجب باختصار عن صحّة SAP (job، lock، work process، dump) وإدارة المستخدمين (lock/unlock/reset). لا تعرض بيانات AWS/Solman/Cost.',
    'tg.aiInstrHint':        'يُضاف إلى system prompt الخاص بـ AI بوصفه "تعليمات إضافية".',
    'tg.welcome':            'نص الترحيب (/start) — اختياري',
    'tg.welcomePlaceholder': 'فارغ = مطابق لـ /help',
    'tg.help':               'نص المساعدة (/help) — اختياري',
    'tg.helpPlaceholder':    'فارغ = مساعدة تلقائية (قائمة الأوامر حسب نطاق البوت)',
    'tg.sectionSchedule':    '🕐 جدول الإشعارات',
    'tg.scheduleHintNotify': 'يرسل بوت الإشعارات لقطة بيانات مجدولة إلى جميع Chat ID.',
    'tg.scheduleHintQuery':  'يمكن لهذا البوت أيضًا إرسال إشعارات مجدولة حسب نطاقه.',
    'tg.addSchedule':        '+ إضافة جدول',
    'tg.saveSchedule':       '💾 حفظ الجدول',
    'tg.sectionGuide':       '📋 دليل إعداد البوتات المتعددة',
    'tg.guide1':             'أنشئ بوتًا منفصلًا في @BotFather لكل لوحة (5 بوتات)',
    'tg.guide2':             'اختر تبويب البوت في الأعلى ← أدخل الرمز ← احفظ (يُضبط الـ webhook تلقائيًا)',
    'tg.guide3':             'أضف Chat ID للمستخدمين المسموح لهم بالوصول إلى ذلك البوت',
    'tg.guide4':             'يكتب المستخدم /start إلى البوت المناسب',
    'tg.guide5':             'بوت الإشعارات 🔔 مخصّص للجدول فقط — لا يخدم المحادثة',
    'tg.phScheduleLabel':    'تسمية الجدول',
    'tg.typeAll':            'الكل (النطاق)',
    'tg.dow0':               'أحد',
    'tg.dow1':               'إثن',
    'tg.dow2':               'ثلا',
    'tg.dow3':               'أرب',
    'tg.dow4':               'خمي',
    'tg.dow5':               'جمع',
    'tg.dow6':               'سبت',

    // ── Telegram Chat Log (TelegramChatLog) ──
    'tgLog.title':           'Telegram Chat Log',
    'tgLog.subtitle':        'سجل محادثات AI عبر Telegram مع تقدير الرموز (tokens)',
    'tgLog.statTotal':       'إجمالي المحادثات',
    'tgLog.statTotalToken':  'إجمالي الرموز',
    'tgLog.statAvgToken':    'متوسط الرموز/محادثة',
    'tgLog.statAvgResp':     'متوسط الاستجابة',
    'tgLog.searchPlaceholder':'بحث عن سؤال أو إجابة أو اسم مستخدم...',
    'tgLog.searchBtn':       'بحث',
    'tgLog.loading':         'جارٍ تحميل السجل...',
    'tgLog.empty':           'لا توجد محادثات بعد.',
    'tgLog.error':           'خطأ',
    'tgLog.question':        'السؤال',
    'tgLog.answer':          'رد البوت',
    'tgLog.showMore':        'عرض المزيد',
    'tgLog.hide':            'إخفاء',
    'tgLog.prev':            '← السابق',
    'tgLog.next':            'التالي →',
    'tgLog.pageInfo':        'ص {page} / {totalPages} · {total} محادثة',
    'tgLog.unknown':         'غير معروف',

    // ── AI Chat History (AIChatHistory) ──
    'aih.title':             'AI Chat History',
    'aih.subtitleAdmin':     'استعرض جميع سجلات محادثات AI لكل المستخدمين',
    'aih.subtitleUser':      'استعرض سجل محادثات AI الخاص بك',
    'aih.relSec':            'منذ {n} ثانية',
    'aih.relMin':            'منذ {n} دقيقة',
    'aih.relHour':           'منذ {n} ساعة',
    'aih.relDay':            'منذ {n} يوم',
    'aih.statMessages':      'إجمالي الرسائل',
    'aih.statSessions':      'الجلسات',
    'aih.statUsers':         'المستخدمون',
    'aih.statTokens':        'إجمالي الرموز',
    'aih.statToday':         'اليوم',
    'aih.tokenUsageProvider':'استهلاك الرموز لكل مزوّد',
    'aih.tabSessions':       'سجل الجلسات',
    'aih.tabUsage':          'تقرير الاستهلاك',
    'aih.usageRange':        'المدى',
    'aih.usageDays':         '{n} يوم',
    'aih.usageTotal':        'إجمالي الرموز',
    'aih.usageEmpty':        'لا يوجد استهلاك رموز في هذا المدى.',
    'aih.usageDailyTitle':   'استهلاك الرموز اليومي',
    'aih.usageCostTotal':    'التكلفة التقديرية',
    'aih.usageCostTitle':    'التكلفة التقديرية لكل نموذج',
    'aih.colModel':          'المزوّد / النموذج',
    'aih.colInput':          'المُدخل',
    'aih.colOutput':         'المُخرَج',
    'aih.colCost':           'التكلفة (USD)',
    'aih.costUnpriced':      'التسعيرة غير مضبوطة',
    'aih.costTotalRow':      'الإجمالي',
    'aih.costDisclaimer':    'تقدير مبني على التسعيرات المُهيّأة (USD لكل مليون رمز، المُدخل والمُخرَج منفصلان). تحقّق من التسعيرات في الصفحة الرسمية للمزوّد — قد تتغيّر الأسعار وتختلف حسب المنطقة. مزوّدو الطبقة المجانية يُحتسبون $0.',
    'aih.msgCount':          '{n} رسالة',
    'aih.searchPlaceholder': 'بحث في محتوى الرسائل أو اللوحة...',
    'aih.filterUser':        'تصفية اسم المستخدم...',
    'aih.totalSessions':     '{n} جلسة إجمالًا',
    'aih.sessionsCount':     'الجلسات ({n})',
    'aih.empty':             'لا يوجد سجل محادثات بعد.',
    'aih.noQuestion':        '(لا يوجد سؤال من المستخدم)',
    'aih.deleteSession':     'حذف الجلسة',
    'aih.selectSession':     'اختر جلسة لعرض المحادثة.',
    'aih.sessionLabel':      'الجلسة',
    'aih.confirmDelete':     'حذف جلسة المحادثة هذه نهائيًا؟',
    'aih.deleteFailed':      'تعذّر الحذف: {err}',
    'aih.exportAll':         'تصدير جميع المحادثات',
    'aih.exportXlsx':        'تصدير XLSX',
    'aih.exportJson':        'تصدير JSON',
    'aih.exporting':         'جارٍ التصدير…',
    'aih.exportEmpty':       'لا توجد محادثات للتصدير.',
    'aih.exportTruncated':   'اقتُصرت النتائج على أعلى {n} صف.',
    'aih.exportFailed':      'فشل التصدير: {err}',
    'aih.tokenTipEst':       'تقدير (المزوّد لا يرسل الاستهلاك) — Prompt: {p} | Completion: {c}',
    'aih.tokenTipReal':      'رموز فعلية من المزوّد — Prompt: {p} | Completion: {c}',
    'aih.estBadge':          'تقدير',
    'aih.estTitle':          'عدد الرموز تقديري وليس رقمًا رسميًا من المزوّد',
    'aih.dataBadge':         'بيانات',

    // ── AI Data Sources (AIDataSources) ──
    'ads.title':             'AI Data Sources',
    'ads.subtitle':          'إدارة بيانات SQLite المُحقَنة في مساعد AI لكل لوحة',
    'ads.addDs':             'إضافة مصدر بيانات',
    'ads.addTitle':          'إضافة مصدر بيانات',
    'ads.editTitle':         'تعديل مصدر بيانات',
    'ads.tabQueries':        'Context Queries',
    'ads.tabSql':            'وضع SQL (Text-to-SQL)',
    'ads.label':             'التسمية',
    'ads.labelPlaceholder':  'مثل: أكثر مُنشئي التذاكر',
    'ads.sqlLabel':          'استعلام SQL (SELECT فقط)',
    'ads.sqlPlaceholder':    'SELECT created_by, COUNT(*) as n FROM solman_tickets GROUP BY created_by ORDER BY n DESC LIMIT 15',
    'ads.sqlNotePre':        'فقط',
    'ads.sqlNotePost':       'تُرفض جُمل الكتابة (INSERT/UPDATE/DELETE/DROP/إلخ) تلقائيًا.',
    'ads.active':            'نشط',
    'ads.inactive':          'غير نشط',
    'ads.botTelegram':       '✈️ بوت Telegram:',
    'ads.botNone':           '-- غير مستخدم --',
    'ads.botBilling':        'بوت AWS Billing',
    'ads.botCost':           'بوت AWS Cost',
    'ads.botSolman':         'بوت SAP Solman',
    'ads.botUsage':          'بوت SAP Usage',
    'ads.botNotify':         'بوت الإشعارات',
    'ads.preview':           'معاينة',
    'ads.rowCount':          '{n} صف',
    'ads.first50':           '(يُعرض أول 50)',
    'ads.previewNoData':     '(لا توجد بيانات)',
    'ads.saving':            'جارٍ الحفظ...',
    'ads.saveChanges':       'حفظ التغييرات',
    'ads.add':               'إضافة',
    'ads.errLabelSql':       'التسمية وSQL مطلوبان.',
    'ads.errLoadDs':         'تعذّر تحميل مصدر البيانات.',
    'ads.errToggle':         'تعذّر تغيير الحالة.',
    'ads.errLoadSql':        'تعذّر تحميل إعدادات SQL.',
    'ads.errDashKey':        'dashboard_key مطلوب.',
    'ads.errPickTable':      'اختر جدولًا واحدًا على الأقل.',
    'ads.errSave':           'تعذّر الحفظ.',
    'ads.errRemove':         'تعذّر الحذف.',
    'ads.sqlSaved':          'تم حفظ إعدادات SQL.',
    'ads.removed':           'تم الحذف.',
    'ads.dsDeleted':         'تم حذف مصدر البيانات.',
    'ads.dsUpdated':         'تم تحديث مصدر البيانات.',
    'ads.dsAdded':           'تمت إضافة مصدر البيانات.',
    'ads.confirmRemoveSql':  'إزالة وضع SQL لـ "{dk}"؟ تعود اللوحة إلى الوضع الثابت.',
    'ads.confirmDeleteDs':   'حذف مصدر البيانات "{label}"؟',
    'ads.sqlModeInfoBold':   'وضع SQL (text-to-SQL):',
    'ads.sqlModeInfoRest':   'للوحات المدرجة هنا، يُنشئ AI استعلام SQL بنفسه لكل سؤال (مناسب للبيانات متعددة الأبعاد). لا يُسمح لـ AI بالوصول إلا للجداول المختارة، ويُتحقّق من الاستعلام كقراءة فقط + مُقيّد بـ LIMIT على الخادم. اللوحات غير المدرجة هنا تظل تستخدم Context Queries الثابتة.',
    'ads.addSqlDash':        'إضافة لوحة SQL',
    'ads.editSqlDash':       'تعديل: {dk}',
    'ads.noSqlDash':         'لا توجد لوحات بوضع SQL بعد.',
    'ads.noSqlDashHint':     'انقر "إضافة لوحة SQL" لتفعيل text-to-SQL.',
    'ads.dashKeyPlaceholder':'مثل aws_cost، overtime',
    'ads.tablesLabel':       'الجداول المسموح بالوصول إليها ({n} مختار)',
    'ads.hintLabel':         'تلميح لـ AI (اختياري)',
    'ads.hintPlaceholder':   'اشرح معنى الأعمدة/الوحدات ليكون SQL الذي يُنشئه AI أكثر دقة.',
    'ads.fewShotLabel':      'أمثلة / Few-shot (اختياري)',
    'ads.fewShotPlaceholder':'أمثلة سؤال ← SQL الصحيح (نمط مرجعي). مثال:\nQ: top 5 reason per company\nSQL: SELECT bu, reason, total FROM (SELECT bu, reason, SUM(amount) total, ROW_NUMBER() OVER(PARTITION BY bu ORDER BY SUM(amount) DESC) rnk FROM employee_overtime GROUP BY bu,reason) WHERE rnk<=5 ORDER BY bu,total DESC',
    'ads.fewShotHelp':       'يُضاف إلى prompt الخاص بـ SQL بوصفه نمطًا مرجعيًا لهذه اللوحة. اتركه فارغًا إن لم يلزم.',
    'ads.sqlModeOn':         'وضع SQL نشط',
    'ads.sqlModeOff':        'غير نشط (وضع ثابت)',
    'ads.noDs':              'لا يوجد مصدر بيانات لهذه اللوحة بعد.',
    'ads.noDsHint':          'انقر "إضافة مصدر بيانات" لإنشاء أول استعلام.',
    'ads.enable':            'تفعيل',
    'ads.disable':           'تعطيل',
    'ads.dsInfoPre':         'مصادر البيانات النشطة لـ',
    'ads.dsInfoMid':         'تُجمَّع في سياق يُرسل إلى AI في كل مرة يسأل فيها المستخدم في هذه اللوحة. الجداول الرئيسية:',

    // ── Activity Log (LogViewer) ──
    'log.title':             'سجل النشاط',
    'log.subtitle':          'مراقبة نشاط جميع المستخدمين · {n} إجمالي السجلات',
    'log.autoRefresh':       'تحديث تلقائي',
    'log.on':                'ON',
    'log.off':               'OFF',
    'log.exportCsv':         'تصدير CSV',
    'log.statToday':         'نشاط اليوم',
    'log.statLoginOk':       'إجمالي تسجيلات الدخول الناجحة',
    'log.statLoginFail':     'تسجيلات دخول فاشلة',
    'log.statActiveUsers':   'المستخدمون النشطون',
    'log.topUsers':          'أعلى المستخدمين (النشاط)',
    'log.actionDist':        'توزيع الإجراءات',
    'log.filter':            'تصفية:',
    'log.searchPlaceholder': 'بحث عن اسم مستخدم، IP، تفاصيل...',
    'log.searchBtn':         'بحث',
    'log.allActions':        'جميع الإجراءات',
    'log.allUsers':          'جميع المستخدمين',
    'log.resetFilter':       '× إعادة تعيين التصفية',
    'log.showing':           'عرض {n} من {total} سجل',
    'log.colId':             'ID',
    'log.colTime':           'الوقت',
    'log.colUser':           'المستخدم',
    'log.colAction':         'الإجراء',
    'log.colDetail':         'التفاصيل',
    'log.colIp':             'عنوان IP',
    'log.colBrowser':        'المتصفّح',
    'log.colRole':           'الدور',
    'log.colUsername':       'اسم المستخدم',
    'log.loading':           'جارٍ تحميل السجل...',
    'log.empty':             'لم يتم العثور على سجلات',
    'log.pageInfo':          'الصفحة {page} من {totalPages}',
    'log.rangeInfo':         '{from}–{to} من {total}',
    'log.prev':              'السابق',
    'log.next':              'التالي',
    'log.relSec':            'منذ {n}ث',
    'log.relMin':            'منذ {n}د',
    'log.relHour':           'منذ {n}س',
    'log.relDay':            'منذ {n}ي',
    'log.actLoginOk':        'تسجيل دخول',
    'log.actLoginFail':      'فشل تسجيل الدخول',
    'log.actLogout':         'تسجيل خروج',
    'log.actViewDash':       'فتح لوحة',
    'log.actOpenAi':         'فتح AI',
    'log.actSaveAiConfig':   'حفظ إعدادات AI',

    // ── AI Workspace (AIWorkspace) ──
    'aiw.pickerLabel':       'تحليل البيانات:',
    'aiw.general':           'عام (بدون بيانات لوحة)',
    'aiw.autoDetected':      'اختيار تلقائي',
    'aiw.autoDetectedNote':  'تم اختيار مصدر البيانات تلقائيًا حسب سؤالك.',
    'aiw.sessionNote':       'جلسة منفصلة عن اللوحة في الرأس. تغيير الاختيار ← بدء جلسة جديدة.',
    'aiw.loadingConfig':     'جارٍ تحميل الإعدادات...',

    // ── User Management (UserManagement) ──
    'um.title':              'User Management',
    'um.subtitle':           '{n} إجمالي المستخدمين المسجّلين · {m} دور متاح',
    'um.addUserBtn':         'إضافة مستخدم',
    'um.totalUsers':         'إجمالي المستخدمين',
    'um.searchPlaceholder':  'بحث عن اسم مستخدم...',
    'um.all':                'الكل',
    'um.colNum':             '#',
    'um.colUsername':        'اسم المستخدم',
    'um.colRole':            'الدور',
    'um.colAccess':          'الوصول',
    'um.colCreated':         'تاريخ الإنشاء',
    'um.colLastLogin':       'آخر تسجيل دخول',
    'um.colAction':          'إجراء',
    'um.empty':              'لم يتم العثور على مستخدمين',
    'um.none':               'لا يوجد',
    'um.never':              'لم يحدث بعد',
    'um.tipEdit':            'تعديل المستخدم',
    'um.tipCopy':            'نسخ المستخدم',
    'um.copyUser':           'نسخ المستخدم',
    'um.copyingFrom':        'نسخ الدور من {name}',
    'um.tipReset':           'إعادة تعيين كلمة المرور',
    'um.tipDelete':          'حذف المستخدم',
    'um.createdOk':          'تم إنشاء المستخدم بنجاح.',
    'um.updatedOk':          'تم تحديث المستخدم بنجاح.',
    'um.userDeleted':        'تم حذف المستخدم "{name}" بنجاح.',
    'um.deleteUserTitle':    'حذف المستخدم',
    'um.irreversible':       'لا يمكن التراجع عن هذا الإجراء',
    'um.confirmDeleteUser':  'هل أنت متأكد من حذف المستخدم "{name}" (الدور: {role})؟',
    'um.yesDelete':          'نعم، احذف',
    'um.editUser':           'تعديل المستخدم',
    'um.addUser':            'إضافة مستخدم جديد',
    'um.editingUser':        'تعديل: {name}',
    'um.createAccount':      'إنشاء حساب جديد',
    'um.username':           'اسم المستخدم',
    'um.usernamePlaceholder':'أدخل اسم المستخدم',
    'um.usernameLocked':     'لا يمكن تغيير اسم المستخدم.',
    'um.password':           'كلمة المرور',
    'um.pwOptional':         '(اتركها فارغة إن لم ترغب في التغيير)',
    'um.pwNewPlaceholder':   'كلمة مرور جديدة (اختياري)',
    'um.pwPlaceholder':      'أدخل كلمة المرور',
    'um.role':               'الدور',
    'um.access':             'الوصول:',
    'um.allAccessAdmin':     'وصول كامل (مسؤول)',
    'um.noAccess':           'لا يوجد وصول',
    'um.saveChanges':        'حفظ التغييرات',
    'um.createUser':         'إنشاء مستخدم',
    'um.resetPw':            'إعادة تعيين كلمة المرور',
    'um.userLabel':          'المستخدم:',
    'um.pwResetOk':          'تمت إعادة تعيين كلمة المرور بنجاح!',
    'um.pwResetPlaceholder': 'كلمة مرور جديدة (6 أحرف على الأقل)',
    'um.allAccess':          'وصول كامل',
    'um.errLoad':            'تعذّر تحميل البيانات.',
    'um.errDelete':          'تعذّر حذف المستخدم.',
    'um.errSaveUser':        'تعذّر حفظ المستخدم.',
    'um.errReset':           'تعذّرت إعادة تعيين كلمة المرور.',
    'um.errUserReq':         'اسم المستخدم مطلوب.',
    'um.errUserMin':         'اسم المستخدم 3 أحرف على الأقل.',
    'um.errPwReq':           'كلمة المرور مطلوبة للمستخدم الجديد.',
    'um.errPwMin':           'كلمة المرور 6 أحرف على الأقل.',
    'um.errRoleReq':         'يجب اختيار دور.',

    // ── Role Management (RoleManagement) ──
    'rm.title':              'Role Management',
    'rm.subtitle':           'إنشاء وإدارة أدوار مخصّصة للتحكّم في الوصول إلى اللوحات',
    'rm.createRoleBtn':      'إنشاء دور',
    'rm.totalRoles':         'إجمالي الأدوار',
    'rm.customRoles':        'أدوار مخصّصة',
    'rm.totalUsers':         'إجمالي المستخدمين',
    'rm.searchPlaceholder':  'بحث عن دور...',
    'rm.loading':            'جارٍ تحميل قائمة الأدوار...',
    'rm.empty':              'لم يتم العثور على أدوار',
    'rm.systemBadge':        'نظامي',
    'rm.noDesc':             'بدون وصف',
    'rm.userUnit':           'مستخدم',
    'rm.permUnit':           'صلاحية',
    'rm.updatedAt':          'حُدّث {date}',
    'rm.allAccessBuiltin':   'وصول كامل (مدمج)',
    'rm.noPerm':             'لا توجد صلاحيات',
    'rm.tipSysNoEdit':       'لا يمكن تعديل الأدوار النظامية',
    'rm.tipEdit':            'تعديل الدور',
    'rm.tipSysNoDelete':     'لا يمكن حذف الأدوار النظامية',
    'rm.tipInUse':           'لا يزال مستخدمًا بواسطة {n} مستخدم',
    'rm.tipDelete':          'حذف الدور',
    'rm.createdOk':          'تم إنشاء الدور بنجاح.',
    'rm.updatedOk':          'تم تحديث الدور بنجاح.',
    'rm.roleDeleted':        'تم حذف الدور "{name}" بنجاح.',
    'rm.deleteRoleTitle':    'حذف الدور',
    'rm.irreversible':       'لا يمكن التراجع عن هذا الإجراء',
    'rm.confirmDelete':      'هل أنت متأكد من حذف الدور "{name}"؟',
    'rm.yesDelete':          'نعم، احذف',
    'rm.editRole':           'تعديل الدور',
    'rm.newRole':            'إنشاء دور جديد',
    'rm.editing':            'تعديل: {name}',
    'rm.subtitleNew':        'عرّف دورًا مخصّصًا بصلاحيات محدّدة',
    'rm.roleName':           'اسم الدور',
    'rm.namePlaceholder':    'مثال: FINANCE، AUDITOR، MANAGER...',
    'rm.nameLocked':         'لا يمكن تغيير اسم الدور.',
    'rm.nameHint':           'أحرف وأرقام وشرطة سفلية أو شرطة. 2-30 حرفًا.',
    'rm.description':        'الوصف',
    'rm.descPlaceholder':    'شرح موجز لهذا الدور',
    'rm.permissions':        'الصلاحيات',
    'rm.selectedCount':      '({n} مختار)',
    'rm.checkAll':           'تحديد الكل',
    'rm.uncheckAll':         'إلغاء تحديد الكل',
    'rm.saveChanges':        'حفظ التغييرات',
    'rm.createRole':         'إنشاء دور',
    'rm.errLoad':            'تعذّر تحميل قائمة الأدوار.',
    'rm.errDelete':          'تعذّر حذف الدور.',
    'rm.errSave':            'تعذّر حفظ الدور.',
    'rm.errNameReq':         'اسم الدور مطلوب.',
    'rm.errNameFormat':      'اسم الدور يقبل الأحرف/الأرقام/_/- فقط (2-30 حرفًا).',
    'rm.errPermReq':         'اختر صلاحية واحدة على الأقل لهذا الدور.',
    'rm.grpDashboard':       'اللوحات',
    'rm.grpAdmin':           'صفحات الإدارة',
    'rm.grpHr':              'الموارد البشرية',
    'rm.grpOther':           'أخرى',
    'rm.desc.aws_billing':       'التكلفة والاستخدام',
    'rm.desc.aws_cost':          'تحليل التكاليف',
    'rm.desc.aws_inventory':     'جرد الموارد',
    'rm.desc.aws_cloudtrail':    'التدقيق والأحداث',
    'rm.desc.solman':            'التذاكر والحوادث',
    'rm.desc.sap_usage':         'الاستخدام',
    'rm.desc.logs':              'عرض سجل التدقيق',
    'rm.desc.ai_history':        'سجل محادثات AI',
    'rm.desc.ai_config':         'ضبط مصادر البيانات وتوجيه AI',
    'rm.desc.ai_workspace':      'محادثة AI بملء الصفحة',
    'rm.desc.users':             'إدارة المستخدمين',
    'rm.desc.role_management':   'إدارة الأدوار',
    'rm.desc.table_maintenance': 'صيانة قاعدة البيانات',
    'rm.desc.telegram':          'إدارة بوتات Telegram',
    'rm.desc.telegram_log':      'سجل محادثات Telegram',
    'rm.desc.sap_user_mgmt':     'إدارة مستخدمي SAP',
    'rm.desc.employee_overtime': 'بيانات العمل الإضافي للموظفين',
    'rm.desc.sap_basis_mon':          'الصحة: المهام والأقفال وعمليات العمل والنظام',
    'rm.desc.sap_roles':              'تدقيق الأدوار والتعيينات (للقراءة فقط)',
    'rm.desc.sap_customizing':        'مخارج المستخدم وBAdI والتحسينات',
    'rm.desc.sap_source':             'عرض شيفرة ABAP للبرامج المخصصة',
    'rm.desc.sap_table_peek':         'عرض عيّنة من محتوى جداول SAP (بيانات العمل)',
    'rm.desc.transport':              'عرض قائمة انتظار STMS',
    'rm.desc.transport_import':       'تنفيذ الاستيراد إلى Q01/P01',
    'rm.desc.monthly_report':         'تقرير شهري تلقائي',
    'rm.desc.notes':                  'إدارة الملاحظات',
    'rm.desc.notes_plain':            'ملاحظات بدون فهرسة RAG',
    'rm.desc.ai_settings':            'المزود والنموذج ومفتاح API',
    'rm.desc.ai_coding':              'مساعد البرمجة + استخدام الأدوات',
    'rm.desc.ai_actions':             'إجراءات بلغة طبيعية + موافقة',
    'rm.desc.m365_license':           'ملخص تراخيص Microsoft 365',
    'rm.desc.m365_pricing_edit':      'تعديل أسعار تراخيص M365',
    'rm.desc.sdp':                    'ManageEngine للتذاكر والأصول',
    'rm.needsParent':        'يتطلب تحديد «{parent}» أيضًا',

    // ── Microsoft 365 License ──
    'm365.title':               'تراخيص Microsoft 365',
    'm365.lastSnapshot':        'آخر لقطة: {snap}',
    'm365.noDataHint':          'لا توجد بيانات بعد — شغّل الجلب في Table Maintenance.',
    'm365.tabOverview':         'ملخّص',
    'm365.tabUserDetail':       'تفاصيل المستخدم',
    'm365.tabPricing':           'التسعير',
    'm365.tabAnalytics':       'التحليلات',
    'm365.anHint':             'تعرض هذه التحليلات اللقطة الحالية (وليست اتجاهًا) وهي مقصورة على مجموعة موقع إندونيسيا. تستخدم قيم التكلفة الأسعار الرئيسية من تبويب التسعير — تأكد من ضبط الأسعار ثم اضغط Calculate للدقة.',
    'm365.snapshot':           'آخر لقطة',
    'm365.anNoPrices':         'لم تُضبط الأسعار — قيم التكلفة = 0.',
    'm365.anSavings':          'إمكانية توفير التكلفة',
    'm365.anUnlicensed':       'مستخدمون بلا ترخيص',
    'm365.anDisabledLicensed': 'معطّل لكنه مرخّص',
    'm365.anPotentialSaving':  'التوفير المقدّر',
    'm365.anPerFetch':         'حسب آخر لقطة',
    'm365.anRevokeCandidates': 'مرشّحو سحب الترخيص (حسابات معطّلة)',
    'm365.anCapacityRisk':     'مخاطر السعة',
    'm365.anNearFull':         'شبه ممتلئ (≥90%)',
    'm365.anLowUse':           'استخدام منخفض (<50%)',
    'm365.anIdleCost':         'تكلفة غير مستغلّة',
    'm365.anCostByOrg':        'التكلفة حسب المؤسسة',
    'm365.anNoOrgData':        'لا توجد بيانات كافية للقسم/الشركة للتحليل.',
    'm365.anByDept':           'التكلفة حسب القسم',
    'm365.anByCompany':        'التكلفة حسب الشركة',
    'm365.anDistribution':     'التوزيع والحالات الشاذة',
    'm365.anLicenseMix':       'مزيج التراخيص',
    'm365.anAnomalies':        'حالات شاذة',
    'm365.anPaidNoDept':       'مرخّص بلا قسم',
    'm365.pricingTitle':         'أسعار التراخيص',
    'm365.pricingReadOnlyHint':  'يمكن للمسؤولين/الأدوار المصرّح لها فقط تعديل الأسعار.',
    'm365.calculate':            'احسب',
    'm365.calcDone':             'اكتمل الحساب.',
    'm365.calcHint':             'تم تحديث التكلفة لكل نطاق (مجموعة إندونيسيا) في تبويب الملخّص.',
    'm365.refresh':              'تحديث',
    'm365.save':                 'حفظ',
    'm365.saveAll':              'حفظ الكل',
    'm365.yes':                  'نعم',
    'm365.colLicenseType':       'نوع الترخيص',
    'm365.colCategory':          'الفئة',
    'm365.colPriceUsd':          'السعر (دولار)',
    'm365.colNotes':             'ملاحظات',
    'm365.colUpdated':           'آخر تحديث',
    'm365.colAction':            'إجراء',
    'm365.kpiTotalUsers':       'إجمالي المستخدمين',
    'm365.kpiAssigned':         'التراخيص المستخدمة',
    'm365.kpiUnlicensed':       'بدون ترخيص',
    'm365.kpiDomains':          'النطاقات',
    'm365.chartPerDomain':      'التراخيص لكل نطاق — إندونيسيا',
    'm365.chartCategoryDist':   'توزيع فئات التراخيص',
    'm365.totalLicensesLabel':  'إجمالي التراخيص',
    'm365.capacityTitle':       'سعة التراخيص',
    'm365.distributionTitle':   'توزيع التراخيص لكل نطاق',
    'm365.perUserTitle':        'تفاصيل الترخيص لكل مستخدم',
    'm365.userDetailTitle':     'تفاصيل المستخدم',
    'm365.rows':                'صفوف',
    'm365.users':               'مستخدم',
    'm365.noUsers':             'لا يوجد مستخدمون.',
    'm365.exportExcel':         'تصدير Excel',
    'm365.allDomains':          'جميع النطاقات',
    'm365.allLicenses':         'جميع التراخيص',
    'm365.allStatus':           'جميع الحالات',
    'm365.allLicenseState':     'الكل مرخّص/غير مرخّص',
    'm365.licensed':            'مرخّص',
    'm365.unlicensedOpt':       'بدون ترخيص',
    'm365.enabledYes':          'نشط',
    'm365.enabledNo':           'غير نشط',
    'm365.search':              'بحث',
    'm365.reset':               'إعادة تعيين',
    'm365.searchUpnDomain':     'بحث عن UPN / نطاق…',
    'm365.searchDetail':        'بحث عن UPN / اسم / بريد / قسم…',
    'm365.prev':                'السابق',
    'm365.next':                'التالي',
    'm365.page':                'ص',
    'm365.colDomain':           'النطاق',
    'm365.colLicense':          'الترخيص',
    'm365.colLicenses':         'التراخيص',
    'm365.colSkuPart':          'SKU Part',
    'm365.colAvailable':        'متاح',
    'm365.colAssignedTotal':    'المستخدم / الإجمالي',
    'm365.colDisplayName':      'الاسم',
    'm365.colDepartment':       'القسم',
    'm365.colCompany':          'الشركة',
    'm365.colEnabled':          'الحالة',

    // ── SAP Notes (ditambahkan: melengkapi parity dengan id/en) ──
    'sapnote.cancelSelect':        'إلغاء التحديد',
    'sapnote.noContentSaved':      'لم يتم حفظ محتوى الملاحظة بعد. اسحبه من النظام لتخزينه بشكل دائم (أو أضف مرفق PDF عبر أيقونة المرفقات).',
    'sapnote.noAttachments':       'لا توجد مرفقات بعد.',
    'sapnote.noNotes':             'لا توجد ملاحظات بعد. أضف واحدة عبر الحقل أعلاه.',
    'sapnote.openPortal':          'فتح في البوابة',
    'sapnote.remark':              'ملاحظات',
    'sapnote.htmlUnavailable':     'محتوى HTML غير متوفر لهذه الملاحظة/اللغة في النظام. جرّب «تعبئة من PDF» أو «فتح في البوابة».',
    'sapnote.noteContentFromSystem': 'محتوى الملاحظة (من النظام)',
    'sapnote.subtitle':            'فهرس وأرشيف وتتبّع ملاحظات SAP للبيئة — فتح في البوابة، حفظ PDF، تتبّع الحالة.',
    'sapnote.manage':              'إدارة',
    'sapnote.stepperHint':         'انقر على مرحلة لتغيير حالة الملاحظة (يُحفظ فوراً).',
    'sapnote.clear':               'مسح',
    'sapnote.snoteStep':           'خطوة SNOTE: المعاملة',
    'sapnote.loading':             'جارٍ التحميل…',
    'sapnote.pullSrsHint':         'اسحب العَرَض/السبب/الحل من SAP ثم أرشِفه (إذا كانت الملاحظة محمّلة في النظام).',
    'sapnote.pullingArchiving':    'جارٍ السحب من النظام والأرشفة…',
    'sapnote.contactingSap':       'جارٍ الاتصال بنظام SAP…',
    'sapnote.deleteWarnOne':       'سيتم حذف بيانات هذه الملاحظة وجميع مرفقاتها نهائياً.',
    'sapnote.deleteWarnMany':      'سيتم حذف بياناتها وجميع مرفقاتها نهائياً.',
    'sapnote.loadArchive':         'تحميل وأرشفة من النظام',
    'sapnote.loadContent':         'تحميل المحتوى من النظام',
    'sapnote.reloadFromSystem':    'إعادة التحميل من النظام',
    'sapnote.reload':              'إعادة تحميل',
    'sapnote.noteNumber':          'رقم الملاحظة',
    'sapnote.notDownloaded':       'لم يتم تنزيل هذه الملاحظة إلى النظام. نزّلها أولاً عبر',
    'sapnote.pdfArchivedWith':     'سيتم أرشفة ملف PDF مع الملاحظة:',
    'sapnote.selectAllShown':      'تحديد الكل (المعروض)',
    'sapnote.selectNew':           'تحديد الجديد',
    'sapnote.properties':          'الخصائص',
    'sapnote.sapNote':             'ملاحظة SAP',
    'sapnote.snote':               'SNOTE',
    'sapnote.alsoArchive':         'أرشفة محتوى الملاحظة أيضاً (التي لها عنوان/مكوّن)',
    'sapnote.allStatus':           'كل الحالات',
    'sapnote.saveToList':          'حفظ في القائمة',
    'sapnote.applyStatus':         'حالة التطبيق',
    'sapnote.noMatch':             'لا نتائج مطابقة للتصفية.',
    'sapnote.addOpenNote':         'إضافة / فتح ملاحظة',
    'sapnote.pullFromSystem':      'سحب من النظام',
    'sapnote.pullNotConfigured':   'خاصية السحب من النظام غير مهيأة على الخادم. استخدم حالياً «تعبئة من PDF» أو «فتح في البوابة».',
    'sapnote.noNotesInSystem':     'لم يتم العثور على ملاحظات في النظام.',
    'sapnote.uploadHint':          'أي نوع (PDF، سكربت، صورة، ‎.SAR/.CAR‎، zip…)، بحد أقصى 20 ميغابايت للملف، وحتى 20 ملفاً لكل رفع.',
    'sapnote.download':            'تنزيل',
    'sapnote.exists':              'موجود بالفعل',
    'sapnote.fetchListTitle':      'جلب قائمة الملاحظات الموجودة في نظام SAP',
    'sapnote.searchPlaceholder':   'ابحث بالرقم / العنوان / المكوّن / النظام / محتوى الملاحظة',
    'sapnote.searchSysPlaceholder': 'ابحث بالرقم / المكوّن / الحالة',
    'sapnote.noteDetail':          'تفاصيل الملاحظة',
    'sapnote.skipHint':            'يُتخطّى فقط إذا كان العنوان والمكوّن فارغين معاً',
    'sapnote.noteContentSystem':   'محتوى الملاحظة من النظام',
    'sapnote.noteContent':         'محتوى الملاحظة',
    'sapnote.manageAttachments':   'إدارة المرفقات',
    'sapnote.remarkPlaceholder':   'السياق، روابط النقل/التذكرة، الأثر…',
    'sapnote.attachments':         'المرفقات',
    'sapnote.viewNoteContent':     'عرض محتوى الملاحظة',
    'sapnote.view':                'عرض',
    'sapnote.selectDeleteEmpty':   'تحديد وحذف الملاحظات بدون عنوان ومكوّن',
    'sapnote.selectAllShownTitle': 'تحديد كل المعروض حالياً',
    'sapnote.titlePlaceholder':    'ملخّص قصير للملاحظة',
    'sapnote.repullTitle':         'إعادة سحب أحدث محتوى من SAP (يُحدَّث الأرشيف عند تغيّر الإصدار)',
    'sapnote.downloadHtmlTitle':   'تنزيل ملف HTML إلى جهازك',
    'sapnote.uploadPdfTitle':      'ارفع ملف PDF لمحتوى الملاحظة ← يتم تعبئة العنوان/المكوّن/الأولوية تلقائياً',
    'sapnote.egNoteNumber':        'مثال: 3421567',
    'sapnote.egComponent':         'مثال: FI-GL',
    'sapnote.egPriority':          'مثال: عالية / تصحيح',
    'sapnote.egSystem':            'مثال: P01، D01',
    'sapnote.preview':             'معاينة',
    'sapnote.statusReview':        'للمراجعة',
    'sapnote.statusApplying':      'قيد التطبيق',
    'sapnote.statusDone':          'منجَز',
    'sapnote.changeStatusTo':      'تغيير الحالة إلى «{status}»',
    'sapnote.colNumber':           'الرقم',
    'sapnote.title':               'العنوان',
    'sapnote.component':           'المكوّن',
    'sapnote.system':              'النظام',
    'sapnote.status':              'الحالة',
    'sapnote.priority':            'الأولوية',
    'sapnote.version':             'الإصدار',
    'sapnote.statusInSystem':      'الحالة في النظام',
    'sapnote.processedBy':         'تمت المعالجة بواسطة',
    'sapnote.portalBanner':        '«فتح في البوابة» يستخدم جلسة SSO في متصفحك. «تعبئة من PDF» تقرأ ترويسة الملاحظة من ملف PDF (زر «pdf» في البوابة، وليس ملف ‎.SAR‎) لتعبئة الحقول تلقائياً — ثم تُؤرشَف نسخة PDF عند الحفظ.',
    'sapnote.editNote':            'تعديل الملاحظة {n}',
    'sapnote.saveNewNote':         'حفظ ملاحظة جديدة',
    'sapnote.deleteNoteTitle':     'حذف الملاحظة {n}؟',
    'sapnote.attachmentsTitle':    'المرفقات · الملاحظة {n}',
    'sapnote.addAttachment':       'إضافة مرفق',
    'sapnote.noteContentTitle':    'محتوى الملاحظة {n}',
    'sapnote.errNoteNumber':       'يجب أن يكون رقم الملاحظة رقمياً (12 خانة كحد أقصى).',
    'sapnote.pdfFilled':           'تمت تعبئة الحقول من PDF — راجعها ثم احفظ.',
    'sapnote.noteUpdated':         'تم تحديث الملاحظة {n}.',
    'sapnote.saveButAttachFail':   'تم حفظ الملاحظة، لكن فشل إرفاق ملف PDF: ',
    'sapnote.noteSaved':           'تم حفظ الملاحظة {n}.',
    'sapnote.noteSavedPdf':        'تم حفظ الملاحظة {n} وأرشفة ملف PDF.',
    'sapnote.noteDeleted':         'تم حذف الملاحظة {n}.',
    'sapnote.notesDeleted':        'تم حذف {count} ملاحظة.',
    'sapnote.attachAdded':         'تمت إضافة {count} مرفق.',
    'sapnote.attachDeleted':       'تم حذف المرفق.',
    'sapnote.notDownloadedFlash':  'الملاحظة غير محمّلة في النظام (نزّلها أولاً عبر SNOTE).',
    'sapnote.contentUnavailable':  'محتوى الملاحظة غير متوفر في النظام.',
    'sapnote.contentPulled':       'تم سحب محتوى الملاحظة من النظام وأرشفته.',
    'sapnote.pullNotConfiguredShort': 'خاصية السحب من النظام غير مهيأة على الخادم.',
    'sapnote.contentArchivedAuto': 'تمت أرشفة محتوى {count} ملاحظة تلقائياً.',
    'sapnote.selectAtLeastOne':    'اختر ملاحظة واحدة على الأقل.',
    'sapnote.importResult':        '{created} تم إنشاؤها، {skipped} تم تخطّيها',
    'sapnote.importInvalid':       '، {invalid} غير صالحة',
    'sapnote.noEmptyNotes':        'لا توجد ملاحظات فارغة.',
    'sapnote.fillNumberFirst':     'أدخل رقم الملاحظة أولاً.',
    'sapnote.fillFromPdf':         'تعبئة من PDF',

    // ── AI Actions ──
    'aiact.title':                 'إجراءات الذكاء الاصطناعي',
    'aiact.subtitle':              'أوامر بلغة طبيعية ← إجراءات محكومة مع موافقة وتدقيق',
    'aiact.tabRun':                'تشغيل',
    'aiact.tabManage':             'إدارة الإجراءات المخصّصة',
    'aiact.send':                  'إرسال',
    'aiact.inputPlaceholder':      'مثال: «افتح قفل المستخدم BUDI في PRD» أو «اعرض المستخدمين المقفلين في QAS»',
    'aiact.actionsAvailable':      '{count} إجراء متاح',
    'aiact.aiChose':               'اختار الذكاء الاصطناعي',
    'aiact.with':                  'مع',
    'aiact.noMatch':               'لم يجد الذكاء الاصطناعي إجراءً مطابقاً لهذا الطلب.',
    'aiact.executedDirect':        'تم التنفيذ مباشرة (إجراء قراءة) —',
    'aiact.awaitingApproval':      'بانتظار الموافقة —',
    'aiact.expiryHint':            'تنتهي الصلاحية خلال 10 دقائق. تحقّق من الهدف والبيئة قبل الموافقة.',
    'aiact.approveRun':            'الموافقة والتشغيل',
    'aiact.reject':                'رفض',
    'aiact.approvedExecuted':      'تمت الموافقة والتنفيذ.',
    'aiact.rejected':              'تم رفض الاقتراح. لم يُنفَّذ أي شيء.',
    'aiact.execFailed':            'فشل التنفيذ:',
    'aiact.history48h':            'آخر 48 ساعة',
    'aiact.noActionsYet':          'لا توجد إجراءات بعد. اكتب أمراً أعلاه للبدء.',
    'aiact.colTime':               'الوقت',
    'aiact.colParam':              'المعاملات',
    'aiact.colSource':             'المصدر',
    'aiact.colRequester':          'مقدّم الطلب',
    'aiact.colStatus':             'الحالة',
    'aiact.colApprover':           'الموافِق',
    'aiact.tempPassword':          'كلمة مرور مؤقتة',
    'aiact.tempPasswordHint':      'شاركها عبر قناة آمنة. يجب على المستخدم تغييرها عند أول تسجيل دخول. هذه القيمة لا تُخزَّن في السجلات.',
    'aiact.moreItems':             '… +{n} أخرى',
    'aiact.showJson':              'عرض JSON الخام',
    'aih.cachedOnly':              'المخزَّن فقط',
    'ai.modeSql':                  'استعلام جديد',
    'ai.inheritedPeriod':          'فترة موروثة',
    'ai.inheritedPeriodTitle':     'أُكمل هذا السؤال تلقائيًا بالفترة من الدور السابق: {periods}.',
    'ai.modeSqlTitle':             'تم تحويل السؤال إلى استعلام SQL جديد. إذا كان المقصود متابعة، فحدّد الفترة أو المرشّح صريحًا.',
    'ai.modeFollowup':             'متابعة',
    'ai.modeFollowupTitle':        'مستنتج من جدول النتائج السابق دون استعلام جديد.',
    'ai.modeContext':              'سياق الصفحة',
    'ai.modeContextTitle':         'تمت الإجابة من ملخّص البيانات المعروضة في هذه الصفحة.',
    'ai.modeDet':                  'حسابي',
    'ai.modeDetTitle':             'محسوب مباشرة على الخادم (ليس SQL من النموذج) لضمان دقة الأرقام.',
    'aih.cachedOnlyTitle':         'إظهار الجلسات التي تحتوي على إجابة من الذاكرة الدلالية فقط',
    'aiact.hideJson':              'إخفاء JSON',
    'aiact.copy':                  'نسخ',
    'aiact.copied':                'تم النسخ',
    'aiact.confirmDelete':         'حذف الإجراء «{name}»؟',
    'aiact.editForm':              'تعديل: {name}',
    'aiact.newAction':             'إجراء مخصّص جديد',
    'aiact.cancelEdit':            'إلغاء التعديل',
    'aiact.lblName':               'الاسم (أحرف صغيرة، شرطة سفلية)',
    'aiact.lblMaxRows':            'حد الصفوف (max_rows)',
    'aiact.lblDescription':        'الوصف (يقرأه الذكاء الاصطناعي لمطابقة الطلبات)',
    'aiact.lblSql':                'قالب SQL (SELECT فقط؛ المعاملات تُكتب بصيغة ‎:name‎)',
    'aiact.detectedParams':        'المعاملات المكتشفة',
    'aiact.required':              'مطلوب',
    'aiact.lblTables':             'الجداول المسموح بها (حارس القائمة البيضاء)',
    'aiact.descPlaceholder':       'عرض تذاكر SAP Solman بحالة معيّنة',
    'aiact.saveChanges':           'حفظ التغييرات',
    'aiact.createAction':          'إنشاء إجراء',
    'aiact.customActions':         'الإجراءات المخصّصة',
    'aiact.noCustomActions':       'لا توجد إجراءات مخصّصة بعد. أنشئ واحداً أعلاه — سيصبح قابلاً للاستدعاء بلغة طبيعية تلقائياً.',
    'aiact.disabled':              '(معطّل)',

    // ══ Hasil migrasi pola dua-bahasa inline (id ? … : …) ══
    // ── aiChat ──
    'aiChat.aiAssistantNotAvailablePage':            'مساعد الذكاء الاصطناعي غير متاح لهذه الصفحة (لم يُهيّأ في مصادر بيانات الذكاء الاصطناعي).',
    'aiChat.aiNotAvailablePage':                     'الذكاء الاصطناعي غير متاح لهذه الصفحة',
    'aiChat.attachImage':                            'إرفاق صورة (وضع البرمجة)',
    'aiChat.removeImage':                            'إزالة الصورة',
    'aiChat.imageTooLarge':                          'يجب ألا يتجاوز حجم الصورة 5 ميغابايت.',
    'aiChat.imageMaxCount':                          'الحد الأقصى {max} صور لكل سؤال.',
    'aiChat.imageUnsupported':                       'تنسيق الصورة غير مدعوم ({name}). استخدم PNG أو JPG أو WebP أو GIF.',
    'aiChat.imageFailed':                            'فشل معالجة الصورة.',

    // ── aiHist ──
    'aiHist.answerServedAiServiceSemantic':          'الإجابة من الذاكرة الدلالية لخدمة الذكاء الاصطناعي — بدون استدعاء LLM (0 توكن)',
    'aiHist.copySessionLink':                        'نسخ رابط الجلسة',
    'aiHist.deleteSession':                          'حذف الجلسة',
    'aiHist.openNewTab':                             'فتح في تبويب جديد',

    // ── aiRouter ──
    'aiRouter.failsUncertainFallsBackKeyword':       'عند الفشل أو عدم اليقين ← يعود إلى مطابقة الكلمات المفتاحية من التلميحات وقاموس المرادفات في مصادر بيانات الذكاء الاصطناعي.',
    'aiRouter.howWorks':                             'كيف يعمل',
    'aiRouter.loading':                              'جارٍ التحميل…',
    'aiRouter.noMatchKeepsUsingCurrently':           'لا مطابقة ← يستمر باستخدام اللوحة النشطة حالياً (تُعامل كمتابعة)، دون العودة إلى «عام».',
    'aiRouter.quickClassificationViaGroqSeparate':   'تصنيف سريع عبر Groq (منفصل عن مزوّد المحادثة الرئيسي — يعمل حتى لو كان المزوّد الرئيسي Bedrock/Ollama).',
    'aiRouter.turnOffIfDonT':                        '💡 أوقف الخيار إن لم ترغب بأي استدعاء LLM إضافي لكل سؤال في الوضع العام.',
    'aiRouter.whenAiWorkspaceGeneralMode':           'عندما تكون مساحة عمل الذكاء الاصطناعي في وضع «عام» (بدون اختيار لوحة)، يكتشف النظام تلقائياً لوحة مناسبة من السؤال (مثلاً «تكلفة AWS» ← AWS Cost Explorer)، ثم يجيب باستخدام تلك البيانات.',

    // ── basis ──
    'basis.1Session':                                'جلسة واحدة',
    'basis.action':                                  'إجراء',
    'basis.activeSessions':                          'الجلسات النشطة',
    'basis.busy':                                    'مشغول',
    'basis.busyTotal':                               'مشغول/الإجمالي',
    'basis.by':                                      'بواسطة',
    'basis.clickRowViewDumpContent':                 'انقر على صف لعرض محتوى الـ dump.',
    'basis.clickRowViewUserS':                       'انقر على صف لعرض جلسات المستخدم (بنمط SM04).',
    'basis.clickViewUserSSessions':                  'انقر لعرض جلسات هذا المستخدم',
    'basis.connectionProfileActive':                 'ملف الاتصال (نشط)',
    'basis.count':                                   'العدد',
    'basis.criteriaDataSources':                     'المعايير ومصادر البيانات',
    'basis.date':                                    'التاريخ من',
    'basis.date2':                                   'التاريخ إلى',
    'basis.date3':                                   'التاريخ',
    'basis.dateCoverage':                            'النطاق الزمني',
    'basis.daysCovered':                             'عدد الأيام',
    'basis.department':                              'القسم',
    'basis.departments':                             'الأقسام',
    'basis.diffTerminal':                            'طرفية مختلفة',
    'basis.differentTerminals':                      'من طرفيات مختلفة',
    'basis.diskAseSpaceBackendNot':                  'مساحة القرص وASE — لم تتم تهيئة الخادم بعد (يتطلب أمر SM69).',
    'basis.emptyDumpContent':                        'محتوى الـ dump فارغ.',
    'basis.emptyErrorlog':                           'سجل الأخطاء فارغ.',
    'basis.failedJobs':                              'المهام الفاشلة',
    'basis.fetchBatches':                            'دفعات الجلب',
    'basis.fetchUserUsage':                          'جلب استخدام المستخدمين',
    'basis.fetched':                                 'تم الجلب',
    'basis.fetchingDump':                            'جارٍ جلب الـ dump…',
    'basis.fetchingSessions':                        'جارٍ جلب الجلسات…',
    'basis.fieldsRead':                              'الحقول المقروءة',
    'basis.firstLogon':                              'أول تسجيل دخول',
    'basis.fmReturnedNoSessionsUser':                'لم تُرجع دالة FM أي جلسات لهذا المستخدم.',
    'basis.fmsTried':                                'دوال FM المجرَّبة',
    'basis.hours':                                   'ساعات',
    'basis.jobName':                                 'اسم المهمة',
    'basis.lastFetch':                               'آخر جلب',
    'basis.lastLogon':                               'آخر تسجيل دخول',
    'basis.latest':                                  'الأحدث',
    'basis.lines':                                   'أسطر',
    'basis.listedMldtableButNotParallel':            'مُدرَج في {mldTable} لكن غير متوازٍ حالياً',
    'basis.loadRefresh':                             'تحميل / تحديث',
    'basis.loading':                                 'جارٍ التحميل…',
    'basis.loadingUserUsageStatus':                  'جارٍ تحميل حالة استخدام المستخدمين…',
    'basis.locked':                                  'مقفل',
    'basis.logged':                                  'مُسجَّل الدخول',
    'basis.loggedUsersSm04ClickLoad':                'المستخدمون المسجّلون (SM04) — انقر «تحميل / تحديث» للجلب.',
    'basis.loginDetailRowsStoredAs':                 'تُخزَّن صفوف تفاصيل تسجيل الدخول كما هي (صفوف RESULT الخام) في جدول sap_usr_utl_raw — بدون تجميع، ومنفصلة عن لوحة استخدام المستخدمين.',
    'basis.multiLogonCard':                          'بطاقة تسجيل الدخول المتعدد',
    'basis.multiLogonClickLoadRefresh':              'تسجيل الدخول المتعدد — انقر «تحميل / تحديث» للجلب.',
    'basis.multipleLogonNotRestricted':              '(تسجيل الدخول المتعدد غير مقيّد)',
    'basis.multipleLogonRestricted':                 '(تسجيل الدخول المتعدد مقيّد)',
    'basis.no':                                      'لا',
    'basis.noCancelledJobs':                         'لا توجد مهام ملغاة.',
    'basis.noDiskData':                              'لا توجد بيانات قرص.',
    'basis.noLockEntriesSm12':                       'لا توجد مدخلات قفل (SM12).',
    'basis.noLockedUsers':                           'لا يوجد مستخدمون مقفلون.',
    'basis.noRowsMatchFilter':                       'لا توجد صفوف مطابقة للمرشّح.',
    'basis.noSavedSnapshotProfileYet':               'لا توجد لقطة محفوظة لهذا الملف بعد — انقر «تحميل / تحديث» لجلبها أول مرة.',
    'basis.noSessionListFmAvailable':                'لا تتوفر دالة FM لقائمة الجلسات على هذا النظام.',
    'basis.noShortDumpsRange':                       'لا توجد short dumps في هذا النطاق.',
    'basis.noUpdateErrors':                          'لا توجد أخطاء تحديث.',
    'basis.noUserUsageDataProfile':                  'لا توجد بيانات استخدام لهذا الملف بعد.',
    'basis.noUsersCurrentlyLogged':                  'لا يوجد مستخدمون مسجّلون حالياً.',
    'basis.noUsersParallelSessionsRight':            'لا يوجد مستخدمون لديهم جلسات متوازية حالياً.',
    'basis.noWpData':                                'لا توجد بيانات WP.',
    'basis.notCountedAsMultiLogon':                  'لا يُحتسب كتسجيل دخول متعدد — مجرد أثر في جدول النواة.',
    'basis.notWhitelisted':                          'غير مدرج في القائمة البيضاء',
    'basis.note':                                    'ملاحظة',
    'basis.olderThan30DaysConsider':                 'أقدم من 30 يوماً — يُستحسن إعادة الجلب.',
    'basis.optional':                                'اختياري',
    'basis.outsideRz11Whitelist':                    'خارج القائمة البيضاء RZ11',
    'basis.parallelSessions':                        'لديها جلسات متوازية',
    'basis.period':                                  'حسب الفترة',
    'basis.period2':                                 'الفترة',
    'basis.range':                                   'النطاق',
    'basis.rangeDays':                               'النطاق (أيام)',
    'basis.historyCronRunConfirm':                   'تشغيل الآن؟ سيتم فحص مؤشرات الأداء لجميع ملفات SAP وكتابة سجل تاريخي جديد إذا حدث أي تغيير.',
    'basis.historyTitle':                            'سجل مؤشرات الأداء (تدقيق)',
    'basis.historyDiffOnlyNote':                      'يُضاف سطر فقط عند حدوث تغيير',
    'basis.historyFrom':                             'من تاريخ',
    'basis.historyTo':                               'إلى تاريخ',
    'basis.historyLoad':                             'تحميل السجل',
    'basis.historyRowCount':                         '{n} صف',
    'basis.historyEmpty':                            'لا يوجد سجل في هذا النطاق الزمني بعد.',
    'basis.historyRecordedAt':                       'الوقت',
    'basis.historyRecordedBy':                       'بواسطة',
    'basis.historyBaseline':                         'بيانات أولية (خط أساس) — لا يوجد صف سابق للمقارنة.',
    'basis.historyNoChange':                         'لا يوجد تغيير في مؤشرات الأداء مقارنة بالصف السابق.',
    'basis.historyChangeIntro':                      'التغييرات:',
    'basis.historyChanges':                          'التغييرات',
    'basis.historyBaselineShort':                    'خط الأساس',
    'basis.historyLoadingDetail':                   'جارٍ تحميل تفاصيل التغيير...',
    'basis.historyDetailError':                       'فشل تحميل تفاصيل التغيير.',
    'basis.historyMoreLines':                         '{n} سطر إضافي',
    'basis.raw':                                     'خام',
    'basis.reason':                                  'السبب',
    'basis.rows':                                    'صفوف',
    'basis.rz11Allowed':                             'مسموح في RZ11',
    'basis.rz11Whitelist':                           'القائمة البيضاء RZ11',
    'basis.sapSystemHealthGlance':                   'صحة نظام SAP في لمحة',
    'basis.sapSystemProfile':                        'ملف نظام SAP',
    'basis.saveMode':                                'وضع الحفظ',
    'basis.savedSnapshot':                           'لقطة محفوظة',
    'basis.searchUserTerminalIp':                    'ابحث عن مستخدم / طرفية / IP…',
    'basis.selectProfile':                           '— اختر ملفاً —',
    'basis.selectProfileClickLoadView':              'اختر ملفاً وانقر «تحميل» لعرض صحة النظام.',
    'basis.selectProfileFirst':                      'اختر ملفاً أولاً.',
    'basis.serviceUserSessions':                     'جلسات مستخدمي الخدمة',
    'basis.sessions':                                'جلسات',
    'basis.sessions2':                               'الجلسات',
    'basis.shortDumpDetail':                         'تفاصيل Short Dump',
    'basis.showingFirst500EventsCapped':             'عرض أول 500 حدث (بحد أقصى)، مجمّعة حسب المهمة.',
    'basis.snapSegments':                            'مقاطع SNAP',
    'basis.sourceLocalTableSapUsr':                  'المصدر: الجدول المحلي sap_usr_utl_raw (من جلب ZRFC_USR_UTL) — وليست بيانات SAP مباشرة. تُحتسب الساعات من مدة كل جلسة.',
    'basis.storedSessions':                          'الجلسات المخزَّنة',
    'basis.summary':                                 'ملخص',
    'basis.sybaseLogBackendNotConfigured':           'سجل Sybase — لم تتم تهيئة الخادم (يتطلب أمر SM69 ZASE_LOG).',
    'basis.system':                                  'النظام',
    'basis.time':                                    'الوقت',
    'basis.today':                                   'اليوم',
    'basis.topUsersHours':                           'أكثر المستخدمين بالساعات',
    'basis.totalHours':                              'إجمالي الساعات',
    'basis.totalSystemSessions':                     'إجمالي جلسات النظام',
    'basis.uniqueUsers':                             'مستخدمون فريدون',
    'basis.unreadable':                              'غير قابل للقراءة',
    'basis.updateErrorsSm13BackendNot':              'أخطاء التحديث (SM13) — لم تتم تهيئة الخادم بعد (يتطلب حقول VBHDR).',
    'basis.updated':                                 'مُحدَّث',
    'basis.usageagedaysDaySAgo':                     'قبل {usageAgeDays} يوم',
    'basis.userSessions':                            'جلسات المستخدم',
    'basis.users':                                   'مستخدمون',
    'basis.valid':                                   'صالح حتى',
    'basis.yes':                                     'نعم',

    // ── dashCtr ──
    'dashCtr.accessDenied':                          'تم رفض الوصول',
    'dashCtr.page':                                  'هذه الصفحة',

    // ── noteView ──
    'noteView.by':                                   'بواسطة',
    'noteView.main':                                 'رئيسي',
    'noteView.mayHaveBeenDeletedLack':               'ربما تم حذفها، أو لا تملك صلاحية الوصول.',
    'noteView.noContent':                            '(لا يوجد محتوى)',
    'noteView.noteNotFound':                         'لم يتم العثور على الملاحظة.',
    'noteView.private':                              '🔒 خاصة',
    'noteView.shared':                               '👥 مشتركة',
    'noteView.untitled':                             '(بدون عنوان)',

    // ── notes ──
    'notes.addTab':                                  'إضافة تبويب',
    'notes.alsoFound':                               'موجود أيضاً في:',
    'notes.anyoneLinkCanViewNote':                   'أي شخص لديه هذا الرابط يمكنه عرض الملاحظة دون تسجيل الدخول.',
    'notes.back':                                    'رجوع',
    'notes.block':                                   'حظر',
    'notes.blockquote':                              'اقتباس',
    'notes.bullet':                                  'قائمة نقطية',
    'notes.by':                                      'بواسطة',
    'notes.cancel':                                  'إلغاء',
    'notes.clear':                                   'مسح',
    'notes.codeBlock':                               'كتلة برمجية',
    'notes.common':                                  '👥 مشتركة',
    'notes.commonAllUsers':                          '👥 مشتركة (كل المستخدمين)',
    'notes.contentMarkdownSupported':                'المحتوى (يدعم Markdown)',
    'notes.copied':                                  '✅ تم النسخ',
    'notes.copy':                                    '📋 نسخ',
    'notes.copyLink':                                'نسخ الرابط',
    'notes.copyMoveNotesPlainNon':                   'نسخ / نقل إلى Notes Plain (بدون RAG)',
    'notes.copyPlain':                               'نسخ إلى Plain',
    'notes.createLink':                              '🔗 إنشاء رابط',
    'notes.creating':                                '⏳ جارٍ الإنشاء…',
    'notes.deleteNote':                              'حذف الملاحظة "',
    'notes.deleted':                                 'تم الحذف.',
    'notes.done':                                    'منجَز',
    'notes.dragResizeDoubleClickReset':              'اسحب لتغيير الحجم · نقرة مزدوجة = إعادة تعيين',
    'notes.editNote':                                '✏️ تعديل الملاحظة',
    'notes.failedCopyLink':                          'فشل نسخ الرابط.',
    'notes.find':                                    'بحث…',
    'notes.find2':                                   '▶ بحث',
    'notes.findReplace':                             'بحث/استبدال',
    'notes.help':                                    'مساعدة',
    'notes.hideList':                                'إخفاء القائمة',
    'notes.holdTabThenDragReorder':                  'اضغط مطوّلاً على ⠿ في التبويب ثم اسحب لإعادة الترتيب.',
    'notes.holdTabThenDragReorder2':                 'اضغط مطوّلاً على ⠿ في التبويب ثم اسحب لإعادة الترتيب (يُحفظ تلقائياً).',
    'notes.hr':                                      'خط فاصل',
    'notes.lastModified':                            'آخر تعديل',
    'notes.linkCopied':                              'تم نسخ الرابط.',
    'notes.linkExpiry':                              'انتهاء صلاحية الرابط',
    'notes.linkReadyShare':                          'الرابط جاهز للمشاركة:',
    'notes.main':                                    'رئيسي',
    'notes.markdownHelp':                            'مساعدة Markdown',
    'notes.markdownReferenceClickInsert':            'مرجع Markdown — انقر للإدراج',
    'notes.move':                                    'نقل',
    'notes.moveCommon':                              'نقل إلى المشتركة؟',
    'notes.moveCommon2':                             'نقل إلى المشتركة',
    'notes.moveMyNotes':                             'نقل إلى ملاحظاتي؟',
    'notes.moveMyNotes2':                            'نقل إلى ملاحظاتي',
    'notes.moveRemoveRag':                           'نقل (إزالة من RAG)',
    'notes.myNotes':                                 '🔒 ملاحظاتي',
    'notes.new':                                     'جديد',
    'notes.newNote':                                 '➕ ملاحظة جديدة',
    'notes.noContent':                               '(لا يوجد محتوى)',
    'notes.noContentYet':                            '(لا يوجد محتوى بعد)',
    'notes.noMatchingNotes':                         'لا توجد ملاحظات مطابقة.',
    'notes.noNotesYet':                              'لا توجد ملاحظات بعد.',
    'notes.notFound':                                'غير موجود',
    'notes.noteIncludingAllTabsWill':                'ستُنسخ الملاحظة (مع جميع التبويبات) إلى Notes Plain. اختر «نقل» لإزالتها من هنا أيضاً — وستُزال من فهرس الذكاء الاصطناعي (لن يعود بإمكانه الاستشهاد بها).',
    'notes.noteMoved':                               'تم نقل الملاحظة.',
    'notes.noteTitle':                               'عنوان الملاحظة',
    'notes.notes':                                   'ملاحظات',
    'notes.notesPlain':                              'إلى Notes Plain',
    'notes.numbered':                                'قائمة مرقّمة',
    'notes.oldestModified':                          'الأقدم تعديلاً',
    'notes.onlyAdminCanMoveShared':                  'المسؤول فقط يمكنه نقل ملاحظة مشتركة.',
    'notes.openNewTabCleanView':                     'فتح في تبويب جديد (عرض نظيف)',
    'notes.outline':                                 'الفهرس:',
    'notes.plain':                                   'إلى Plain',
    'notes.privateNotesSharedTeamNotes':             'ملاحظاتك الخاصة + ملاحظات الفريق المشتركة.',
    'notes.privateOnlyMe':                           '🔒 خاصة (أنا فقط)',
    'notes.replace':                                 'استبدال بـ…',
    'notes.replace2':                                'استبدال',
    'notes.replaceAll':                              'استبدال الكل',
    'notes.save':                                    '💾 حفظ',
    'notes.saved':                                   'تم الحفظ.',
    'notes.saving':                                  '⏳ جارٍ الحفظ…',
    'notes.savingOrder':                             'جارٍ حفظ الترتيب…',
    'notes.searchNote':                              'ابحث في الملاحظة…',
    'notes.searchTitleContent':                      'ابحث في العنوان أو المحتوى…',
    'notes.selectNoteLeftCreateNew':                 'اختر ملاحظة من اليمين، أو أنشئ واحدة جديدة.',
    'notes.selectTextEditorFirstThen':               'حدّد نصاً في المحرّر أولاً، ثم انقر عنصراً لتغليفه.',
    'notes.share':                                   'مشاركة',
    'notes.shareNote':                               'مشاركة الملاحظة',
    'notes.showList':                                'إظهار القائمة',
    'notes.sort':                                    'الترتيب:',
    'notes.svgBlock':                                'كتلة SVG',
    'notes.tabTitle':                                'عنوان التبويب',
    'notes.table':                                   'جدول',
    'notes.text':                                    'نص',
    'notes.title':                                   'العنوان',
    'notes.titleContentRequired':                    'العنوان أو المحتوى مطلوب.',
    'notes.titleZ':                                  'العنوان أ–ي',
    'notes.titleZ2':                                 'العنوان ي–أ',
    'notes.untitled':                                '(بدون عنوان)',
    'notes.visibility':                              'الظهور',

    // ── notesPlain ──
    'notesPlain.addTab':                             'إضافة تبويب',
    'notesPlain.all':                                'الكل',
    'notesPlain.alsoFound':                          'موجود أيضاً في:',
    'notesPlain.back':                               'رجوع',
    'notesPlain.block':                              'حظر',
    'notesPlain.blockquote':                         'اقتباس',
    'notesPlain.boldText':                           'نص عريض',
    'notesPlain.bullet':                             'قائمة نقطية',
    'notesPlain.cancel':                             'إلغاء',
    'notesPlain.close':                              'إغلاق',
    'notesPlain.codeBlock':                          'كتلة برمجية',
    'notesPlain.codeHere':                           'الكود هنا',
    'notesPlain.collapse':                           'طيّ',
    'notesPlain.conversionFailed':                   'فشل التحويل.',
    'notesPlain.converting':                         'جارٍ التحويل…',
    'notesPlain.copyNotesRag':                       'نسخ إلى الملاحظات (RAG)؟',
    'notesPlain.copyNotesRagIndexedInto':            'نسخ إلى الملاحظات (RAG) — مفهرَس في قاعدة معرفة الذكاء الاصطناعي',
    'notesPlain.copyRag':                            'نسخ إلى RAG',
    'notesPlain.copyWillAddedNotesRag':              'ستُضاف نسخة إلى صفحة الملاحظات (RAG) وتُفهرَس في قاعدة معرفة الذكاء الاصطناعي. تبقى نسخة Notes Plain كما هي.',
    'notesPlain.dragResizeDoubleClickReset':         'اسحب لتغيير الحجم · نقرة مزدوجة = إعادة تعيين',
    'notesPlain.editNote':                           'تعديل الملاحظة',
    'notesPlain.empty':                              '(فارغ)',
    'notesPlain.find':                               'بحث…',
    'notesPlain.find2':                              '▶ بحث',
    'notesPlain.findReplace':                        'بحث/استبدال',
    'notesPlain.help':                               'مساعدة',
    'notesPlain.holdTabThenDragReorder':             'اضغط مطوّلاً على ⠿ في التبويب ثم اسحب لإعادة الترتيب.',
    'notesPlain.hr':                                 'خط فاصل',
    'notesPlain.imagesLengthClickInsertCursor':      'الصور ({length}) — انقر للإدراج عند المؤشر',
    'notesPlain.importDocument':                     'استيراد مستند',
    'notesPlain.insertImage':                        'إدراج صورة',
    'notesPlain.insertImageHint':                    'إدراج صورة (أو لصقها / سحبها وإفلاتها في المحرر)',
    'notesPlain.imageOnly':                          'يُدعم ملفات الصور فقط (PNG، JPG، WebP، GIF).',
    'notesPlain.imageMax5mb':                        'يجب ألا يتجاوز حجم الصورة 5 ميغابايت.',
    'notesPlain.imageInserted':                      'تم إدراج {count} صورة ({size}).',
    'notesPlain.imageFailed':                        'فشل معالجة الصورة.',
    'notesPlain.imageUnsupportedFormat':             'تنسيق الصورة غير مدعوم في المتصفح ({name}). يجب تحويل صور HEIC/HEIF إلى JPG/PNG أولاً.',
    'notesPlain.importPdfWordExcelAs':               'استيراد PDF/Word/Excel كـ Markdown (يُدرج عند المؤشر)',
    'notesPlain.insert':                             '➕ إدراج',
    'notesPlain.insertTextCursor':                   'إدراج نص عند المؤشر',
    'notesPlain.inserted':                           '✓ تم الإدراج',
    'notesPlain.italicText':                         'نص مائل',
    'notesPlain.linkTable':                          'رابط وجدول',
    'notesPlain.linkText':                           'نص الرابط',
    'notesPlain.loading':                            'جارٍ التحميل…',
    'notesPlain.main':                               'رئيسي',
    'notesPlain.markdownHelp':                       'مساعدة Markdown',
    'notesPlain.markdownImagesInserted':             'تم إدراج Markdown والصور.',
    'notesPlain.markdownReferenceClickInsert':       'مرجع Markdown — انقر للإدراج',
    'notesPlain.max10mb':                            'بحد أقصى 10 ميغابايت.',
    'notesPlain.moveNotesRag':                       'نقل إلى الملاحظات (RAG)؟',
    'notesPlain.moveNotesRagRemovedPlain':           'نقل إلى الملاحظات (RAG) — يُحذف من Plain',
    'notesPlain.moveRag':                            'نقل إلى RAG',
    'notesPlain.newNote':                            'ملاحظة جديدة',
    'notesPlain.noNotes':                            'لا توجد ملاحظات.',
    'notesPlain.notFound':                           'غير موجود',
    'notesPlain.noteDeleted':                        'تم حذف الملاحظة.',
    'notesPlain.noteSaved':                          'تم حفظ الملاحظة.',
    'notesPlain.noteTitle':                          'عنوان الملاحظة…',
    'notesPlain.noteWillAddedNotesRag':              'ستُضاف الملاحظة إلى صفحة الملاحظات (RAG)، وتُفهرَس في قاعدة معرفة الذكاء الاصطناعي، وتُحذف من Notes Plain.',
    'notesPlain.notesDocumentImportNotRag':          'ملاحظات واستيراد مستندات — غير مفهرسة في RAG.',
    'notesPlain.numbered':                           'قائمة مرقّمة',
    'notesPlain.openNotesList':                      'فتح قائمة الملاحظات',
    'notesPlain.pdfWordDocxExcelXlsx':               'PDF أو Word (.docx) أو Excel (.xlsx) فقط.',
    'notesPlain.preview':                            'معاينة',
    'notesPlain.private':                            'خاص',
    'notesPlain.private2':                           '🔒 خاصة',
    'notesPlain.promoteRagNotesWhenReady':           'الترقية إلى ملاحظات RAG عند الجهوزية',
    'notesPlain.quote':                              'اقتباس',
    'notesPlain.replace':                            'استبدال بـ…',
    'notesPlain.replace2':                           'استبدال',
    'notesPlain.replaceAll':                         'استبدال الكل',
    'notesPlain.reviewDocumentConversion':           'مراجعة تحويل المستند',
    'notesPlain.save':                               'حفظ',
    'notesPlain.searchNote':                         'ابحث في الملاحظة…',
    'notesPlain.searchNotes':                        'ابحث في الملاحظات…',
    'notesPlain.selectNoteLeftCreateNew':            'اختر ملاحظة من اليمين، أو أنشئ واحدة جديدة.',
    'notesPlain.selectTextEditorFirstThen':          'حدّد نصاً في المحرّر أولاً، ثم انقر عنصراً لتغليفه.',
    'notesPlain.shared':                             'مشتركة',
    'notesPlain.shared2':                            '👥 مشتركة',
    'notesPlain.svgBlock':                           'كتلة SVG',
    'notesPlain.tabActivetabTitle':                  'عنوان التبويب {activeTab}…',
    'notesPlain.table':                              'جدول',
    'notesPlain.text':                               'نص',
    'notesPlain.title1':                             'عنوان 1',
    'notesPlain.title2':                             'عنوان 2',
    'notesPlain.title3':                             'عنوان 3',
    'notesPlain.titleContentRequired':               'العنوان أو المحتوى مطلوب.',
    'notesPlain.untitled':                           '(بدون عنوان)',
    'notesPlain.updated':                            'مُحدَّث',
    'notesPlain.writeNoteMarkdown':                  'اكتب ملاحظتك بصيغة Markdown…',
    'notesPlain.yesCopy':                            'نعم، انسخ',
    'notesPlain.yesMove':                            'نعم، انقل',

    // ── sapRole ──
    'sapRole.activeUsers':                           'المستخدمون النشطون الذين لديهم',
    'sapRole.add':                                   'إضافة',
    'sapRole.addChange':                             'إضافة تغيير',
    'sapRole.addRoles':                              'إضافة أدوار',
    'sapRole.applyGenerate':                         'تطبيق + توليد',
    'sapRole.applySap':                              'تطبيق على SAP؟',
    'sapRole.applySap2':                             'تطبيق على SAP',
    'sapRole.back':                                  'العودة إلى',
    'sapRole.buildObjectCache':                      'بناء ذاكرة الكائنات',
    'sapRole.cacheClickLoadRolesRefresh':            '(من الذاكرة المؤقتة — انقر «تحميل الأدوار» للتحديث من SAP)',
    'sapRole.cancel':                                'إلغاء',
    'sapRole.changeSet':                             'مجموعة التغييرات',
    'sapRole.changes':                               'تغييرات',
    'sapRole.class':                                 'حسب الفئة',
    'sapRole.clickBuildObjectCacheStart':            'انقر «بناء ذاكرة الكائنات» للبدء.',
    'sapRole.close':                                 'إغلاق',
    'sapRole.confirmRoleChanges':                    'تأكيد تغييرات الأدوار',
    'sapRole.created':                               'أُنشئ',
    'sapRole.currentRolesSap':                       'الأدوار الحالية (من SAP)',
    'sapRole.d':                                     ' يوم',
    'sapRole.date':                                  'التاريخ',
    'sapRole.ddDays':                                '≤{dd} يوم',
    'sapRole.deleteObjectD':                         'حذف كائن (D)',
    'sapRole.eGZEmptyAll':                           'مثال: ‎Z_‎ أو اتركه فارغاً = الكل',
    'sapRole.editAuthorizations':                    'تعديل الصلاحيات',
    'sapRole.editAuthorizationsWriteSap':            'تعديل الصلاحيات (كتابة في SAP)',
    'sapRole.errorOccurred':                         'حدث خطأ.',
    'sapRole.expiring30Days':                        'تنتهي خلال ≤30 يوماً',
    'sapRole.failedReadAuthObjects':                 'فشلت قراءة كائنات الصلاحيات: ',
    'sapRole.fieldEGActvt':                          'الحقل (مثال: ACTVT)',
    'sapRole.finalLengthRolesWrittenSap':            'النهائي: {length} دور. كُتبت في SAP فوراً وسُجّلت.',
    'sapRole.finalListPreview':                      'معاينة القائمة النهائية',
    'sapRole.from':                                  'من',
    'sapRole.generateProfile':                       'توليد الملف الشخصي',
    'sapRole.generateProfile2':                      ' · توليد الملف الشخصي',
    'sapRole.iInsertUUpdateO':                       'I=إدراج، U=تحديث، O=مستوى تنظيمي، D=حذف كائن. دالة FM Z تعالج نسخة AUTH.',
    'sapRole.ind':                                   'النوع',
    'sapRole.insertI':                               'إدراج (I)',
    'sapRole.limitedLatest500':                      ' (بحد أقصى آخر 500)',
    'sapRole.load':                                  'تحميل',
    'sapRole.loadRoles':                             'تحميل الأدوار',
    'sapRole.loading':                               'جارٍ التحميل…',
    'sapRole.loadingDetail':                         'جارٍ تحميل التفاصيل…',
    'sapRole.loadingList':                           'جارٍ تحميل القائمة…',
    'sapRole.loadingMenu':                           'جارٍ تحميل القائمة…',
    'sapRole.loadingObjects':                        'جارٍ تحميل الكائنات…',
    'sapRole.loadingRolesSap':                       'جارٍ تحميل الأدوار من SAP…',
    'sapRole.manageRoles':                           'إدارة الأدوار',
    'sapRole.maximize':                              'تكبير',
    'sapRole.newValue':                              'القيمة الجديدة',
    'sapRole.noAssignmentsNotLoadedYet':             'لا توجد تعيينات / لم يتم التحميل بعد.',
    'sapRole.noAuthorizationObjects':                'لا توجد كائنات صلاحيات.',
    'sapRole.noCacheYetBuildFirst':                  'لا توجد ذاكرة مؤقتة — ابنِها أولاً (تقرأ AGR_1251 مرة واحدة).',
    'sapRole.noChangesPeriodPfcgChange':             'لا توجد تغييرات في هذه الفترة (أو مستندات تغيير PFCG غير مفعّلة).',
    'sapRole.noChangesYet':                          'لا توجد تغييرات بعد.',
    'sapRole.noChildRoles':                          'لا توجد أدوار فرعية.',
    'sapRole.noClass':                               '(بدون فئة)',
    'sapRole.noDataNotLoadedYet':                    'لا توجد بيانات / لم يتم التحميل بعد.',
    'sapRole.noFieldDetailEmptyCdpos':               'لا توجد تفاصيل حقول (CDPOS فارغ لهذا التغيير).',
    'sapRole.noFields':                              '(بدون حقول)',
    'sapRole.noMatch':                               'لا توجد مطابقة.',
    'sapRole.noMatchingObjects':                     'لا توجد كائنات مطابقة.',
    'sapRole.noMatchingTcodes':                      'لا توجد رموز معاملات مطابقة.',
    'sapRole.noRelatedRoles':                        'لا توجد أدوار مرتبطة.',
    'sapRole.noRoles':                               'لا توجد أدوار.',
    'sapRole.noRolesActiveUsersNot':                 'لا توجد أدوار لها مستخدمون نشطون / لم يتم التحميل بعد.',
    'sapRole.noRolesFound':                          'لم يتم العثور على أدوار.',
    'sapRole.noTcodes':                              '(لا توجد رموز معاملات)',
    'sapRole.noTcodesNotLoadedYet':                  'لا توجد رموز معاملات / لم يتم التحميل بعد.',
    'sapRole.noTcodesPossiblyCompositeRole':         'لا توجد رموز معاملات (قد يكون دوراً مركّباً).',
    'sapRole.noUsers':                               'لا يوجد مستخدمون.',
    'sapRole.noUsersAssigned':                       'لا يوجد مستخدمون معيّنون.',
    'sapRole.noUsersObjects':                        'لا يوجد مستخدمون/كائنات.',
    'sapRole.objectEGSTcode':                        'الكائن (مثال: S_TCODE)',
    'sapRole.of':                                    'من',
    'sapRole.oldValue':                              'القيمة القديمة',
    'sapRole.onlyAssignedRoles':                     'الأدوار المعيَّنة فقط',
    'sapRole.openRoleDetail':                        'فتح تفاصيل الدور',
    'sapRole.openValueEditorDownloadSap':            'افتح محرّر القيم: نزّل ملف ‎.SAP‎ يدوياً من PFCG (قائمة Download)، عدّله هنا، ثم ارفعه مرة أخرى إلى PFCG',
    'sapRole.orphan0Users':                          'دور معزول (0 مستخدم)',
    'sapRole.pageReadOnlyPhase1':                    'هذه الصفحة للقراءة فقط (المرحلة 1): تدقيق الأدوار والتعيينات ورموز المعاملات وتركيب الأدوار المركّبة. تُقرأ البيانات عبر RFC_READ_TABLE من جداول ‎AGR_*‎. لا يُكتب أي شيء في SAP.',
    'sapRole.period':                                'الفترة',
    'sapRole.profileHasNoPasswordSet':               '⚠ الملف الشخصي بلا كلمة مرور — عيّنها في صيانة الجداول ← إعدادات SAP.',
    'sapRole.profileSapConfig':                      'الملف الشخصي (من إعدادات SAP)',
    'sapRole.readingAgr1251':                        'جارٍ قراءة AGR_1251…',
    'sapRole.readingDetailCdpos':                    'جارٍ قراءة التفاصيل (CDPOS)…',
    'sapRole.rebuildCache':                          'إعادة بناء الذاكرة المؤقتة',
    'sapRole.relatedRoles':                          'الأدوار المرتبطة',
    'sapRole.remove':                                'إزالة',
    'sapRole.removesAllRolesTickAllow':              'هذا يزيل جميع الأدوار. ضع علامة على «السماح بالفراغ» للمتابعة.',
    'sapRole.restore':                               'استعادة',
    'sapRole.rfcReadTableServicePath':               'مسار خدمة RFC_READ_TABLE مفقود — عيّنه في إعدادات SAP.',
    'sapRole.roleFilterPrefixOptional':              'مرشّح الأدوار (بادئة، اختياري)',
    'sapRole.roleMenuEmpty':                         'قائمة الدور فارغة.',
    'sapRole.roleNameEGZ':                           'اسم الدور (مثال: Z_GENERAL)',
    'sapRole.roleObjectChangeHistory':               'سجل تغييرات الأدوار / الكائنات',
    'sapRole.roleUsers':                             'الدور ← المستخدمون',
    'sapRole.roles':                                 'أدوار',
    'sapRole.rolesAssigned':                         'أدوار (معيَّنة)',
    'sapRole.rolesContainingTcode':                  'الأدوار التي تحتوي رمز المعاملة',
    'sapRole.rolesManageuserUpdated':                'تم تحديث أدوار {manageUser}.',
    'sapRole.rolesTcode':                            'الأدوار التي بها رمز المعاملة',
    'sapRole.saving':                                'جارٍ الحفظ…',
    'sapRole.searchObject':                          'ابحث عن كائن…',
    'sapRole.searchRoleDescription':                 'ابحث عن دور / وصف…',
    'sapRole.searchTab':                             'ابحث في هذا التبويب…',
    'sapRole.searchTcode':                           'ابحث عن رمز معاملة…',
    'sapRole.searchUsername':                        'ابحث عن اسم مستخدم…',
    'sapRole.selectProfile':                         '— اختر ملفاً —',
    'sapRole.selectSapSystem':                       'اختر نظام SAP',
    'sapRole.showing':                               'عرض',
    'sapRole.simulate':                              'محاكاة',
    'sapRole.simulationOk':                          'المحاكاة ناجحة: ',
    'sapRole.someTablesFailedRead':                  'فشلت قراءة بعض الجداول: ',
    'sapRole.table':                                 'جدول',
    'sapRole.tcodeUsers':                            'رمز المعاملة ← المستخدمون',
    'sapRole.to':                                    'إلى',
    'sapRole.totalRoles':                            'إجمالي الأدوار',
    'sapRole.type':                                  'النوع',
    'sapRole.undo':                                  'تراجع',
    'sapRole.unlimited':                             'بلا حد',
    'sapRole.updateU':                               'تحديث (U)',
    'sapRole.user':                                  'للمستخدم',
    'sapRole.userHasNoRoles':                        'المستخدم لا يملك أدواراً.',
    'sapRole.userObjects':                           'المستخدم ← الكائنات',
    'sapRole.userRoles':                             'المستخدم ← الأدوار',
    'sapRole.userSRolesContainingObject':            'أدوار هذا المستخدم التي تحتوي الكائن',
    'sapRole.userTcodes':                            'المستخدم ← رموز المعاملات',
    'sapRole.valueEditorPfcgFile':                   'محرّر القيم (ملف PFCG)',
    'sapRole.valueEditorSap':                        'محرّر القيم (.SAP)',
    'sapRole.writesSapTestNonPrd':                   'يكتب في SAP. اختبره على نظام غير إنتاجي أولاً.',
    'sapRole.writesSapViaZRole':                     'يكتب في SAP عبر Z_ROLE_AUTH_MODIFY + توليد. اختبره على DEV أولاً.',
    'sapRole.writtenSapImmediatelyLoggedMake':       'يُكتب في SAP فوراً ويُسجَّل. تأكد أن هذا ليس نظام إنتاج إلا إذا كان مقصوداً.',
    'sapRole.yesApply':                              'نعم، طبّق',

    // ── sapUser ──
    'sapUser.actions':                               'الإجراءات',
    'sapUser.actionsHereWriteDirectlySap':           'الإجراءات هنا تُكتب مباشرة في SAP (القفل/فتح القفل وإعادة تعيين كلمة المرور). تُعرض فقط حسابات الحوار. جميع الإجراءات تُسجَّل في سجل النشاط.',
    'sapUser.active':                                'نشط',
    'sapUser.active2':                               'نشط',
    'sapUser.activeOnly':                            'النشِط فقط',
    'sapUser.activeUsers':                           'مستخدم نشط من',
    'sapUser.blank':                                 '(فارغ)',
    'sapUser.cancel':                                'إلغاء',
    'sapUser.clear':                                 'مسح',
    'sapUser.companyAll':                            'الشركة: الكل',
    'sapUser.dataAs':                                'البيانات حتى',
    'sapUser.dbSnapshotClickLoadUsers':              'من لقطة قاعدة البيانات — انقر «تحميل المستخدمين» للتحديث من SAP.',
    'sapUser.dialogUsers':                           'مستخدمو الحوار',
    'sapUser.dialogUsers2':                          'مستخدمو الحوار',
    'sapUser.distributionPerCompany':                'التوزيع حسب الشركة',
    'sapUser.eGWelcome1':                            'مثال: Welcome1!',
    'sapUser.editDetails':                           'تعديل التفاصيل',
    'sapUser.editDetails2':                          'تعديل التفاصيل',
    'sapUser.editUserDetails':                       'تعديل بيانات المستخدم',
    'sapUser.emptyDateUnlimitedOnlyChanged':         'ترك التاريخ فارغاً = بلا حد. تُرسل الحقول المعدَّلة فقط إلى SAP.',
    'sapUser.errorOccurred':                         'حدث خطأ.',
    'sapUser.failed':                                'فشل',
    'sapUser.firstName':                             'الاسم الأول',
    'sapUser.fullName':                              'الاسم الكامل',
    'sapUser.inactiveUsersExcluded':                 'المستخدمون غير النشطين مستثنون',
    'sapUser.lastName':                              'اسم العائلة',
    'sapUser.licenseAll':                            'الترخيص: الكل',
    'sapUser.licenseDistributionAllCompanies':       'توزيع التراخيص (كل الشركات)',
    'sapUser.licenseSummaryActiveUsers':             'ملخص التراخيص — المستخدمون النشطون',
    'sapUser.loadUsers':                             'تحميل المستخدمين',
    'sapUser.loading':                               'جارٍ التحميل…',
    'sapUser.lockReason':                            'سبب القفل',
    'sapUser.lockSelected':                          'قفل المحدد',
    'sapUser.locked':                                'مقفل',
    'sapUser.lockedOnly':                            'المقفَل فقط',
    'sapUser.missingServicePaths':                   'مسارات خدمة ناقصة: ',
    'sapUser.moduleAll':                             'الوحدة: الكل',
    'sapUser.newPassword':                           'كلمة مرور جديدة',
    'sapUser.newPasswordInitialUserMust':            'كلمة المرور الجديدة مبدئية — على المستخدم تغييرها عند تسجيل الدخول التالي.',
    'sapUser.noDialogUsers':                         'لا يوجد مستخدمو حوار.',
    'sapUser.noExpiry':                              'بلا انتهاء',
    'sapUser.noExpiry2':                             '∞ (بلا انتهاء)',
    'sapUser.noLicense':                             '(بدون ترخيص)',
    'sapUser.noUsersMatchFilter':                    'لا يوجد مستخدمون مطابقون للمرشّح.',
    'sapUser.ok':                                    'ناجح',
    'sapUser.passwordReset':                         'تمت إعادة تعيين كلمة المرور',
    'sapUser.processing':                            'جارٍ المعالجة…',
    'sapUser.profileHasNoPasswordSet':               '⚠ الملف الشخصي بلا كلمة مرور — عيّنها في صيانة الجداول ← إعدادات SAP.',
    'sapUser.profileSapConfig':                      'الملف الشخصي (من إعدادات SAP)',
    'sapUser.relatedListActionsBlockedUntil':        ' — القائمة/الإجراءات المرتبطة محظورة حتى تتم التهيئة.',
    'sapUser.saveSap':                               'حفظ في SAP',
    'sapUser.saving':                                'جارٍ الحفظ…',
    'sapUser.searchUserNameEmail':                   'ابحث عن مستخدم/اسم/بريد…',
    'sapUser.selectProfile':                         '— اختر ملفاً —',
    'sapUser.selectSapSystem':                       'اختر نظام SAP',
    'sapUser.selected':                              'محدد',
    'sapUser.someEnrichmentFailed':                  'فشل جزء من الإثراء — ',
    'sapUser.summary':                               'ملخص',
    'sapUser.totalUsage':                            'إجمالي الاستخدام',
    'sapUser.unlockSelected':                        'فتح قفل المحدد',
    'sapUser.unlocked':                              'غير مقفل',
    'sapUser.userDetailsUpdated':                    'تم تحديث بيانات المستخدم',
    'sapUser.users':                                 'مستخدمون',
    'sapUser.valid':                                 'صالح من',
    'sapUser.validThrough':                          'صالح حتى',

    // ── sdp ──
    'sdp.activeFilter':                              'المرشّح النشط:',
    'sdp.all':                                       'الكل',
    'sdp.assetAnalytics':                            '— تحليلات الأصول —',
    'sdp.assetsManufacturerTop10':                   'الأصول حسب الشركة المصنّعة (أفضل 10)',
    'sdp.assetsRegion':                              'الأصول حسب المنطقة',
    'sdp.assetsType':                                'الأصول حسب النوع',
    'sdp.auditFailed':                               'فشل التدقيق',
    'sdp.auditSuccess':                              'نجح التدقيق',
    'sdp.auditTime':                                 'وقت التدقيق',
    'sdp.avgResolutionDays':                         'متوسط زمن الحل (أيام)',
    'sdp.avgResolutionTimePriorityDays':             'متوسط زمن الحل حسب الأولوية (أيام)',
    'sdp.clickSort':                                 'انقر للترتيب',
    'sdp.closedRequests':                            'الطلبات المغلقة',
    'sdp.dataCompletenessSerialHaveSerial':          'اكتمال البيانات: {serial}% لديها رقم تسلسلي، {region}% لديها منطقة، {audited}% تم تدقيقها، {barcode}% لديها باركود.',
    'sdp.description':                               'الوصف',
    'sdp.escalated':                                 'مُصعَّد',
    'sdp.failedAuditAssetsLength':                   'الأصول التي فشل تدقيقها ({length})',
    'sdp.issueCategoriesTop10':                      'فئات المشكلات (أفضل 10)',
    'sdp.loading':                                   'جارٍ التحميل…',
    'sdp.monthlyTicketVolumeTrend':                  'اتجاه حجم التذاكر الشهري',
    'sdp.name':                                      'الاسم',
    'sdp.noData':                                    'لا توجد بيانات.',
    'sdp.noDataYetRunTable':                         'لا توجد بيانات بعد؟ شغّلها من صيانة الجداول ← SDP Cloud.',
    'sdp.none':                                      'لا شيء.',
    'sdp.notAudited':                                'لم يُدقَّق',
    'sdp.openRequests':                              'الطلبات المفتوحة',
    'sdp.overdueTickets':                            'التذاكر المتأخرة',
    'sdp.reload':                                    'إعادة تحميل',
    'sdp.requestsStatus':                            'الطلبات حسب الحالة',
    'sdp.search':                                    'بحث…',
    'sdp.serialNumber':                              '% لديها رقم تسلسلي',
    'sdp.sites':                                     'المواقع',
    'sdp.slaOverduePriority':                        'SLA — نسبة التأخير حسب الأولوية',
    'sdp.statusClosed':                              'الحالة: مغلق',
    'sdp.statusOpen':                                'الحالة: مفتوح',
    'sdp.technician':                                'الفني',
    'sdp.technicianWorkloadLength':                  'عبء عمل الفنيين ({length})',
    'sdp.ticketingAssetsServicedeskPlusCloud':       'التذاكر والأصول من ServiceDesk Plus Cloud (للقراءة فقط).',
    'sdp.totalTickets':                              'إجمالي التذاكر',
    'sdp.year':                                      'السنة:',

    // ── shared ──
    'shared.aiAssistant':                            'مساعد الذكاء الاصطناعي',
    'shared.aiHasNotBeenEnabled':                    'لم يتم تفعيل الذكاء الاصطناعي لهذا الرابط. تواصل مع مالك الرابط.',
    'shared.aiModelUsed':                            'نموذج الذكاء الاصطناعي المستخدم',
    'shared.aiTyping':                               'الذكاء الاصطناعي يكتب…',
    'shared.askAboutDashboardSData':                 'اسأل عن بيانات هذه اللوحة.',
    'shared.askAi':                                  '✨ اسأل الذكاء الاصطناعي',
    'shared.askAnythingAboutTeamS':                  'اسأل أي شيء عن ملاحظات الفريق المشتركة.',
    'shared.availableCommandsHelpShowHelp':          '**الأوامر المتاحة:**\n- `/help` — عرض هذه المساعدة\n- `/sql` — عرض استعلام SQL لآخر إجابة بيانات\n- `/clear` (أو `/new`، `/reset`) — بدء جلسة جديدة',
    'shared.avgResponseTime':                        'متوسط زمن الاستجابة',
    'shared.by':                                     'بواسطة',
    'shared.cancel':                                 'إلغاء',
    'shared.clickShowFull':                          'انقر للعرض الكامل',
    'shared.dashboardNotAvailableSharing':           'هذه اللوحة غير متاحة للمشاركة.',
    'shared.editResend':                             'تعديل وإعادة إرسال',
    'shared.failedGetAnswer':                        'تعذّر الحصول على إجابة.',
    'shared.failedLoadNote':                         'فشل تحميل الملاحظة.',
    'shared.general':                                'عام',
    'shared.invalidLink':                            'رابط غير صالح.',
    'shared.linkInvalidHasExpired':                  'هذا الرابط غير صالح أو انتهت صلاحيته.',
    'shared.linkUnavailable':                        'الرابط غير متاح',
    'shared.loadingNote':                            'جارٍ تحميل الملاحظة…',
    'shared.maximize':                               'تكبير',
    'shared.minimize':                               'تصغير',
    'shared.noContent':                              '(لا يوجد محتوى)',
    'shared.noSqlYetAskData':                        'لا يوجد SQL بعد. اطرح سؤال بيانات أولاً.',
    'shared.notesCommon':                            'الملاحظات (مشتركة)',
    'shared.publicViewReadOnly':                     'عرض عام · للقراءة فقط',
    'shared.readOnly':                               'للقراءة فقط',
    'shared.resend':                                 'إعادة إرسال',
    'shared.resize':                                 'تغيير الحجم',
    'shared.responseTime':                           'زمن الاستجابة',
    'shared.send':                                   'إرسال',
    'shared.sqlLastAnswer':                          'استعلام SQL لآخر إجابة:',
    'shared.startGeneralConversationAi':             'ابدأ محادثة عامة مع الذكاء الاصطناعي.',
    'shared.tokensPromptCompletionTotal':            'التوكنات: الطلب / الإجابة / الإجمالي',
    'shared.typeQuestion':                           'اكتب سؤالاً…',
    'shared.typeQuestionHelpCommands':               'اكتب سؤالاً… (‎/help‎ للأوامر)',
    'shared.unknownCommandCmdTypeHelp':              'الأمر ‎`/{cmd}`‎ غير معروف. اكتب ‎`/help`‎.',
    'shared.untitled':                               '(بدون عنوان)',


    // ══ Migrasi lanjutan: AWS Inventory / CloudTrail / Role Auth Editor ══
    // ── awsInv ──
    'awsInv.account':                                'الحساب',
    'awsInv.actionsEnabled':                         'الإجراءات مفعّلة',
    'awsInv.addInboundRule':                         'إضافة قاعدة واردة',
    'awsInv.addRule':                                'إضافة قاعدة',
    'awsInv.addTag':                                 'إضافة وسم',
    'awsInv.adding':                                 'جارٍ الإضافة…',
    'awsInv.analysisStillRunningTryAgain':           'التحليل ما زال جارياً، أعد المحاولة بعد قليل.',
    'awsInv.analytics':                              'التحليلات',
    'awsInv.analyzingServiceAccess':                 'جارٍ تحليل الوصول إلى الخدمات…',
    'awsInv.associated':                             'مرتبط',
    'awsInv.associatedInstance':                     'المثيل المرتبط',
    'awsInv.attachments':                            'المرفقات',
    'awsInv.bucketEmpty':                            'الحاوية فارغة.',
    'awsInv.cancel':                                 'إلغاء',
    'awsInv.clickObjectsTabLoad':                    'انقر تبويب Objects للتحميل.',
    'awsInv.clickRefreshFetchResourcesAws':          'انقر «تحديث» لجلب الموارد من AWS.',
    'awsInv.clickTabLoadHistory':                    'انقر التبويب لتحميل السجل.',
    'awsInv.clickTabLoadRules':                      'انقر التبويب لتحميل القواعد.',
    'awsInv.close':                                  'إغلاق',
    'awsInv.consoleLastLogin':                       'آخر دخول إلى الكونسول',
    'awsInv.created':                                'أُنشئ',
    'awsInv.details':                                'التفاصيل',
    'awsInv.disabled':                               'معطّل',
    'awsInv.eipNotAssociatedAnyInstance':            'عنوان EIP هذا غير مرتبط بأي مثيل (تُطبَّق رسوم الخمول).',
    'awsInv.enabled':                                'مفعّل',
    'awsInv.entities':                               'الكيانات',
    'awsInv.evaluationPeriods':                      'فترات التقييم',
    'awsInv.fetching12Min':                          'جارٍ الجلب… (1–2 دقيقة)',
    'awsInv.fetchingBucketContents':                 'جارٍ تحميل محتويات الحاوية…',
    'awsInv.files':                                  'ملفات',
    'awsInv.folders':                                'مجلدات',
    'awsInv.groupName':                              'اسم المجموعة',
    'awsInv.groups':                                 'المجموعات',
    'awsInv.hideSidebar':                            'إخفاء الشريط الجانبي',
    'awsInv.history':                                'السجل',
    'awsInv.lastAccessed':                           'آخر وصول',
    'awsInv.lastUsed':                               'آخر استخدام',
    'awsInv.lengthWarningsDuringFetch':              '{length} تحذير أثناء الجلب',
    'awsInv.loadLastAccessDataAccess':               'تحميل بيانات آخر وصول (Access Advisor)',
    'awsInv.loading':                                'جارٍ التحميل…',
    'awsInv.maxSession':                             'أقصى مدة جلسة',
    'awsInv.never':                                  'أبداً',
    'awsInv.newPasswordCopyShareSecurely':           'كلمة المرور الجديدة (انسخها وشاركها بأمان — تظهر مرة واحدة):',
    'awsInv.no':                                     'لا',
    'awsInv.noAccessKeys':                           'لا توجد مفاتيح وصول.',
    'awsInv.noAttachments':                          'لا توجد مرفقات.',
    'awsInv.noBusinessUnit':                         'بدون وحدة أعمال',
    'awsInv.noHistoryFound':                         'لا يوجد سجل.',
    'awsInv.noInboundRules':                         'لا توجد قواعد واردة.',
    'awsInv.noInventoryYet':                         'لا يوجد جرد بعد',
    'awsInv.noOutboundRules':                        'لا توجد قواعد صادرة.',
    'awsInv.noPoliciesAttached':                     'لا توجد سياسات مرفقة.',
    'awsInv.noRelatedSnapshots':                     'لا توجد لقطات مرتبطة.',
    'awsInv.noResources':                            'لا توجد موارد.',
    'awsInv.noResults':                              'لا توجد نتائج.',
    'awsInv.noResultsFound':                         'لم يتم العثور على نتائج.',
    'awsInv.noRoutes':                               'لا توجد مسارات.',
    'awsInv.noSecurityGroups':                       'لا توجد مجموعات أمان.',
    'awsInv.noServiceAccessRecorded':                'لا يوجد وصول مسجَّل إلى الخدمات.',
    'awsInv.noTunnels':                              'لا توجد أنفاق.',
    'awsInv.noVolumes':                              'لا توجد وحدات تخزين.',
    'awsInv.none':                                   'لا شيء',
    'awsInv.notAssociated':                          'غير مرتبط',
    'awsInv.notAttached':                            'غير مرفق.',
    'awsInv.notMemberAnyGroup':                      'ليس عضواً في أي مجموعة.',
    'awsInv.optional':                               'اختياري',
    'awsInv.permissions':                            'الصلاحيات',
    'awsInv.cronConfirm':                            'تشغيل جلب مخزون AWS الآن؟ يفحص 19 منطقة (1–2 دقيقة)، ويستبدل النسخة الحالية، ويسجل الفروق في سجل التغييرات.',
    'awsInv.refreshAws':                             'تحديث من AWS',
    'awsInv.regionsScanned':                         'المناطق المفحوصة',
    'awsInv.remediationGuide':                       'دليل المعالجة',
    'awsInv.removeInboundRuleProtocolPorts':         'إزالة القاعدة الواردة {protocol} {ports} من {source}؟',
    'awsInv.resetConsolePassword':                   'إعادة تعيين كلمة مرور الكونسول',
    'awsInv.resetConsolePasswordNameNew':            'إعادة تعيين كلمة مرور الكونسول لـ "{name}"؟ ستُولَّد كلمة مرور جديدة وعلى المستخدم تغييرها عند أول تسجيل دخول.',
    'awsInv.resetPasswordRandom':                    'إعادة تعيين كلمة المرور (عشوائية)',
    'awsInv.resetting':                              'جارٍ إعادة التعيين…',
    'awsInv.resourceDetail':                         'تفاصيل المورد',
    'awsInv.resources':                              'موارد',
    'awsInv.resourcesPerService':                    'الموارد لكل خدمة',
    'awsInv.results':                                'نتائج',
    'awsInv.resultsCapped50RefineQuery':             'النتائج محدودة بـ 50. حسّن استعلامك.',
    'awsInv.roleLastUsed':                           'آخر استخدام للدور',
    'awsInv.save':                                   'حفظ',
    'awsInv.saved':                                  'تم الحفظ',
    'awsInv.saving':                                 'جارٍ الحفظ…',
    'awsInv.search':                                 'بحث…',
    'awsInv.searchAllResourcesIdName':               'ابحث في كل الموارد… (المعرّف، الاسم، IP، الوسم، الحالة، إلخ)',
    'awsInv.securityCredentials':                    'بيانات الاعتماد',
    'awsInv.serviceTypes':                           'أنواع الخدمات',
    'awsInv.showSidebar':                            'إظهار الشريط الجانبي',
    'awsInv.sourceRequired':                         'المصدر مطلوب.',
    'awsInv.stateReason':                            'سبب الحالة',
    'awsInv.stateUpdated':                           'تم تحديث الحالة',
    'awsInv.totalResources':                         'إجمالي الموارد',
    'awsInv.treatMissingData':                       'معالجة البيانات المفقودة',
    'awsInv.updated':                                'مُحدَّث',
    'awsInv.userMustChangePasswordFirst':            'على المستخدم تغيير كلمة المرور عند أول تسجيل دخول.',
    'awsInv.volumes':                                'وحدات تخزين',
    'awsInv.yes':                                    'نعم',

    // ── awsTrail ──
    'awsTrail.account':                              'الحساب',
    'awsTrail.action':                               'إجراء',
    'awsTrail.affectedResources':                    'الموارد المتأثرة',
    'awsTrail.allEvents':                            'كل الأحداث',
    'awsTrail.allRegions':                           'كل المناطق',
    'awsTrail.analytics':                            'التحليلات',
    'awsTrail.backList':                             'العودة إلى القائمة',
    'awsTrail.clickRefreshFetchActivityEvents':      'انقر «تحديث» لجلب أحداث النشاط من AWS.',
    'awsTrail.clickResetFilters':                    'انقر لإعادة تعيين المرشّحات',
    'awsTrail.clickViewFailures':                    'انقر لعرض الإخفاقات',
    'awsTrail.collapseAll':                          'طيّ الكل',
    'awsTrail.copied':                               'تم النسخ',
    'awsTrail.copy':                                 'نسخ',
    'awsTrail.copyJson':                             'نسخ JSON',
    'awsTrail.days':                                 'أيام',
    'awsTrail.days2':                                'الأيام',
    'awsTrail.errorsOnly':                           'الأخطاء فقط',
    'awsTrail.eventDetail':                          'تفاصيل الحدث',
    'awsTrail.eventFailed':                          'فشل الحدث.',
    'awsTrail.events':                               'أحداث',
    'awsTrail.expandAll':                            'توسيع الكل',
    'awsTrail.failed':                               'فشل',
    'awsTrail.failedEvents':                         'الأحداث الفاشلة',
    'awsTrail.failedRegions':                        'المناطق الفاشلة',
    'awsTrail.fetching13Min':                        'جارٍ الجلب… (1–3 دقائق)',
    'awsTrail.hoverBreakdown':                       'مرّر المؤشر للتفصيل',
    'awsTrail.includeReadOnly':                      'تضمين للقراءة فقط',
    'awsTrail.jsonDetail':                           'تفاصيل JSON',
    'awsTrail.lengthRegionSFailedFetch':             'فشل جلب {length} منطقة — قد تكون النتائج غير مكتملة.',
    'awsTrail.loading':                              'جارٍ التحميل…',
    'awsTrail.name':                                 'الاسم',
    'awsTrail.noCloudtrailDataYet':                  'لا توجد بيانات CloudTrail بعد',
    'awsTrail.noEvents':                             'لا توجد أحداث.',
    'awsTrail.noMfa':                                'بدون MFA',
    'awsTrail.noResults':                            'لا توجد نتائج.',
    'awsTrail.oftenCausedCloudtrailApiThrottling':   'غالباً بسبب تقييد واجهة CloudTrail عند النوافذ الكبيرة / المناطق المتعددة. انقر للتفاصيل.',
    'awsTrail.publicIp':                             'عنوان IP عام',
    'awsTrail.readOnly':                             'للقراءة فقط',
    'awsTrail.refreshAws':                           'تحديث من AWS',
    'awsTrail.regionsNoEvents':                      'مناطق بلا أحداث',
    'awsTrail.regionsScanned':                       'المناطق المفحوصة',
    'awsTrail.search':                               'بحث…',
    'awsTrail.service':                              'الخدمة',
    'awsTrail.success':                              'نجاح',
    'awsTrail.time':                                 'الوقت',
    'awsTrail.topEvent':                             'الحدث الأبرز',
    'awsTrail.totalEvents':                          'إجمالي الأحداث',
    'awsTrail.unknownUser':                          'مستخدم غير معروف',
    'awsTrail.updated':                              'مُحدَّث',
    'awsTrail.user':                                 'المستخدم',
    'awsTrail.what':                                 'ماذا',
    'awsTrail.where':                                'من أين',
    'awsTrail.who':                                  'مَن',

    // ── roleAuthEd ──
    'roleAuthEd.authorizationValueEditorPfcgFile':   'محرّر قيم الصلاحيات (ملف PFCG)',
    'roleAuthEd.downloadResult':                     'تنزيل الملف الناتج',
    'roleAuthEd.editFieldValuesThenUpload':          'عدّل قيم الحقول ثم ارفعها مجدداً إلى PFCG. لا يُعدَّل SAP من هنا.',
    'roleAuthEd.failedLoadFileSap':                  'فشل تحميل الملف من SAP: ',
    'roleAuthEd.failedReadFile':                     'فشلت قراءة الملف: ',
    'roleAuthEd.noAgr1251RowsFound':                 'لم يتم العثور على صفوف AGR_1251.',
    'roleAuthEd.noChangesYet':                       'لا توجد تغييرات بعد',
    'roleAuthEd.noMatchingValues':                   'لا توجد قيم مطابقة.',
    'roleAuthEd.searchObjectField':                  'ابحث عن كائن / حقل…',
    'roleAuthEd.someValuesExceedVWidth':             'بعض القيم تتجاوز {V_WIDTH} حرفاً. صحّحها أولاً.',
    'roleAuthEd.someValuesTooLong':                  '· بعض القيم طويلة جداً',
    'roleAuthEd.uploadPfcgRoleDownloadFile':         'ارفع ملف تنزيل دور من PFCG لبدء تحرير القيم.',
    'roleAuthEd.uploadSapFile':                      'رفع ملف ‎.SAP‎',
    'roleAuthEd.valuesChanged':                      'قيمة معدَّلة',


    // ── File Deploy (fdeploy) ──
    'fdeploy.adaPerubahanBelumDisimpanTutup':        'هناك تغييرات غير محفوظة. إغلاق على أي حال؟',
    'fdeploy.adaSubfolderFileJsJsx':                 'لا توجد مجلدات فرعية أو ملفات ‎.js/.jsx‎ هنا.',
    'fdeploy.aiService':                             'AI Service',
    'fdeploy.aiServiceRestartSekaliSetelah':         'تتم إعادة تشغيل AI Service مرة واحدة بعد كتابة جميع الملفات.',
    'fdeploy.aiServiceRestartSetelahnya':            'ستتم إعادة تشغيل AI Service بعد ذلك.',
    'fdeploy.aiServiceSedangRestartTunggu':          'AI Service قيد إعادة التشغيل — انتظر نحو 10 ثوانٍ.',
    'fdeploy.aksi':                                  'الإجراءات',
    'fdeploy.ambilLogTerbaruSemuaProses':            'اجلب أحدث سجلات جميع العمليات عبر',
    'fdeploy.autocomplete':                          'إكمال تلقائي  ·',
    'fdeploy.backend':                               'Backend',
    'fdeploy.backendRestartSekaliSetelahSemua':      'تتم إعادة تشغيل الـ backend مرة واحدة بعد كتابة جميع الملفات.',
    'fdeploy.backendRestartSetelahnya':              'ستتم إعادة تشغيل الـ backend بعد ذلك.',
    'fdeploy.backendSedangRestartTunggu10':          'الـ backend قيد إعادة التشغيل — انتظر نحو 10 ثوانٍ ثم حدّث الصفحة.',
    'fdeploy.backup2':                               '📸 نسخة احتياطية',
    'fdeploy.backup3':                               ' (نسخة احتياطية: {backupName})',
    'fdeploy.backupSekarang':                        '📸 أنشئ نسخة احتياطية الآن',
    'fdeploy.backupSemua':                           '💾 نسخ احتياطي للكل',
    'fdeploy.backupSemuaFile':                       'نسخ احتياطي لجميع الملفات',
    'fdeploy.baru':                                  '← جديد',
    'fdeploy.baru2':                                 '←  الجديد:',
    'fdeploy.batal':                                 'إلغاء',
    'fdeploy.batal2':                                '✕ إلغاء',
    'fdeploy.bedakanHurufBesarKecil':                'مطابقة حالة الأحرف',
    'fdeploy.belumAdaBackupFile':                    'لا توجد نسخ احتياطية لهذا الملف بعد.',
    'fdeploy.belumAdaFileKlikTambah':                'لا توجد ملفات بعد. انقر «إضافة ملف…» ثم حدّد مسار الوجهة لكل ملف.',
    'fdeploy.belumAdaRiwayatDiffFile':               'لا يوجد سجل فروقات لهذا الملف بعد (يُسجَّل فقط عند النشر من تبويب Deploy).',
    'fdeploy.berhasilRename':                        'تمت إعادة التسمية بنجاح.',
    'fdeploy.bersihkan':                             '✖ مسح',
    'fdeploy.bersihkanSemua':                        'مسح الكل',
    'fdeploy.bisaDibatalkan':                        'لا يمكن التراجع عنه',
    'fdeploy.browse':                                '📂 استعراض',
    'fdeploy.browseServer':                          '📂 استعراض الخادم',
    'fdeploy.btnDeployMixed':                        '🚀 نشر {n} ملف، إعادة البناء وإعادة التشغيل',
    'fdeploy.btnDeployRebuild':                      '🚀 نشر {n} ملف وإعادة البناء',
    'fdeploy.btnDeployRestart':                      '🚀 نشر {n} ملف وإعادة التشغيل',
    'fdeploy.buildBerjalan':                         '⏳ البناء قيد التنفيذ…',
    'fdeploy.buildFrontend':                         '🔨 بناء الواجهة',
    'fdeploy.buildFrontendSekarang':                 '🔨 ابنِ الواجهة الآن',
    'fdeploy.buildSelesaiHardRefreshCtrl':           'اكتمل البناء. حدّث الصفحة تحديثاً كاملاً (Ctrl+Shift+R) لتحميل الإصدار الجديد.',
    'fdeploy.building':                              '⏳ جارٍ البناء…',
    'fdeploy.cari2':                                 'بحث',
    'fdeploy.cariBackup':                            'ابحث عن النسخ الاحتياطية',
    'fdeploy.cariDiFile':                            'بحث في الملف',
    'fdeploy.clear':                                 '🗑 مسح',
    'fdeploy.clearOutput':                           'مسح المخرجات',
    'fdeploy.confirmBackupAll':                      'نسخ جميع ملفات ‎.js/.jsx‎ في {type} ({code}) احتياطياً بشكل متكرر؟',
    'fdeploy.confirmDeleteOne':                      'حذف {code}؟',
    'fdeploy.confirmDeleteSelected':                 'حذف العناصر المحددة البالغ عددها {b}؟',
    'fdeploy.confirmDeployMulti':                    'نشر {n} ملف إلى {type}؟ يتم نسخ الملف السابق في كل مسار احتياطياً تلقائياً. بدون معاينة أو مقارنة.',
    'fdeploy.confirmDeployOne':                      'نشر {name} إلى {type} في المسار {code}؟',
    'fdeploy.confirmRestore':                        'استعادة {code} من النسخة الاحتياطية {b}؟',
    'fdeploy.connectSsh':                            '🔌 الاتصال عبر SSH',
    'fdeploy.connecting':                            '⏳ جارٍ الاتصال…',
    'fdeploy.copyLog':                               '📄 نسخ السجل',
    'fdeploy.ctrlC':                                 'Ctrl+C',
    'fdeploy.ctrlD':                                 'Ctrl+D',
    'fdeploy.ctrlL':                                 'Ctrl+L',
    'fdeploy.ctrlS':                                 'Ctrl+S',
    'fdeploy.dashboardAiServiceDll':                 '(dashboard، ai-service، إلخ).',
    'fdeploy.deployRebuildFrontend':                 'نشر وإعادة بناء الواجهة',
    'fdeploy.deployRestartAiService':                'نشر وإعادة تشغيل AI Service',
    'fdeploy.deployRestartBackend':                  'نشر وإعادة تشغيل الـ backend',
    'fdeploy.diff':                                  'الفروقات: {rel}',
    'fdeploy.diff2':                                 'الفروقات:',
    'fdeploy.diff3':                                 'الفروقات: {targetPath}',
    'fdeploy.dihapus':                               'تم الحذف: {p}',
    'fdeploy.dipulihkanJalankanRebuildTabDeploy':    'تمت الاستعادة من {backupName}. شغّل إعادة البناء في تبويب Deploy إن كان هذا ملف واجهة.',
    'fdeploy.dipulihkanRestartTunggu10Detik':        'تمت الاستعادة من {backupName}. {label} قيد إعادة التشغيل — انتظر نحو 10 ثوانٍ ثم حدّث الصفحة.',
    'fdeploy.direktoriKosong':                       'المجلد فارغ.',
    'fdeploy.disalin':                               '✅ تم النسخ',
    'fdeploy.disconnect':                            '⏏ قطع الاتصال',
    'fdeploy.diunduh':                               'تم التنزيل: {download}',
    'fdeploy.download':                              '⬇️ تنزيل',
    'fdeploy.download2':                             'تنزيل',
    'fdeploy.downloadDiffTxt':                       '⬇️ تنزيل ‎.diff.txt‎',
    'fdeploy.downloadServer':                        '⬇️ تنزيل من الخادم',
    'fdeploy.dropHere':                              '📂 أفلت الملفات هنا لرفعها إلى {code}',
    'fdeploy.ec2UserLocalhostSsh':                   'ec2-user@localhost (SSH)',
    'fdeploy.enter':                                 'Enter',
    'fdeploy.entri':                                 'مدخلات',
    'fdeploy.eof':                                   'EOF  ·',
    'fdeploy.error':                                 'خطأ',
    'fdeploy.escKeTeks':                             'Esc للعودة إلى النص',
    'fdeploy.posisiKursor':                          'سطر {line}، عمود {col}',
    'fdeploy.jumlahBaris':                           '{total} سطر',
    'fdeploy.terpilihKarakter':                      '{n} محدد',
    'fdeploy.nomorBaris':                            'أرقام الأسطر',
    'fdeploy.explorerBackupNote':                    'يُنسخ الملف السابق احتياطياً تلقائياً إلى مجلد {code} في هذا الدليل (يُحتفظ بآخر 10 إصدارات) قبل الاستبدال.',
    'fdeploy.file':                                  'ملف',
    'fdeploy.file2':                                 'ملف',
    'fdeploy.fileAdaServer':                         'الملف غير موجود على الخادم.',
    'fdeploy.fileBaruTanpaBackup':                   ' (ملف جديد، بلا نسخة احتياطية)',
    'fdeploy.fileBelumAdaServerDibuat':              'ℹ️ الملف غير موجود على الخادم بعد — سيُنشأ كملف جديد (بلا نسخة احتياطية).',
    'fdeploy.fileBerubahBesarDiringkasBukan':        'تغيّر الملف بشكل كبير — تم التلخيص، وليست مقارنة دقيقة سطراً بسطر',
    'fdeploy.fileDeploy':                            '📦 نشر الملفات',
    'fdeploy.fileLamaBilaAdaBackup':                 'يُنسخ الملف السابق (إن وُجد) احتياطياً تلقائياً، ويُحفظ سجل فروقاته (انظر تبويب النسخ والاستعادة) للتتبّع.',
    'fdeploy.fileTerDeployMemulaiRebuild':           'تم نشر الملف{bk}. جارٍ بدء إعادة بناء الواجهة…',
    'fdeploy.fileTerDeploySedangRestart':            'تم نشر الملف{bk}. {label} قيد إعادة التشغيل — انتظر نحو 10 ثوانٍ ثم حدّث الصفحة.',
    'fdeploy.fileTerUpload':                         'تم رفع {ok} ملف إلى {curPath}',
    'fdeploy.fileTerUploadMenimpaFile':              'تم رفع {ok} ملف إلى {curPath} ({overwritten} استبدل ملفات موجودة — حُفظت نسخ احتياطية تلقائياً)',
    'fdeploy.fileTerlaluBesarDitampilkanDiff':       'الملف أكبر من أن تُعرض مقارنة سطرية. تحقّق من الحجم: الخادم',
    'fdeploy.fileTerpilih':                          'ملف محدد',
    'fdeploy.folderBeratNodeModulesBuild':           'يتم تخطّي المجلدات الثقيلة (node_modules، build، backups، إلخ). تُؤخذ لقطة لكل ملف في مجلد backups (يُحتفظ بـ 10 لكل ملف).',
    'fdeploy.frontend':                              'Frontend',
    'fdeploy.frontendRebuildBeberapaMenit':          'ستتم إعادة بناء الواجهة (تستغرق بضع دقائق).',
    'fdeploy.frontendRebuildSekaliSetelahSemua':     'تتم إعادة بناء الواجهة مرة واحدة بعد كتابة جميع الملفات.',
    'fdeploy.gagal':                                 '، {fail} فشل',
    'fdeploy.gagal2':                                '، {fail} فشل',
    'fdeploy.halamanHanyaAdmin':                     'هذه الصفحة للمسؤولين فقط.',
    'fdeploy.hanyaFileJsJsxDiizinkan':               'يُسمح بملفات ‎.js / .jsx‎ فقط.',
    'fdeploy.hapus':                                 '🗑️ حذف',
    'fdeploy.hapus2':                                'حذف',
    'fdeploy.hasilBerikutnya':                       'النتيجة التالية',
    'fdeploy.hasilSebelumnya':                       'النتيجة السابقة',
    'fdeploy.hintAiService':                         'نسبةً إلى ‎/awsbasis/ai-service‎ — مثال: server.js أو aiProxy.js',
    'fdeploy.hintBackend':                           'نسبةً إلى ‎/awsbasis/dashboard/backend‎ — مثال: fileDeployRoutes.js',
    'fdeploy.hintFrontend':                          'نسبةً إلى ‎/awsbasis/dashboard/frontend‎ — مثال: src/pages/FileDeployPage.jsx',
    'fdeploy.histSubtitle':                          'سجل جميع عمليات النشر في الجذور الثلاثة، مجمَّعة حسب الجلسة. أداة تتبّع — السجل الرسمي يبقى سجل التدقيق.',
    'fdeploy.histAllTypes':                          'كل الجذور',
    'fdeploy.histSearchPh':                          'تصفية المسار — مثال: TableMaintenance',
    'fdeploy.histSearch':                            'بحث',
    'fdeploy.histClear':                             'مسح',
    'fdeploy.histRefresh':                           '↻ إعادة التحميل',
    'fdeploy.histLoading':                           'جارٍ تحميل سجل النشر…',
    'fdeploy.histEmpty':                             'لا يوجد سجل نشر بعد.',
    'fdeploy.histSummary':                           '{s} جلسة · {d} فرق · تُفصل الجلسات عند تجاوز الفارق {g} ثانية',
    'fdeploy.histCapped':                            'تم تقليص النتائج بسبب حد الفحص — بعض السجل القديم غير معروض.',
    'fdeploy.histFiles':                             '{n} ملف',
    'fdeploy.histLoadFailed':                        'فشل تحميل سجل النشر.',
    'fdeploy.indent2Spasi':                          'مسافة بادئة بمقدار مسافتين',
    'fdeploy.interupsi':                             'مقاطعة  ·',
    'fdeploy.isiDuluPathFileServer':                 'أدخل مسار الملف على الخادم أولاً.',
    'fdeploy.isiDuluPathTujuanServer':               'أدخل مسار الوجهة على الخادم أولاً.',
    'fdeploy.isiPathFileDulu':                       'أدخل مسار الملف أولاً.',
    'fdeploy.itemDipilih':                           'عنصر محدد',
    'fdeploy.jalankanRebuildFrontendSekarangProses': 'إعادة بناء الواجهة الآن؟ تستغرق بضع دقائق، والسجل يُعرض مباشرةً.',
    'fdeploy.jumlahBaris':                           'عدد الأسطر:',
    'fdeploy.kembaliDaftar':                         '→ العودة إلى القائمة',
    'fdeploy.ketikCommandEnterKirim':                'اكتب أمراً، واضغط Enter للإرسال…',
    'fdeploy.kirim':                                 'إرسال  ·',
    'fdeploy.kondisiFileSaatBackupDulu':             'يُنسخ الملف الحالي احتياطياً قبل استبداله (يمكن التراجع بالاستعادة مجدداً).',
    'fdeploy.konfirmasiBuild':                       'تأكيد البناء',
    'fdeploy.konfirmasiDeploy':                      'تأكيد النشر',
    'fdeploy.konfirmasiHapus':                       'تأكيد الحذف',
    'fdeploy.konfirmasiHapusMassal':                 'تأكيد الحذف الجماعي',
    'fdeploy.konfirmasiMultiDeploy':                 'تأكيد النشر المتعدد',
    'fdeploy.konfirmasiRestart':                     'تأكيد إعادة التشغيل',
    'fdeploy.konfirmasiRestartAiService':            'تأكيد إعادة تشغيل AI Service',
    'fdeploy.konfirmasiRestore':                     'تأكيد الاستعادة',
    'fdeploy.konfirmasiTimpaFile':                   'تأكيد الاستبدال',
    'fdeploy.konfirmasiTimpaPesan':                  '{n} من أصل {total} ملف مرفوع موجودة بالفعل في هذا المجلد وسيتم استبدالها:',
    'fdeploy.lama':                                  'القديم:',
    'fdeploy.left':                                  'يسار',
    'fdeploy.lihat':                                 '👁️ عرض',
    'fdeploy.lihatDiff':                             'عرض الفروقات',
    'fdeploy.lihatDiff2':                            '👁️ عرض الفروقات',
    'fdeploy.logBuild':                              '📋 سجل البناء',
    'fdeploy.logDisalinClipboard':                   'تم نسخ السجل إلى الحافظة.',
    'fdeploy.logKosong':                             '(السجل فارغ)',
    'fdeploy.logSemuaProses':                        '📋 سجل جميع العمليات',
    'fdeploy.masukkanPathFileLaluKlik':              'أدخل مسار ملف ثم انقر «ابحث عن النسخ الاحتياطية».',
    'fdeploy.mdBuildFailedNoRestart':                'فشل البناء — أُلغيت إعادة تشغيل pm2. الملفات مكتوبة على الخادم بالفعل؛ صحّح الخطأ ثم أعد البناء من تبويب العمليات.',
    'fdeploy.mdOrderNote':                           'يُنفَّذ البناء أولاً ثم تأتي إعادة تشغيل pm2 — فإعادة التشغيل أثناء البناء هي ما نتجنّبه.',
    'fdeploy.mdPlanTitle':                           'خطة التنفيذ',
    'fdeploy.mdRestarting':                          '{label} قيد إعادة التشغيل — انتظر نحو 10 ثوانٍ.',
    'fdeploy.mdRowTypeTitle':                        'الجذر الهدف لهذا الملف',
    'fdeploy.mdStepBuild':                           'إعادة بناء الواجهة (npm run build، سجل مباشر)',
    'fdeploy.mdStepRestart':                         'إعادة تشغيل pm2: {list}',
    'fdeploy.mdStepWrite':                           'كتابة {n} ملف (+ نسخة احتياطية وسجل الفروقات)',
    'fdeploy.mdTypeDefault':                         'النوع الافتراضي (الصفوف الجديدة)',
    'fdeploy.mdTypeDefaultHint':                     'يمكن تغيير النوع لكل ملف في القائمة — يمكن لدفعة واحدة أن تخلط الجذور.',
    'fdeploy.memuat':                                '⏳ جارٍ التحميل…',
    'fdeploy.memuat2':                               'جارٍ التحميل…',
    'fdeploy.memuatRiwayatDiff':                     'جارٍ تحميل سجل الفروقات…',
    'fdeploy.memulaiRebuildFrontend':                '{base}. جارٍ بدء إعادة بناء الواجهة…',
    'fdeploy.menghubungkan':                         'جارٍ الاتصال…',
    'fdeploy.menyimpan':                             '⏳ جارٍ الحفظ…',
    'fdeploy.naik':                                  '⬆ للأعلى',
    'fdeploy.nama':                                  'الاسم',
    'fdeploy.namaBaru':                              'الاسم الجديد',
    'fdeploy.namafileJs':                            'fileName.js',
    'fdeploy.opsRebuildDesc':                        'شغّل {code} في ‎/awsbasis/dashboard/frontend‎. استخدم هذا بعد رفع ملفات الواجهة دون المرور بتبويب Deploy.',
    'fdeploy.opsRestartAiDesc':                      'شغّل {code} في ‎/awsbasis/ai-service‎ (delete ← start من ecosystem، وليس إعادة تشغيل عادية). مفيد بعد نشر ملفات AI Service.',
    'fdeploy.opsRestartBackendDesc':                 'شغّل {code} في ‎/awsbasis/dashboard/backend‎ — وليس مجرد {plain} — حتى تُقرأ فعلياً متغيرات البيئة والكود الجديد من ecosystem.config.js. ينقطع الاتصال لحظياً (نحو 10 ثوانٍ).',
    'fdeploy.pathFile':                              'مسار الملف',
    'fdeploy.pathTujuanServer':                      'مسار الوجهة على الخادم',
    'fdeploy.pilihFile':                             '📄 اختر ملفاً…',
    'fdeploy.pilihFileBackup':                       'اختر ملفاً لنسخه احتياطياً',
    'fdeploy.pilihFileServer':                       'اختر ملفاً على الخادم',
    'fdeploy.pm2DeleteAiServicePm2':                 'pm2 delete ai-service && pm2 start ecosystem.config.js --only ai-service && pm2 save',
    'fdeploy.pm2DeleteDashboardPm2Start':            'pm2 delete dashboard && pm2 start ecosystem.config.js --only dashboard && pm2 save',
    'fdeploy.pm2Logs':                               'pm2 logs',
    'fdeploy.pm2Restart':                            'pm2 restart',
    'fdeploy.primary':                               'primary',
    'fdeploy.pulihkan':                              '↩️ استعادة',
    'fdeploy.refresh':                               '🔄 تحديث',
    'fdeploy.rename':                                'إعادة تسمية',
    'fdeploy.rename2':                               'إعادة تسمية: {name}',
    'fdeploy.reset':                                 '↩ إعادة تعيين',
    'fdeploy.restartAiService':                      '🤖 إعادة تشغيل AI Service',
    'fdeploy.restartAiServiceSekarang':              '🤖 أعد تشغيل AI Service الآن',
    'fdeploy.restartAiServiceSekarangKoneksi':       'إعادة تشغيل AI Service الآن؟ سينقطع اتصال الذكاء الاصطناعي لحظياً (نحو 10 ثوانٍ).',
    'fdeploy.restartBackend':                        '🔄 إعادة تشغيل الـ backend',
    'fdeploy.restartBackendSekarang':                '🔄 أعد تشغيل الـ backend الآن',
    'fdeploy.restartBackendSekarangSemuaKoneksi':    'إعادة تشغيل الـ backend الآن؟ ستنقطع جميع الاتصالات لحظياً (نحو 10 ثوانٍ).',
    'fdeploy.restartTunggu10DetikLalu':              '{base}. {label} قيد إعادة التشغيل — انتظر نحو 10 ثوانٍ ثم حدّث الصفحة.',
    'fdeploy.restarting':                            '⏳ جارٍ إعادة التشغيل…',
    'fdeploy.right':                                 'يمين',
    'fdeploy.ringkasan':                             '⚠ ملخّص',
    'fdeploy.riwayatDiff':                           'سجل الفروقات: {rel}',
    'fdeploy.riwayatDiffDeploy':                     '📝 سجل الفروقات (النشر)',
    'fdeploy.riwayatDiffTracingDeployTab':           'سجل الفروقات (تتبّع — من عمليات النشر عبر تبويب Deploy)',
    'fdeploy.rmRfNodeModulesCache':                  'rm -rf node_modules/.cache && npm run build',
    'fdeploy.sama':                                  'مطابق)',
    'fdeploy.sebagianFileDilewatiHanyaJs':           'تم تخطّي بعض الملفات (‎.js/.jsx‎ فقط).',
    'fdeploy.seretFileAreaAtasUpload':               '💡 اسحب الملفات إلى المنطقة أعلاه للرفع السريع',
    'fdeploy.simpan':                                '💾 حفظ',
    'fdeploy.simpan2':                               'حفظ  ·',
    'fdeploy.simpan3':                               '✅ حفظ',
    'fdeploy.success':                               'نجاح',
    'fdeploy.tab':                                   'Tab',
    'fdeploy.tabBackup':                             'النسخ والاستعادة',
    'fdeploy.tabConsole':                            'طرفية النظام',
    'fdeploy.tabDeploy':                             'النشر',
    'fdeploy.tabExplorer':                           'مستعرض الملفات',
    'fdeploy.tabHistory':                            'سجل النشر',
    'fdeploy.tabMulti':                              'نشر متعدد',
    'fdeploy.tabOps':                                'العمليات',
    'fdeploy.tambahFile':                            '📄 إضافة ملف…',
    'fdeploy.tampilkanLog':                          '📋 عرض السجل',
    'fdeploy.tekanConnectSshMemulaiSesi':            'اضغط «الاتصال عبر SSH» لبدء جلسة طرفية…',
    'fdeploy.teks':                                  '{dir}/{name}',
    'fdeploy.teks2':                                 '{curPath}/{name}',
    'fdeploy.terakhirDiubah':                        'آخر تعديل',
    'fdeploy.terhubung':                             'غير متصل',
    'fdeploy.terhubung2':                            '(غير متصل)',
    'fdeploy.tersimpan':                             'تم الحفظ: {name}',
    'fdeploy.tindakan':                              'هذا الإجراء',
    'fdeploy.tipe':                                  'النوع',
    'fdeploy.tipeSatuBatchSatuTipe':                 'النوع (دفعة واحدة = نوع واحد)',
    'fdeploy.tracingApaBerubahTiapDeploy':           'للتتبّع — ما الذي تغيّر في كل عملية نشر',
    'fdeploy.tutup':                                 'إغلاق',
    'fdeploy.ukuran':                                'الحجم',
    'fdeploy.unggahFileJsJsxLangsung':               'ارفع ملفات ‎.js/.jsx‎ مباشرةً من المتصفح — نسخ احتياطي تلقائي، ثم إعادة تشغيل الـ backend أو إعادة بناء الواجهة.',
    'fdeploy.upload':                                '⬆️ رفع',
    'fdeploy.uploading':                             '⏳ جارٍ الرفع…',
    'fdeploy.viewEdit':                              'عرض / تعديل',
    'fdeploy.warning':                               'تحذير',
    'fdeploy.wss':                                   'wss',
    'fdeploy.yaBackupSemua':                         'نعم، انسخ الكل احتياطياً',
    'fdeploy.yaBuild':                               'نعم، ابنِ',
    'fdeploy.yaDeploy':                              'نعم، انشر',
    'fdeploy.yaDeploySemua':                         'نعم، انشر الكل',
    'fdeploy.yaHapus':                               '🗑️ نعم، احذف',
    'fdeploy.yaHapusSemua':                          '🗑️ نعم، احذف الكل',
    'fdeploy.yaPulihkan':                            'نعم، استعِد',
    'fdeploy.yaRestart':                             'نعم، أعد التشغيل',
    'fdeploy.yaRestartAiService':                    'نعم، أعد تشغيل AI Service',
    'fdeploy.yaTimpa':                               '⚠️ نعم، استبدل',


    // ── AI Settings + Table Maintenance ──
    'aiSet2.modelIdContohUsAnthropic':               'معرّف النموذج، مثال: us.anthropic.claude-3-5-sonnet-20241022-v2:0',
    'aiSet2.promptGlobalDipakaiSaatAda':             'موجّه عام — يُستخدم عند عدم وجود لوحة نشطة (مثل AI Workspace «General»).',
    'tblMaint.aiServiceDbOperasiRestore':            'ℹ️ قاعدة بيانات AI Service: الاستعادة غير متاحة من هنا. استخدم الملف',
    'tblMaint.aktif':                                'نشط',
    'tblMaint.baris':                                '{total} صف',
    'tblMaint.batal':                                'إلغاء',
    'tblMaint.belumAdaDataIdSuim':                   'لا توجد بيانات SUIM ID بعد',
    'tblMaint.belumAdaDataKlikRun':                  'لا توجد بيانات بعد — انقر Run Now أعلاه لأول عملية جلب.',
    'tblMaint.belumAdaDataOvertimeUpload':           'لا توجد بيانات عمل إضافي بعد. ارفع ملف CSV للبدء.',
    'tblMaint.belumAdaDataRingkasan':                'لا توجد بيانات ملخّص بعد.',
    'tblMaint.belumAdaDataUser':                     'لا توجد بيانات مستخدمين بعد.',
    'tblMaint.belumAdaSourceFile':                   'لا توجد ملفات مصدر بعد',
    'tblMaint.belumAdaUpload':                       'لا توجد عمليات رفع بعد',
    'tblMaint.cari':                                 'بحث',
    'tblMaint.cariNamaKodeDept':                     '🔍 ابحث بالاسم أو الرمز أو القسم…',
    'tblMaint.cariUpnDomain':                        'ابحث بـ UPN أو النطاق…',
    'tblMaint.cariUserNamaDeptEmail':                '🔍 ابحث بالمستخدم أو الاسم أو القسم أو البريد…',
    'tblMaint.dataDetailLoginDiagregasiOtomatis':    'تُجمَّع بيانات تفاصيل تسجيل الدخول تلقائياً إلى ساعات لكل مستخدم / فترة (YYYY-MM) / قسم، ثم تُخزَّن في قاعدة بيانات اللوحة (المصدر: SAP:<SID> <range>).',
    'tblMaint.fetchSimpan':                          '📡 جلب وحفظ',
    'tblMaint.fetchUserUtilizationSapZrfc':          '📡 جلب استخدام المستخدمين من SAP (ZRFC_USR_UTL)',
    'tblMaint.halaman':                              'الصفحة',
    'tblMaint.hapus':                                '🗑️ حذف',
    'tblMaint.hapus2':                               'حذف',
    'tblMaint.hapusDomainDaftarRingkasan':           'إزالة النطاق «{dom}» من قائمة الملخّص؟',
    'tblMaint.hapusIdSuimData':                      'حذف بيانات SUIM ID من «{selSrc}»؟',
    'tblMaint.hapusMappingSku':                      'حذف تعيين SKU «{part}»؟',
    'tblMaint.hapusOvertimeData':                    'حذف بيانات العمل الإضافي من «{selSrc}»؟',
    'tblMaint.hapusSource':                          '🗑️ حذف المصدر',
    'tblMaint.hapusUploadBesertaSemuaDatanya':       'حذف الرفع «{filename}» وجميع بياناته؟',
    'tblMaint.isiLicense':                           '🩹 تعبئة الترخيص',
    'tblMaint.jalankanVacuumAiServiceDb':            'تشغيل VACUUM على قاعدة بيانات AI Service؟',
    'tblMaint.kolomKategoriTampilSebagaiKolom':      'يظهر عمود «الفئة» كعمود في جدول الملخّص.',
    'tblMaint.kosongkanSemua':                       '⚠️ مسح الكل',
    'tblMaint.kosongkanSemuaDataEmployeeOvertime':   'مسح جميع بيانات العمل الإضافي للموظفين؟ لا يمكن التراجع عن هذا!',
    'tblMaint.kosongkanSemuaDataIdSuim':             'مسح جميع بيانات SUIM ID؟ لا يمكن التراجع عن هذا!',
    'tblMaint.memuatData':                           'جارٍ تحميل البيانات…',
    'tblMaint.modeSimpan':                           'وضع الحفظ',
    'tblMaint.namaRamah':                            'الاسم المألوف',
    'tblMaint.nonaktif':                             'غير نشط',
    'tblMaint.pageOfRecords':                        'الصفحة {page} من {totalPages} ({shown} من {total} سجل)',
    'tblMaint.penghapusanSourceFileSolmanSap':       'ℹ️ حذف ملفات مصدر Solman/SAP/SUIM يتم من تبويب كل منها.',
    'tblMaint.pilihKoneksi':                         '— اختر اتصالاً —',
    'tblMaint.pilihSourceFile':                      '-- اختر ملف مصدر --',
    'tblMaint.ringkasanLisensiPerDomain':            '📊 ملخّص التراخيص حسب النطاق',
    'tblMaint.riwayatUploadSourceFileSemua':         'سجل الرفع وملفات المصدر لجميع الجداول',
    'tblMaint.semuaBln':                             'كل الأشهر',
    'tblMaint.semuaBu':                              'كل وحدات الأعمال',
    'tblMaint.semuaTahun':                           'كل السنوات',
    'tblMaint.snapshotTerakhir':                     'آخر لقطة: {snap}',
    'tblMaint.tabelAktif':                           'الجدول النشط:',
    'tblMaint.tampilkanSebagaiKolomKategoriRingkasan': 'عرضه كعمود فئة في الملخّص؟ موافق = نعم.',
    'tblMaint.tanggal':                              'التاريخ من',
    'tblMaint.tanggalSampai':                        'التاريخ إلى',
    'tblMaint.total':                                'الإجمالي',
    'tblMaint.totalAssets':                          'إجمالي الأصول',
    'tblMaint.totalRecords':                         'إجمالي السجلات',
    'tblMaint.totalRequests':                        'إجمالي الطلبات',
    'tblMaint.totalUsers':                           'إجمالي المستخدمين',


    // ── File Deploy: auto-locate ──
    'fdeploy.locAmbiguous':                    'تم العثور على {n} ملف باسم {name} في مواقع مختلفة.',
    'fdeploy.locAmbiguousShort':               '{n} موقع — اختر:',
    'fdeploy.locChooseHint':                   'اختر واحداً أدناه. لا يُختار أي منها تلقائياً، تفادياً لاستبدال الملف الخطأ.',
    'fdeploy.locFound':                        'تم تحديد الموقع تلقائياً:',
    'fdeploy.locNew':                          '{name} غير موجود في المشروع بعد — سيُنشأ كملف جديد. أدخل مسار الوجهة يدوياً.',
    'fdeploy.locNewShort':                     'ملف جديد — أدخل المسار يدوياً',
    'fdeploy.locRenamed':                      'تم توحيد اسم الملف: {from} ← {to} (أُزيلت لاحقة التنزيل المتكرر).',
    'fdeploy.locSearching':                    '🔎 جارٍ تحديد موقع الملف في المشروع…',
    'fdeploy.locSizeSame':                     'الحجم نفسه',
    'fdeploy.locUploadSize':                   'الملف المرفوع: {size}',
    'fdeploy.locTypeMismatch':                 'تم اكتشاف {n} ملف في جذر غير «{type}».',
    'fdeploy.locTypeMismatchHint':             'يستخدم النشر المتعدد نوعاً واحداً للدفعة كاملة. انقل هذه الملفات إلى دفعة منفصلة، أو غيّر النوع أعلاه.',
    'fdeploy.nihil':                                 'لا شيء',


    // ══ AWS Pricing Calculator (Tahap 3) ══
    'page.awsPricing.title':      'حاسبة أسعار AWS',
    'page.awsPricing.subtitle':   'تقدير تكاليف AWS مع مقارنة خيارات الالتزام جنباً إلى جنب',
    'sidebar.awsPricing':         'حاسبة أسعار AWS',
    'sidebar.awsPricing.sub':     'تقدير التكلفة والالتزام',
    'rm.desc.aws_pricing':        'حاسبة الأسعار والتقديرات',
    'awsp.tab.calculator':        'الحاسبة',
    'awsp.tab.catalog':           'كتالوج الأسعار',
    'awsp.tab.sync':              'المزامنة والإعداد',
    'awsp.loading':               'جارٍ التحميل…',
    'awsp.configError':           'فشل تحميل الإعدادات:',
    'awsp.region':                'المنطقة',
    'awsp.service':               'الخدمة',
    'awsp.instanceType':          'نوع النسخة',
    'awsp.os':                    'نظام التشغيل',
    'awsp.tenancy':               'نوع الاستضافة',
    'awsp.preInstalledSw':        'البرامج المثبتة',
    'awsp.termType':              'نوع العرض',
    'awsp.offeringClass':         'فئة العرض',
    'awsp.lease':                 'المدة',
    'awsp.payment':               'طريقة الدفع',
    'awsp.range':                 'النطاق',
    'awsp.upfront':               'الدفعة المقدمة',
    'awsp.rate':                  'السعر',
    'awsp.unit':                  'الوحدة',
    'awsp.all':                   'الكل',
    'awsp.search':                'بحث',
    'awsp.clearFilters':          'مسح عوامل التصفية',
    'awsp.save':                  'حفظ',
    'awsp.yes':                   'نعم',
    'awsp.no':                    'لا',
    'awsp.mo':                    'شهر',
    'awsp.hr':                    'ساعة',
    'awsp.calc.cart':             'السلة',
    'awsp.calc.cartEmpty':        'لا توجد بنود بعد. أضف مورداً من اللوحة الوسطى.',
    'awsp.calc.addLine':          'إضافة بند',
    'awsp.calc.addToCart':        'أضف إلى السلة',
    'awsp.calc.kindEc2':          'نسخة EC2',
    'awsp.calc.kindUsage':        'التخزين / النقل',
    'awsp.calc.qty':              'الكمية',
    'awsp.calc.hoursPerMonth':    'ساعات في الشهر',
    'awsp.calc.volumeGb':         'الحجم (غيغابايت)',
    'awsp.calc.usageType':        'نوع الاستخدام',
    'awsp.calc.onDemand':         'عند الطلب',
    'awsp.calc.noPrice':          'السعر غير متوفر',
    'awsp.calc.needInstance':     'اختر نوع النسخة ونظام التشغيل ونوع الاستضافة أولاً.',
    'awsp.calc.needUsageType':    'اختر نوع الاستخدام أولاً.',
    'awsp.calc.pickLine':         'اختر بنداً من السلة لعرض مصفوفة الالتزام الخاصة به.',
    'awsp.calc.noCommitment':     'بنود التخزين ونقل البيانات لها أسعار عند الطلب متدرجة فقط — دون خيارات التزام.',
    'awsp.calc.tiers':            'مستويات السعر',
    'awsp.calc.supportPlan':      'خطة الدعم',
    'awsp.calc.vat':              'ضريبة القيمة المضافة',
    'awsp.calc.vatId':            'ضريبة إندونيسيا',
    'awsp.calc.vatSg':            'ضريبة سنغافورة',
    'awsp.calc.vatNone':          'بدون ضريبة',
    'awsp.calc.hoursNote':        'الساعات الافتراضية شهرياً:',
    'awsp.calc.recurring':        'التكلفة المتكررة',
    'awsp.calc.amortizedUpfront': 'الدفعة المقدمة موزعة',
    'awsp.calc.usageSubtotal':    'مجموع الاستخدام',
    'awsp.calc.support':          'الدعم',
    'awsp.calc.totalMonthly':     'الإجمالي شهرياً',
    'awsp.calc.cashUpfront':      'النقد المقدم (الشهر 0)',
    'awsp.calc.cashNote':         'هذا الرقم منفصل عن الإجمالي الشهري الذي يستخدم الدفعة المقدمة الموزعة.',
    'awsp.calc.supportBasisNote': 'أساس حساب الدعم يستثني الدفعة المقدمة للحجز، مطابقاً لطريقة فوترة AWS.',
    'awsp.calc.kindRds':      'مثيل RDS',
    'awsp.calc.dbEngine':     'محرك قاعدة البيانات',
    'awsp.calc.dbEdition':    'الإصدار',
    'awsp.calc.dbEditionNone':'بدون إصدار',
    'awsp.calc.deployment':   'نمط النشر',
    'awsp.calc.licenseModel': 'نموذج الترخيص',
    'awsp.calc.needRds':      'اختر محرك قاعدة البيانات ونمط النشر ونوع المثيل أولاً.',
    'awsp.calc.rdsMultiAzNote': 'النشر متعدد المناطق منتج منفصل في كتالوج AWS وليس ضعف الكمية — السعر يشمل النسخة الاحتياطية.',
    'awsp.calc.kindOpenSearch': 'OpenSearch',
    'awsp.calc.usageAmount':  'مقدار الاستخدام',
    'awsp.calc.elbNote':      'يُفوتر موازن التحميل التطبيقي بسطرين: LoadBalancerUsage بالساعة وLCUUsage بوحدة LCU-ساعة. أدخل الساعات/الشهر (مثلاً 730) للأول، وLCU × الساعات للثاني.',
    'awsp.calc.needOpenSearch': 'اختر نوع مثيل OpenSearch أولاً.',
    'awsp.calc.openSearchNote': 'يشمل هذا السعر مثيل النطاق فقط. تخزين EBS للنطاق سطر منفصل — أضفه من تبويب التخزين / النقل.',
    // ── تصدير التقدير النشط (Excel / PDF) ──────────────────────────────────
    'awsp.exp.excel':         'Excel',
    'awsp.exp.pdf':           'PDF',
    'awsp.exp.docTitle':      'تقدير تكلفة AWS',
    'awsp.exp.generatedAt':   'أُنشئ في',
    'awsp.exp.colKind':       'النوع',
    'awsp.exp.colItem':       'العنصر',
    'awsp.exp.colUsageType':  'نوع الاستخدام / العملية',
    'awsp.exp.colCommitment': 'الالتزام',
    'awsp.exp.colLoad':       'الساعات / الحجم',
    'awsp.exp.colUnit':       'الوحدة',
    'awsp.exp.colUnitPrice':  'سعر الوحدة',
    'awsp.exp.colRecurring':  'متكرر/شهر',
    'awsp.exp.colUpfront':    'الدفعة المقدمة',
    'awsp.exp.colFlags':      'ملاحظات',
    'awsp.exp.flagDerived':   'سعر مشتق',
    'awsp.exp.flagAnomaly':   'شذوذ في الكتالوج',
    'awsp.exp.flagDrift':     'تغيّر السعر',
    'awsp.exp.inIdr':         'بالروبية',
    'awsp.exp.popupBlocked':  'حظر المتصفح نافذة الطباعة — اسمح بالنوافذ المنبثقة لهذا الموقع.',
    'awsp.matrix.title':          'مصفوفة الالتزام',
    'awsp.matrix.subtitle':       'جميع الخيارات جنباً إلى جنب. انقر صفاً لتطبيقه على الحساب.',
    'awsp.matrix.option':         'الخيار',
    'awsp.matrix.upfront':        'الدفعة المقدمة',
    'awsp.matrix.monthly':        '$/شهر',
    'awsp.matrix.year1':          'إجمالي سنة',
    'awsp.matrix.saving':         'التوفير',
    'awsp.matrix.missing':        'غير موجود في الكتالوج',
    'awsp.matrix.riStd':          'النسخ المحجوزة — قياسي',
    'awsp.matrix.riConv':         'النسخ المحجوزة — قابل للتحويل',
    'awsp.matrix.spCompute':      'خطة التوفير — الحوسبة',
    'awsp.matrix.spEc2':          'خطة التوفير — نسخة EC2',
    'awsp.matrix.derivedHint':    'التدفق النقدي مستنتج من السعر الملتزم به',
    'awsp.matrix.derivedNote':    'خطط التوفير لا تحتوي على دفعة مقدمة لكل سعر؛ الرقم مستنتج من السعر الملتزم به × الساعات. التكلفة الموزعة متطابقة في خيارات الدفع الثلاثة — يختلف توقيت الدفع فقط.',
    'awsp.matrix.savingNote':     'يُحسب التوفير مقابل السعر عند الطلب بنفس الكمية والساعات.',
    'awsp.matrix.anomalyWarn':    '{n} خلية تخالف نمط الدفعة المقدمة/السعر المتوقع. تظل معروضة ليكون الكتالوج المعطوب مرئياً لا مخفياً.',
    'awsp.catalog.searchHint':    'نوع النسخة أو الوصف أو نوع الاستخدام',
    'awsp.catalog.rowCount':      '{n} صف مطابق',
    'awsp.catalog.page':          'صفحة {p} من {t}',
    'awsp.catalog.empty':         'لا توجد صفوف تطابق عوامل التصفية.',
    'awsp.sync.jobStatus':        'حالة المهام لكل منطقة',
    'awsp.sync.job':              'المهمة',
    'awsp.sync.products':         'المنتجات',
    'awsp.sync.terms':            'العروض',
    'awsp.sync.jobsCount':        'عدد المهام',
    'awsp.sync.running':          'قيد التشغيل',
    'awsp.sync.duration':         'المدة',
    'awsp.sync.lastSync':         'آخر مزامنة',
    'awsp.sync.status':           'الحالة',
    'awsp.sync.never':            'لم تُنفَّذ',
    'awsp.sync.run':              'تشغيل',
    'awsp.sync.confirm':          'تشغيل المزامنة الآن؟ سيتم استبدال الصفوف الحالية لهذه المهمة والمنطقة، لا إضافتها.',
    'awsp.sync.confirmSp':        'تستغرق مزامنة خطط التوفير نحو 12 دقيقة وأكثر من 2000 طلب API. هل تريد التشغيل الآن؟',
    'awsp.sync.emptyNote':        'تعني الحالة «empty» أن المهمة عملت دون خطأ لكنها لم تُرجع أي منتج — الكتالوج ناقص وليس مكتملاً.',
    'awsp.sync.config':           'إعدادات الحاسبة',
    'awsp.sync.savedKeys':        'تم الحفظ: {keys}',
    'awsp.sync.supportTiers':     'مستويات الدعم',
    'awsp.sync.tierFrom':         'من',
    'awsp.sync.tierTo':           'إلى',
    'awsp.sync.min':              'الحد الأدنى',
    'awsp.sync.marginalNote':     'المستويات هامشية: تنطبق كل نسبة على الجزء الواقع داخل نطاقها فقط.',


    // ══ AWS Pricing Calculator — CRUD estimate ══
    'awsp.est.title':         'التقدير',
    'awsp.est.unsaved':       'غير محفوظ — ستفقد السلة عند إغلاق التبويب.',
    'awsp.est.currentName':   '{name} (#{id})',
    'awsp.est.save':          'حفظ',
    'awsp.est.saveNew':       'حفظ التقدير',
    'awsp.est.saveAs':        'حفظ كتقدير جديد',
    'awsp.est.open':          'فتح',
    'awsp.est.loadBtn':       'تحميل',
    'awsp.est.namePrompt':    'اسم التقدير:',
    'awsp.est.defaultName':   'تقدير جديد',
    'awsp.est.emptyCart':     'السلة فارغة — لا شيء لحفظه.',
    'awsp.est.saved':         'تم الحفظ، {n} بند.',
    'awsp.est.loaded':        'تم تحميل التقدير. أُعيد جلب الأسعار من الكتالوج وهي مطابقة لما تم حفظه.',
    'awsp.est.loadedEmpty':   'تم تحميل التقدير، لكنه لا يحتوي على بنود.',
    'awsp.est.loadedDrift':   'تم تحميل التقدير: {d} بند يختلف سعره عن وقت الحفظ، و{x} بند لم يعد موجوداً في الكتالوج. الأرقام المعروضة تستخدم الأسعار الحالية.',
    'awsp.est.listEmpty':     'لا توجد تقديرات محفوظة بعد.',
    'awsp.est.lineCount':     '{n} بند',
    'awsp.est.confirmDelete': 'حذف التقدير «{name}»؟ ستُحذف جميع بنوده ولا يمكن استعادتها.',
    'awsp.est.snapshotNote':  'تحفظ بنود التقدير السعر الساري وقت الحفظ. لن تُغيّر المزامنة الأسبوعية تقديراً قديماً بصمت — بل يُشار إلى أي اختلاف عند فتحه.',
    'awsp.est.driftTitle':    'تغيّر السعر منذ حفظ التقدير',
    'awsp.est.driftSaved':    'وقت الحفظ:',


    // ══ AWS Pricing Calculator — No Support option ══
    'awsp.calc.supportNone': 'بدون دعم',


    // ══ AWS Pricing Calculator — konvensi AWS (recurring vs upfront) ══
    'awsp.matrix.leaseTotal':         'إجمالي مدة العقد',
    'awsp.calc.totalMonthlyNote':     'يتبع اصطلاح حاسبة أسعار AWS: التكلفة المتكررة فقط. لا تشمل الدفعة المقدمة هنا — انظر السطر أدناه.',
    'awsp.calc.amortizedCompare':     'المعادل الشهري (موزّع)',
    'awsp.calc.amortizedCompareNote': 'رقم للمقارنة فقط وليس جزءاً من الإجمالي الشهري: توزَّع الدفعة المقدمة على كامل مدة العقد لمقارنة عادلة بين خياري بدون دفعة مقدمة ودفعة كاملة مقدماً.',
    'awsp.calc.oneTime':              'دفعة واحدة',


    // ══ SearchableSelect ══
    'awsp.searchPlaceholder': 'اكتب للبحث…',

  },
};
